import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import * as React from 'react';
import React__default, { createContext, useState, useCallback, useEffect, useContext, useRef, Component, Children, useMemo, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import usePortal from 'react-cool-portal';
import classnames from 'classnames';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.parse-float.js';
import 'core-js/modules/es.string.match.js';
import { isEmpty } from 'lodash';
import 'core-js/modules/es.string.ends-with.js';
import 'core-js/modules/es.array.reduce.js';
import numeral from 'numeral';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.object.assign.js';
import axios from 'axios';
import camelCaseKeys from 'camelcase-keys';
import isEmpty$1 from 'lodash/isEmpty';
import 'core-js/modules/esnext.promise.all-settled.js';
import { useQuery, useQueryClient, useMutation, QueryClient, QueryClientProvider } from 'react-query';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.string.trim.js';
import parser from 'parse-address';
import parseJWT from 'jwt-decode';
import { useCountUp } from 'react-countup';
import TextArea$1 from 'react-textarea-autosize';
import NumberFormat from 'react-number-format';
import 'core-js/modules/es.number.to-fixed.js';
import uniqueId from 'lodash/uniqueId';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.regexp.to-string.js';
import require$$0 from 'util';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.array.sort.js';
import { Line, Bar } from '@visx/shape';
import { Point } from '@visx/point';
import { useTooltip, useTooltipInPortal } from '@visx/tooltip';
import { localPoint } from '@visx/event';

const TABS = {
  OVERVIEW: 'Overview',
  SETTINGS: 'Your Profile',
  TEAM: 'Your Team'
};
const INPUT_NAMES = {
  CURRENT_MONTHLY_COST: 'currentMonthlyCost',
  MAX_BUDGET: 'maxBudget',
  DOWN_PAYMENT: 'downPayment',
  YEARS_IN_HOME: 'yearsInHome',
  RENTABLE_NIGHTS: 'rentableNights'
};
const positioningTypes = {
  FIXED_RIGHT: 'FixedRight',
  RELATIVE: 'Relative'
};
const VALID_TAB_VALUES = Object.keys(TABS).map(k => TABS[k]);

// ENSURE THESE MATCH MIKASA!!
// TODO - Let mikasa drive this
const DEFAULT_MAX_BUDGET = 1500;
const DEFAULT_CURRENT_MONTHLY_COST = 1500;
const DEFAULT_DOWN_PAYMENT = 30000;
const DEFAULT_YEARS_IN_HOME = 7;
const DEFAULT_RENTABLE_NIGHTS = 6;
const MIN_YEARS_IN_HOME = 1;
const MAX_YEARS_IN_HOME = 30;
const MIN_RENTABLE_NIGHTS = 0;
const MAX_RENTABLE_NIGHTS = 31;
const BUDGET_PRICE_POINT_RATIO = 0.005;
const BUYER_PREQUAL_PROMPT = 'buyer-prequal-prompt';
const OWNER_CLIENT_TYPE = 'homeowner';
const RENTER_CLIENT_TYPE = 'renter';
const GUEST_CLIENT_TYPE = 'guest';
const BUYER_DOWN_PAYMENT_PERCENT_OF_LISTING_PRICE = 0.07;
const BUYER_DOWN_PAYMENT = 7;
const OWNER_TYPES = [OWNER_CLIENT_TYPE];
const RENTER_TYPES = [RENTER_CLIENT_TYPE];
const GUEST_TYPES = [GUEST_CLIENT_TYPE];
const PMI_DROPPED_PERCENT = 22;
const PMI_DROPPED_PERCENT_AS_DECIMAL = PMI_DROPPED_PERCENT / 100.0;

const AppContext = /*#__PURE__*/createContext({
  thumbDirection: null,
  includeRental: false,
  focusedSettingsField: ''
});
const AppContextProvider = ({
  address,
  listingPrice,
  widgetMode,
  devMode,
  clientAuthToken,
  customerPublicKey,
  customerProfileId,
  children
}) => {
  const [marketTempSliderPrice, setMarketTempSliderPrice] = useState(null);
  const [appreciationSliderPercent, setAppreciationSliderPercent] = useState(null);
  const [thumbDirection, setThumbDirection] = useState(null);
  const [includeRental, setIncludeRental] = useState(false);
  const [focusedSettingsField, setFocusedSettingsField] = useState('');
  const [clientType, setClientType] = useState(RENTER_CLIENT_TYPE);
  const [activeTab, setActiveTab] = useState(TABS.OVERVIEW);

  const setFocusFieldAndNavigateToSettings = fieldName => {
    setFocusedSettingsField(fieldName);
    setActiveTab(TABS.SETTINGS);
  };

  const value = {
    address,
    listingPrice,
    marketTempSliderPrice,
    setMarketTempSliderPrice,
    thumbDirection,
    setThumbDirection,
    includeRental,
    setIncludeRental,
    focusedSettingsField,
    setFocusedSettingsField,
    activeTab,
    setActiveTab,
    setFocusFieldAndNavigateToSettings,
    appreciationSliderPercent,
    setAppreciationSliderPercent,
    devMode,
    clientType,
    setClientType,
    widgetMode,
    customerPublicKey,
    customerProfileId,
    clientAuthToken
  };
  return /*#__PURE__*/React__default.createElement(AppContext.Provider, {
    value: value
  }, children);
};
AppContextProvider.defaultProps = {
  devMode: false,
  zillowUrl: null
};
AppContextProvider.propTypes = {
  address: PropTypes.string,
  listingPrice: PropTypes.number,
  widgetMode: PropTypes.string,
  devMode: PropTypes.bool,
  zillowUrl: PropTypes.string,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string,
  customerProfileId: PropTypes.string,
  children: PropTypes.any
};

var _jsxFileName$1P = "/home/circleci/app/libs/listings-bot/src/contexts/OverlayContext.jsx";
const OverlayContext = /*#__PURE__*/createContext({});
const OverlayContextProvider = ({
  children
}) => {
  const [overlayIdHistory, setOverlayIdHistory] = useState([]);
  const activeOverlayId = overlayIdHistory[overlayIdHistory.length - 1];
  const handleOverlayBack = useCallback(() => {
    const existingIds = [...overlayIdHistory];
    existingIds.pop();
    setOverlayIdHistory(existingIds);
  }, [overlayIdHistory]);
  const handleAddOverlay = useCallback(id => {
    const existingIds = [...overlayIdHistory];
    existingIds.push(id);
    setOverlayIdHistory(existingIds);
  }, [overlayIdHistory]);
  const value = {
    setOverlayIdHistory,
    activeOverlayId,
    handleAddOverlay,
    handleOverlayBack
  };
  return /*#__PURE__*/React__default.createElement(OverlayContext.Provider, {
    value: value,
    __self: window,
    __source: {
      fileName: _jsxFileName$1P,
      lineNumber: 34,
      columnNumber: 5
    }
  }, children);
};
OverlayContextProvider.propTypes = {
  children: PropTypes.any
};

var _jsxFileName$1O = "/home/circleci/app/libs/listings-bot/src/contexts/RouterContext.jsx";
const RouterContext = /*#__PURE__*/createContext({});
const RouterContextProvider = ({
  children
}) => {
  const [showIframe, setShowIframe] = useState(false);
  const [iframeSrc, setIframeSrc] = useState('');
  const [iframeReady, setIframeReady] = useState(false);
  useEffect(() => {
    setIframeReady(false);
  }, [iframeSrc]);
  const value = {
    showIframe,
    setShowIframe,
    iframeSrc,
    setIframeSrc,
    iframeReady,
    setIframeReady
  };
  return /*#__PURE__*/React__default.createElement(RouterContext.Provider, {
    value: value,
    __self: window,
    __source: {
      fileName: _jsxFileName$1O,
      lineNumber: 25,
      columnNumber: 5
    }
  }, children);
};
RouterContextProvider.propTypes = {
  children: PropTypes.any
};

const homebotHostname = process.env.REACT_APP_HB_HOSTNAME;
const mikasaBaseUrl = process.env.REACT_APP_MIKASA_BASE_URL;
const clientFrontendUri = process.env.REACT_APP_CFE_BASE_URL;
process.env.REACT_APP_SHOW_DEV_TOOLS;
const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
const gaApiSecret = process.env.REACT_APP_GA_API_SECRET;
const widgetMode = process.env.WIDGET_MODE;
process.env.NODE_ENV;

const getFullLocation = () => window.location.origin + window.location.pathname;
const getIsHomebotDomain = () => {
  var _window, _window$location;

  const windowHostname = (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.hostname;

  if (windowHostname.endsWith) {
    return windowHostname.endsWith(homebotHostname);
  }

  return false;
};

// 0 = round to nearest whole number, 123.456 => 123
// 1 = round to nearest ones place, 123.456 => 123.5
// 2 = round to nearest tens place, 123.456 => 123.46
// -1 = round to nearest ones place the other way, 12345.6789 => 12350
// -2 = round to nearest tens place the other way, 12345.6789 => 12300

const roundWithPrecision = (value, precision) => {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};
const formatToCurrency = (value, format, precision) => {
  const defaultFormat = '$0,0[.]00';
  if (!value && value !== 0) return null;
  const roundedValue = roundWithPrecision(value, precision);
  let currency;

  if (format) {
    currency = numeral(roundedValue).format(format);
  } else {
    currency = numeral(roundedValue).format(defaultFormat);
  }

  return currency;
};
const formatAbbrCurrency = value => {
  if (value < 1000) {
    return numeral(value).format('($0,0)');
  }

  if (value < 1000000) {
    return numeral(value).format('($0a)');
  }

  return numeral(value).format('($0.00a)');
};
const formatToPercent = (value, precision = 1) => {
  const suffix = '%';
  if (!value && value !== 0) return `0${suffix}`;
  const roundedValue = roundWithPrecision(value, precision);
  return `${roundedValue}${suffix}`;
};
const formatToPhone = value => {
  if (!value) return null;
  value = value.replace(/[^\d]/g, '');
  if (value.length < 10) return null;

  if (value.length === 10) {
    value = ['1', value].join('');
  }

  return value.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '$2-$3-$4');
};
const snakeCaseKeys = obj => {
  return Object.keys(obj).reduce((newObj, key) => {
    const snakeKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    newObj[snakeKey] = obj[key];
    return newObj;
  }, {});
};
const capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const EMBEDDED = 'EMBEDDED';
const CHROME_EXTENSION = 'CHROME_EXTENSION';

const isExtension = mode => mode === CHROME_EXTENSION;

// Uses the chrome.storage API for storing and retrieving data
const get$2 = keys => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.get(keys, entries => {
      if (chrome.runtime.lastError) {
        reject({
          error: chrome.runtime.lastError.message
        });
      } else {
        resolve(entries);
      }
    });
  });
};

const set$2 = items => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.set(items, () => {
      if (chrome.runtime.lastError) {
        reject({
          error: chrome.runtime.lastError.message
        });
      } else {
        resolve();
      }
    });
  });
};

const remove$2 = keys => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.remove(keys, () => {
      if (chrome.runtime.lastError) {
        reject({
          error: chrome.runtime.lastError.message
        });
      } else {
        resolve();
      }
    });
  });
}; // Used for debugging


const displayName$1 = 'chromeStorageAdapter';
const chromeStorageAdapter = {
  get: get$2,
  set: set$2,
  remove: remove$2,
  displayName: displayName$1
};

// Uses window.localStorage API for storing and retrieving data
const get$1 = keys => {
  return new Promise((resolve, reject) => {
    if (typeof keys === 'string' || keys instanceof String) {
      const rawValue = localStorage.getItem(keys);
      const value = rawValue ? JSON.parse(rawValue) : rawValue;

      if (value == null) {
        resolve({});
      } else {
        resolve({
          [keys]: value
        });
      }
    } else if (Array.isArray(keys) && keys.every(i => typeof i === 'string')) {
      const values = {};
      keys.forEach(key => {
        const rawValue = localStorage.getItem(key);
        const storageValue = rawValue ? JSON.parse(rawValue) : rawValue;

        if (storageValue !== null) {
          values[key] = storageValue;
        }
      });
      resolve(values);
    } else {
      reject({
        error: 'Keys must be a string or array of strings'
      });
    }
  });
};

const set$1 = items => {
  return new Promise((resolve, reject) => {
    if (typeof items === 'object' && items !== null && !Array.isArray(items)) {
      const keys = Object.keys(items);
      keys.forEach(key => {
        localStorage.setItem(key, JSON.stringify(items[key]));
      });
      resolve();
    } else {
      reject({
        error: 'Items must be an object'
      });
    }
  });
};

const remove$1 = keys => {
  return new Promise((resolve, reject) => {
    if (typeof keys === 'string' || keys instanceof String) {
      localStorage.removeItem(keys);
      resolve();
    } else if (Array.isArray(keys) && keys.every(i => typeof i === 'string')) {
      keys.forEach(key => {
        localStorage.removeItem(key);
      });
      resolve();
    } else {
      reject('Keys must be a string or array of strings');
    }
  });
}; // Used for debugging


const displayName = 'localStorageAdapter';
const localStorageAdapter = {
  get: get$1,
  set: set$1,
  remove: remove$1,
  displayName
};

// Controls which storage solution we need to use based on if the extension is in
const adapter = isExtension(widgetMode) ? chromeStorageAdapter : localStorageAdapter; // Gets one or more items from storage
//
// Params
//
// keys: string | string[]

const get = keys => {
  return adapter.get(keys);
}; // Sets multiple items
//
// Params:
//
// items: object


const set = items => {
  return adapter.set(items);
}; // Remove one or more items from storage.
//
// Params:
//
// keys: string | string[]


const remove = keys => {
  return adapter.remove(keys);
};

const lazarette = {
  get,
  set,
  remove
};

const DEV_MODE_TOKEN = 'devModeAuthToken';

const JWT_TOKEN_KEY = 'LISTINGS_BOT_JWT_TOKEN'; // Same as JWT_TOKEN_KEY. JWT_TOKEN_KEY will be deprecated soon

const ACCESS_TOKEN = 'LISTINGS_BOT_ACCESS_TOKEN';
const EXTENSION_DEBOUNCE_KEY_MAP = 'LISTINGS_BOT_EXTENSION_DEBOUNCE_KEY_MAP';

const getClientTokenFromStorage = async () => {
  const storageValues = await lazarette.get([DEV_MODE_TOKEN, JWT_TOKEN_KEY, ACCESS_TOKEN]);

  if (storageValues[DEV_MODE_TOKEN]) {
    return storageValues[DEV_MODE_TOKEN];
  } else {
    var _storageValues$JWT_TO;

    // TODO: - uncomment when deprecating JWT_TOKEN_KEY
    // return storageValues[ACCESS_TOKEN] ?? null
    // TODO: - remove when deprecating JWT_TOKEN_KEY
    return (_storageValues$JWT_TO = storageValues[JWT_TOKEN_KEY]) != null ? _storageValues$JWT_TO : null;
  }
};
const getExtensionDebounceKeys = async () => {
  var _storageValues$EXTENS;

  const storageValues = await lazarette.get(EXTENSION_DEBOUNCE_KEY_MAP);
  return (_storageValues$EXTENS = storageValues[EXTENSION_DEBOUNCE_KEY_MAP]) != null ? _storageValues$EXTENS : {};
};

const setExtensionDebounceKeys = async data => {
  await lazarette.set({
    [EXTENSION_DEBOUNCE_KEY_MAP]: data
  });
  return data;
};

const oncePer24Hours = async (key, justChecking) => {
  const pastKeyTimeMap = await getExtensionDebounceKeys();
  const pastTime = pastKeyTimeMap[key];
  const checkTime = pastTime ? new Date(pastTime + 24 * 60 * 60 * 1000).getTime() : null;
  const nowTime = new Date().getTime();

  if (!checkTime || nowTime > checkTime) {
    if (!justChecking) {
      await setExtensionDebounceKeys(Object.assign({}, pastKeyTimeMap, {
        [key]: nowTime
      }));
    }

    return true;
  }

  return false;
};

const getRandomInt = max => {
  return Math.floor(Math.random() * max);
};

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const listingRegex = /*#__PURE__*/_wrapRegExp(/zillow.com\/home(detail)?s\/[^/]*?\/(\d+)_(zpid)/, {
  id: 2
});

const ZILLOW_DOM_STATUS_ID = '.ds-status-details';
const ZILLOW_SUMMARY_SELECTOR = '.summary-container';
const ZILLOW_SUMMARY_SELECTOR_2 = '.ds-chip-removable-content';
const ZILLOW_OWNED_SELECTOR = '.hdp__sc-13xpdoz-0';
const DENY_LISTING_STATUSES = ['rent', 'sold', 'closed', 'lot/land'];
const FETCH_ZILLOW_ELEMENT_TIMEOUT_MS = 15000;

var _jsxFileName$1N = "/home/circleci/app/libs/listings-bot/src/contexts/Zillow/ZillowContext.jsx";
const ZillowContext = /*#__PURE__*/createContext({
  locationUrl: null,
  proxiedZillowUrl: null
});

const parseAllowedAndStatus = () => {
  let isAllowed, status; // Order dependent, the top selector is the least specific

  const listingStatusContainer = document.querySelector(ZILLOW_SUMMARY_SELECTOR) || document.querySelector(ZILLOW_SUMMARY_SELECTOR_2) || document.querySelector(ZILLOW_DOM_STATUS_ID) || document.querySelector(ZILLOW_OWNED_SELECTOR);

  if (listingStatusContainer) {
    const listingStatusText = listingStatusContainer.textContent.toLowerCase();
    const isADeniedStatus = DENY_LISTING_STATUSES.some(status => listingStatusText.includes(status));
    isAllowed = !isADeniedStatus;
    status = listingStatusText;
  } else {
    isAllowed = false;
    status = null;
  }

  return {
    isAllowed,
    status
  };
};

const ZillowContextProvider = ({
  zillowUrl,
  children
}) => {
  var _match$groups;

  const {
    setIncludeRental
  } = useContext(AppContext);
  const [locationUrl, setLocationUrl] = useState(zillowUrl || getFullLocation());
  const [hasAllowedStatus, setHasAllowedStatus] = useState(false);
  const [address, setAddress] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [listingPrice, setListingPrice] = useState(null);
  const [listingStatus, setListingStatus] = useState(null);
  const [userManuallyEntered, setUserManuallyEntered] = useState(false);
  const [isAddressError, setIsAddressError] = useState(false);
  const [isListingPriceError, setIsListingPriceError] = useState(false);
  const [isStatusError, setIsStatusError] = useState(false);

  const parseAddressFromDom = () => {
    var _addressNode, _window$document$quer, _window$document$quer2, _window$document$quer5;

    let parsedAddress = '';
    let parsedUrl = '';
    let parsedListingPrice = '';
    let addressNode = window.document.querySelector('#ds-chip-property-address');
    let addressString = (_addressNode = addressNode) == null ? void 0 : _addressNode.textContent;

    if (!addressString) {
      var _addressNode2;

      addressNode = window.document.querySelector('.summary-container h1');
      addressString = (_addressNode2 = addressNode) == null ? void 0 : _addressNode2.textContent;
    } // Handle Lazy Loading of Zillow Address Scenario


    if (addressString && !addressString.includes('--')) {
      // Overwrite Address
      parsedAddress = addressString;
    } // Fetch Price


    parsedListingPrice = (_window$document$quer = window.document.querySelector('.ds-summary-row > span')) == null ? void 0 : (_window$document$quer2 = _window$document$quer.textContent) == null ? void 0 : _window$document$quer2.replace(/[$,]+/g, '');

    if (!parsedListingPrice) {
      var _window$document$quer3, _window$document$quer4;

      parsedListingPrice = (_window$document$quer3 = window.document.querySelector("[data-testid='price']")) == null ? void 0 : (_window$document$quer4 = _window$document$quer3.textContent) == null ? void 0 : _window$document$quer4.replace(/[$,]+/g, '');
    } // Fetch Image


    parsedUrl = (_window$document$quer5 = window.document.querySelector('.media-stream-tile--prominent img')) == null ? void 0 : _window$document$quer5.src;
    return {
      parsedAddress,
      parsedUrl,
      parsedListingPrice
    };
  };

  useEffect(() => {
    const statusObj = parseAllowedAndStatus();
    setHasAllowedStatus(statusObj.isAllowed);
    setListingStatus(statusObj.status);
    const observer = new MutationObserver(mutations => {
      if (userManuallyEntered) return;
      mutations.forEach(_m => {
        const {
          parsedAddress,
          parsedUrl,
          parsedListingPrice
        } = parseAddressFromDom();
        const newUrl = zillowUrl || getFullLocation();

        if (/zillow/.test(newUrl)) {
          // Guard for Storybook
          const statusObj = parseAllowedAndStatus();
          setHasAllowedStatus(statusObj.isAllowed);
          setListingStatus(statusObj.status); // Url Has Changed

          if (locationUrl !== newUrl) {
            setLocationUrl(newUrl);
            setIncludeRental(false);
            setAddress(null);
            setListingPrice(null);
          }
        }

        if (!isEmpty(parsedAddress) && parsedAddress !== address) {
          setAddress(parsedAddress);
        }

        if (!isEmpty(parsedListingPrice)) {
          const floatPrice = parseFloat(parsedListingPrice, 10);
          floatPrice && setListingPrice(floatPrice);
        }

        setImageUrl(parsedUrl);
      });
    });
    const body = document.querySelector('body');
    const config = {
      childList: true,
      subtree: true,
      characterData: true
    };
    observer.observe(body, config);
    return () => {
      observer.disconnect();
    };
  }, [locationUrl, zillowUrl, setIncludeRental, setHasAllowedStatus, address, userManuallyEntered]);
  useEffect(() => {
    const timeOut = () => {
      // Runs after 15 seconds
      const currentUrl = getFullLocation();
      const unfetchedAttributes = []; // If not on a Zillow listing url - exit

      if (!listingRegex.test(currentUrl)) return; // If the listing status was never found - fire error to sentry

      if (listingStatus === null) {
        unfetchedAttributes.push('status');
        setIsStatusError(true);
        window.Sentry.captureException(new Error(`Could not find the following Zillow DOM elements in ${FETCH_ZILLOW_ELEMENT_TIMEOUT_MS / 1000}s: ${unfetchedAttributes.join(', ')}`));
        return;
      } // If address or listing price wasn't found
      // And it is a valid listing type (ie For Sale)
      // Fire Error to Sentry


      if (address == null) {
        unfetchedAttributes.push('address');
        setIsAddressError(true);
      }

      if (listingPrice == null) {
        unfetchedAttributes.push('listingPrice');
        setIsListingPriceError(true);
      } // Homes owned by Zillow has an entirely different dom structure
      // So we want the error modal to pop open but we don't want to send to Sentrys


      const isOwnedByZillowHome = document.querySelector(ZILLOW_OWNED_SELECTOR);

      if (unfetchedAttributes.length && hasAllowedStatus && !isOwnedByZillowHome) {
        window.Sentry.captureException(new Error(`Could not find the following Zillow DOM elements in ${FETCH_ZILLOW_ELEMENT_TIMEOUT_MS / 1000}s: ${unfetchedAttributes.join(', ')}`));
      }
    };

    const timer = setTimeout(timeOut, FETCH_ZILLOW_ELEMENT_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [locationUrl, address, listingPrice, listingStatus, hasAllowedStatus]);
  const match = locationUrl.match(listingRegex);
  const zpid = match == null ? void 0 : (_match$groups = match.groups) == null ? void 0 : _match$groups.id; // TODO: Replace with our own CORS proxy

  const proxiedZillowUrl = `http://0.0.0.0:1000/${zillowUrl}`;

  const resetAndFetchManualAddress = (address, listingPrice) => {
    setAddress(address);
    setListingPrice(listingPrice);
    setIsListingPriceError(false);
    setIsAddressError(false);
    setUserManuallyEntered(true);
    setIsStatusError(true);
  };

  const value = {
    locationUrl,
    proxiedZillowUrl,
    showBothead: Boolean(zpid) && hasAllowedStatus,
    address,
    setAddress,
    isAddressError,
    imageUrl,
    listingPrice,
    setListingPrice,
    isListingPriceError,
    isStatusError,
    userManuallyEntered,
    setUserManuallyEntered,
    setIsAddressError,
    setIsListingPriceError,
    resetAndFetchManualAddress
  }; // Guard Clause - wait till Children are ready

  return /*#__PURE__*/React__default.createElement(ZillowContext.Provider, {
    value: value,
    __self: window,
    __source: {
      fileName: _jsxFileName$1N,
      lineNumber: 271,
      columnNumber: 5
    }
  }, children);
};
ZillowContextProvider.defaultProps = {
  devMode: false,
  zillowUrl: null
};
ZillowContextProvider.propTypes = {
  devMode: PropTypes.bool,
  zillowUrl: PropTypes.string,
  children: PropTypes.any
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1e = ".ScrollableContent-module_analyzeModalBody__Es-Rw {\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 539px;\n  width: 100%;\n  font-size: 1em;\n  flex: 1;\n  transform: translateY(0);\n}\n\n/* total width */\n.ScrollableContent-module_analyzeModalBody__Es-Rw::-webkit-scrollbar {\n  background-color: #302e35;\n}\n\n/* background of the scrollbar except button or resizer */\n.ScrollableContent-module_analyzeModalBody__Es-Rw::-webkit-scrollbar-track {\n  background-color: #302e35;\n}\n\n/* scrollbar itself */\n.ScrollableContent-module_analyzeModalBody__Es-Rw::-webkit-scrollbar-thumb {\n  background-color: #6e6d6d;\n  border-radius: 16px;\n  border: 4px solid #302e35;\n}\n\n/* set button(top and bottom of the scrollbar) */\n.ScrollableContent-module_analyzeModalBody__Es-Rw::-webkit-scrollbar-button {\n  display: none;\n}\n\n.ScrollableContent-module_scrollable__-p7N7 {\n  height: 100%;\n  overflow: hidden;\n  overflow-y: scroll;\n}\n\n/* total width */\n.ScrollableContent-module_scrollable__-p7N7::-webkit-scrollbar {\n  background-color: #302e35;\n}\n\n/* background of the scrollbar except button or resizer */\n.ScrollableContent-module_scrollable__-p7N7::-webkit-scrollbar-track {\n  background-color: #302e35;\n}\n\n/* scrollbar itself */\n.ScrollableContent-module_scrollable__-p7N7::-webkit-scrollbar-thumb {\n  background-color: #6e6d6d;\n  border-radius: 16px;\n  border: 4px solid #302e35;\n}\n\n/* set button(top and bottom of the scrollbar) */\n.ScrollableContent-module_scrollable__-p7N7::-webkit-scrollbar-button {\n  display: none;\n}";
var styles$1c = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","analyzeModalBody":"ScrollableContent-module_analyzeModalBody__Es-Rw","scrollable":"ScrollableContent-module_scrollable__-p7N7","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$1e);

var _jsxFileName$1M = "/home/circleci/app/libs/listings-bot/src/components/ScrollableContent/ScrollableContent.jsx";
const ScrollContext = /*#__PURE__*/createContext();

const ScrollableContent = ({
  scrollTopDeps,
  children
}) => {
  const scrollRef = useRef();
  const scrollToTop = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    scrollToTop();
  }, [...scrollTopDeps]);
  const contextValue = {
    scrollToTop
  };
  return /*#__PURE__*/React__default.createElement("div", {
    ref: scrollRef,
    className: styles$1c.scrollable,
    __self: window,
    __source: {
      fileName: _jsxFileName$1M,
      lineNumber: 31,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(ScrollContext.Provider, {
    value: contextValue,
    __self: window,
    __source: {
      fileName: _jsxFileName$1M,
      lineNumber: 32,
      columnNumber: 7
    }
  }, children));
};

ScrollableContent.propTypes = {
  children: PropTypes.any,
  scrollTopDeps: PropTypes.array
};

const GA_SEND_EVENT = 'GA_SEND_EVENT'; // message type
// Event names are case sensitive. For example, my_event and My_Event are two distinct events.
// Use only letters, numbers, and underscores. Don't use spaces. Names must start with a letter.
// https://support.google.com/analytics/answer/10085872
// Event Names

const BOTHEAD_MOUNT_ON_LISTING = 'bothead_mount_on_listing';
const LISTING_EVAL_SLIDER_MOVED = 'listing_eval_slider_moved';
const EDIT_ESTIMATED_COSTS_TEASER_CLICK = 'edit_estimated_costs_teaser_click';

const buildMikasaClient = async authSettings => {
  const options = {
    baseURL: mikasaBaseUrl,
    timeout: 30000,
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    },
    transformResponse: [data => {
      // Convert mikasa's default kebab-case to camelCase for easier destructuring in Javascript
      let parsedData = null;

      try {
        parsedData = camelCaseKeys(JSON.parse(data), {
          deep: true
        });
      } catch (e) {}

      return parsedData || data;
    }]
  };

  if (authSettings != null && authSettings.scheme) {
    options.headers.Authorization = `${authSettings.scheme} ${authSettings.token}`;
  }

  return axios.create(options);
};

const getQueryDefaults = () => ({
  retry: (failureCount, error) => {
    var _error$response;

    const {
      status
    } = (_error$response = error == null ? void 0 : error.response) != null ? _error$response : {};

    if (status >= 400 && status < 500) {
      return false;
    }

    return failureCount < 3;
  },
  keepPreviousData: true,
  staleTime: 5 * 60 * 1000 // 5 mins sounds fair?

});

const useWidgetMode = () => {
  const {
    widgetMode
  } = useContext(AppContext);
  return widgetMode;
};

const useIsExtension = () => {
  const mode = useWidgetMode();
  return isExtension(mode);
}; // redundant from isExtension? kinda... but may not always be true


const useIsZillow = () => {
  const mode = useWidgetMode();
  return isExtension(mode);
};

const defaultDebounceTime = 1000;
const asyncStatuses = {
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error'
}; // minimumDuration accepts a number in ms, else if truthy sets as defaultDebounceTime
// executeOnMount if you just want shit to happen and don't need to fire manually

const useAsync = (asyncFunction, {
  minimumDuration,
  executeOnMount
} = {}) => {
  const [callCount, setCallCount] = useState(0);
  const [status, setStatus] = useState(asyncStatuses.IDLE);
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [lastCallFailed, setLastCallFailed] = useState(null);
  let debounce = 0;

  if (typeof minimumDuration === 'number') {
    debounce = minimumDuration;
  } else if (minimumDuration) {
    debounce = defaultDebounceTime;
  } // The execute function wraps asyncFunction and
  // handles setting state for pending, value, and error.
  // useCallback ensures the below useEffect is not called
  // on every render, but only if asyncFunction changes.


  const execute = useCallback((...args) => {
    // used for uniqueness, reset function will increment, thus
    // previous calls will be ignored for returning status
    const callNumber = callCount;

    try {
      setStatus(asyncStatuses.PENDING);
      setValue(null);
      setError(null);
      const fireAsync = new Promise((resolve, reject) => asyncFunction(...args).then(resolve).catch(reject));
      const overrideLoading = new Promise(resolve => setTimeout(resolve, debounce)); // allSettled to wiat on both async call, and debounceTime
      // (whatever is slowest) if minimumDuration option is true

      return Promise.allSettled([fireAsync, overrideLoading]).then(responseArray => {
        const result = responseArray[0];

        if (callNumber === callCount) {
          if (result.status === 'rejected') {
            setError(result.reason);
            setStatus(asyncStatuses.ERROR);
            setLastCallFailed(true);
          } else {
            setValue(result.value);
            setStatus(asyncStatuses.SUCCESS);
            setLastCallFailed(false);
          }
        }
      });
    } catch (error) {
      if (callNumber === callCount) {
        setError(error);
        setStatus(asyncStatuses.ERROR);
        setLastCallFailed(true);
      }

      return null;
    }
  }, [asyncFunction, debounce, callCount]); // resets status back to idle, disregards any result
  // of in progress requests (w/ callCount uniqueuness)

  const reset = useCallback(() => {
    setCallCount(callCount + 1);
    setStatus(asyncStatuses.IDLE);
    setValue(null);
    setError(null);
    setLastCallFailed(null);
  }, [callCount]); // Call execute if we want to fire it right away.
  // Otherwise execute can be called later, such as
  // in an onClick handler.

  useEffect(() => {
    if (execute && executeOnMount && status === asyncStatuses.IDLE) {
      execute();
    }
  }, [execute, executeOnMount, status]);
  return {
    // Functions
    execute,
    // fires async function provided
    reset,
    // resets to IDLE, disregard previous call's responses
    // execute reporting namespaced
    executeStatus: status,
    // one of [asyncStatuses]
    executeValue: value,
    // result of execute
    executeError: error,
    // error execute may have thrown
    // actionable statuses
    isIdle: status === asyncStatuses.IDLE,
    isLoading: status === asyncStatuses.PENDING,
    isSuccess: status === asyncStatuses.SUCCESS,
    isErrored: status === asyncStatuses.ERROR,
    promptRetry: lastCallFailed // previous failure, but retryable until success

  };
};

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

const BEARER_PREFIX = 'Bearer';
const CUSTOMER_PUBLIC_KEY_PREFIX = 'hb-cust-pub';
const useAuthSettings = () => {
  const {
    customerPublicKey,
    clientAuthToken: clientTokenFromContext,
    clientType
  } = useContext(AppContext);
  const isExtension = useIsExtension();
  const [authSettings, setAuthSettings] = useState(null);
  const establishAuthorizationScheme = useCallback(async () => {
    const clientTokenFromStorage = await getClientTokenFromStorage();

    if (isExtension) {
      if (!clientTokenFromStorage) {
        setAuthSettings({
          scheme: null,
          token: null
        });
      } else {
        setAuthSettings({
          scheme: BEARER_PREFIX,
          token: clientTokenFromStorage
        });
      }
    } else {
      if (!customerPublicKey) {
        // TODO: this will allow requests to fire and authenticated endpoints will fail,
        // however our auth error is fairly extension specific as it stands
        setAuthSettings({
          scheme: null,
          token: null
        });
      } else if (clientTokenFromContext && clientType !== GUEST_CLIENT_TYPE) {
        setAuthSettings({
          scheme: BEARER_PREFIX,
          token: clientTokenFromContext
        });
      } else {
        setAuthSettings({
          scheme: CUSTOMER_PUBLIC_KEY_PREFIX,
          token: customerPublicKey
        });
      }
    }
  }, [clientTokenFromContext, clientType, customerPublicKey, isExtension]);
  useEffect(() => {
    establishAuthorizationScheme();
    window.addEventListener('visibilitychange', establishAuthorizationScheme);
    return () => window.removeEventListener('visibilitychange', establishAuthorizationScheme);
  }, [establishAuthorizationScheme]);
  return authSettings;
};

const CHROMEBOT_BOTHEAD_CLICK = 'chromebot:bothead-click';
const CHROMEBOT_FEEDBACK = 'chromebot:feedback';
const CHROMEBOT_UPDATED_PROFILE_SETTINGS = 'chromebot:updated-profile-settings';
const EXTENSION_CLIENT_EVENT_SOURCE = 'homebot-for-chrome';
const EMBED_CLIENT_EVENT_SOURCE = 'listings-bot';

const getChromeBotClientEvents = async authSettings => {
  const client = await buildMikasaClient(authSettings);
  const response = await client.get('/chromebot/client_events');
  return response == null ? void 0 : response.data;
};

const useClientEventsQuery = () => {
  const authSettings = useAuthSettings();
  return useQuery(['clientEvents'], () => getChromeBotClientEvents(authSettings), Object.assign({}, getQueryDefaults(), {
    staleTime: Infinity,
    enabled: Boolean(authSettings)
  }));
};

const _excluded$s = ["data"];

const trackEventFunc = (authSettings, isExtension, eventName, eventProperties = {}, debounceFunc = () => true) => async uniquenessKey => {
  const client = await buildMikasaClient(authSettings);

  if (!eventName) {
    throw new Error('EventName required to track event.');
  }

  let eventKey = eventName;

  if (uniquenessKey) {
    eventKey += ` + ${uniquenessKey}`;
  }

  const shouldFire = await debounceFunc(eventKey);

  if (shouldFire) {
    let source = isExtension ? EXTENSION_CLIENT_EVENT_SOURCE : EMBED_CLIENT_EVENT_SOURCE;
    let body = {
      client_event: {
        name: eventName,
        source: source
      }
    };

    if (!isEmpty$1(eventProperties)) {
      body = {
        client_event: Object.assign({}, body.client_event, {
          properties: eventProperties
        })
      };
    }

    await client.post('/chromebot/client_events', body);
  }
};

const useChromeBotUpdatedProfileSettingsClientEvents = () => {
  const _useClientEventsQuery = useClientEventsQuery(),
        {
    data
  } = _useClientEventsQuery,
        restProps = _objectWithoutPropertiesLoose$1(_useClientEventsQuery, _excluded$s);

  let chromeBotUpdatedProfileSettingsClientEvents = [];

  if (data) {
    chromeBotUpdatedProfileSettingsClientEvents = data.filter(clientEvent => clientEvent.name === CHROMEBOT_UPDATED_PROFILE_SETTINGS);
  }

  return {
    restProps,
    data: chromeBotUpdatedProfileSettingsClientEvents
  };
}; // Hook encapsulates 'session' and 'zpid' uniqueness
// Per useAsync

const useTrackBotheadClickAsync = () => {
  const authSettings = useAuthSettings();
  const isExtension = useIsExtension();
  const trackFunction = trackEventFunc(authSettings, isExtension, CHROMEBOT_BOTHEAD_CLICK);

  const asyncFunc = async () => trackFunction();

  return useAsync(asyncFunc);
};

const useShouldShowFeedback = () => {
  var _useAsync;

  const result = (_useAsync = useAsync(async () => oncePer24Hours(CHROMEBOT_FEEDBACK, true), {
    executeOnMount: true
  })) != null ? _useAsync : {};
  return !!(result != null && result.executeValue);
};

const useTrackFeedbackClick = () => {
  const {
    thumbDirection
  } = useContext(AppContext);
  const authSettings = useAuthSettings();
  const isExtension = useIsExtension();

  const trackFunction = async () => trackEventFunc(authSettings, isExtension, CHROMEBOT_FEEDBACK, {
    thumb_direction: thumbDirection
  }, oncePer24Hours);

  return useAsync(trackFunction);
};

const getListingEvaluationByAddressAndPrice = async (authSettings, address, price, appreciationSliderPercent, includeRental = false) => {
  const client = await buildMikasaClient(authSettings);
  let params = {
    raw_address: address,
    listing_price: price
  };

  if (appreciationSliderPercent) {
    params = Object.assign({}, params, {
      tuned_appreciation_percent: appreciationSliderPercent
    });
  }

  if (includeRental) {
    params = Object.assign({}, params, {
      include_rental: includeRental
    });
  }

  const endpoint = `/chromebot/listing_evaluation?${new URLSearchParams(params)}`;
  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};
const getAppreciationIndicatorByAddressAndPrice = async (authSettings, address, price) => {
  const client = await buildMikasaClient(authSettings);
  const endpoint = `/chromebot/annual_appreciation_percent?${new URLSearchParams({
    raw_address: address,
    listing_price: price
  })}`;
  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};
const getMarketTempIndicatorByAddressAndPrice = async (authSettings, address, price) => {
  const client = await buildMikasaClient(authSettings);
  const endpoint = `/chromebot/market_temp?${new URLSearchParams({
    raw_address: address,
    listing_price: price
  })}`;
  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};
const getListingRentalPotentialByAddress = async (authSettings, address) => {
  const client = await buildMikasaClient(authSettings);
  const endpoint = `/chromebot/rental_potential?${new URLSearchParams({
    raw_address: address
  })}`;
  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};

const getAccess = async authSettings => {
  const client = await buildMikasaClient(authSettings);
  let endpoint = 'chromebot/access';
  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};

const useBuyerSettingsQuery = () => {
  const queryClient = useQueryClient();
  const authSettings = useAuthSettings();
  const {
    clientType,
    setClientType,
    customerProfileId
  } = useContext(AppContext);
  const {
    address,
    listingPrice
  } = useRawListingData();
  const isExtension = useIsExtension();
  return useQuery(['buyerSettings', authSettings == null ? void 0 : authSettings.scheme], () => getBuyerSettings(authSettings, {
    customerProfileId: customerProfileId,
    isExtension
  }), Object.assign({}, getQueryDefaults(), {
    staleTime: 0,
    enabled: Boolean(authSettings) && (isExtension || Boolean(customerProfileId)),
    onSuccess: data => {
      // TODO: move to auth layer over single endpoint check
      if ((data == null ? void 0 : data.clientType) !== clientType) {
        setClientType(data == null ? void 0 : data.clientType);
        queryClient.removeQueries({
          predicate: query => query.queryKey[0] !== 'buyerSettings'
        });

        if (address && listingPrice) {
          fireAddressAndPricePrefetch(queryClient, authSettings, address, listingPrice);
        }
      }
    }
  }));
};

const getBuyerSettings = async (authSettings, {
  customerProfileId,
  isExtension
}) => {
  const client = await buildMikasaClient(authSettings);
  let endpoint = 'chromebot/buyers';

  if (!isExtension) {
    // NOTE: customer_profile_id REQUIRED for non-extension mode or this will auth with bad data
    endpoint += `?${new URLSearchParams({
      customer_profile_id: customerProfileId
    })}`;
  }

  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};

const getPricePoint = (affordability, maxBudget) => {
  if (affordability) {
    return affordability;
  }

  if (maxBudget) {
    return maxBudget / BUDGET_PRICE_POINT_RATIO;
  }

  return null;
};
const getMaxBudget = (affordability, maxBudget) => {
  if (maxBudget) {
    return maxBudget;
  }

  if (affordability) {
    return BUDGET_PRICE_POINT_RATIO * affordability;
  }

  return null;
};

const useBuyerSettingsMutation = () => {
  const queryClient = useQueryClient();
  const {
    setMarketTempSliderPrice,
    setAppreciationSliderPercent
  } = useContext(AppContext);
  const authSettings = useAuthSettings();
  return useMutation(variables => updateBuyerSettings(authSettings, variables), {
    onMutate: async variables => {
      var _queryClient$getQuery;

      await queryClient.cancelQueries('buyerSettings'); // Fetch previous buyer settings

      const previousBuyerSettings = (_queryClient$getQuery = queryClient.getQueryData('buyerSettings')) != null ? _queryClient$getQuery : {}; // Create optimistic settings

      const optimisticBuyerSettings = Object.assign({}, previousBuyerSettings, variables); // Set optimistic settings to buyerSettings cache

      queryClient.setQueryData('buyerSettings', optimisticBuyerSettings);
      return {
        optimisticBuyerSettings,
        previousBuyerSettings
      };
    },
    onSuccess: (result, _variables, _context) => {
      var _queryClient$getQuery2, _queryClient$getQuery3;

      // TODO - eventually handle success states?
      queryClient.setQueryData('buyerSettings', result);
      const url = getFullLocation();
      const {
        address,
        listingPrice
      } = (_queryClient$getQuery2 = queryClient.getQueryData(['rawListing', url])) != null ? _queryClient$getQuery2 : {};
      const {
        annualAppreciationPercent
      } = (_queryClient$getQuery3 = queryClient.getQueryData(['listingAppreciationIndicator', address, listingPrice])) != null ? _queryClient$getQuery3 : {}; // recenter sliders

      setMarketTempSliderPrice(listingPrice);
      setAppreciationSliderPercent(annualAppreciationPercent);
    },
    onSettled: () => {
      queryClient.refetchQueries('listingEvaluation', {
        throwOnError: true
      });
      queryClient.refetchQueries('clientEvents', {
        throwOnError: true
      });
    },
    onError: (error, _variables, context) => {
      // TODO - eventually handle error states?
      console.error(error);
      queryClient.setQueryData('buyerSettings', context.previousBuyerSettings);
    },
    retry: 1
  });
};

const updateBuyerSettings = async (authSettings, params) => {
  const client = await buildMikasaClient(authSettings);
  const endpoint = 'chromebot/buyers/update';
  const response = await client.put(endpoint, params);
  return response == null ? void 0 : response.data;
};

const useBrandingQuery = address => {
  const authSettings = useAuthSettings();
  return useQuery(['branding', address], () => getBranding(authSettings, address), Object.assign({}, getQueryDefaults(), {
    staleTime: Infinity,
    enabled: Boolean(authSettings)
  }));
};

const REA = 'RealEstateAgent';
const LO = 'LoanOfficer';

const useBranding = () => {
  var _useFullListingData, _useBrandingQuery;

  const {
    address
  } = (_useFullListingData = useFullListingData()) != null ? _useFullListingData : {};
  const {
    data,
    refetch,
    isError,
    isFetched
  } = (_useBrandingQuery = useBrandingQuery(address)) != null ? _useBrandingQuery : {};
  const {
    customerProfile: customer,
    sponsor,
    branding
  } = data != null ? data : {};
  const customerType = customer == null ? void 0 : customer.type;
  const isSponsorPresent = Boolean(sponsor);

  const isSoloRea = () => {
    if ((customer == null ? void 0 : customer.type) === LO) {
      return false;
    }

    return customerType === REA && !isSponsorPresent;
  };

  return {
    // customer fields
    customerType,
    customerFirstName: customer == null ? void 0 : customer.firstName,
    customerLastName: customer == null ? void 0 : customer.lastName,
    customerFullName: Boolean((customer == null ? void 0 : customer.firstName) && (customer == null ? void 0 : customer.lastName)) ? `${customer == null ? void 0 : customer.firstName} ${customer == null ? void 0 : customer.lastName}` : null,
    customerEmail: customer == null ? void 0 : customer.email,
    customerPhone: customer == null ? void 0 : customer.phone,
    customerNMLS: customer == null ? void 0 : customer.nmls,
    customerPhotoUri: customer == null ? void 0 : customer.photo,
    customerStatement: customer == null ? void 0 : customer.brandingStatement,
    customerCorporateName: customer == null ? void 0 : customer.corporateProfileName,
    customerCorporatePhone: customer == null ? void 0 : customer.corporateProfilePhone,
    // sponsor fields
    sponsorType: sponsor == null ? void 0 : sponsor.type,
    sponsorFirstName: sponsor == null ? void 0 : sponsor.firstName,
    sponsorLastName: sponsor == null ? void 0 : sponsor.lastName,
    sponsorFullName: Boolean((sponsor == null ? void 0 : sponsor.firstName) && (sponsor == null ? void 0 : sponsor.lastName)) ? `${sponsor == null ? void 0 : sponsor.firstName} ${sponsor == null ? void 0 : sponsor.lastName}` : null,
    sponsorEmail: sponsor == null ? void 0 : sponsor.email,
    sponsorPhone: sponsor == null ? void 0 : sponsor.phone,
    sponsorNMLS: sponsor == null ? void 0 : sponsor.nmls,
    sponsorPhotoUri: sponsor == null ? void 0 : sponsor.photo,
    sponsorStatement: sponsor == null ? void 0 : sponsor.brandingStatement,
    sponsorCorporateName: sponsor == null ? void 0 : sponsor.corporateProfileName,
    sponsorCorporatePhone: sponsor == null ? void 0 : sponsor.corporateProfilePhone,
    isSponsorPresent,
    // branding fields
    loClientsHelped: branding == null ? void 0 : branding.loanOfficerClientsHelped,
    loYearsInIndustry: branding == null ? void 0 : branding.loanOfficerYearsInIndustry,
    // Computed Field
    isSoloRea: isSoloRea(),
    // misc
    refetch,
    isError,
    isFetched,
    isLoading: !isError && !isFetched
  };
};
const useIsOwner = () => {
  const {
    clientType
  } = useBuyerSettings();
  return OWNER_TYPES.includes(clientType);
};

const useBuyerSettingsWithDefaults = () => {
  const buyerSettings = useBuyerSettingsQuery();
  const {
    data = {}
  } = buyerSettings;
  const {
    affordability,
    maxBudget,
    currentAddress,
    currentMonthlyCost,
    yearsInHome,
    downPayment,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment,
    rentableNights
  } = data != null ? data : {};
  const pricePoint = getPricePoint(affordability, maxBudget);
  const budget = getMaxBudget(affordability, maxBudget);
  return {
    affordability: pricePoint,
    maxBudget: budget != null ? budget : DEFAULT_MAX_BUDGET,
    currentMonthlyCost: currentMonthlyCost != null ? currentMonthlyCost : DEFAULT_CURRENT_MONTHLY_COST,
    yearsInHome: yearsInHome != null ? yearsInHome : DEFAULT_YEARS_IN_HOME,
    downPayment: downPayment != null ? downPayment : DEFAULT_DOWN_PAYMENT,
    rentableNights: rentableNights != null ? rentableNights : DEFAULT_RENTABLE_NIGHTS,
    currentAddress,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment,
    isFetched: buyerSettings.isFetched,
    isError: buyerSettings.isError,
    error: buyerSettings.error,
    refetch: buyerSettings.refetch
  };
}; // For display purposes

const useBuyerSettings = () => {
  var _buyerSettings$data;

  const buyerSettings = useBuyerSettingsQuery();
  const {
    clientType,
    currentAddress,
    affordability,
    maxBudget,
    currentMonthlyCost,
    yearsInHome,
    downPayment,
    rentableNights,
    eligibleForPrequal
  } = (_buyerSettings$data = buyerSettings == null ? void 0 : buyerSettings.data) != null ? _buyerSettings$data : {};
  return {
    clientType,
    currentAddress,
    affordability,
    maxBudget,
    currentMonthlyCost,
    yearsInHome,
    downPayment,
    rentableNights,
    eligibleForPrequal,
    isFetched: buyerSettings.isFetched
  };
};

const useShouldRequestPrequal = () => {
  var _useAsync;

  const {
    eligibleForPrequal
  } = useBuyerSettings();
  const {
    isSoloRea
  } = useBranding();

  const noop = () => {};

  const result = (_useAsync = useAsync(async () => oncePer24Hours(BUYER_PREQUAL_PROMPT), {
    executeOnMount: true
  })) != null ? _useAsync : {};
  return Object.assign({}, result, {
    execute: eligibleForPrequal ? result == null ? void 0 : result.execute : noop,
    value: eligibleForPrequal && !isSoloRea && !!(result != null && result.executeValue)
  });
};

const useZillowListingUrl = () => {
  const {
    proxiedZillowUrl
  } = useContext(ZillowContext);
  const {
    devMode
  } = useContext(AppContext);
  return devMode ? proxiedZillowUrl : window.location.origin + window.location.pathname;
};

const useListingEvaluationQuery = (address, listingPrice, marketTempSliderPrice, appreciationSliderPercent, includeRental) => {
  const authSettings = useAuthSettings();
  const price = marketTempSliderPrice || listingPrice;
  return useQuery(['listingEvaluation', address, price, appreciationSliderPercent, includeRental], () => getListingEvaluationByAddressAndPrice(authSettings, address, price, appreciationSliderPercent, includeRental), Object.assign({}, getQueryDefaults(), {
    enabled: Boolean(address && price && authSettings)
  }));
};
const useValidateListingEvaluationQuery = (address, listingPrice) => {
  const authSettings = useAuthSettings();
  return useQuery(['listingEvaluationValidation', address, listingPrice], () => getListingEvaluationByAddressAndPrice(authSettings, address, listingPrice), Object.assign({}, getQueryDefaults(), {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: false // turned off by default, manual refetch is needed

  }));
};
const useAppreciationIndicatorQuery = (address, price) => {
  const authSettings = useAuthSettings();
  return useQuery(['listingAppreciationIndicator', address, price], () => getAppreciationIndicatorByAddressAndPrice(authSettings, address, price), Object.assign({}, getQueryDefaults(), {
    enabled: Boolean(address && price && authSettings)
  }));
};
const useMarketTempIndicatorQuery = (address, price) => {
  const authSettings = useAuthSettings();
  return useQuery(['listingMarketTempIndicator', address, price], () => getMarketTempIndicatorByAddressAndPrice(authSettings, address, price), Object.assign({}, getQueryDefaults(), {
    enabled: Boolean(address && price && authSettings)
  }));
};
const useListingRentalPotentialQuery = address => {
  const authSettings = useAuthSettings();
  return useQuery(['listingRentalPotential', address], () => getListingRentalPotentialByAddress(authSettings, address), Object.assign({}, getQueryDefaults(), {
    enabled: Boolean(address && authSettings)
  }));
};

const GREEN = 'green';
const ORANGE = 'orange';
const RED = 'red';

const POSSIBLE_GAIN = 'Possible gain';
const POSSIBLE_LOSS = 'Possible loss'; // RENTER INDICATORS

const POSSIBLY_SAVE = 'Possibly save';
const POSSIBLY_LOSE = 'Possibly lose'; // BUDGET INDICATORS

const OVER_BUDGET = 'Over budget';
const UNDER_BUDGET = 'Under budget';

const FALLBACK_APPRECIATION_PERCENT = 2.5;
const STEADY_APPRECIATION_PERCENT = 3.25;
const FAST_APPRECIATION_PERCENT = 4;

const LISTING_CAUTION_FACTOR = 1.1;
const getListingRecommendationStatus = (potentialSavings, listingMonthlyCost, maxBudget) => {
  if (isNaN(potentialSavings) || isNaN(listingMonthlyCost) || isNaN(maxBudget)) {
    return null;
  }

  if (potentialSavings >= 0) {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return GREEN;else return ORANGE;
  } else {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return ORANGE;else return RED;
  }
};
const getHomeownerListingRecommendationStatus = (totalBuyCost, listingMonthlyCost, maxBudget) => {
  if (isNaN(totalBuyCost) || isNaN(listingMonthlyCost) || isNaN(maxBudget)) {
    return null;
  }

  if (totalBuyCost < 0) {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return GREEN;else return ORANGE;
  } else {
    if (listingMonthlyCost <= maxBudget * LISTING_CAUTION_FACTOR) return ORANGE;else return RED;
  }
};
const getListingRecommendationDecorators = status => {
  switch (status) {
    case GREEN:
      return {
        color: GREEN,
        text: 'Smart',
        theme: 'success'
      };

    case ORANGE:
      return {
        color: ORANGE,
        text: 'Fair',
        theme: 'warning'
      };

    case RED:
      return {
        color: RED,
        text: 'Weak',
        theme: 'danger'
      };

    default:
      return {
        color: null,
        text: '',
        theme: 'none'
      };
  }
};
const getListingZipcode = address => {
  if (!address) {
    return null;
  }

  const {
    zip
  } = parser.parseLocation(address);
  return zip;
};
const getListingStreet = address => {
  if (!address) {
    return null;
  }

  const addressObject = parser.parseLocation(address);
  const {
    number,
    prefix,
    street,
    type,
    suffix
  } = addressObject;
  const streetNumber = number || '';
  const streetPrefix = prefix || '';
  const streetName = street || '';
  const streetType = type || '';
  const streetSuffix = suffix || '';
  return `${streetNumber} ${streetPrefix} ${streetName} ${streetType} ${streetSuffix}`.replace(/\s+/g, ' ').trim();
};
const getAppreciationIndicator = (annualAppreciationPercent, yearsOfData) => {
  const appreciationPercent = yearsOfData === null || yearsOfData === 0 ? FALLBACK_APPRECIATION_PERCENT : annualAppreciationPercent;

  if (!appreciationPercent) {
    return null;
  }

  const indicator = {
    appreciationPercent,
    yearsOfData
  };

  if (appreciationPercent >= 5) {
    return decorateIndicator(indicator, GREEN);
  } else {
    return decorateIndicator(indicator, ORANGE);
  }
};
const getMarketTempIndicator = marketTemp => {
  if (!marketTemp) {
    return null;
  }

  const indicator = {
    marketTemp
  };

  if (marketTemp >= 60) {
    return decorateIndicator(indicator, ORANGE);
  }

  return decorateIndicator(indicator, GREEN);
};

const decorateIndicator = (indicator, color) => {
  if (color === GREEN) {
    return Object.assign({}, indicator, {
      color,
      text: 'Smart',
      theme: 'success'
    });
  } else if (color === ORANGE) {
    return Object.assign({}, indicator, {
      color,
      text: 'Fair',
      theme: 'warning'
    });
  } else if (color === RED) {
    return Object.assign({}, indicator, {
      color,
      text: 'Weak',
      theme: 'danger'
    });
  } else {
    return Object.assign({}, indicator, {
      color: null,
      text: '',
      theme: 'none'
    });
  }
};

const validate = (address, listingPrice) => {
  const errorMessages = [];

  if (address && typeof address !== 'string') {
    errorMessages.push("Address provided is not of type 'string'");
  }

  if (listingPrice && typeof listingPrice !== 'number') {
    errorMessages.push("Listing Price provided is not of type 'number'");
  }

  if (typeof listingPrice === 'number' && listingPrice <= 0) {
    errorMessages.push('Listing Price provided is not a positive value');
  }

  const addressValid = address && address.length;
  const priceValid = typeof listingPrice === 'number';
  return {
    refetch: () => {// refetch from react query
    },
    isError: errorMessages.length,
    error: errorMessages.length ? new Error(errorMessages.join(', ')) : null,
    isFetched: errorMessages.length === 0 && addressValid && priceValid
  };
};

const useZillowListingData = () => {
  const url = useZillowListingUrl();
  const {
    address,
    listingPrice,
    isAddressError,
    isListingPriceError
  } = useContext(ZillowContext);

  if (listingRegex.test(url)) {
    var _match$groups;

    const match = url.match(listingRegex);
    const id = match == null ? void 0 : (_match$groups = match.groups) == null ? void 0 : _match$groups.id;
    const validation = validate(address, listingPrice);
    const zillowDomError = isAddressError || isListingPriceError;
    return Object.assign({
      data: {
        id,
        url,
        address,
        listingPrice
      }
    }, validation, {
      zillowDomError,
      isError: validation.isError || isAddressError || isListingPriceError,
      isFetched: validation.isFetched || isAddressError || isListingPriceError
    });
  }
};

const useProvidedListingData = () => {
  const {
    address,
    listingPrice
  } = useContext(AppContext);
  const validation = validate(address, listingPrice);
  return Object.assign({
    data: {
      address,
      listingPrice
    }
  }, validation);
};

const useRawListingData = () => {
  const isZillow = useIsZillow();
  const zillowFields = useZillowListingData();
  const providedFields = useProvidedListingData();

  if (isZillow) {
    return zillowFields;
  }

  return providedFields;
}; // Need anything returned by these {5} endpoints in one tidy package?
// Use with CAUTION: {5} endpoints means increased edge cases, only use optimisticly


const useFullListingData = () => {
  var _rawListing$data;

  const {
    marketTempSliderPrice,
    appreciationSliderPercent,
    includeRental
  } = useContext(AppContext);
  const rawListing = useRawListingData(); // Dependant on rawListing

  const {
    address,
    listingPrice
  } = (_rawListing$data = rawListing == null ? void 0 : rawListing.data) != null ? _rawListing$data : {};
  const listingEvaluation = useListingEvaluationQuery(address, listingPrice, marketTempSliderPrice, appreciationSliderPercent, includeRental);
  const marketTempIndicator = useMarketTempIndicator();
  const appreciationIndicator = useAppreciationIndicatorQuery(address, listingPrice);
  const listingRentalPotential = useListingRentalPotentialQuery(address);
  return Object.assign({}, rawListing.data, listingEvaluation == null ? void 0 : listingEvaluation.data, appreciationIndicator == null ? void 0 : appreciationIndicator.data, marketTempIndicator == null ? void 0 : marketTempIndicator.data, listingRentalPotential.data);
}; // For most UI, determines "status" (aka color) and drives a lot of copy
// Very number crunchy with async dependancies, ensure safe "default" behavior

const useListingDisplay = () => {
  var _rawListing$data2, _listingEvaluation$da;

  const {
    marketTempSliderPrice,
    appreciationSliderPercent,
    includeRental
  } = useContext(AppContext); // Data

  const buyerSettings = useBuyerSettingsWithDefaults();
  const rawListing = useRawListingData(); // Dependant on rawListing

  const {
    address,
    listingPrice
  } = (_rawListing$data2 = rawListing == null ? void 0 : rawListing.data) != null ? _rawListing$data2 : {};
  const listingEvaluation = useListingEvaluationQuery(address, listingPrice, marketTempSliderPrice, appreciationSliderPercent, includeRental);
  const {
    maxBudget,
    yearsInHome,
    currentAddress,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment
  } = buyerSettings;
  const {
    savingsValues,
    breakEvenYears,
    monthlyCost,
    monthlyCostBreakdown,
    totalBuyCost,
    totalCurrentCost,
    mostRecentInterestRate
  } = (_listingEvaluation$da = listingEvaluation == null ? void 0 : listingEvaluation.data) != null ? _listingEvaluation$da : {};
  const savingsValue = savingsValues && savingsValues.length >= yearsInHome ? savingsValues[yearsInHome - 1] : null;
  const streetAddress = getListingStreet(address);
  let status;
  const isOwner = useIsOwner();

  if (isOwner) {
    status = getHomeownerListingRecommendationStatus(totalBuyCost, monthlyCost, maxBudget);
  } else {
    status = getListingRecommendationStatus(savingsValue, monthlyCost, maxBudget);
  }

  const budgetDiff = monthlyCost - maxBudget;
  const decoratorStatus = listingEvaluation.isPreviousData ? null : status;
  const decorators = getListingRecommendationDecorators(decoratorStatus);
  return Object.assign({}, listingEvaluation, {
    address,
    listingPrice,
    yearsInHome,
    currentAddress,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment,
    monthlyCost,
    streetAddress,
    savingsValue,
    savingsValues,
    breakEvenYears,
    monthlyCostBreakdown,
    status,
    totalBuyCost,
    totalCurrentCost,
    mostRecentInterestRate,
    budgetDiff,
    zillowDomError: rawListing == null ? void 0 : rawListing.zillowDomError
  }, decorators, {
    // color, text, theme
    refetch: () => {
      buyerSettings == null ? void 0 : buyerSettings.refetch();
      rawListing == null ? void 0 : rawListing.refetch();
      listingEvaluation == null ? void 0 : listingEvaluation.refetch();
    },
    isError: (buyerSettings == null ? void 0 : buyerSettings.isError) || (rawListing == null ? void 0 : rawListing.isError) || (listingEvaluation == null ? void 0 : listingEvaluation.isError),
    error: (buyerSettings == null ? void 0 : buyerSettings.error) || (rawListing == null ? void 0 : rawListing.error) || (listingEvaluation == null ? void 0 : listingEvaluation.error),
    isFetched: (rawListing == null ? void 0 : rawListing.isError) || (buyerSettings == null ? void 0 : buyerSettings.isFetched) && (rawListing == null ? void 0 : rawListing.isFetched) && (listingEvaluation == null ? void 0 : listingEvaluation.isFetched) && !listingEvaluation.isPreviousData
  });
};
const useAppreciationIndicator = () => {
  var _rawListing$data3, _rawListing$data4, _indicator$data;

  const rawListing = useRawListingData();
  const indicator = useAppreciationIndicatorQuery(rawListing == null ? void 0 : (_rawListing$data3 = rawListing.data) == null ? void 0 : _rawListing$data3.address, rawListing == null ? void 0 : (_rawListing$data4 = rawListing.data) == null ? void 0 : _rawListing$data4.listingPrice);
  const {
    annualAppreciationPercent,
    yearsOfData
  } = (_indicator$data = indicator == null ? void 0 : indicator.data) != null ? _indicator$data : {};
  return getAppreciationIndicator(annualAppreciationPercent, yearsOfData);
};
const useMarketTempIndicator = () => {
  var _rawListing$data5, _rawListing$data6, _indicator$data2;

  const rawListing = useRawListingData();
  const indicator = useMarketTempIndicatorQuery(rawListing == null ? void 0 : (_rawListing$data5 = rawListing.data) == null ? void 0 : _rawListing$data5.address, rawListing == null ? void 0 : (_rawListing$data6 = rawListing.data) == null ? void 0 : _rawListing$data6.listingPrice);
  const {
    marketTemp
  } = (_indicator$data2 = indicator == null ? void 0 : indicator.data) != null ? _indicator$data2 : {};
  return getMarketTempIndicator(marketTemp);
};
const useListingError = () => {
  const {
    isError,
    error,
    zillowDomError
  } = useListingDisplay();
  return {
    isError,
    error,
    isZillowDomError: zillowDomError
  };
};

const getBranding = async (authSettings, address) => {
  const client = await buildMikasaClient(authSettings);
  let endpoint = 'chromebot/branding';

  if (address) {
    const zip = getListingZipcode(address);

    if (zip) {
      endpoint += `?zip=${zip}`;
    }
  }

  const response = await client.get(endpoint);
  return response == null ? void 0 : response.data;
};

const useQueryPrefetches = () => {
  const queryClient = useQueryClient();
  const authSettings = useAuthSettings();
  const isChromeExtension = useIsExtension();
  const hasDefaults = Boolean(queryClient && authSettings);
  const defaultOptions = {
    queryClient,
    authSettings,
    isChromeExtension
  };
  const {
    address,
    listingPrice
  } = useListingDisplay();
  useAddressAndPricePrefetch(hasDefaults ? defaultOptions : null, address, listingPrice);
};

const useAddressAndPricePrefetch = (options, address, listingPrice) => {
  const {
    queryClient,
    authSettings,
    isChromeExtension
  } = options || {};
  useEffect(() => fireAddressAndPricePrefetch(queryClient, authSettings, address, listingPrice, isChromeExtension), [queryClient, authSettings, address, listingPrice, isChromeExtension]);
};

const fireAddressAndPricePrefetch = (queryClient, authSettings, address, listingPrice, isChromeExtension) => {
  if (queryClient && authSettings && address && listingPrice) {
    if (isChromeExtension) {
      queryClient.prefetchQuery('access', () => getAccess(authSettings));
    }

    queryClient.prefetchQuery(['listingEvaluation', address, listingPrice], () => getListingEvaluationByAddressAndPrice(authSettings, address, listingPrice));
    queryClient.prefetchQuery(['listingAppreciationIndicator', address, listingPrice], () => getAppreciationIndicatorByAddressAndPrice(authSettings, address, listingPrice));
    queryClient.prefetchQuery(['listingMarketTempIndicator', address, listingPrice], () => getMarketTempIndicatorByAddressAndPrice(authSettings, address, listingPrice));
    queryClient.prefetchQuery(['listingRentalPotential', address], () => getListingRentalPotentialByAddress(authSettings, address));
    queryClient.prefetchQuery(['branding', address], () => getBranding(authSettings, address));
    queryClient.prefetchQuery(['clientEvents'], () => getChromeBotClientEvents(authSettings));
  }
};

const isChromeExtension = true; // TODO: won't be true forever...

const noop$1 = () => {};

const sendMessage = (...args) => {
  if (chrome && chrome.runtime && isChromeExtension) {
    return chrome.runtime.sendMessage(...args);
  } else {
    return noop$1;
  }
};

const postGAEvent = ({
  event,
  clientId
}) => {
  if (event && gaMeasurementId && gaApiSecret) {
    // Post to Google Analytics endpoint
    return fetch(`https://www.google-analytics.com/mp/collect?measurement_id=${gaMeasurementId}&api_secret=${gaApiSecret}`, {
      method: 'post',
      body: JSON.stringify({
        client_id: clientId != null ? clientId : 'GUEST',
        events: [event]
      })
    });
  }
};

const useLogGAEvent = (name, {
  debounceInterval
} = {}) => {
  const [token, setToken] = useState(null);
  const [bounceTimer, setBounceTimer] = useState(null);
  const [queuedArgs, setQueuedArgs] = useState(null);
  const widgetMode = useWidgetMode();
  const isExtension = useIsExtension();
  const authSettings = useAuthSettings();

  if (!token && (authSettings == null ? void 0 : authSettings.scheme) === BEARER_PREFIX && authSettings != null && authSettings.token) {
    try {
      const jwt = parseJWT(authSettings.token);
      setToken(jwt);
    } catch (e) {
      console.warn('Unable to parse provided JWT');
    }
  }

  const execute = useCallback((params = {}) => {
    let clientId;
    const event = {
      name,
      params: Object.assign({
        widgetMode
      }, params)
    };

    if (token) {
      var _token$acr;

      const tokenValues = (_token$acr = token.acr) == null ? void 0 : _token$acr.values;
      const clientValue = tokenValues && tokenValues.length ? tokenValues[0].context : null;

      if (clientValue.replace) {
        clientId = clientValue.replace('client:', '');
      }
    }

    const sendArgs = {
      clientId,
      event
    };

    if (getIsHomebotDomain()) {
      postGAEvent(sendArgs);
    } else if (isExtension) {
      // Don't post apiSecrets and GA stuff from extension DOM, send via background service worker
      sendMessage(Object.assign({}, sendArgs, {
        type: GA_SEND_EVENT
      }));
    } else {
      console.warn('WARNING: GA events will not be logged unless built with CHROME_EXTENSION widget mode or we are on a Homebot domain');
    }
  }, [token, name, widgetMode, isExtension]);
  const fireAndForget = useCallback((...args) => {
    if (!token && !queuedArgs) {
      setQueuedArgs(args);
    } else if (!bounceTimer) {
      execute(...args);

      if (debounceInterval && !isNaN(debounceInterval)) {
        const timer = setTimeout(() => setBounceTimer(null), debounceInterval);
        setBounceTimer(timer);
      }
    } else {
      clearTimeout(bounceTimer);
      const timer = setTimeout(() => setBounceTimer(null), debounceInterval);
      setBounceTimer(timer);
    }
  }, [token, execute, bounceTimer, debounceInterval, queuedArgs]);
  useEffect(() => {
    if (token && queuedArgs) {
      execute(...queuedArgs);
      setQueuedArgs(null);
    }
  }, [queuedArgs, token, execute]);
  return fireAndForget;
};

var css_248z$1d = ".Svg-module_svg__CUM79 {\n  width: 100%;\n  height: 100%;\n}";
var styles$1b = {"svg":"Svg-module_svg__CUM79"};
styleInject(css_248z$1d);

var _jsxFileName$1L = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svg.jsx";
const propTypes$8 = {
  className: PropTypes.string,
  xmlns: PropTypes.string,
  xlink: PropTypes.string,
  viewBox: PropTypes.string.isRequired
};
const defaultProps$2 = {
  xmlns: 'http://www.w3.org/2000/svg',
  xlink: 'http://www.w3.org/1999/xlink'
};

const Svg = props => /*#__PURE__*/React__default.createElement("svg", _extends$1({
  className: styles$1b.svg
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$1L,
    lineNumber: 18,
    columnNumber: 24
  }
}));

Svg.propTypes = propTypes$8;
Svg.defaultProps = defaultProps$2;

var _jsxFileName$1K = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/HomebotIcon.svg.jsx";

const HomebotIcon = props => {
  return /*#__PURE__*/React__default.createElement(Svg, {
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    fill: "none",
    __self: window,
    __source: {
      fileName: _jsxFileName$1K,
      lineNumber: 7,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.952 10c0 5.497-4.456 9.952-9.952 9.952C4.503 19.952.048 15.497.048 10S4.503.048 10 .048c5.496 0 9.952 4.455 9.952 9.952zM1.16 10a8.841 8.841 0 1017.682 0A8.841 8.841 0 001.16 10z",
    fill: "#FC5AA6",
    __self: window,
    __source: {
      fileName: _jsxFileName$1K,
      lineNumber: 8,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.959 11.101a1.2 1.2 0 11-.001-2.4 1.2 1.2 0 01.001 2.4zm-3.895 0a1.2 1.2 0 11-.001-2.4 1.2 1.2 0 01.001 2.4zm-1.163 3.225h6.203a.78.78 0 00.78-.78v-1.32h.457a.42.42 0 00.42-.42v-1.697a.42.42 0 00-.42-.42h-.457V8.027a.78.78 0 00-.78-.779h-2.885V6.78a1.232 1.232 0 10-.442-.01v.477H6.9a.78.78 0 00-.78.78V9.69h-.463a.42.42 0 00-.42.42v1.696c0 .231.188.42.42.42h.464v1.32c0 .43.349.78.78.78zm.251-1.602c0-.284.23-.514.514-.514h4.8a.514.514 0 010 1.027h-4.8a.514.514 0 01-.514-.513z",
    fill: "#F3EFF1",
    __self: window,
    __source: {
      fileName: _jsxFileName$1K,
      lineNumber: 14,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1J = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/BudgetRightArrow.svg.jsx";

const BudgetRightArrow = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1J,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm-.036 10.25L10.214 6l-4.25-4.25L4.75 2.964l2.179 2.179H1.714v1.714H6.93L4.75 9.036l1.214 1.214z",
    fill: "currentColor",
    __self: window,
    __source: {
      fileName: _jsxFileName$1J,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1I = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Check.svg.jsx";

const Check = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    height: "1em",
    viewBox: "0 0 14 12",
    width: "1em"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1I,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.688.556L14 1.868l-9.188 9.188L0 6.243l1.313-1.312 3.5 3.5z",
    fill: "#3ce967",
    fillRule: "evenodd",
    __self: window,
    __source: {
      fileName: _jsxFileName$1I,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1H = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Chart.svg.jsx";

const Chart$1 = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 12 11"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1H,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.119 5.796L5.196 3.919l-4.182 6.63c-.107.166-.238.249-.392.249-.154 0-.285-.036-.392-.107s-.178-.178-.214-.32-.012-.274.071-.405l4.491-7.045a.56.56 0 01.345-.25.52.52 0 01.416.071l2.946 1.89 2.71-3.91a.51.51 0 01.344-.213.51.51 0 01.606.428.51.51 0 01-.083.392L8.856 5.665c-.084.119-.202.19-.345.214s-.273 0-.392-.083zm.285 3.184l2.673-2.4-.012-.024a.51.51 0 01.393-.13.602.602 0 01.392.178.51.51 0 01.13.392.522.522 0 01-.178.368l-3.006 2.71c-.107.094-.226.142-.356.142s-.25-.036-.345-.107L4.685 7.47l-.653-.166.618-.963.416.107c.07.024.142.048.202.095zM1.228 6.64l-.82-.203.012-.011a.537.537 0 01-.333-.25c-.083-.13-.107-.261-.071-.404s.119-.25.25-.32.273-.096.415-.06l1.165.285z",
    fill: "#ff9545",
    fillRule: "evenodd",
    __self: window,
    __source: {
      fileName: _jsxFileName$1H,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1G = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Dog.svg.jsx";

const Dog = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 13 13"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1G,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84 4.342h2.503L13 2.654l-.653-.615-1.466.012-1.04-.947H8.234L9.123 0 7.307.443l-.525 2.013c-.282.99-.89 2.31-1.374 3.068-1.41 2.204-2.764 3.67-2.972 5.22-.92-.232-2.273-.936-2.325-3.062 0 0-.86 3.281 2.199 4.257-.052.664-.048 1.061-.048 1.061h6.846c-.054-.396-.423-.602-.67-.697l-.102-1.873-.232-.75.508-.107L9.488 13h2.833c-.084-.604-.898-.765-.898-.765h-.56l-.779-2.804-.245-1.228-.767-3.05.401-1.007z",
    fill: "#3ce967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1G,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1F = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/LightBulb.svg.jsx";

const LightBulb = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 26 26"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1F,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5.91A7.09 7.09 0 0120.09 13a7.107 7.107 0 01-3.545 6.146v2.127a1.182 1.182 0 01-1.181 1.181h-4.728a1.182 1.182 0 01-1.181-1.181v-2.127A7.107 7.107 0 015.909 13 7.091 7.091 0 0113 5.91zm2.364 17.726v1.182A1.182 1.182 0 0114.182 26h-2.364a1.182 1.182 0 01-1.182-1.182v-1.182zm7.09-11.818H26v2.364h-3.546zM0 11.818h3.545v2.364H0zM14.182 0v3.545h-2.364V0zm-9.55 2.955L7.15 5.484 5.472 7.15 2.955 4.645zM18.85 5.472l2.506-2.517 1.69 1.69-2.518 2.505z",
    fill: "#98979c",
    __self: window,
    __source: {
      fileName: _jsxFileName$1F,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1E = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Gear.svg.jsx";

const Gear = props => {
  return /*#__PURE__*/React__default.createElement(Svg, _extends$1({
    viewBox: "0 0 20 21"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 7,
      columnNumber: 5
    }
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 20.4H20V0.4H0V20.4Z",
    fill: "url(#pattern0)",
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 8,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("defs", {
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 9,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1",
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 10,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.015625)",
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 16,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("image", {
    id: "image0",
    width: "64",
    height: "64",
    xlinkHref: "data:image/png;base64,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",
    __self: window,
    __source: {
      fileName: _jsxFileName$1E,
      lineNumber: 18,
      columnNumber: 9
    }
  })));
};

var _jsxFileName$1D = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/GreenMoneyBag.svg.jsx";

const GreenMoneyBag = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 13",
    fill: "none"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1D,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.276 8.636a.618.618 0 00-.174-.126 2.093 2.093 0 00-.439-.156v1.163c.244-.027.523-.116.651-.343a.531.531 0 00.048-.363.365.365 0 00-.086-.175zM6.313 9.178l.002-.004-.002.004zM4.52 6.777a.49.49 0 00-.05.43.362.362 0 00.14.155c.065.044.137.079.21.108.06.024.13.048.203.07V6.489c-.187.04-.39.125-.503.289zM6.32 9.165l-.006.012.007-.012zM6.325 9.156c.001-.003.001-.003 0 0z",
    fill: "#3CE967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1D,
      lineNumber: 9,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.072 2.829c.99-.831 1.65-2.703 1.244-2.785-.54-.108-1.714.369-2.281.453-.805.097-1.68-.872-2.172-.332-.4.44.286 2.037 1.36 2.733-3.204 1.575-7.708 9.48.15 10.055 10.871.793 5.427-8.59 1.7-10.124zm.934 6.235a1.143 1.143 0 01-.44.776c-.259.2-.582.293-.903.319v.34c0 .091-.04.18-.108.24a.322.322 0 01-.346.05.322.322 0 01-.186-.29v-.372a2.131 2.131 0 01-.164-.038 1.57 1.57 0 01-.782-.481 1.41 1.41 0 01-.28-.514c-.011-.036-.022-.072-.026-.108a.32.32 0 01.622-.133c.012.037.02.074.034.11a.815.815 0 00.19.285c.112.11.256.18.406.222V8.205c-.293-.076-.596-.174-.838-.362a.976.976 0 01-.283-.34 1.064 1.064 0 01-.1-.458 1.09 1.09 0 01.36-.824c.235-.217.547-.337.861-.382V5.486c0-.091.04-.18.108-.24a.322.322 0 01.346-.051.323.323 0 01.186.29V5.838c.042.005.083.012.125.02.308.055.61.182.835.404a1.22 1.22 0 01.33.599.32.32 0 01-.614.162c-.014-.035-.02-.072-.034-.107a.61.61 0 00-.203-.26 1.037 1.037 0 00-.44-.17v1.21c.185.044.37.092.547.162.267.105.52.267.667.522a1.926 1.926 0 010 .001c.045.079.024.041.001.002.116.205.154.45.13.682z",
    fill: "#3CE967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1D,
      lineNumber: 13,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31 9.182l-.006.012.007-.012z",
    fill: "#3CE967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1D,
      lineNumber: 17,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1C = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/OrangeMoneyBag.svg.jsx";

const OrangeMoneyBag = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 13",
    fill: "none"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1C,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.276 8.636a.618.618 0 00-.174-.126 2.093 2.093 0 00-.439-.156v1.163c.244-.027.523-.116.651-.343a.531.531 0 00.048-.363.365.365 0 00-.086-.175zM6.313 9.178l.002-.004-.002.004zM4.52 6.777a.49.49 0 00-.05.43.362.362 0 00.14.155c.065.044.137.079.21.108.06.024.13.048.203.07V6.489c-.187.04-.39.125-.503.289zM6.32 9.165l-.006.012.007-.012zM6.325 9.156c.001-.003.001-.003 0 0z",
    fill: "#ff9545",
    __self: window,
    __source: {
      fileName: _jsxFileName$1C,
      lineNumber: 9,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.072 2.829c.99-.831 1.65-2.703 1.244-2.785-.54-.108-1.714.369-2.281.453-.805.097-1.68-.872-2.172-.332-.4.44.286 2.037 1.36 2.733-3.204 1.575-7.708 9.48.15 10.055 10.871.793 5.427-8.59 1.7-10.124zm.934 6.235a1.143 1.143 0 01-.44.776c-.259.2-.582.293-.903.319v.34c0 .091-.04.18-.108.24a.322.322 0 01-.346.05.322.322 0 01-.186-.29v-.372a2.131 2.131 0 01-.164-.038 1.57 1.57 0 01-.782-.481 1.41 1.41 0 01-.28-.514c-.011-.036-.022-.072-.026-.108a.32.32 0 01.622-.133c.012.037.02.074.034.11a.815.815 0 00.19.285c.112.11.256.18.406.222V8.205c-.293-.076-.596-.174-.838-.362a.976.976 0 01-.283-.34 1.064 1.064 0 01-.1-.458 1.09 1.09 0 01.36-.824c.235-.217.547-.337.861-.382V5.486c0-.091.04-.18.108-.24a.322.322 0 01.346-.051.323.323 0 01.186.29V5.838c.042.005.083.012.125.02.308.055.61.182.835.404a1.22 1.22 0 01.33.599.32.32 0 01-.614.162c-.014-.035-.02-.072-.034-.107a.61.61 0 00-.203-.26 1.037 1.037 0 00-.44-.17v1.21c.185.044.37.092.547.162.267.105.52.267.667.522a1.926 1.926 0 010 .001c.045.079.024.041.001.002.116.205.154.45.13.682z",
    fill: "#ff9545",
    __self: window,
    __source: {
      fileName: _jsxFileName$1C,
      lineNumber: 13,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31 9.182l-.006.012.007-.012z",
    fill: "#ff9545",
    __self: window,
    __source: {
      fileName: _jsxFileName$1C,
      lineNumber: 17,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1B = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Rabbit.svg.jsx";

const Rabbit = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 14 12"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1B,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 2.835c-2.24 0-3.63 1.497-3.63 3.393 0 .92.737 2.993 5.721 5.363.262.12.682.409 1.718.409h2.408c0-.985-.878-.957-2.8-.995-.01-2.62-.532-4.182-2.268-5.855l-.738.074c2.632 1.208 3.472 2.78 3.472 4.833l2.754-2.063-1.932-2.129c-.579-.78-1.97-3.03-4.704-3.03zm-2.22 7.743c-.505.018-.897.307-.897.957 0 0 1.923.019 3.286-.39l-1.382-.734a3.363 3.363 0 01-1.008.167zm7.643-5.075l.906-.354C11.219 2.798 10.033 1.042 8.297 0c0 1.72.878 3.588 2.576 5.503zM12.217 0c-.756 1.46-.756 3.16 0 4.517.738-1.357.738-3.058 0-4.517zM9.455 6.516l2.632 1.487c.886 0 1.913-.111 1.913-.8 0-1.105-1.652-2.444-2.856-2.054zM0 6.469c0 1.897 2.93 1.897 2.93 0 0-1.821-2.93-1.821-2.93 0z",
    fill: "#3ce967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1B,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1A = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/SnowflakeCool.svg.jsx";

const SnowflakeCool = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 12 14"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1A,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.665 8.268l-1.503.402-1.29-.734V6.064l1.29-.734 1.503.403L12 4.478l-1.141-.305.296-1.151-1.244-.338-.4 1.515-1.29.734-1.58-.936V2.528l1.103-1.111L6.83.5l-.832.839L5.165.5l-.916.917 1.103 1.111v1.469l-1.612.936-1.29-.734-.374-1.515-1.238.338.303 1.15L0 4.479l.335 1.255 1.503-.403 1.29.734v1.879l-1.29.734-1.503-.403L0 9.529l1.141.305-.303 1.144 1.245.338.4-1.514 1.29-.735 1.579.936v1.469l-1.103 1.111.916.917.832-.839.832.839.909-.917-1.096-1.111v-1.469l1.612-.943 1.29.735.399 1.514 1.212-.331-.303-1.15 1.142-.306zm-7.28-2.204l1.612-.943 1.612.943v1.872l-1.612.943-1.612-.943z",
    fill: "#3ce967",
    __self: window,
    __source: {
      fileName: _jsxFileName$1A,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1z = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Thumb.svg.jsx";

const Thumb = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 17 17"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1z,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2921 8.27938C16.6254 8.75557 16.8 9.34287 16.8 9.9143C16.8 10.4857 16.6254 11.073 16.2921 11.5492C16.3874 12.3746 16.1016 13.2159 15.5302 13.8349C15.2921 15.1841 14.1016 16.2 12.7207 16.2H9.94291C8.46672 16.2 6.75243 15.6921 5.37148 15.1524V16.2H0.800049V5.9143H5.16513L7.45084 3.51747C7.83179 3.13652 8.14926 2.37462 8.14926 1.83493C8.14926 0.930171 8.87941 0.200012 9.78418 0.200012H10.5143C12.054 0.200012 12.8794 1.6762 12.8794 3.05715C12.8794 3.73969 12.7207 4.5016 12.3874 5.10477H13.4508C15.0223 5.10477 16.308 6.39049 16.308 7.96192C16.308 8.07303 16.308 8.18414 16.2921 8.27938ZM4.22862 15.0572V7.05716H1.94291V15.0572H4.22862ZM15.0381 11.2318C15.435 10.8984 15.6572 10.4222 15.6572 9.9143C15.6572 9.40636 15.435 8.93017 15.0381 8.59684C15.1175 8.39049 15.1651 8.16827 15.1651 7.96192C15.1651 7.00954 14.4032 6.24763 13.4508 6.24763H10.2762C10.9905 5.16827 11.7366 4.37462 11.7366 3.05715C11.7366 2.327 11.3715 1.34287 10.5143 1.34287C10.1175 1.34287 9.29211 1.20001 9.29211 1.83493C9.29211 2.6762 8.89529 3.6762 8.30799 4.27938L5.37148 7.34287V13.9143C6.64132 14.4699 8.51434 15.0572 9.94291 15.0572H12.7207C13.6572 15.0572 14.4826 14.2794 14.435 13.3429V13.2794C14.8953 12.9619 15.1651 12.4381 15.1651 11.8667C15.1651 11.6603 15.1175 11.4381 15.0381 11.2318Z",
    fill: "#41B9FA",
    __self: window,
    __source: {
      fileName: _jsxFileName$1z,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1y = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Turtle.svg.jsx";

const Turtle = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    viewBox: "0 0 16 10"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1y,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.31 3.841c-.811.455-.786 1.567-2.77 3.054-.484.362.511 2.262.08 2.686-.438.431-2.195.452-2.62.217-.625-.346-.135-1.25.005-2.57-1.281.127-1.696.106-2.984.054.196 1.001.484 2.114.067 2.481-.34.299-1.99.331-2.507.004-.646-.41.468-2.74.09-2.779-.434-.043-3.084.058-2.616-2.735.496.704 1.344 1.366 2.317 1.069.133-2.37 1.613-4.5 3.975-4.5s4.032 1.779 4.045 3.984c1.399-1.02.37-3.527 2.047-4.464 1.193-.668 2.589-.323 3.254.735.348.552.456 1.526.026 2.06-.642.797-1.853.392-2.41.704z",
    fill: "#ff9545",
    __self: window,
    __source: {
      fileName: _jsxFileName$1y,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1x = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Pencil.svg.jsx";

const Pencil = props => /*#__PURE__*/React.createElement(Svg, _extends$1({
  viewBox: "0 0 12 12",
  fill: "none"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$1x,
    lineNumber: 7,
    columnNumber: 3
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.429 0L12 2.571v1.286l-7.286 7.286L0 12l.857-4.714L8.143 0h1.286zM4.298 10.345l4.44-4.428-2.655-2.655-4.428 4.44-.595 3.239 3.238-.596zM11.143 3.5v-.571L9.07.857H8.5L6.69 2.655 9.345 5.31l1.798-1.81z",
  fill: "#06A3F7",
  __self: window,
  __source: {
    fileName: _jsxFileName$1x,
    lineNumber: 8,
    columnNumber: 5
  }
}));

var _jsxFileName$1w = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/ExclamationTriangle.svg.jsx";

const ExclamationTriangle = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    viewBox: "0 0 36 32",
    fill: "none"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1w,
      lineNumber: 7,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.813 24.75c0-1.531-1.282-2.813-2.813-2.813-1.531 0-2.813 1.282-2.813 2.813 0 1.531 1.282 2.813 2.813 2.813 1.531 0 2.813-1.282 2.813-2.813zm-1.125-4.5L20.25 9h-4.5l.563 11.25h3.375zM20.813 0L36 27l-3.375 4.5H3.375L0 27 15.188 0h5.624z",
    fill: "#BBB2B7",
    __self: window,
    __source: {
      fileName: _jsxFileName$1w,
      lineNumber: 8,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1v = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Envelope.svg.jsx";

const Envelope = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    viewBox: "0 0 116 108",
    width: 116,
    height: 108,
    fill: "none"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.046 74.796L110.7 41.587a3.165 3.165 0 00-.089-5.104L59.849.583a3.176 3.176 0 00-3.667 0L5.42 36.483a3.166 3.166 0 00-.09 5.104l43.656 33.21h18.06z",
    fill: "#9D989B",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 9,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__filter0_bd)",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 13,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.257 12.14a2 2 0 012-2h93.572V72.86a2 2 0 01-2 2H12.257a2 2 0 01-2-2V12.14z",
    fill: "#535058",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 14,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.965,
    y: 32.792,
    width: 76.371,
    height: 5.393,
    rx: 2.697,
    fill: "#BBB2B7",
    fillOpacity: 0.2,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 19,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.965,
    y: 21.358,
    width: 76.371,
    height: 5.393,
    rx: 2.697,
    fill: "#BBB2B7",
    fillOpacity: 0.2,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 28,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.067,
    y: 43.795,
    width: 47.462,
    height: 5.393,
    rx: 2.697,
    fill: "#BBB2B7",
    fillOpacity: 0.2,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 37,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.786 107.869H7.262a3.171 3.171 0 01-3.173-3.169V38.786c0-.488-1.017 1.41 3.816 4.718l40.706 31.038h18.826l43.504-33.074c.763-1.017 1.017-1.78 1.017-2.682V104.7a3.17 3.17 0 01-3.172 3.169z",
    fill: "#BBB2B7",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 46,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.107 106.552l43.957-32.138h17.92l43.957 32.138a3.131 3.131 0 01-2.548 1.317H7.655a3.13 3.13 0 01-2.548-1.317z",
    fill: "#B5ADB1",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 50,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94 106.552L66.983 74.414h-8.96v33.455h50.369c1.049 0 1.976-.52 2.548-1.317z",
    fill: "#C4BCC5",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 54,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.682 75.765c0 7.612-6.152 13.78-13.737 13.78s-13.737-6.168-13.737-13.78c0-7.612 6.152-13.78 13.737-13.78s13.737 6.168 13.737 13.78z",
    fill: "#37393B",
    stroke: "#FC5AA6",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 58,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.747 77.345a1.72 1.72 0 01-1.717-1.72c0-.952.77-1.722 1.717-1.722.95 0 1.718.77 1.718 1.721 0 .95-.768 1.721-1.718 1.721zm-5.571 0a1.72 1.72 0 01-1.718-1.72c0-.952.769-1.722 1.718-1.722s1.718.77 1.718 1.721c0 .95-.77 1.721-1.718 1.721zm-1.663 4.627h8.872c.616 0 1.116-.5 1.116-1.118v-1.896h.654c.333 0 .602-.27.602-.602v-2.434a.602.602 0 00-.602-.602h-.654v-2.387c0-.617-.5-1.117-1.116-1.117H58.26v-.67a1.767 1.767 0 00-.281-3.511c-.974 0-1.763.79-1.763 1.766 0 .855.605 1.568 1.411 1.731v.684h-4.114c-.615 0-1.115.5-1.115 1.117v2.387h-.663c-.332 0-.6.27-.6.602v2.434c0 .333.268.602.6.602h.663v1.896c0 .617.5 1.118 1.116 1.118zm.358-2.299c0-.407.33-.737.737-.737h6.863a.737.737 0 110 1.474h-6.862a.737.737 0 01-.738-.737z",
    fill: "#fff",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 63,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("defs", {
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 69,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__filter0_bd",
    x: -98.474,
    y: -98.592,
    width: 313.035,
    height: 282.184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 79,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 54.366,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 80,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 81,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 86,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 90,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 91,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 92,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 93,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape",
    __self: window,
    __source: {
      fileName: _jsxFileName$1v,
      lineNumber: 94,
      columnNumber: 11
    }
  }))));
};

var _jsxFileName$1u = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Chevron.svg.jsx";

const Chevron = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    fill: "none",
    height: "13",
    viewBox: "0 0 26 13",
    width: "26"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1u,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1 1 12.1212 10 11.5152-10",
    stroke: "#41b9fa",
    strokeWidth: "2",
    __self: window,
    __source: {
      fileName: _jsxFileName$1u,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};

var _jsxFileName$1t = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Times.svg.jsx";

const Times = props => /*#__PURE__*/React.createElement(Svg, _extends$1({
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$1t,
    lineNumber: 7,
    columnNumber: 3
  }
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 0.910714L9.41071 8.5L17 16.0893L16.0893 17L8.5 9.41071L0.910714 17L0 16.0893L7.58929 8.5L0 0.910714L0.910714 0L8.5 7.58929L16.0893 0L17 0.910714Z",
  fill: "#06A3F7",
  __self: window,
  __source: {
    fileName: _jsxFileName$1t,
    lineNumber: 13,
    columnNumber: 5
  }
}));

var _jsxFileName$1s = "/home/circleci/app/libs/listings-bot/src/components/Svg/Svgs/Lock.svg.jsx";

const Lock = props => {
  return /*#__PURE__*/React.createElement(Svg, _extends$1({
    viewBox: "0 0 20 21",
    fill: "none"
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1s,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#F3EFF1",
    __self: window,
    __source: {
      fileName: _jsxFileName$1s,
      lineNumber: 9,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 9.405,
    stroke: "#000",
    strokeOpacity: 0.04,
    strokeWidth: 1.189,
    __self: window,
    __source: {
      fileName: _jsxFileName$1s,
      lineNumber: 10,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.932 13.142c.533 0 .941-.431.941-.964a.925.925 0 00-.941-.941.925.925 0 00-.941.941c0 .533.408.964.941.964zm2.392-5.25v.964h.465c.533 0 .964.397.964.93v4.784c0 .533-.431.93-.964.93H7.075c-.533 0-.964-.397-.964-.93V9.786c0-.533.43-.93.964-.93h.465v-.964A2.371 2.371 0 019.932 5.5a2.371 2.371 0 012.392 2.392zM9.932 6.464c-.805 0-1.429.623-1.429 1.428v.964h2.857v-.964c0-.805-.623-1.428-1.428-1.428z",
    fill: "#FF9545",
    __self: window,
    __source: {
      fileName: _jsxFileName$1s,
      lineNumber: 18,
      columnNumber: 7
    }
  }));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HomebotIcon: HomebotIcon,
  BudgetRightArrow: BudgetRightArrow,
  Check: Check,
  Chart: Chart$1,
  Dog: Dog,
  LightBulb: LightBulb,
  Gear: Gear,
  GreenMoneyBag: GreenMoneyBag,
  OrangeMoneyBag: OrangeMoneyBag,
  Rabbit: Rabbit,
  SnowflakeCool: SnowflakeCool,
  Thumb: Thumb,
  Turtle: Turtle,
  Pencil: Pencil,
  ExclamationTriangle: ExclamationTriangle,
  Envelope: Envelope,
  Chevron: Chevron,
  Times: Times,
  Lock: Lock,
  'default': Svg
});

const _excluded$r = ["condition", "children"];
var _jsxFileName$1r = "/home/circleci/app/libs/listings-bot/src/components/Conditionals/Conditionals.js";
const If = ({
  condition,
  children
}) => condition ? children : null;
If.propTypes = {
  condition: PropTypes.any
};
const Unless = ({
  condition,
  children
}) => !condition ? children : null;
Unless.propTypes = {
  condition: PropTypes.any
};

const IfOwner = ({
  children
}) => {
  const {
    clientType
  } = useBuyerSettings();
  return OWNER_TYPES.includes(clientType) ? children : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1r,
      lineNumber: 28,
      columnNumber: 56
    }
  });
};

IfOwner.propTypes = {
  children: PropTypes.any
};
If.Own = IfOwner;

const UnlessOwner = ({
  children
}) => {
  const {
    clientType
  } = useBuyerSettings();
  return OWNER_TYPES.includes(clientType) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1r,
      lineNumber: 38,
      columnNumber: 45
    }
  }) : children;
};

UnlessOwner.propTypes = {
  children: PropTypes.any
};
Unless.Own = UnlessOwner;

const IfRenter = ({
  children
}) => {
  const {
    clientType
  } = useBuyerSettings();
  return RENTER_TYPES.includes(clientType) ? children : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1r,
      lineNumber: 48,
      columnNumber: 57
    }
  });
};

IfRenter.propTypes = {
  children: PropTypes.any
};
If.Rent = IfRenter;

const IfGuest = ({
  children
}) => {
  const {
    clientType
  } = useBuyerSettings();
  return GUEST_TYPES.includes(clientType) ? children : null;
};

IfGuest.propTypes = {
  children: PropTypes.any
};
If.Guest = IfGuest;
const Show = _ref => {
  let {
    condition,
    children
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$r);

  return /*#__PURE__*/React__default.createElement("div", _extends$1({}, restProps, {
    style: condition ? {} : {
      display: 'none'
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$1r,
      lineNumber: 70,
      columnNumber: 3
    }
  }), children);
};
Show.propTypes = {
  condition: PropTypes.any,
  children: PropTypes.any
};

var img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3e%3ccircle cx='64' cy='64' r='64' fill='%23FC5AA6'/%3e%3cpath fill-opacity='.2' d='M107.3 111a63.3 63.3 0 0 1-86 .5A72.1 72.1 0 0 1 52 96l1.7-6.9c-4.5-4.5-8.9-12-9.6-17.9-5.2-1.8-7.3-12.2-3.9-16.8-1.9-29 12.2-32 24-32.2 15.2-.2 27.3 6.2 24 32 4.4 3.9 2.5 15.2-2.9 15.4a37 37 0 0 1-9.6 19.6l1 6.2c8.8 2.7 20 7.8 30.5 15.5z'/%3e%3c/svg%3e";

var css_248z$1c = ".Avatar-module_root__x-hdl {\n  width: 70px;\n  height: 70px;\n  border-radius: 100%;\n  background-color: #fc5aa6;\n  overflow: hidden;\n}\n\n.Avatar-module_img__-klXi {\n  width: 100%;\n  height: 100%;\n}";
var styles$1a = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"Avatar-module_root__x-hdl","img":"Avatar-module_img__-klXi","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$1c);

const _excluded$q = ["className", "src", "alt"];
var _jsxFileName$1q = "/home/circleci/app/libs/listings-bot/src/components/Avatar/Avatar.jsx";

const Avatar = _ref => {
  let {
    className,
    src,
    alt
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$q);

  return /*#__PURE__*/React__default.createElement("div", _extends$1({
    className: classnames(styles$1a.root, className)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1q,
      lineNumber: 13,
      columnNumber: 5
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: src || img$2,
    alt: alt,
    className: styles$1a.img,
    __self: window,
    __source: {
      fileName: _jsxFileName$1q,
      lineNumber: 14,
      columnNumber: 7
    }
  }));
};

Avatar.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string
};
Avatar.defaultProps = {
  alt: 'avatar'
};

var css_248z$1b = ".BotHead-module_root__v-RsF {\n  height: 100%;\n  width: 100%;\n  border-radius: 100%;\n  background: #202020;\n}\n\n.BotHead-module_head__ueG5O {\n  transform: translate(-30%, -30%);\n}";
var styles$19 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"BotHead-module_root__v-RsF","head":"BotHead-module_head__ueG5O","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$1b);

const _excluded$p = ["className", "color"];
var _jsxFileName$1p = "/home/circleci/app/libs/listings-bot/src/components/BotHead/BotHead.jsx";

const rootProps = _ref => {
  let {
    className,
    color
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$p);

  return Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    className: classnames(styles$19.root, className),
    color: color || 'pink'
  }, restProps);
};

const BotHead = props => {
  const {
    color
  } = props;
  const cssStroke = styles$19[`color-${color}`];
  let headPathD;
  let bgColor;

  switch (color) {
    case 'green':
      headPathD = 'M44.9208 42.7658C43.2553 42.7658 41.905 41.417 41.905 39.7533C41.905 38.0887 43.2562 36.7398 44.9208 36.7398C46.5879 36.7398 47.9374 38.0887 47.9374 39.7533C47.9374 41.417 46.5879 42.7658 44.9208 42.7658ZM35.1378 42.7658C33.4715 42.7658 32.1212 41.417 32.1212 39.7533C32.1212 38.0887 33.4715 36.7398 35.1378 36.7398C36.8041 36.7398 38.1544 38.0887 38.1544 39.7533C38.1544 41.417 36.8041 42.7658 35.1378 42.7658ZM32.2164 50.8658H35.5154H44.5238H47.797C48.8778 50.8658 49.7561 49.9892 49.7561 48.9088V45.5899H50.9049C51.4888 45.5899 51.9615 45.1177 51.9615 44.5361V40.2745C51.9615 39.6921 51.4888 39.2207 50.9049 39.2207H49.7561V35.0416C49.7561 33.962 48.8786 33.0854 47.797 33.0854H40.5505V31.9121C42.0256 31.6755 43.1537 30.3989 43.1537 28.8582C43.1537 27.1498 41.7673 25.7656 40.0571 25.7656C38.3468 25.7656 36.9613 27.1498 36.9613 28.8582C36.9613 30.355 38.0248 31.6024 39.4396 31.8888V33.0854H32.2155C31.1348 33.0854 30.2573 33.9612 30.2573 35.0416V39.2207H29.093C28.51 39.2207 28.0381 39.693 28.0381 40.2745V44.5361C28.0381 45.1177 28.5109 45.5899 29.093 45.5899H30.2581V48.9088C30.2581 49.9892 31.1348 50.8658 32.2164 50.8658ZM45.4851 45.1658C46.0075 44.8313 46.6814 45.0191 46.9901 45.5851C47.2989 46.1511 47.1256 46.8811 46.6031 47.2155C45.908 47.6605 44.8137 47.9864 43.6803 48.2057C42.5075 48.4327 41.1514 48.5715 39.8453 48.5715C38.5385 48.5715 37.2301 48.4326 36.1149 48.2034C35.043 47.9832 34.0093 47.6523 33.3533 47.1858C32.846 46.8249 32.7048 46.0869 33.0378 45.5373C33.3709 44.9877 34.0522 44.8347 34.5595 45.1956C34.8334 45.3904 35.5043 45.6547 36.5245 45.8643C37.5014 46.0651 38.6726 46.1907 39.8453 46.1907C41.0187 46.1907 42.2454 46.0649 43.2938 45.862C44.3817 45.6515 45.1471 45.3822 45.4851 45.1658Z';
      bgColor = '#3CE967';
      break;

    case 'red':
      headPathD = 'M44.9208 42.7658C43.2553 42.7658 41.905 41.417 41.905 39.7533C41.905 38.0887 43.2562 36.7398 44.9208 36.7398C46.5879 36.7398 47.9374 38.0887 47.9374 39.7533C47.9374 41.417 46.5879 42.7658 44.9208 42.7658ZM35.1378 42.7658C33.4715 42.7658 32.1212 41.417 32.1212 39.7533C32.1212 38.0887 33.4715 36.7398 35.1378 36.7398C36.8041 36.7398 38.1544 38.0887 38.1544 39.7533C38.1544 41.417 36.8041 42.7658 35.1378 42.7658ZM32.2164 50.8658H35.5154H44.5238H47.797C48.8778 50.8658 49.7561 49.9892 49.7561 48.9088V45.5899H50.9049C51.4888 45.5899 51.9615 45.1177 51.9615 44.5361V40.2745C51.9615 39.6921 51.4888 39.2207 50.9049 39.2207H49.7561V35.0416C49.7561 33.962 48.8786 33.0854 47.797 33.0854H40.5505V31.9121C42.0256 31.6755 43.1537 30.3989 43.1537 28.8582C43.1537 27.1498 41.7673 25.7656 40.0571 25.7656C38.3468 25.7656 36.9613 27.1498 36.9613 28.8582C36.9613 30.355 38.0248 31.6024 39.4396 31.8888V33.0854H32.2155C31.1348 33.0854 30.2573 33.9612 30.2573 35.0416V39.2207H29.093C28.51 39.2207 28.0381 39.693 28.0381 40.2745V44.5361C28.0381 45.1177 28.5109 45.5899 29.093 45.5899H30.2581V48.9088C30.2581 49.9892 31.1348 50.8658 32.2164 50.8658ZM34.5155 48.4058C33.993 48.7402 33.3192 48.5525 33.0104 47.9865C32.7017 47.4205 32.875 46.6905 33.3974 46.356C34.0926 45.9111 35.1869 45.5852 36.3202 45.3658C37.493 45.1389 38.8491 45.0001 40.1553 45.0001C41.4621 45.0001 42.7705 45.139 43.8856 45.3681C44.9575 45.5884 45.9913 45.9192 46.6472 46.3858C47.1546 46.7466 47.2958 47.4847 46.9627 48.0342C46.6296 48.5838 45.9483 48.7368 45.441 48.376C45.1672 48.1812 44.4963 47.9169 43.4761 47.7072C42.4991 47.5065 41.328 47.3809 40.1553 47.3809C38.9819 47.3809 37.7551 47.5067 36.7067 47.7095C35.6189 47.9201 34.8535 48.1894 34.5155 48.4058Z';
      bgColor = '#FF4545';
      break;

    case 'orange':
      headPathD = 'M44.9208 42.7658C43.2553 42.7658 41.905 41.417 41.905 39.7533C41.905 38.0887 43.2562 36.7398 44.9208 36.7398C46.5879 36.7398 47.9374 38.0887 47.9374 39.7533C47.9374 41.417 46.5879 42.7658 44.9208 42.7658ZM35.1378 42.7658C33.4715 42.7658 32.1212 41.417 32.1212 39.7533C32.1212 38.0887 33.4715 36.7398 35.1378 36.7398C36.8041 36.7398 38.1544 38.0887 38.1544 39.7533C38.1544 41.417 36.8041 42.7658 35.1378 42.7658ZM32.2164 50.8658H35.5154H44.5238H47.797C48.8778 50.8658 49.7561 49.9892 49.7561 48.9088V45.5899H50.9049C51.4888 45.5899 51.9615 45.1177 51.9615 44.5361V40.2745C51.9615 39.6921 51.4888 39.2207 50.9049 39.2207H49.7561V35.0416C49.7561 33.962 48.8786 33.0854 47.797 33.0854H40.5505V31.9121C42.0256 31.6755 43.1537 30.3989 43.1537 28.8582C43.1537 27.1498 41.7673 25.7656 40.0571 25.7656C38.3468 25.7656 36.9613 27.1498 36.9613 28.8582C36.9613 30.355 38.0248 31.6024 39.4396 31.8888V33.0854H32.2155C31.1348 33.0854 30.2573 33.9612 30.2573 35.0416V39.2207H29.093C28.51 39.2207 28.0381 39.693 28.0381 40.2745V44.5361C28.0381 45.1177 28.5109 45.5899 29.093 45.5899H30.2581V48.9088C30.2581 49.9892 31.1348 50.8658 32.2164 50.8658ZM32.8465 46.5514C32.8465 45.9991 33.2942 45.5514 33.8465 45.5514H46.4859C47.0382 45.5514 47.4859 45.9991 47.4859 46.5514V47.1321C47.4859 47.6844 47.0382 48.1321 46.4859 48.1321H33.8465C33.2942 48.1321 32.8465 47.6844 32.8465 47.1321V46.5514Z';
      bgColor = '#FF9545';
      break;

    default:
      headPathD = 'M44.9208 42.7658C43.2553 42.7658 41.905 41.417 41.905 39.7533C41.905 38.0887 43.2562 36.7398 44.9208 36.7398C46.5879 36.7398 47.9374 38.0887 47.9374 39.7533C47.9374 41.417 46.5879 42.7658 44.9208 42.7658ZM35.1378 42.7658C33.4715 42.7658 32.1212 41.417 32.1212 39.7533C32.1212 38.0887 33.4715 36.7398 35.1378 36.7398C36.8041 36.7398 38.1544 38.0887 38.1544 39.7533C38.1544 41.417 36.8041 42.7658 35.1378 42.7658ZM32.2164 50.8658H35.5154H44.5238H47.797C48.8778 50.8658 49.7561 49.9892 49.7561 48.9088V45.5899H50.9049C51.4888 45.5899 51.9615 45.1177 51.9615 44.5361V40.2745C51.9615 39.6921 51.4888 39.2207 50.9049 39.2207H49.7561V35.0416C49.7561 33.962 48.8786 33.0854 47.797 33.0854H40.5505V31.9121C42.0256 31.6755 43.1537 30.3989 43.1537 28.8582C43.1537 27.1498 41.7673 25.7656 40.0571 25.7656C38.3468 25.7656 36.9613 27.1498 36.9613 28.8582C36.9613 30.355 38.0248 31.6024 39.4396 31.8888V33.0854H32.2155C31.1348 33.0854 30.2573 33.9612 30.2573 35.0416V39.2207H29.093C28.51 39.2207 28.0381 39.693 28.0381 40.2745V44.5361C28.0381 45.1177 28.5109 45.5899 29.093 45.5899H30.2581V48.9088C30.2581 49.9892 31.1348 50.8658 32.2164 50.8658ZM45.4851 45.1658C46.0075 44.8313 46.6814 45.0191 46.9901 45.5851C47.2989 46.1511 47.1256 46.8811 46.6031 47.2155C45.908 47.6605 44.8137 47.9864 43.6803 48.2057C42.5075 48.4327 41.1514 48.5715 39.8453 48.5715C38.5385 48.5715 37.2301 48.4326 36.1149 48.2034C35.043 47.9832 34.0093 47.6523 33.3533 47.1858C32.846 46.8249 32.7048 46.0869 33.0378 45.5373C33.3709 44.9877 34.0522 44.8347 34.5595 45.1956C34.8334 45.3904 35.5043 45.6547 36.5245 45.8643C37.5014 46.0651 38.6726 46.1907 39.8453 46.1907C41.0187 46.1907 42.2454 46.0649 43.2938 45.862C44.3817 45.6515 45.1471 45.3822 45.4851 45.1658Z';
      bgColor = '#FC5AA6';
  }

  return /*#__PURE__*/React__default.createElement("svg", _extends$1({}, rootProps(props), {
    viewBox: "0 0 50 50",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 43,
      columnNumber: 5
    }
  }), /*#__PURE__*/React__default.createElement("g", {
    filter: "url(#filter0_d)",
    className: styles$19.head,
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("circle", {
    cx: "39.9994",
    cy: "39.9999",
    r: "22.3285",
    fill: "#202020",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 45,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    cx: "40.1196",
    cy: "39.9999",
    rx: "22.3286",
    ry: "22.3285",
    fill: bgColor,
    fillOpacity: "0.2",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 46,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("path", {
    stroke: cssStroke,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 40C65 53.8071 53.8071 65 40 65C26.1929 65 15 53.8071 15 40C15 26.1929 26.1929 15 40 15C53.8071 15 65 26.1929 65 40ZM17.7909 40C17.7909 52.2657 27.7341 62.209 39.9998 62.209C52.2655 62.209 62.2087 52.2657 62.2087 40C62.2087 27.7344 52.2655 17.7911 39.9998 17.7911C27.7341 17.7911 17.7909 27.7344 17.7909 40Z",
    fill: bgColor,
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 54,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: headPathD,
    fill: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 61,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("defs", {
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 68,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "80",
    height: "80",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 69,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 78,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 79,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feOffset", {
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 84,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feGaussianBlur", {
    stdDeviation: "7.5",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 85,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.25 0",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 86,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 90,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape",
    __self: window,
    __source: {
      fileName: _jsxFileName$1p,
      lineNumber: 95,
      columnNumber: 11
    }
  }))));
};

BotHead.propTypes = {
  color: PropTypes.oneOf(['green', 'red', 'orange', 'pink'])
};

var css_248z$1a = ".Button-module_button__xI9Nv {\n  font-size: 1em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  color: #06a3f7;\n  border: none;\n}\n.Button-module_button__xI9Nv:hover {\n  cursor: pointer;\n}\n\n.Button-module_minimal__Y44Gp {\n  background-color: transparent;\n  padding: 0.375em;\n}\n.Button-module_minimal__Y44Gp:hover {\n  color: #0696e3;\n}\n\n.Button-module_regular__82Fjf {\n  background-color: #262626;\n  border-radius: 2%;\n  line-height: 1;\n  padding: 0.75em 1em;\n  text-decoration: none;\n  height: 40px;\n}\n.Button-module_regular__82Fjf > .Button-module_buttonChild__kqoc8 {\n  opacity: 1;\n}\n.Button-module_regular__82Fjf:hover {\n  background-color: #06a3f7;\n  color: #f3eff1;\n}\n.Button-module_regular__82Fjf:hover svg path {\n  fill: #f3eff1;\n}\n\n.Button-module_primary__72tKF {\n  background-color: #06a3f7;\n  border-radius: 2%;\n  color: #f3eff1;\n  line-height: 1;\n  padding: 0.75em 1em;\n  text-decoration: none;\n  height: 40px;\n}\n.Button-module_primary__72tKF:hover, .Button-module_primary__72tKF:focus, .Button-module_primary__72tKF:active {\n  color: #f3eff1;\n  background-color: #0696e3;\n}\n.Button-module_primary__72tKF:hover svg path, .Button-module_primary__72tKF:focus svg path, .Button-module_primary__72tKF:active svg path {\n  fill: #f3eff1;\n}\n\n.Button-module_secondary__UymNc {\n  background-color: #fc5aa6;\n  border-radius: 2%;\n  color: #f3eff1;\n  line-height: 1;\n  padding: 0.75em 1em;\n  text-decoration: none;\n  height: 40px;\n}\n.Button-module_secondary__UymNc:hover, .Button-module_secondary__UymNc:focus, .Button-module_secondary__UymNc:active {\n  color: #f3eff1;\n  background-color: #fc4198;\n}\n.Button-module_secondary__UymNc:hover svg path, .Button-module_secondary__UymNc:focus svg path, .Button-module_secondary__UymNc:active svg path {\n  fill: #f3eff1;\n}\n\n.Button-module_editable__abvkd {\n  display: inline-flex;\n  background-color: inherit;\n  border: 1px solid #302e35;\n  padding-left: 2px;\n  padding-right: 2px;\n  color: #f3eff1;\n}\n.Button-module_editable__abvkd:hover, .Button-module_editable__abvkd:focus, .Button-module_editable__abvkd:active {\n  cursor: pointer;\n  color: #06a3f7;\n}\n.Button-module_editable__abvkd.Button-module_border__1P-D3 {\n  border: 1px solid #3a383f;\n}\n.Button-module_editable__abvkd:focus-visible {\n  outline: none;\n  border: 1px solid #06a3f7;\n}\n.Button-module_editable__abvkd > .Button-module_editableChildren__8Fa0Q {\n  border-bottom: 1px dashed #06a3f7;\n}\n.Button-module_editable__abvkd > .Button-module_editableChildren__8Fa0Q *:hover, .Button-module_editable__abvkd > .Button-module_editableChildren__8Fa0Q *:focus, .Button-module_editable__abvkd > .Button-module_editableChildren__8Fa0Q *:active {\n  cursor: pointer;\n  color: #06a3f7;\n}\n\n.Button-module_wide__rUzE5 {\n  width: 140px;\n}\n\n.Button-module_fullWidth__iiBA7 {\n  width: 100%;\n}\n\n:disabled {\n  background-color: #2e2e2e;\n  border-radius: 2%;\n  line-height: 1;\n  padding: 0.75em 1em;\n  text-decoration: none;\n  height: 40px;\n  color: #bbb2b7;\n}\n:disabled > .Button-module_buttonChild__kqoc8 {\n  opacity: 1;\n}\n:disabled:hover {\n  color: #6e6d6d;\n  cursor: default;\n}\n:disabled:hover svg path {\n  fill: #f3eff1;\n}\n\n.Button-module_loading__l7Ssa {\n  -webkit-animation-name: Button-module_spin__xHB2W;\n          animation-name: Button-module_spin__xHB2W;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-duration: 0.35s;\n          animation-duration: 0.35s;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  -webkit-animation-delay: 0.15s;\n          animation-delay: 0.15s;\n  border: rgba(255, 255, 255, 0.45);\n  background-color: #302e35;\n  border-style: outset;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  cursor: wait;\n  transition: all 0.15s ease-in-out, width 0s;\n}\n.Button-module_loading__l7Ssa > .Button-module_buttonChild__kqoc8 {\n  opacity: 0;\n}\n\n.Button-module_iconOnly__2KUAc {\n  height: 2.5em;\n  width: 2.5em;\n  padding: 0;\n}\n.Button-module_iconOnly__2KUAc .Button-module_iconEnd__AFcBP,\n.Button-module_iconOnly__2KUAc .Button-module_iconStart__IRP-N {\n  margin: 0;\n}\n.Button-module_iconOnly__2KUAc:active, .Button-module_iconOnly__2KUAc:focus, .Button-module_iconOnly__2KUAc:hover {\n  -webkit-animation: Button-module_button-pop__tqzpb 0.35s;\n          animation: Button-module_button-pop__tqzpb 0.35s;\n  transition: 0.3s;\n}\n.Button-module_iconOnly__2KUAc:active svg path, .Button-module_iconOnly__2KUAc:focus svg path, .Button-module_iconOnly__2KUAc:hover svg path {\n  fill: #f3eff1;\n}\n\n.Button-module_iconEnd__AFcBP {\n  margin-left: 0.35em;\n  height: 12px;\n  width: 12px;\n  margin-bottom: -2px;\n}\n\n.Button-module_iconStart__IRP-N {\n  margin-right: 0.35em;\n  height: 12px;\n  width: 12px;\n  margin-bottom: -2px;\n}\n\n@-webkit-keyframes Button-module_spin__xHB2W {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n}\n\n@keyframes Button-module_spin__xHB2W {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n}\n@-webkit-keyframes Button-module_button-pop__tqzpb {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes Button-module_button-pop__tqzpb {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}";
var baseButtonStyles = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","button":"Button-module_button__xI9Nv","minimal":"Button-module_minimal__Y44Gp","regular":"Button-module_regular__82Fjf","buttonChild":"Button-module_buttonChild__kqoc8","primary":"Button-module_primary__72tKF","secondary":"Button-module_secondary__UymNc","editable":"Button-module_editable__abvkd","border":"Button-module_border__1P-D3","editableChildren":"Button-module_editableChildren__8Fa0Q","wide":"Button-module_wide__rUzE5","fullWidth":"Button-module_fullWidth__iiBA7","loading":"Button-module_loading__l7Ssa","spin":"Button-module_spin__xHB2W","iconOnly":"Button-module_iconOnly__2KUAc","iconEnd":"Button-module_iconEnd__AFcBP","iconStart":"Button-module_iconStart__IRP-N","button-pop":"Button-module_button-pop__tqzpb","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7","button___pop":"Button-module_button-pop__tqzpb"};
styleInject(css_248z$1a);

const _excluded$o = ["regular", "primary", "secondary", "minimal", "editable", "wide", "fullWidth", "className", "children", "onClick", "loading", "disabled", "iconStart", "iconEnd"];
var _jsxFileName$1o = "/home/circleci/app/libs/listings-bot/src/components/Button/Button.jsx";
const Button = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    regular,
    primary,
    secondary,
    minimal,
    editable,
    wide,
    fullWidth,
    className,
    children,
    onClick,
    loading,
    disabled,
    iconStart: IconStart,
    iconEnd: IconEnd
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$o);

  return /*#__PURE__*/React__default.createElement("button", _extends$1({
    className: classnames(baseButtonStyles.button, regular && baseButtonStyles.regular, primary && baseButtonStyles.primary, secondary && baseButtonStyles.secondary, minimal && baseButtonStyles.minimal, editable && baseButtonStyles.editable, wide && baseButtonStyles.wide, fullWidth && baseButtonStyles.fullWidth, loading && baseButtonStyles.loading, (IconEnd || IconStart) && !children && baseButtonStyles.iconOnly, className),
    disabled: loading || disabled,
    ref: ref,
    onClick: onClick
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1o,
      lineNumber: 29,
      columnNumber: 7
    }
  }), !loading && !!IconStart && /*#__PURE__*/React__default.createElement(IconStart, {
    className: baseButtonStyles.iconStart,
    __self: window,
    __source: {
      fileName: _jsxFileName$1o,
      lineNumber: 48,
      columnNumber: 37
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classnames(baseButtonStyles.buttonChild, editable && baseButtonStyles.editableChildren),
    __self: window,
    __source: {
      fileName: _jsxFileName$1o,
      lineNumber: 49,
      columnNumber: 9
    }
  }, children), !loading && !!IconEnd && /*#__PURE__*/React__default.createElement(IconEnd, {
    className: baseButtonStyles.iconEnd,
    __self: window,
    __source: {
      fileName: _jsxFileName$1o,
      lineNumber: 57,
      columnNumber: 35
    }
  }));
});
Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  wide: PropTypes.bool,
  fullWidth: PropTypes.bool,
  regular: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  minimal: PropTypes.bool,
  editable: PropTypes.bool,
  iconEnd: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  iconStart: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
};

var css_248z$19 = ".Checkbox-module_root__4lbq9 {\n  display: inline-block;\n}\n.Checkbox-module_root__4lbq9 .Checkbox-module_inputRoot__qCaqp {\n  position: static;\n}\n\n.Checkbox-module_checkBoxRoot__h3-7q {\n  position: relative;\n  height: 20px;\n  width: 40px;\n  border-radius: 10px;\n  background: #808080;\n  flex-shrink: 0;\n}\n.Checkbox-module_checkBoxRoot__h3-7q .Checkbox-module_circle__jEHOV {\n  background: #ffffff;\n  height: calc(100% - 4px);\n  width: calc(50% - 4px);\n  border: 2px solid transparent;\n  border-radius: 100%;\n  margin: 2px;\n  transition: margin-left ease-out 0.175s;\n  margin: 2px;\n}\n.Checkbox-module_checkBoxRoot__h3-7q.Checkbox-module_focused__o8ufE {\n  outline: auto;\n}\n.Checkbox-module_checkBoxRoot__h3-7q:not(.Checkbox-module_disabled__C2hNz):hover {\n  background: #8d8d8d;\n}\n.Checkbox-module_checkBoxRoot__h3-7q.Checkbox-module_checked__vcFLf {\n  background: hsl(332deg, 96%, 67%);\n}\n.Checkbox-module_checkBoxRoot__h3-7q.Checkbox-module_checked__vcFLf .Checkbox-module_circle__jEHOV {\n  margin-left: calc(50% + 2px);\n}\n.Checkbox-module_checkBoxRoot__h3-7q.Checkbox-module_checked__vcFLf:not(.Checkbox-module_disabled__C2hNz):hover {\n  background: hsl(332deg, 96%, 75%);\n}\n.Checkbox-module_checkBoxRoot__h3-7q .Checkbox-module_hide__zTh-O {\n  position: absolute;\n  opacity: 0;\n  width: 30px;\n  top: 3px;\n  left: 4px;\n  cursor: pointer;\n}\n\n.Checkbox-module_checkBoxPill__W13In {\n  position: relative;\n  cursor: pointer;\n  background-color: #48474d;\n  font-weight: 400;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 1px solid #48474d;\n  color: #f3eff1;\n}\n.Checkbox-module_checkBoxPill__W13In:hover {\n  background-color: #525158;\n  border: 1px solid #9d97ab;\n}\n.Checkbox-module_checkBoxPill__W13In.Checkbox-module_focused__o8ufE {\n  border: 1px solid #9d97ab;\n}\n.Checkbox-module_checkBoxPill__W13In.Checkbox-module_checked__vcFLf {\n  background-color: #68676d;\n}\n.Checkbox-module_checkBoxPill__W13In > input {\n  width: 100%;\n  height: 100%;\n}\n.Checkbox-module_checkBoxPill__W13In .Checkbox-module_hide__zTh-O {\n  position: absolute;\n  opacity: 0;\n  top: -2px;\n  left: -2px;\n  cursor: pointer;\n}\n\n.Checkbox-module_disabled__C2hNz {\n  opacity: 0.5;\n}";
var styles$18 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"Checkbox-module_root__4lbq9","inputRoot":"Checkbox-module_inputRoot__qCaqp","checkBoxRoot":"Checkbox-module_checkBoxRoot__h3-7q","circle":"Checkbox-module_circle__jEHOV","focused":"Checkbox-module_focused__o8ufE","disabled":"Checkbox-module_disabled__C2hNz","checked":"Checkbox-module_checked__vcFLf","hide":"Checkbox-module_hide__zTh-O","checkBoxPill":"Checkbox-module_checkBoxPill__W13In","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$19);

const _excluded$n = ["id", "name", "className", "toggle", "pill", "children", "checked", "onChange", "onBlur", "onFocus", "disabled"];
var _jsxFileName$1n = "/home/circleci/app/libs/listings-bot/src/components/Checkbox/Checkbox.jsx";

const noop = () => false;

const Checkbox = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    id,
    name,
    className,
    toggle,
    pill,
    children,
    checked,
    onChange = noop,
    onBlur,
    onFocus,
    disabled
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$n);

  const [focused, setFocused] = useState(false);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$18.root, toggle && styles$18.checkBoxRoot, pill && styles$18.checkBoxPill, checked && styles$18.checked, focused && styles$18.focused, disabled && styles$18.disabled, className),
    onKeyDown: e => {
      if (e.key === 'Enter') {
        e.target.checked = !e.target.checked;
        onChange(e);
      }
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$1n,
      lineNumber: 30,
      columnNumber: 7
    }
  }, toggle && /*#__PURE__*/React__default.createElement("div", {
    className: styles$18.circle,
    __self: window,
    __source: {
      fileName: _jsxFileName$1n,
      lineNumber: 47,
      columnNumber: 20
    }
  }), /*#__PURE__*/React__default.createElement("input", _extends$1({
    id: id,
    ref: ref,
    name: name,
    type: "checkbox",
    className: classnames(styles$18.inputRoot, toggle && styles$18.hide, pill && styles$18.hide),
    checked: checked,
    onChange: onChange,
    onFocus: e => {
      setFocused(true);
      if (onFocus) onFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      if (onBlur) onBlur(e);
    },
    onClick: e => e.target.blur(),
    disabled: disabled
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1n,
      lineNumber: 48,
      columnNumber: 9
    }
  })), pill && children);
});
Checkbox.defaultProps = {
  checked: false
};
Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  toggle: PropTypes.bool,
  pill: PropTypes.bool,
  children: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};

var css_248z$18 = ".CircleIcon-module_iconWrapper__Sj95E {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  padding: 4px;\n}\n.CircleIcon-module_iconWrapper-success__7XStB {\n  background: rgba(60, 233, 103, 0.15);\n}\n.CircleIcon-module_iconWrapper-warning__3-kNB {\n  background: rgba(255, 149, 69, 0.15);\n}\n.CircleIcon-module_iconWrapper-danger__5tmlq {\n  background: rgba(255, 69, 69, 0.15);\n}\n.CircleIcon-module_iconWrapper-none__r9vik {\n  background: none;\n}\n\n.CircleIcon-module_icon__tg4CY {\n  align-self: center;\n}";
var styles$17 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","iconWrapper":"CircleIcon-module_iconWrapper__Sj95E","iconWrapper-success":"CircleIcon-module_iconWrapper-success__7XStB","iconWrapper-warning":"CircleIcon-module_iconWrapper-warning__3-kNB","iconWrapper-danger":"CircleIcon-module_iconWrapper-danger__5tmlq","iconWrapper-none":"CircleIcon-module_iconWrapper-none__r9vik","icon":"CircleIcon-module_icon__tg4CY","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7","iconWrapper___success":"CircleIcon-module_iconWrapper-success__7XStB","iconWrapper___warning":"CircleIcon-module_iconWrapper-warning__3-kNB","iconWrapper___danger":"CircleIcon-module_iconWrapper-danger__5tmlq","iconWrapper___none":"CircleIcon-module_iconWrapper-none__r9vik"};
styleInject(css_248z$18);

var _jsxFileName$1m = "/home/circleci/app/libs/listings-bot/src/components/CircleIcon/CircleIcon.jsx";
const BACKGROUND_COLORS = ['success', 'warning', 'danger', 'none'];
const ICONS = ['dog', 'lightBulb', 'rabbit', 'turtle', 'snowflakeCool', 'greenMoneyBag', 'orangeMoneyBag', 'check', 'chart', 'homebot'];
const propTypes$7 = {
  backgroundColor: PropTypes.oneOf(BACKGROUND_COLORS).isRequired,
  icon: PropTypes.oneOf(ICONS).isRequired,
  className: PropTypes.string
};

const CircleIcon = ({
  backgroundColor,
  icon,
  className
}) => {
  const iconMapping = {
    dog: /*#__PURE__*/React__default.createElement(Dog, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 45,
        columnNumber: 10
      }
    }),
    check: /*#__PURE__*/React__default.createElement(Check, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 46,
        columnNumber: 12
      }
    }),
    chart: /*#__PURE__*/React__default.createElement(Chart$1, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 47,
        columnNumber: 12
      }
    }),
    greenMoneyBag: /*#__PURE__*/React__default.createElement(GreenMoneyBag, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 48,
        columnNumber: 20
      }
    }),
    lightBulb: /*#__PURE__*/React__default.createElement(LightBulb, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 49,
        columnNumber: 16
      }
    }),
    orangeMoneyBag: /*#__PURE__*/React__default.createElement(OrangeMoneyBag, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 50,
        columnNumber: 21
      }
    }),
    rabbit: /*#__PURE__*/React__default.createElement(Rabbit, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 51,
        columnNumber: 13
      }
    }),
    snowflakeCool: /*#__PURE__*/React__default.createElement(SnowflakeCool, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 52,
        columnNumber: 20
      }
    }),
    turtle: /*#__PURE__*/React__default.createElement(Turtle, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 53,
        columnNumber: 13
      }
    }),
    homebot: /*#__PURE__*/React__default.createElement(HomebotIcon, {
      __self: window,
      __source: {
        fileName: _jsxFileName$1m,
        lineNumber: 54,
        columnNumber: 14
      }
    })
  };
  const wrapperClassName = classnames(styles$17.iconWrapper, styles$17[`iconWrapper-${backgroundColor}`], className);
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClassName,
    __self: window,
    __source: {
      fileName: _jsxFileName$1m,
      lineNumber: 63,
      columnNumber: 10
    }
  }, iconMapping[icon]);
};

CircleIcon.propTypes = propTypes$7;
CircleIcon.BackgroundColors = BACKGROUND_COLORS;
CircleIcon.Icons = ICONS;

var img$1 = "data:image/svg+xml,%3csvg width='7' height='13' viewBox='0 0 7 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath opacity='0.5' fill-rule='evenodd' clip-rule='evenodd' d='M1.48576 0L7 6.34308L1.50229 13L0 11.6761L4.37585 6.37754L0.0165288 1.36296L1.48576 0Z' fill='white'/%3e%3c/svg%3e";

var css_248z$17 = ".ClickableTile-module_root__uIkih {\n  position: relative;\n  border-radius: 8px;\n  background-color: #3a383f;\n  padding: 0.75em;\n  cursor: pointer;\n  transition: 0.1s ease-in-out background-color;\n}\n.ClickableTile-module_root__uIkih:hover {\n  background-color: #46444d;\n}\n.ClickableTile-module_root__uIkih:focus {\n  box-shadow: inset 0 0 0 2px rgba(65, 185, 250, 0.5);\n}\n.ClickableTile-module_root__uIkih:active {\n  background-color: rgba(58, 56, 63, 0.4);\n}\n\n.ClickableTile-module_currency__uN8AG {\n  margin: 1.5em 0;\n}\n.ClickableTile-module_currency__uN8AG .ClickableTile-module_countUp__51UgD {\n  font-weight: 400;\n}\n\n.ClickableTile-module_arrow__H3-Es {\n  position: absolute;\n  right: 5px;\n  top: 3em;\n}";
var styles$16 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"ClickableTile-module_root__uIkih","currency":"ClickableTile-module_currency__uN8AG","countUp":"ClickableTile-module_countUp__51UgD","arrow":"ClickableTile-module_arrow__H3-Es","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$17);

const _excluded$m = ["heading", "value", "prefix", "suffix", "formatter", "subTitleComponent", "className", "onClick"];
var _jsxFileName$1l = "/home/circleci/app/libs/listings-bot/src/components/ClickableTile/ClickableTile.jsx";

const ClickableTile = _ref => {
  let {
    heading,
    value,
    prefix,
    suffix,
    formatter,
    subTitleComponent: SubTitleComponent = React__default.Fragment,
    className,
    onClick
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$m);

  return /*#__PURE__*/React__default.createElement("div", {
    role: "button",
    tabIndex: "0",
    className: classnames(styles$16.root, className),
    onClick: onClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 25,
      columnNumber: 5
    }
  }, heading && /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    color: "white",
    weight: "semibold",
    transform: "uppercase",
    letterSpacing: "large",
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 32,
      columnNumber: 9
    }
  }, heading), /*#__PURE__*/React__default.createElement(Text, {
    size: "xl",
    letterSpacing: "large",
    weight: "regular",
    className: styles$16.currency,
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 42,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ColoredCountUp, _extends$1({
    className: styles$16.countUp,
    value: value,
    prefix: prefix,
    suffix: suffix,
    formatter: formatter
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 48,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React__default.createElement("img", {
    src: img$1,
    alt: "right arrow",
    className: styles$16.arrow,
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 57,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(SubTitleComponent, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1l,
      lineNumber: 58,
      columnNumber: 7
    }
  }));
};

ClickableTile.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.number,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  formatter: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  subTitleComponent: PropTypes.any.isRequired
};

var css_248z$16 = ".CloseButton-module_closeButton__xcFrs {\n  width: 16px;\n  height: 16px;\n  padding: 4px;\n  margin: 0;\n  box-sizing: content-box;\n}\n.CloseButton-module_closeButton__xcFrs > * {\n  width: 100%;\n  height: 100%;\n}\n.CloseButton-module_closeButton__xcFrs:hover svg path {\n  fill: #0696e3;\n}";
var styles$15 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","closeButton":"CloseButton-module_closeButton__xcFrs","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$16);

var _jsxFileName$1k = "/home/circleci/app/libs/listings-bot/src/components/CloseButton/CloseButton.jsx";

const CloseButton = ({
  className,
  onClick
}) => /*#__PURE__*/React__default.createElement(Button, {
  className: classnames(styles$15.closeButton, className),
  onClick: onClick,
  __self: window,
  __source: {
    fileName: _jsxFileName$1k,
    lineNumber: 11,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement(Times, {
  alt: "close",
  __self: window,
  __source: {
    fileName: _jsxFileName$1k,
    lineNumber: 15,
    columnNumber: 5
  }
}));

CloseButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

var _jsxFileName$1j = "/home/circleci/app/libs/listings-bot/src/components/CountUp/ColoredCountUp.jsx";

const ColoredCountUp = ({
  value,
  prefix,
  suffix,
  formatter: _formatter = v => v,
  absolute: _absolute = true,
  countAtMount,
  className,
  controlledColor,
  weight: _weight = 'bold'
}) => {
  const incValue = parseFloat(value, 10);
  const startValue = typeof countAtMount === 'number' ? countAtMount : Boolean(countAtMount) ? 0 : incValue;
  const {
    countUp,
    start: startCount,
    update: updateCount
  } = useCountUp({
    start: startValue,
    end: incValue,
    duration: 1
  });
  useEffect(() => {
    updateCount(incValue);
  }, [incValue]); // eslint-disable-line

  useEffect(() => {
    startCount();
  }, []); // eslint-disable-line

  const countUpValue = parseFloat(countUp, 10);
  const display = _absolute ? _formatter(Math.abs(countUpValue)) : _formatter(countUpValue);
  const color = controlledColor ? controlledColor : countUpValue > 0 ? 'green' : countUpValue < 0 ? 'red' : 'white';
  return /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: color,
    weight: _weight,
    element: "span",
    className: className,
    __self: window,
    __source: {
      fileName: _jsxFileName$1j,
      lineNumber: 56,
      columnNumber: 5
    }
  }, `${prefix != null ? prefix : ''}${display}${suffix != null ? suffix : ''}`);
};

ColoredCountUp.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  controlledColor: PropTypes.string,
  className: PropTypes.string,
  formatter: PropTypes.func,
  absolute: PropTypes.bool,
  countAtMount: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  weight: PropTypes.oneOf(['light', 'regular', 'semibold', 'bold'])
};

var css_248z$15 = ".DisclaimerButton-module_root__sZgZV div {\n  color: #06a3f7;\n  text-decoration: none;\n  cursor: pointer;\n}\n.DisclaimerButton-module_root__sZgZV div:hover {\n  color: #0696e3;\n}\n.DisclaimerButton-module_root__sZgZV div > .DisclaimerButton-module_children__JaCWl {\n  margin-right: 5px;\n}";
var styles$14 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"DisclaimerButton-module_root__sZgZV","children":"DisclaimerButton-module_children__JaCWl","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$15);

var _jsxFileName$1i = "/home/circleci/app/libs/listings-bot/src/components/DisclaimerButton/DisclaimerButton.jsx";

const DisclaimerButton = ({
  children,
  onClick,
  className
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$14.root, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$1i,
      lineNumber: 10,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$1i,
      lineNumber: 11,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    className: styles$14.children,
    __self: window,
    __source: {
      fileName: _jsxFileName$1i,
      lineNumber: 12,
      columnNumber: 9
    }
  }, children)));
};

DisclaimerButton.propTypes = {
  children: PropTypes.any,
  linkTo: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};
DisclaimerButton.defaultProps = {
  onClick: () => {}
};

var css_248z$14 = ".Drawer-module_drawer__osR1k {\n  overflow: hidden;\n  max-height: 74px;\n  min-height: 50px;\n  transition: min-height 0.5s ease-in-out, max-height 0.5s ease-in-out;\n}\n\n.Drawer-module_expanded__owvPX {\n  max-height: 500px;\n  min-height: 350px;\n}\n\n.Drawer-module_avatar__Obfw4 {\n  height: 50px;\n  width: 50px;\n  border: 2px solid #f3eff1;\n}\n\n.Drawer-module_helpContainer__kYmZJ {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n}\n.Drawer-module_helpContainer__kYmZJ:hover {\n  background-color: #2e2c35;\n}\n\n.Drawer-module_textItem__pcJuX {\n  width: 61%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-evenly;\n}\n\n.Drawer-module_iconContainer__cJOfI {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 2.5%;\n}\n.Drawer-module_iconContainer__cJOfI.Drawer-module_disabled__WjEwa {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.Drawer-module_notSelected__W57qX {\n  transition: all 0.3s ease-in-out;\n  transform: rotate(-180deg);\n}\n\n.Drawer-module_selected__cW9Ki {\n  transition: all 0.3s ease-in-out;\n  transform: rotate(0deg);\n}\n\n.Drawer-module_expandedRow__MTKzy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  visibility: visible;\n  opacity: 1;\n  height: auto;\n  transition: visibility 0.5s, opacity 0.5s 0.25s linear, height 0.5s linear;\n}\n\n.Drawer-module_hidden__8UJdg {\n  visibility: hidden;\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n  transition: visibility 0.5s, opacity 0.5s linear, height 0.5s 0.5s linear;\n}";
var styles$13 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","drawer":"Drawer-module_drawer__osR1k","expanded":"Drawer-module_expanded__owvPX","avatar":"Drawer-module_avatar__Obfw4","helpContainer":"Drawer-module_helpContainer__kYmZJ","textItem":"Drawer-module_textItem__pcJuX","iconContainer":"Drawer-module_iconContainer__cJOfI","disabled":"Drawer-module_disabled__WjEwa","notSelected":"Drawer-module_notSelected__W57qX","selected":"Drawer-module_selected__cW9Ki","expandedRow":"Drawer-module_expandedRow__MTKzy","hidden":"Drawer-module_hidden__8UJdg","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$14);

var _jsxFileName$1h = "/home/circleci/app/libs/listings-bot/src/components/Drawer/Drawer.jsx";

const Drawer = ({
  imageSrc,
  text,
  subtext,
  children,
  className,
  disabled,
  onClick,
  expanded
}) => {
  const [height, setHeight] = useState(0);
  const expandingDiv = useRef();
  const handleClick = useCallback(e => {
    const node = expandingDiv.current;

    if (node) {
      const height = node.getBoundingClientRect().height;
      setHeight(height);
    }

    onClick && onClick(e);
  }, [onClick]);
  const expandingHeightStyle = {
    height: expanded ? 'auto' : `${height}px`
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$13.drawer, className, expanded && styles$13.expanded),
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 41,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$13.helpContainer,
    onClick: handleClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 48,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$13.avatar,
    src: imageSrc,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 49,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$13.textItem,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 50,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "l",
    color: "gray",
    letterSpacing: "normal",
    className: styles$13.drawerText,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 51,
      columnNumber: 11
    }
  }, text), /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    color: "heather",
    letterSpacing: "normal",
    className: styles$13.drawerSubtext,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 59,
      columnNumber: 11
    }
  }, subtext)), /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$13.iconContainer, disabled && styles$13.disabled),
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Chevron, {
    className: classnames(styles$13.notSelected, className, expanded && styles$13.selected),
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 74,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    ref: expandingDiv,
    className: classnames(styles$13.expandedRow, !expanded && styles$13.hidden),
    style: expandingHeightStyle,
    __self: window,
    __source: {
      fileName: _jsxFileName$1h,
      lineNumber: 83,
      columnNumber: 7
    }
  }, children));
};

Drawer.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  text: PropTypes.string,
  subtext: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  status: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired
};

var _jsxFileName$1g = "/home/circleci/app/libs/listings-bot/src/components/ErrorBoundary/ErrorBoundary.js";
const propTypes$6 = {
  children: PropTypes.any,
  fallbackComponent: PropTypes.any
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }

  render() {
    const {
      hasError,
      error
    } = this.state;
    const {
      children,
      fallbackComponent: FallbackComponent = React__default.Fragment
    } = this.props;
    const props = this.props;

    if (hasError) {
      return /*#__PURE__*/React__default.createElement(FallbackComponent, _extends$1({
        error: error
      }, props, {
        __self: this,
        __source: {
          fileName: _jsxFileName$1g,
          lineNumber: 28,
          columnNumber: 14
        }
      }));
    }

    return children;
  }

}

ErrorBoundary.propTypes = propTypes$6;

var css_248z$13 = ".ExpandablePillTextField-module_textArea__-bT62 {\n  background-color: #48474d;\n  border-radius: 20px;\n  border: 1px solid #48474d;\n  box-shadow: none;\n  padding: 8px 14px;\n  color: #f3eff1;\n  transition: width 2s linear;\n  width: 100%;\n  resize: vertical;\n  font: inherit;\n  min-height: 26px;\n  max-height: 120px;\n}\n.ExpandablePillTextField-module_textArea__-bT62::-moz-placeholder {\n  color: #9d97ab;\n}\n.ExpandablePillTextField-module_textArea__-bT62:-ms-input-placeholder {\n  color: #9d97ab;\n}\n.ExpandablePillTextField-module_textArea__-bT62::placeholder {\n  color: #9d97ab;\n}\n.ExpandablePillTextField-module_textArea__-bT62:hover {\n  background-color: #525158;\n  border: 1px solid #9d97ab;\n}\n.ExpandablePillTextField-module_textArea__-bT62:focus-visible {\n  outline: none;\n  border: 1px solid #f3eff1;\n  border-radius: 20px;\n}";
var styles$12 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","textArea":"ExpandablePillTextField-module_textArea__-bT62","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$13);

const _excluded$l = ["name", "placeholder", "className", "value", "onChange", "maxRows"];
var _jsxFileName$1f = "/home/circleci/app/libs/listings-bot/src/components/ExpandablePillTextField/ExpandablePillTextField.jsx";

const ExpandablePillTextField = _ref => {
  let {
    name,
    placeholder,
    className,
    value,
    onChange,
    maxRows
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$l);

  return /*#__PURE__*/React__default.createElement(TextArea$1, _extends$1({
    className: classnames(styles$12.textArea, className),
    value: value,
    name: name,
    placeholder: placeholder,
    onChange: onChange,
    maxRows: maxRows
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1f,
      lineNumber: 19,
      columnNumber: 5
    }
  }));
};

ExpandablePillTextField.defaultProps = {
  placeholder: 'Type your question...'
};
ExpandablePillTextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  maxRows: PropTypes.number
};

var css_248z$12 = ".ErrorMessage-module_errorMessage__64aoW {\n  margin-top: 0.375em;\n  font-size: 0.8125em;\n  color: #ff4545;\n}";
var styles$11 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","errorMessage":"ErrorMessage-module_errorMessage__64aoW","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$12);

var _jsxFileName$1e = "/home/circleci/app/libs/listings-bot/src/components/Forms/ErrorMessage/ErrorMessage.jsx";

const ErrorMessage = props => /*#__PURE__*/React__default.createElement("div", _extends$1({
  className: styles$11.errorMessage
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$1e,
    lineNumber: 5,
    columnNumber: 3
  }
}));

var css_248z$11 = "@charset \"UTF-8\";\n\n.InlineBulletedList-module_list__4I-SC {\n  display: flex;\n  padding-left: 0;\n  margin: 0;\n}\n\n.InlineBulletedList-module_listItem__ngqLy {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.InlineBulletedList-module_listItem__ngqLy:before {\n  content: \"•\";\n  padding: 0 5px 0 5px;\n  color: #bbb2b7;\n}\n.InlineBulletedList-module_listItem__ngqLy:first-child:before {\n  display: none;\n}\n.InlineBulletedList-module_listItem__ngqLy:last-child:after {\n  display: none;\n}";
var styles$10 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","list":"InlineBulletedList-module_list__4I-SC","listItem":"InlineBulletedList-module_listItem__ngqLy","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$11);

var _jsxFileName$1d = "/home/circleci/app/libs/listings-bot/src/components/InlineBulletedList/InlineBulletedList.jsx";
const propTypes$5 = {
  children: PropTypes.any
};

const InlineBulletedList = ({
  children
}) => /*#__PURE__*/React__default.createElement(If, {
  condition: children,
  __self: window,
  __source: {
    fileName: _jsxFileName$1d,
    lineNumber: 12,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement("ul", {
  className: styles$10.list,
  __self: window,
  __source: {
    fileName: _jsxFileName$1d,
    lineNumber: 13,
    columnNumber: 5
  }
}, Children.toArray(children).map((child, index) => /*#__PURE__*/React__default.createElement("li", {
  className: styles$10.listItem,
  key: `li-${child.key || index}`,
  __self: window,
  __source: {
    fileName: _jsxFileName$1d,
    lineNumber: 15,
    columnNumber: 9
  }
}, child))));

InlineBulletedList.propTypes = propTypes$5;

var css_248z$10 = ".Input-module_root__r0Wa5 {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #f3eff1;\n  border: none;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1.5em;\n  font-weight: 300;\n  line-height: 2;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transition: background-color 0.35s ease-out, color 0.35s ease-out;\n  padding: 0;\n  box-sizing: border-box;\n  position: relative;\n}\n.Input-module_root__r0Wa5 > input {\n  padding: 0.25em 1.5em 0.25em 0.75em;\n  box-sizing: border-box;\n}\n.Input-module_root__r0Wa5::-moz-placeholder {\n  color: #3f3f3f;\n}\n.Input-module_root__r0Wa5:-ms-input-placeholder {\n  color: #3f3f3f;\n}\n.Input-module_root__r0Wa5::placeholder {\n  color: #3f3f3f;\n}\n.Input-module_root__r0Wa5:focus, .Input-module_root__r0Wa5:hover, .Input-module_root__r0Wa5:active {\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n.Input-module_root__r0Wa5:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  height: 0;\n  left: 50%;\n  right: 50%;\n  background-color: #bbb2b7;\n  transition: all 0.15s ease-out;\n}\n\n.Input-module_focused__Fqqjo:after {\n  height: 2px;\n  left: 0;\n  right: 0;\n}\n.Input-module_focused__Fqqjo input {\n  outline: none;\n}\n\n.Input-module_input__gA-3O {\n  background: none;\n  border: none;\n  color: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: left;\n  width: 100%;\n  height: auto;\n  box-shadow: unset;\n  padding: 0;\n}\n.Input-module_input__gA-3O:focus {\n  box-shadow: none;\n}\n\n.Input-module_appendText__ym3DV {\n  position: absolute;\n  right: 0.75em;\n  display: block;\n  transform: translate(0, -50%);\n  top: 50%;\n  pointer-events: none;\n  text-align: center;\n}";
var styles$$ = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"Input-module_root__r0Wa5","focused":"Input-module_focused__Fqqjo","input":"Input-module_input__gA-3O","appendText":"Input-module_appendText__ym3DV","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$10);

const _excluded$k = ["className", "type", "onFocus", "onBlur", "appendText"];
var _jsxFileName$1c = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/Input/Input.jsx";
const Input = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    className,
    type,
    onFocus,
    onBlur,
    appendText
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$k);

  const [mouseFocused, setMouseFocused] = useState(false);
  const [moused, setMoused] = useState(false);

  const captureMouse = () => {
    setMoused(true);
    window.addEventListener('mouseup', () => setMoused(false));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$$.root, mouseFocused && styles$$.focused, className),
    "data-qa": "input-wrapper",
    __self: window,
    __source: {
      fileName: _jsxFileName$1c,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("input", _extends$1({
    className: styles$$.input,
    type: type,
    onMouseDown: captureMouse,
    onFocus: e => {
      setMouseFocused(moused);
      if (onFocus) onFocus(e);
    },
    onBlur: e => {
      setMouseFocused(false);
      if (onBlur) onBlur(e);
    },
    ref: ref
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1c,
      lineNumber: 27,
      columnNumber: 9
    }
  })), appendText && /*#__PURE__*/React__default.createElement(Text, {
    size: "xs",
    className: styles$$.appendText,
    __self: window,
    __source: {
      fileName: _jsxFileName$1c,
      lineNumber: 43,
      columnNumber: 11
    }
  }, appendText));
});
Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  appendText: PropTypes.string
};
Input.displayName = 'Input';

var css_248z$$ = ".TextArea-module_root__QDOT0 {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #f3eff1;\n  border: none;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1.5em;\n  font-weight: 300;\n  line-height: 2;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n  transition: background-color 0.35s ease-out, color 0.35s ease-out;\n  padding: 0;\n  box-sizing: border-box;\n  position: relative;\n}\n.TextArea-module_root__QDOT0 > input {\n  padding: 0.25em 1.5em 0.25em 0.75em;\n  box-sizing: border-box;\n}\n.TextArea-module_root__QDOT0::-moz-placeholder {\n  color: #3f3f3f;\n}\n.TextArea-module_root__QDOT0:-ms-input-placeholder {\n  color: #3f3f3f;\n}\n.TextArea-module_root__QDOT0::placeholder {\n  color: #3f3f3f;\n}\n.TextArea-module_root__QDOT0:focus, .TextArea-module_root__QDOT0:hover, .TextArea-module_root__QDOT0:active {\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n.TextArea-module_root__QDOT0:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  height: 0;\n  left: 50%;\n  right: 50%;\n  background-color: #bbb2b7;\n  transition: all 0.15s ease-out;\n}\n\n.TextArea-module_focused__suavN:after {\n  height: 2px;\n  left: 0;\n  right: 0;\n}\n.TextArea-module_focused__suavN input {\n  outline: none;\n}\n\n.TextArea-module_input__5V1j8 {\n  box-shadow: none;\n  background: none;\n  outline: none;\n  border: none;\n  color: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: left;\n  width: 100%;\n}";
var styles$_ = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"TextArea-module_root__QDOT0","focused":"TextArea-module_focused__suavN","input":"TextArea-module_input__5V1j8","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$$);

const _excluded$j = ["className", "onFocus", "onBlur"];
var _jsxFileName$1b = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/TextArea/TextArea.jsx";
const TextArea = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    className,
    onFocus,
    onBlur
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$j);

  const [mouseFocused, setMouseFocused] = useState(false);
  const [moused, setMoused] = useState(false);

  const captureMouse = () => {
    setMoused(true);
    window.addEventListener('mouseup', () => setMoused(false));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$_.root, mouseFocused && styles$_.focused, className),
    "data-qa": "text-area-input-wrapper",
    __self: window,
    __source: {
      fileName: _jsxFileName$1b,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(TextArea$1, _extends$1({
    className: styles$_.input,
    onMouseDown: captureMouse,
    onFocus: e => {
      setMouseFocused(moused);
      if (onFocus) onFocus(e);
    },
    onBlur: e => {
      setMouseFocused(false);
      if (onBlur) onBlur(e);
    },
    ref: ref
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$1b,
      lineNumber: 27,
      columnNumber: 9
    }
  })));
});
TextArea.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
TextArea.displayName = 'TextArea';

var css_248z$_ = ".Iframe-module_root__3liMq {\n  border: none;\n}";
var styles$Z = {"root":"Iframe-module_root__3liMq"};
styleInject(css_248z$_);

const _excluded$i = ["src", "className", "title", "style"];
var _jsxFileName$1a = "/home/circleci/app/libs/listings-bot/src/components/Iframe/Iframe.jsx";

const Iframe = _ref => {
  let {
    src,
    className,
    title,
    style
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$i);

  return /*#__PURE__*/React__default.createElement("iframe", _extends$1({}, restProps, {
    style: style,
    className: classnames(styles$Z.root, className),
    title: title,
    src: src,
    __self: window,
    __source: {
      fileName: _jsxFileName$1a,
      lineNumber: 9,
      columnNumber: 5
    }
  }));
};

Iframe.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  style: PropTypes.object // iframes have a default height of 300px, need to manually override if we want it bigger

};

const _excluded$h = ["onChange", "name"];
var _jsxFileName$19 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/CurrencyInput/CurrencyInput.jsx";
const propTypes$4 = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  appendText: PropTypes.string
};
const CurrencyInput = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    onChange,
    name
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$h);

  const myRef = useRef(null);
  const inputRef = ref || myRef;
  return /*#__PURE__*/React__default.createElement(NumberFormat, _extends$1({
    customInput: Input,
    prefix: "$",
    getInputRef: inputRef,
    thousandSeparator: true,
    name: name,
    onValueChange: values => {
      const {
        value
      } = values;
      const event = {
        target: {
          name,
          value
        }
      };
      if (onChange) onChange(event);
    }
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$19,
      lineNumber: 19,
      columnNumber: 7
    }
  }));
});
CurrencyInput.propTypes = propTypes$4;
CurrencyInput.displayName = 'CurrencyInput';

var css_248z$Z = ".NightsInput-module_nightsInput__QHHPx > input {\n  padding-right: 3.5em;\n}";
var styles$Y = {"nightsInput":"NightsInput-module_nightsInput__QHHPx"};
styleInject(css_248z$Z);

const _excluded$g = ["className"];
var _jsxFileName$18 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/NightsInput/NightsInput.jsx";

const NightsInput = _ref => {
  let {
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$g);

  return /*#__PURE__*/React__default.createElement(Input, _extends$1({
    className: classnames(className, styles$Y.nightsInput),
    type: "number",
    appendText: "nights"
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$18,
      lineNumber: 10,
      columnNumber: 3
    }
  }));
};

NightsInput.propTypes = {
  className: PropTypes.string
};

var css_248z$Y = ".PerMonthInput-module_perMonthInput__beSCQ > input {\n  padding-right: 2.75em;\n}";
var styles$X = {"perMonthInput":"PerMonthInput-module_perMonthInput__beSCQ"};
styleInject(css_248z$Y);

const _excluded$f = ["className"];
var _jsxFileName$17 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/PerMonthInput/PerMonthInput.jsx";

const PerMonthInput = _ref => {
  let {
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$f);

  return /*#__PURE__*/React__default.createElement(CurrencyInput, _extends$1({
    className: classnames(className, styles$X.perMonthInput),
    appendText: "/mo"
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$17,
      lineNumber: 10,
      columnNumber: 3
    }
  }));
};

PerMonthInput.propTypes = {
  className: PropTypes.string
};

var css_248z$X = ".YearsInput-module_yearsInput__tKz7d > input {\n  padding-right: 3.25em;\n}";
var styles$W = {"yearsInput":"YearsInput-module_yearsInput__tKz7d"};
styleInject(css_248z$X);

const _excluded$e = ["className"];
var _jsxFileName$16 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/YearsInput/YearsInput.jsx";

const YearsInput = _ref => {
  let {
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$e);

  return /*#__PURE__*/React__default.createElement(Input, _extends$1({
    className: classnames(className, styles$W.yearsInput),
    type: "number",
    appendText: "years"
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$16,
      lineNumber: 10,
      columnNumber: 3
    }
  }));
};

YearsInput.propTypes = {
  className: PropTypes.string
};

const calculatePercent = (value, total) => value / total * 100.0;
const percentToDecimal = percentage => percentage / 100.0;

var css_248z$W = ".AmountPercentInput-module_amountPercentInput__b4S4N {\n  display: flex;\n  flex-direction: row;\n}\n\n.AmountPercentInput-module_amountField__WeWm6 {\n  flex: 1 0 66%;\n}\n\n.AmountPercentInput-module_percentField__90Ik- {\n  flex: 0 1 33%;\n  border-left: 1px solid #bbb2b7;\n}\n.AmountPercentInput-module_percentField__90Ik- > input {\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}";
var styles$V = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","amountPercentInput":"AmountPercentInput-module_amountPercentInput__b4S4N","amountField":"AmountPercentInput-module_amountField__WeWm6","percentField":"AmountPercentInput-module_percentField__90Ik-","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$W);

const _excluded$d = ["total", "amount", "name", "placeholder", "onChange", "autoFocus"];
var _jsxFileName$15 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Inputs/AmountPercentInput/AmountPercentInput.jsx";

const AmountPercentInput = _ref => {
  let {
    total,
    amount,
    name,
    placeholder: amountPlaceholder,
    onChange,
    autoFocus
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$d);

  const amountInputName = name || 'amount';
  const percentInputName = name ? `${name}Percent` : 'percent';
  const [percent, setPercent] = useState('');
  useEffect(() => {
    if (amount && total) {
      setPercent(calculatePercent(amount, total));
    }
  }, []);

  const handleChange = e => {
    const {
      target: {
        name,
        value
      }
    } = e;
    let newAmount;

    switch (name) {
      case percentInputName:
        newAmount = total * percentToDecimal(value);
        setPercent(value);
        break;

      case amountInputName:
        newAmount = value;
        setPercent(calculatePercent(value, total));
        break;

      default:
        console.log('Unexpected name');
    }

    if (onChange) {
      onChange({
        target: {
          name: amountInputName,
          value: newAmount
        }
      });
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$V.amountPercentInput,
    __self: window,
    __source: {
      fileName: _jsxFileName$15,
      lineNumber: 61,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(CurrencyInput, _extends$1({}, restProps, {
    name: amountInputName,
    placeholder: amountPlaceholder,
    className: styles$V.amountField,
    value: amount || '',
    allowNegative: false,
    onChange: handleChange,
    autoFocus: autoFocus,
    isNumericString: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$15,
      lineNumber: 62,
      columnNumber: 7
    }
  })), /*#__PURE__*/React__default.createElement(NumberFormat, _extends$1({}, restProps, {
    name: percentInputName,
    placeholder: amountPlaceholder && `${calculatePercent(numeral(amountPlaceholder).value(), total).toFixed(0)}%`,
    className: styles$V.percentField,
    value: percent || '',
    customInput: Input,
    suffix: "%",
    decimalScale: 0,
    isAllowed: ({
      value
    }) => value <= 100,
    allowNegative: false,
    isNumericString: true,
    onChange: e => {
      const {
        target: {
          value,
          name
        }
      } = e;
      handleChange({
        target: {
          name,
          value: value.replace(/%/g, '')
        }
      });
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$15,
      lineNumber: 73,
      columnNumber: 7
    }
  })));
};

AmountPercentInput.propTypes = {
  total: PropTypes.number,
  amount: PropTypes.number,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool
};

var css_248z$V = ".Feedback-module_root__FjvGp {\n  padding: 0 0.375em;\n}\n\n.Feedback-module_thumbs__uPiXN {\n  float: right;\n  padding: 0;\n  margin: -1em 0.375em 0.375em 0.375em;\n}\n.Feedback-module_thumbs__uPiXN:hover, .Feedback-module_thumbs__uPiXN:focus {\n  -webkit-animation: none;\n          animation: none;\n}\n.Feedback-module_thumbs__uPiXN.Feedback-module_down__-Nga- {\n  transform: scaleY(-1);\n}";
var styles$U = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"Feedback-module_root__FjvGp","thumbs":"Feedback-module_thumbs__uPiXN","down":"Feedback-module_down__-Nga-","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$V);

var _jsxFileName$14 = "/home/circleci/app/libs/listings-bot/src/components/Forms/Feedback/Feedback.jsx";

const Feedback = () => {
  const renderFeedback = useShouldShowFeedback();
  const {
    execute: trackFeedbackEvent
  } = useTrackFeedbackClick();
  const {
    thumbDirection,
    setThumbDirection
  } = useContext(AppContext);
  useEffect(() => {
    setThumbDirection(null);
  }, []);
  useEffect(() => {
    if (thumbDirection) {
      trackFeedbackEvent();
    }
  }, [thumbDirection]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$U.root,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 36,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: renderFeedback,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 37,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("hr", {
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 38,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    weight: "semibold",
    size: "s",
    letterSpacing: "large",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 39,
      columnNumber: 9
    }
  }, "Your Opinion"), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 48,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(If, {
    condition: thumbDirection === null,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 49,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    regular: true,
    onClick: () => setThumbDirection('down'),
    className: classnames(styles$U.thumbs, styles$U.down),
    iconStart: Thumb,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 50,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    regular: true,
    onClick: () => setThumbDirection('up'),
    className: styles$U.thumbs,
    iconStart: Thumb,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 57,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: "white",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 64,
      columnNumber: 11
    }
  }, "How useful was this?")), /*#__PURE__*/React__default.createElement(Unless, {
    condition: thumbDirection === null,
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: "white",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$14,
      lineNumber: 69,
      columnNumber: 11
    }
  }, "Submitted. Thank you for your feedback."))));
};

var css_248z$U = ".FormField-module_formField__sPPcq {\n  margin-bottom: 1rem;\n}\n\n.FormField-module_labelContainer__guBtF {\n  margin-bottom: 0.375em;\n}";
var styles$T = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","formField":"FormField-module_formField__sPPcq","labelContainer":"FormField-module_labelContainer__guBtF","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$U);

const _excluded$c = ["label", "hint", "name", "input", "subtext", "error"];
var _jsxFileName$13 = "/home/circleci/app/libs/listings-bot/src/components/Forms/FormField/FormField.jsx";

const DefaultLabel = props => /*#__PURE__*/React__default.createElement(Text, _extends$1({
  weight: "semibold",
  color: "inherit"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$13,
    lineNumber: 10,
    columnNumber: 3
  }
}));

const DefaultHint = props => /*#__PURE__*/React__default.createElement(Text, _extends$1({
  size: "s",
  color: "heather",
  element: "div"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$13,
    lineNumber: 14,
    columnNumber: 3
  }
}));

const Subtext = props => /*#__PURE__*/React__default.createElement(Text, _extends$1({
  size: "s",
  color: "heather",
  element: "div"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$13,
    lineNumber: 18,
    columnNumber: 3
  }
}));

const FormField = _ref => {
  let {
    label,
    hint,
    name,
    input,
    subtext,
    error
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$c);

  const InputComponent = input;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$T.formField,
    "data-qa": "form-field",
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 33,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$T.labelContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 34,
      columnNumber: 7
    }
  }, label && /*#__PURE__*/React__default.createElement(DefaultLabel, {
    text: label,
    htmlFor: name,
    "data-qa": "form-field-label",
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 36,
      columnNumber: 11
    }
  }, label), hint && /*#__PURE__*/React__default.createElement(DefaultHint, {
    "data-qa": "form-field-hint",
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 40,
      columnNumber: 18
    }
  }, hint)), /*#__PURE__*/React__default.createElement(InputComponent, _extends$1({
    "data-qa": `${name}-input`,
    name: name
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 42,
      columnNumber: 7
    }
  })), subtext && /*#__PURE__*/React__default.createElement(Subtext, {
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 43,
      columnNumber: 19
    }
  }, subtext), error && /*#__PURE__*/React__default.createElement(ErrorMessage, {
    "data-qa": `${name}-error`,
    __self: window,
    __source: {
      fileName: _jsxFileName$13,
      lineNumber: 44,
      columnNumber: 17
    }
  }, error));
};

FormField.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  input: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.elementType]).isRequired,
  subtext: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.elementType]),
  error: PropTypes.string
};

var css_248z$T = "@-webkit-keyframes LineLoader-module_lineScale__tpVbT {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n@keyframes LineLoader-module_lineScale__tpVbT {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.LineLoader-module_lineScale__tpVbT > div:nth-child(1) {\n  -webkit-animation: LineLoader-module_lineScale__tpVbT 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: LineLoader-module_lineScale__tpVbT 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n\n.LineLoader-module_lineScale__tpVbT > div:nth-child(2) {\n  -webkit-animation: LineLoader-module_lineScale__tpVbT 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: LineLoader-module_lineScale__tpVbT 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n\n.LineLoader-module_lineScale__tpVbT > div:nth-child(3) {\n  -webkit-animation: LineLoader-module_lineScale__tpVbT 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: LineLoader-module_lineScale__tpVbT 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n\n.LineLoader-module_lineScale__tpVbT > div:nth-child(4) {\n  -webkit-animation: LineLoader-module_lineScale__tpVbT 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: LineLoader-module_lineScale__tpVbT 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n\n.LineLoader-module_lineScale__tpVbT > div:nth-child(5) {\n  -webkit-animation: LineLoader-module_lineScale__tpVbT 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: LineLoader-module_lineScale__tpVbT 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n\n.LineLoader-module_lineScale__tpVbT > div {\n  background-color: white;\n  width: 0.25em;\n  height: 2.1875em;\n  border-radius: 0.125em;\n  margin: 0.125em;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n}";
var styles$S = {"lineScale":"LineLoader-module_lineScale__tpVbT"};
styleInject(css_248z$T);

var _jsxFileName$12 = "/home/circleci/app/libs/listings-bot/src/components/LineLoader/LineLoader.jsx";
const BAR_COUNT = 5; // Keep in sync with scss until we have json wired in
// Ahead of time for slight render performance

const BARS = new Array(BAR_COUNT).fill().map((_, i) => /*#__PURE__*/React__default.createElement("div", {
  key: `lineScale_${i}`,
  __self: window,
  __source: {
    fileName: _jsxFileName$12,
    lineNumber: 12,
    columnNumber: 18
  }
}));

const LineLoader = ({
  className
}) => /*#__PURE__*/React__default.createElement("div", {
  className: classnames(styles$S.lineScale, className),
  __self: window,
  __source: {
    fileName: _jsxFileName$12,
    lineNumber: 15,
    columnNumber: 3
  }
}, BARS);

LineLoader.propTypes = {
  className: PropTypes.string
};

var css_248z$S = ".ListingStatusHead-module_wrapper__HShOc {\n  position: relative;\n  padding: 0;\n  width: 50px;\n  height: 50px;\n  border: none;\n  outline: none;\n  border-radius: 100%;\n  flex-shrink: 0;\n}\n.ListingStatusHead-module_wrapper__HShOc.ListingStatusHead-module_errored__HP5wd {\n  background: transparent;\n  width: 44px;\n  height: 44px;\n  border: 3px solid #fc5aa6;\n}\n.ListingStatusHead-module_wrapper__HShOc.ListingStatusHead-module_errored__HP5wd > svg {\n  transform: scale(0.5) translateY(-1px);\n}\n.ListingStatusHead-module_wrapper__HShOc.ListingStatusHead-module_errored__HP5wd > svg > path {\n  fill: #f3eff1;\n}\n\n.ListingStatusHead-module_color-green__vOnqf {\n  box-shadow: 0 0 10px #3ce967;\n}\n.ListingStatusHead-module_color-orange__fERGe {\n  box-shadow: 0 0 10px #ff9545;\n}\n.ListingStatusHead-module_color-red__LADok {\n  box-shadow: 0 0 10px #ff4545;\n}\n\n.ListingStatusHead-module_loading__47Rry:before {\n  content: close-quote;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  border-radius: 100%;\n  border: 4px solid #535256;\n  border-top-color: transparent;\n  -webkit-animation: ListingStatusHead-module_rotate__8GQ2i 0.65s infinite linear;\n          animation: ListingStatusHead-module_rotate__8GQ2i 0.65s infinite linear;\n}\n\n@-webkit-keyframes ListingStatusHead-module_rotate__8GQ2i {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes ListingStatusHead-module_rotate__8GQ2i {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}";
var styles$R = {"color-green":"ListingStatusHead-module_color-green__vOnqf","color-dark-green":"#41664c","color-orange":"ListingStatusHead-module_color-orange__fERGe","color-pink":"#fc5aa6","color-red":"ListingStatusHead-module_color-red__LADok","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","wrapper":"ListingStatusHead-module_wrapper__HShOc","errored":"ListingStatusHead-module_errored__HP5wd","loading":"ListingStatusHead-module_loading__47Rry","rotate":"ListingStatusHead-module_rotate__8GQ2i","color___green":"ListingStatusHead-module_color-green__vOnqf","color___dark___green":"#41664c","color___orange":"ListingStatusHead-module_color-orange__fERGe","color___pink":"#fc5aa6","color___red":"ListingStatusHead-module_color-red__LADok","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$S);

var _jsxFileName$11 = "/home/circleci/app/libs/listings-bot/src/components/ListingStatusHead/ListingStatusHead.jsx";

const ListingStatusHead = ({
  color,
  spin,
  fail,
  className
}) => /*#__PURE__*/React__default.createElement("div", {
  className: classnames(styles$R.wrapper, styles$R[`color-${!fail && color}`], spin && styles$R.loading, fail && styles$R.errored, className),
  __self: window,
  __source: {
    fileName: _jsxFileName$11,
    lineNumber: 11,
    columnNumber: 3
  }
}, fail ? /*#__PURE__*/React__default.createElement(ExclamationTriangle, {
  __self: window,
  __source: {
    fileName: _jsxFileName$11,
    lineNumber: 20,
    columnNumber: 13
  }
}) : /*#__PURE__*/React__default.createElement(BotHead, {
  color: color,
  __self: window,
  __source: {
    fileName: _jsxFileName$11,
    lineNumber: 20,
    columnNumber: 39
  }
}));

ListingStatusHead.propTypes = {
  color: PropTypes.string,
  spin: PropTypes.bool,
  fail: PropTypes.any,
  className: PropTypes.string
};

var css_248z$R = ".MultiSelect-module_root__OLHmR {\n  display: inline-block;\n}\n.MultiSelect-module_root__OLHmR .MultiSelect-module_inputRoot__0U7UN {\n  position: static;\n}\n\n.MultiSelect-module_checkBoxRoot__DzXEU {\n  position: relative;\n  height: 20px;\n  width: 40px;\n  border-radius: 10px;\n  background: #808080;\n  flex-shrink: 0;\n}\n.MultiSelect-module_checkBoxRoot__DzXEU .MultiSelect-module_circle__J4Kp- {\n  background: #ffffff;\n  height: calc(100% - 4px);\n  width: calc(50% - 4px);\n  border: 2px solid transparent;\n  border-radius: 100%;\n  margin: 2px;\n  transition: margin-left ease-out 0.175s;\n  margin: 2px;\n}\n.MultiSelect-module_checkBoxRoot__DzXEU.MultiSelect-module_focused__2wMVW {\n  outline: auto;\n}\n.MultiSelect-module_checkBoxRoot__DzXEU:not(.MultiSelect-module_disabled__hrS06):hover {\n  background: #8d8d8d;\n}\n.MultiSelect-module_checkBoxRoot__DzXEU.MultiSelect-module_checked__HCDvp {\n  background: hsl(332deg, 96%, 67%);\n}\n.MultiSelect-module_checkBoxRoot__DzXEU.MultiSelect-module_checked__HCDvp .MultiSelect-module_circle__J4Kp- {\n  margin-left: calc(50% + 2px);\n}\n.MultiSelect-module_checkBoxRoot__DzXEU.MultiSelect-module_checked__HCDvp:not(.MultiSelect-module_disabled__hrS06):hover {\n  background: hsl(332deg, 96%, 75%);\n}\n.MultiSelect-module_checkBoxRoot__DzXEU .MultiSelect-module_hide__uWS7Q {\n  position: absolute;\n  opacity: 0;\n  width: 30px;\n  top: 3px;\n  left: 4px;\n  cursor: pointer;\n}\n\n.MultiSelect-module_checkBoxPill__ZXjTt {\n  position: relative;\n  cursor: pointer;\n  background-color: #48474d;\n  font-weight: 400;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 1px solid #48474d;\n  color: #f3eff1;\n}\n.MultiSelect-module_checkBoxPill__ZXjTt:hover {\n  background-color: #525158;\n  border: 1px solid #9d97ab;\n}\n.MultiSelect-module_checkBoxPill__ZXjTt.MultiSelect-module_focused__2wMVW {\n  border: 1px solid #9d97ab;\n}\n.MultiSelect-module_checkBoxPill__ZXjTt.MultiSelect-module_checked__HCDvp {\n  background-color: #68676d;\n}\n.MultiSelect-module_checkBoxPill__ZXjTt > input {\n  width: 100%;\n  height: 100%;\n}\n.MultiSelect-module_checkBoxPill__ZXjTt .MultiSelect-module_hide__uWS7Q {\n  position: absolute;\n  opacity: 0;\n  top: -2px;\n  left: -2px;\n  cursor: pointer;\n}\n\n.MultiSelect-module_disabled__hrS06 {\n  opacity: 0.5;\n}\n\n.MultiSelect-module_multiSelect__xDp6- {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-around;\n  width: 90%;\n}\n\n.MultiSelect-module_questionHeader__YmoTl {\n  opacity: 0.5;\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  opacity: 0.5;\n}\n\n.MultiSelect-module_questionHeaderContainer__qSQqZ {\n  margin: 10px 0px 10px 0px;\n}\n\n.MultiSelect-module_submitContainer__0CZLW {\n  font-family: Open Sans;\n  text-align: center;\n  color: #f3eff1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0.75em 0;\n}\n\n.MultiSelect-module_submitButton__i-hG3 {\n  background-color: #06a3f7;\n  border-radius: 2%;\n  color: #f3eff1;\n  line-height: 1;\n  padding: 0.75em 1em;\n  text-decoration: none;\n  height: 40px;\n}\n.MultiSelect-module_submitButton__i-hG3:hover, .MultiSelect-module_submitButton__i-hG3:focus, .MultiSelect-module_submitButton__i-hG3:active {\n  color: #f3eff1;\n}\n.MultiSelect-module_submitButton__i-hG3:hover svg path, .MultiSelect-module_submitButton__i-hG3:focus svg path, .MultiSelect-module_submitButton__i-hG3:active svg path {\n  fill: #f3eff1;\n}\n\n.MultiSelect-module_retrySubmit__-CKXl {\n  color: #0696e3;\n  cursor: pointer;\n}\n.MultiSelect-module_retrySubmit__-CKXl:hover {\n  color: #06a3f7;\n}\n\n.MultiSelect-module_fullWidth__2-s5U {\n  width: 100%;\n  display: flex;\n}\n\n.MultiSelect-module_filled__FE9GQ {\n  background: #68676d;\n}";
var styles$Q = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"MultiSelect-module_root__OLHmR","inputRoot":"MultiSelect-module_inputRoot__0U7UN","checkBoxRoot":"MultiSelect-module_checkBoxRoot__DzXEU","circle":"MultiSelect-module_circle__J4Kp-","focused":"MultiSelect-module_focused__2wMVW","disabled":"MultiSelect-module_disabled__hrS06","checked":"MultiSelect-module_checked__HCDvp","hide":"MultiSelect-module_hide__uWS7Q","checkBoxPill":"MultiSelect-module_checkBoxPill__ZXjTt","multiSelect":"MultiSelect-module_multiSelect__xDp6-","questionHeader":"MultiSelect-module_questionHeader__YmoTl","questionHeaderContainer":"MultiSelect-module_questionHeaderContainer__qSQqZ","submitContainer":"MultiSelect-module_submitContainer__0CZLW","submitButton":"MultiSelect-module_submitButton__i-hG3","retrySubmit":"MultiSelect-module_retrySubmit__-CKXl","fullWidth":"MultiSelect-module_fullWidth__2-s5U","filled":"MultiSelect-module_filled__FE9GQ","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$R);

const AFFORD_TOPIC_KEY = 'chromebot_listing_affordability_to_customer';
const INVESTMENT_TOPIC_KEY = 'chromebot_listing_investment_to_customer';
const PREQUAL_TOPIC_KEY = 'chromebot_listing_prequalification_to_sponsor';
const CUSTOM_QUESTION_TOPIC_KEY = 'chromebot_listing_custom_to_customer';

const HIDDEN = 'hidden';

var _jsxFileName$10 = "/home/circleci/app/libs/listings-bot/src/components/MultiSelect/MultiSelect.jsx";

const MultiSelect = ({
  onCustomQuestionChange,
  updateSelectedQuestions,
  setPrequalSelected,
  onSubmit,
  error,
  loadingSpin,
  className,
  buttonLabel,
  questions,
  customQuestionMessage,
  multiSelectDisabled
}) => {
  const displayRef = useRef();
  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleSelectQuestions = topicKey => {
    const found = selectedKeys.includes(topicKey);

    if (found) {
      const selectedKeysCopy = [...selectedKeys];
      const newSelectedKeys = selectedKeysCopy.filter(key => key !== topicKey);
      setSelectedKeys(newSelectedKeys);
    } else {
      setSelectedKeys(selectedKeys => [...selectedKeys, topicKey]);
    }
  };

  useEffect(() => {
    if (selectedKeys) {
      if (selectedKeys.length >= 0) {
        const selectedQuestions = selectedKeys.map(selectedQuestionKey => {
          const selectedQuestion = questions.find(q => q.topicKey === selectedQuestionKey);
          return selectedQuestion;
        });
        updateSelectedQuestions(selectedQuestions);
      }
    }
  }, [selectedKeys, questions, updateSelectedQuestions]);
  useEffect(() => {
    if (selectedKeys) {
      const prequalFound = selectedKeys.includes(PREQUAL_TOPIC_KEY);

      if (prequalFound) {
        setPrequalSelected(true);
      } else {
        setPrequalSelected(false);
      }
    }
  }, [selectedKeys, setPrequalSelected]); //resets qustions on drawer close

  useEffect(() => {
    if (displayRef.current && selectedKeys.length && window.getComputedStyle(displayRef == null ? void 0 : displayRef.current).visibility === HIDDEN) {
      setSelectedKeys([]);
    }
  });
  const customIsFilled = customQuestionMessage && customQuestionMessage.length;
  return /*#__PURE__*/React__default.createElement("div", {
    ref: displayRef,
    className: classnames(styles$Q.multiSelect, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 90,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q.questionHeaderContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 91,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    className: styles$Q.questionHeader,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 92,
      columnNumber: 9
    }
  }, "Select As Many As You'd Like")), /*#__PURE__*/React__default.createElement(QuestionCheckboxes, {
    onClick: handleSelectQuestions,
    questions: questions,
    selectedKeys: selectedKeys,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 96,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$Q.questionCheckboxContainer, styles$Q.fullWidth),
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 101,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ExpandablePillTextField, {
    className: customIsFilled && styles$Q.filled,
    name: "Custom Question",
    onChange: onCustomQuestionChange,
    value: customQuestionMessage,
    maxRows: 2,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 107,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$Q.submitContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 115,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Unless, {
    condition: error,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 116,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    primary: !multiSelectDisabled,
    onClick: onSubmit,
    disabled: multiSelectDisabled,
    children: buttonLabel,
    fullWidth: true,
    loading: loadingSpin,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 117,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(If, {
    condition: error,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 126,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 127,
      columnNumber: 11
    }
  }, "Something went wrong."), /*#__PURE__*/React__default.createElement("div", {
    onClick: onSubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 128,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    className: styles$Q.retrySubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$10,
      lineNumber: 129,
      columnNumber: 13
    }
  }, "Retry Sending?")))));
};

MultiSelect.propTypes = {
  onCustomQuestionChange: PropTypes.func,
  updateSelectedQuestions: PropTypes.func,
  setPrequalSelected: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedKeys: PropTypes.array,
  questions: PropTypes.array,
  className: PropTypes.string,
  customQuestionMessage: PropTypes.string,
  buttonLabel: PropTypes.string,
  multiSelectDisabled: PropTypes.bool,
  loadingSpin: PropTypes.bool,
  error: PropTypes.bool
};

var css_248z$Q = ".NavigationButton-module_button__wRAfx {\n  display: inline-flex;\n  background-color: inherit;\n  border: none;\n  padding-left: 2px;\n  padding-right: 2px;\n}\n.NavigationButton-module_button__wRAfx:hover, .NavigationButton-module_button__wRAfx:focus, .NavigationButton-module_button__wRAfx:active {\n  cursor: pointer;\n  color: #4fbffb;\n}\n.NavigationButton-module_button__wRAfx.NavigationButton-module_border__5kKvA {\n  border: 1px solid #3a383f;\n}\n.NavigationButton-module_button__wRAfx:focus-visible {\n  outline: none;\n  border: 1px solid #06a3f7;\n}\n.NavigationButton-module_button__wRAfx > .NavigationButton-module_buttonChild__UctsY {\n  border-bottom: 1px dashed #06a3f7;\n}\n.NavigationButton-module_button__wRAfx > .NavigationButton-module_buttonChild__UctsY *:hover, .NavigationButton-module_button__wRAfx > .NavigationButton-module_buttonChild__UctsY *:focus, .NavigationButton-module_button__wRAfx > .NavigationButton-module_buttonChild__UctsY *:active {\n  cursor: pointer;\n  color: #4fbffb;\n  border-bottom: 1px dashed #4fbffb;\n}";
var styles$P = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","button":"NavigationButton-module_button__wRAfx","border":"NavigationButton-module_border__5kKvA","buttonChild":"NavigationButton-module_buttonChild__UctsY","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$Q);

const _excluded$b = ["className", "children", "onClick"];
var _jsxFileName$$ = "/home/circleci/app/libs/listings-bot/src/components/NavigationButton/NavigationButton.jsx";
const NavigationButton = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    className,
    children,
    onClick
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$b);

  return /*#__PURE__*/React__default.createElement("button", _extends$1({
    className: classnames(styles$P.button, className),
    ref: ref,
    onClick: onClick
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$$,
      lineNumber: 14,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    weight: "semibold",
    element: "span",
    color: "blue",
    className: classnames(styles$P.buttonChild),
    __self: window,
    __source: {
      fileName: _jsxFileName$$,
      lineNumber: 20,
      columnNumber: 9
    }
  }, children));
});
NavigationButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]),
  onClick: PropTypes.func
};

var css_248z$P = ".OverlayPanel-module_root__id38L {\n  background-color: #302e35;\n  position: relative;\n}\n\n.OverlayPanel-module_body__h-akQ {\n  position: relative;\n  padding: 0 1em 1em;\n}";
var styles$O = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"OverlayPanel-module_root__id38L","body":"OverlayPanel-module_body__h-akQ","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$P);

var _jsxFileName$_ = "/home/circleci/app/libs/listings-bot/src/components/OverlayPanel/OverlayPanel.jsx";

const OverlayPanel = ({
  children,
  className
}) => /*#__PURE__*/React__default.createElement("div", {
  className: classnames(styles$O.root, className),
  __self: window,
  __source: {
    fileName: _jsxFileName$_,
    lineNumber: 9,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement("div", {
  className: styles$O.body,
  __self: window,
  __source: {
    fileName: _jsxFileName$_,
    lineNumber: 10,
    columnNumber: 5
  }
}, children));

OverlayPanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

var css_248z$O = ".OverlayPanelHeader-module_header__UHk6q {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0.75em 0 1.5em 0;\n}\n\n.OverlayPanelHeader-module_backButtonWrap__tL-5x {\n  margin: 0;\n  margin-left: -0.75em;\n  padding: 0;\n}\n.OverlayPanelHeader-module_backButtonWrap__tL-5x svg {\n  transform: rotate(90deg);\n}\n\n.OverlayPanelHeader-module_headerContent__R8G-0 {\n  width: 100%;\n  text-align: center;\n  padding-right: 50px;\n}\n\n.OverlayPanelHeader-module_empty__wWZqN {\n  flex: 1;\n}";
var styles$N = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","header":"OverlayPanelHeader-module_header__UHk6q","backButtonWrap":"OverlayPanelHeader-module_backButtonWrap__tL-5x","headerContent":"OverlayPanelHeader-module_headerContent__R8G-0","empty":"OverlayPanelHeader-module_empty__wWZqN","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$O);

var _jsxFileName$Z = "/home/circleci/app/libs/listings-bot/src/components/OverlayPanel/OverlayPanelHeader.jsx";

const OverlayPanelHeader = ({
  onBack,
  children
}) => /*#__PURE__*/React__default.createElement("div", {
  className: styles$N.header,
  __self: window,
  __source: {
    fileName: _jsxFileName$Z,
    lineNumber: 9,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement("div", {
  className: styles$N.backButtonWrap,
  __self: window,
  __source: {
    fileName: _jsxFileName$Z,
    lineNumber: 10,
    columnNumber: 5
  }
}, /*#__PURE__*/React__default.createElement(Button, {
  iconStart: Chevron,
  onClick: onBack,
  minimal: true,
  __self: window,
  __source: {
    fileName: _jsxFileName$Z,
    lineNumber: 11,
    columnNumber: 7
  }
}, "Back")), /*#__PURE__*/React__default.createElement("div", {
  className: styles$N.headerContent,
  __self: window,
  __source: {
    fileName: _jsxFileName$Z,
    lineNumber: 15,
    columnNumber: 5
  }
}, children), /*#__PURE__*/React__default.createElement("div", {
  className: styles$N.empty,
  __self: window,
  __source: {
    fileName: _jsxFileName$Z,
    lineNumber: 18,
    columnNumber: 5
  }
}));

OverlayPanelHeader.propTypes = {
  onBack: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var css_248z$N = ".Pill-module_pill__VTtfp {\n  font-size: 1em;\n  display: inline;\n  align-items: center;\n  padding: 0.375em 0.75em;\n  margin: 0.375em;\n  color: #f3eff1;\n  background-color: #3a383f;\n  border: none;\n  border-radius: 20px;\n}\n.Pill-module_pill__VTtfp:hover {\n  cursor: pointer;\n  background-color: #4c4851;\n  transition: 0.1s ease-in-out background-color;\n}";
var styles$M = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","pill":"Pill-module_pill__VTtfp","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$N);

const _excluded$a = ["className", "children", "onClick"];
var _jsxFileName$Y = "/home/circleci/app/libs/listings-bot/src/components/Pill/Pill.jsx";

const Pill = _ref => {
  let {
    className,
    children,
    onClick
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$a);

  return /*#__PURE__*/React__default.createElement("button", _extends$1({
    className: classnames(styles$M.pill, className),
    onClick: onClick
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$Y,
      lineNumber: 9,
      columnNumber: 5
    }
  }), children);
};

Pill.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]),
  onClick: PropTypes.func
};

var css_248z$M = ".Panel-module_panel__qmU1z {\n  background: #3a383f;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.195511);\n  border-radius: 12px;\n}";
var styles$L = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","panel":"Panel-module_panel__qmU1z","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$M);

var _jsxFileName$X = "/home/circleci/app/libs/listings-bot/src/components/Panel/Panel.jsx";

const Panel = ({
  className,
  children
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$L.panel, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$X,
      lineNumber: 9,
      columnNumber: 10
    }
  }, children);
};

Panel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

var css_248z$L = ".PanelDivider-module_root__8Ortf hr {\n  border-top: 0.025px solid #2e2e2e;\n  border-bottom: none;\n  border-left: none;\n  border-right: none;\n  box-shadow: 0px 1px 2px #888888;\n  margin: 0.75em -17px 0.75em -17px;\n}\n.PanelDivider-module_root__8Ortf .PanelDivider-module_wrapper__oYg5m {\n  display: flex;\n}\n.PanelDivider-module_root__8Ortf .PanelDivider-module_icon__WSfSN {\n  height: 26px;\n  width: 26px;\n  margin-right: 15px;\n  flex-shrink: 0;\n}";
var styles$K = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"PanelDivider-module_root__8Ortf","wrapper":"PanelDivider-module_wrapper__oYg5m","icon":"PanelDivider-module_icon__WSfSN","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$L);

var _jsxFileName$W = "/home/circleci/app/libs/listings-bot/src/components/PanelDivider/PanelDivider.jsx";

const PanelDivider = ({
  className,
  children,
  icon,
  footer,
  header
}) => {
  if (footer === undefined && header === undefined) {
    throw new Error('Header or Footer must be supplied as prop to PanelDivider');
  }

  const renderChildrenWithIcon = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$K.wrapper,
      __self: window,
      __source: {
        fileName: _jsxFileName$W,
        lineNumber: 15,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$K.icon,
      __self: window,
      __source: {
        fileName: _jsxFileName$W,
        lineNumber: 16,
        columnNumber: 9
      }
    }, icon()), children);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$K.root, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$W,
      lineNumber: 22,
      columnNumber: 5
    }
  }, footer && /*#__PURE__*/React__default.createElement("hr", {
    className: styles$K.hr,
    __self: window,
    __source: {
      fileName: _jsxFileName$W,
      lineNumber: 23,
      columnNumber: 18
    }
  }), icon && renderChildrenWithIcon(), !icon && children, header && /*#__PURE__*/React__default.createElement("hr", {
    className: styles$K.hr,
    __self: window,
    __source: {
      fileName: _jsxFileName$W,
      lineNumber: 26,
      columnNumber: 18
    }
  }));
};

PanelDivider.propTypes = {
  header: PropTypes.bool,
  footer: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.object])
};

var css_248z$K = ".QuestionCheckboxes-module_questionCheckboxContainer__fIz45 {\n  margin-bottom: 0.375em;\n  width: auto;\n}";
var styles$J = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","questionCheckboxContainer":"QuestionCheckboxes-module_questionCheckboxContainer__fIz45","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$K);

var _jsxFileName$V = "/home/circleci/app/libs/listings-bot/src/components/QuestionCheckboxes/QuestionCheckboxes.jsx";

const QuestionCheckboxes = ({
  onClick,
  selectedKeys,
  questions
}) => {
  return questions.map(question => {
    const {
      topicKey,
      message
    } = question;
    const checked = selectedKeys.includes(topicKey);

    const handleClick = () => {
      onClick(topicKey);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      key: topicKey,
      className: styles$J.questionCheckboxContainer,
      onClick: handleClick,
      role: "button",
      __self: window,
      __source: {
        fileName: _jsxFileName$V,
        lineNumber: 19,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      pill: true,
      name: topicKey,
      children: message,
      checked: checked,
      __self: window,
      __source: {
        fileName: _jsxFileName$V,
        lineNumber: 25,
        columnNumber: 9
      }
    }));
  });
};

QuestionCheckboxes.propTypes = {
  onClick: PropTypes.func,
  selectedKeys: PropTypes.array,
  questions: PropTypes.array
};

var css_248z$J = ".Slider-module_slider__sTsv6 {\n  position: relative;\n  min-height: 56px;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0 {\n  background: none;\n  border: none;\n  box-shadow: unset;\n  display: block;\n  position: absolute;\n  -webkit-appearance: none;\n  background-color: transparent;\n  width: calc(100% + 2 *16px);\n  left: -16px;\n  margin: 0;\n  padding: 0;\n  min-height: 56px;\n  z-index: 1;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0::-webkit-slider-runnable-track {\n  box-sizing: border-box;\n  border: none;\n  cursor: pointer;\n  height: 8px;\n  width: 100%;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0::-webkit-slider-thumb {\n  width: 56px;\n  height: 56px;\n  box-shadow: none;\n  border: none;\n  border-radius: 56px;\n  background: transparent;\n  cursor: pointer;\n  -webkit-appearance: none;\n  position: relative;\n  top: -24px;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0::-moz-range-thumb {\n  width: 56px;\n  height: 56px;\n  box-shadow: none;\n  border: none;\n  border-radius: 56px;\n  background: transparent;\n  cursor: pointer;\n  -moz-appearance: none;\n  position: relative;\n  top: -24px;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0:focus {\n  outline: none;\n}\n.Slider-module_slider__sTsv6 .Slider-module_input__fDbA0:focus-visible {\n  outline: none;\n}\n\n.Slider-module_caption__dW4PL {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.Slider-module_progress__pVHaQ {\n  height: 8px;\n  background: rgba(243, 239, 241, 0.8);\n  position: absolute;\n  left: 0px;\n  top: 24px;\n  border-radius: 5px 0 0 5px;\n}\n\n.Slider-module_background__XOJ1x {\n  background: rgba(157, 151, 171, 0.5);\n  height: 8px;\n  position: absolute;\n  right: 0px;\n  top: 24px;\n  border-radius: 0 5px 5px 0;\n}\n\n.Slider-module_svg__W3-3B {\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 20px;\n  transform: translateX(-50%);\n  overflow: visible !important;\n}\n\n.Slider-module_outerCircle__5jKs4 {\n  stroke: #f3eff1;\n  stroke-width: 0.15px;\n  fill: #000000;\n  transition: r 0.15s ease-out, fill 0.15s ease-out 0.15s;\n}\n.Slider-module_outerCircle__5jKs4.Slider-module_active__NI6hj {\n  fill: #fc5aa6;\n  r: 1.4;\n  transition: r 0.15s ease-out, fill 0s ease-out;\n}\n.Slider-module_outerCircle__5jKs4.Slider-module_focus__Qg-xe {\n  fill: #fc5aa6;\n  r: 1.4;\n  transition: r 0.15s ease-out, fill 0s ease-out;\n}\n\n.Slider-module_innerCircle__ceeZ1 {\n  stroke: none;\n  stroke-width: 0.25px;\n  fill: #f3eff1;\n}\n\n.Slider-module_marker__eC-PU {\n  position: absolute;\n  border-bottom: 1px dashed rgba(243, 239, 241, 0.8);\n  transform: rotate(90deg);\n  width: 22px;\n}\n\n.Slider-module_markerContent__DWzFw {\n  position: absolute;\n}";
var styles$I = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","markerWidth":"22px","markerTopUpDirection":"20px","markerTopDownDirection":"35px","markerContentTopUpDirectionSingle":"-7px","markerContentTopUpDirectionDouble":"-23px","markerContentTopDownDirection":"50px","slider":"Slider-module_slider__sTsv6","input":"Slider-module_input__fDbA0","caption":"Slider-module_caption__dW4PL","progress":"Slider-module_progress__pVHaQ","background":"Slider-module_background__XOJ1x","svg":"Slider-module_svg__W3-3B","outerCircle":"Slider-module_outerCircle__5jKs4","active":"Slider-module_active__NI6hj","focus":"Slider-module_focus__Qg-xe","innerCircle":"Slider-module_innerCircle__ceeZ1","marker":"Slider-module_marker__eC-PU","markerContent":"Slider-module_markerContent__DWzFw","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$J);

const _excluded$9 = ["ariaLabel", "caption", "className", "defaultValue", "name", "id", "markers", "max", "maxPhrase", "min", "minPhrase", "onBlur", "onChange", "onFocus", "onMouseDown", "onMouseUp", "onTouchEnd", "onTouchStart", "value"];
var _jsxFileName$U = "/home/circleci/app/libs/listings-bot/src/components/Slider/Slider.jsx";

const markerWidth = styles$I.markerWidth;
const markerTopUpDirection = styles$I.markerTopUpDirection;
const markerTopDownDirection = styles$I.markerTopDownDirection; // Marker Content Styles

const markerContentTopUpDirectionSingleLine = styles$I.markerContentTopUpDirectionSingle;
const markerContentTopUpDirectionDoubleLine = styles$I.markerContentTopUpDirectionDouble;
const markerContentTopDownDirection = styles$I.markerContentTopDownDirection;
const propTypes$3 = {
  ariaLabel: PropTypes.string,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
  markers: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    direction: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    multiline: PropTypes.bool
  })),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxPhrase: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minPhrase: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onTouchStart: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps$1 = {
  ariaLabel: 'slider values',
  max: '100',
  min: '0'
};
const defaultCaptionPropTypes = {
  minPhrase: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  maxPhrase: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

const CaptionText = props => /*#__PURE__*/React__default.createElement(Text, _extends$1({
  size: "xxs",
  weight: "bold",
  color: "heather",
  element: "span"
}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$U,
    lineNumber: 65,
    columnNumber: 3
  }
}));

const DefaultCaption = ({
  minPhrase,
  maxPhrase
}) => /*#__PURE__*/React__default.createElement("div", {
  className: styles$I.caption,
  __self: window,
  __source: {
    fileName: _jsxFileName$U,
    lineNumber: 69,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement(CaptionText, {
  __self: window,
  __source: {
    fileName: _jsxFileName$U,
    lineNumber: 70,
    columnNumber: 5
  }
}, minPhrase), /*#__PURE__*/React__default.createElement(CaptionText, {
  __self: window,
  __source: {
    fileName: _jsxFileName$U,
    lineNumber: 71,
    columnNumber: 5
  }
}, maxPhrase));

const Slider = _ref => {
  let {
    ariaLabel,
    caption,
    className,
    defaultValue,
    name,
    id = uniqueId(name),
    markers,
    max,
    maxPhrase,
    min,
    minPhrase,
    onBlur,
    onChange,
    onFocus,
    onMouseDown,
    onMouseUp,
    onTouchEnd,
    onTouchStart,
    value
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$9);

  const [controlledValue, setControlledValue] = useState(defaultValue);
  const [active, setActive] = useState(false);
  const [focused, setFocused] = useState(false);
  const [firstMarkerParams, setFirstMarkerParams] = useState({
    width: 0
  });
  const [secondMarkerParams, setSecondMarkerParams] = useState({
    width: 0
  });
  const firstMarkerRef = useRef(null);
  const secondMarkerRef = useRef(null);
  const myValue = controlledValue || value;
  const Caption = caption || DefaultCaption;
  const numMin = parseFloat(min);
  const numMax = parseFloat(max);
  const numVal = parseFloat(myValue);
  const percentFromMax = (numMax - numVal) / (numMax - numMin);
  const percentFromMin = 1 - percentFromMax;
  useEffect(() => {
    var _firstMarkerRef$curre, _secondMarkerRef$curr;

    setFirstMarkerParams({
      width: (_firstMarkerRef$curre = firstMarkerRef.current) == null ? void 0 : _firstMarkerRef$curre.offsetWidth
    });
    setSecondMarkerParams({
      width: (_secondMarkerRef$curr = secondMarkerRef.current) == null ? void 0 : _secondMarkerRef$curr.offsetWidth
    });
  }, []);

  const renderMarkers = () => {
    if (isEmpty$1(markers)) return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      __self: window,
      __source: {
        fileName: _jsxFileName$U,
        lineNumber: 125,
        columnNumber: 34
      }
    });
    return markers.map((marker, index) => {
      // Distance in percentage of the marker's value from the left side of the slider
      const markerPercentFromMin = 1 - (numMax - marker.value) / (numMax - numMin); // Assume we will only ever have 1 or 2 markers

      const ref = index === 0 ? firstMarkerRef : secondMarkerRef;
      const markerContentWidth = index === 0 ? firstMarkerParams.width : secondMarkerParams.width;
      const markerIsUp = marker.direction === 'up'; // Assume we will only have 1 or 2 lines of text in top markers
      // If the direction of the marker is up and it is a single line of content - apply the top vars px
      // Etc..

      let markerContentTop;

      if (markerIsUp) {
        markerContentTop = marker.multiline ? markerContentTopUpDirectionDoubleLine : markerContentTopUpDirectionSingleLine;
      } else {
        markerContentTop = markerContentTopDownDirection;
      }

      return /*#__PURE__*/React__default.createElement("div", {
        key: uniqueId(marker.value),
        __self: window,
        __source: {
          fileName: _jsxFileName$U,
          lineNumber: 154,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          top: markerIsUp ? markerTopUpDirection : markerTopDownDirection,
          left: `calc(${markerPercentFromMin} * 100% - ${markerWidth} / 2)`
        },
        className: styles$I.marker,
        __self: window,
        __source: {
          fileName: _jsxFileName$U,
          lineNumber: 155,
          columnNumber: 11
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        ref: ref,
        className: styles$I.markerContent,
        style: {
          top: markerContentTop,
          left: `calc(${markerPercentFromMin} * 100% - ${markerContentWidth / 2}px)`
        },
        __self: window,
        __source: {
          fileName: _jsxFileName$U,
          lineNumber: 162,
          columnNumber: 11
        }
      }, marker.content));
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 180,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$I.slider,
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 181,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$I.progress,
    style: {
      right: `calc((${percentFromMax} * 100%)`
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 182,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$I.background,
    style: {
      left: `calc((${percentFromMin} * 100%)`
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 188,
      columnNumber: 9
    }
  }), renderMarkers(), /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 2 2",
    className: styles$I.svg,
    style: {
      left: `calc(${percentFromMin} * 100%)`
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 195,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: classnames(styles$I.outerCircle, active && styles$I.active, focused && styles$I.focus),
    cx: "1",
    cy: "1",
    r: "1",
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 202,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement("circle", {
    className: classnames(styles$I.innerCircle, focused && styles$I.focused),
    cx: "1",
    cy: "1",
    r: "0.65",
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 212,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement("input", _extends$1({
    id: id,
    name: name,
    type: "range",
    onTouchStart: e => {
      setActive(true);
      if (onTouchStart) onTouchStart(e);
    },
    onTouchEnd: e => {
      setActive(false);
      if (onTouchEnd) onTouchEnd(e);
    },
    onMouseDown: e => {
      setActive(true);
      if (onMouseDown) onMouseDown(e);
    },
    onMouseUp: e => {
      setActive(false);
      if (onMouseUp) onMouseUp(e);
    },
    onFocus: e => {
      !active && setFocused(true);
      if (onFocus) onFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      if (onBlur) onBlur(e);
    },
    onChange: event => {
      const newValue = event.target.value;

      if (value == null) {
        setControlledValue(newValue);
      }

      if (onChange) {
        onChange(event);
      }
    },
    min: min,
    max: max,
    value: myValue,
    className: styles$I.input,
    "aria-label": ariaLabel
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 222,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Caption, {
    minPhrase: minPhrase,
    maxPhrase: maxPhrase,
    __self: window,
    __source: {
      fileName: _jsxFileName$U,
      lineNumber: 266,
      columnNumber: 9
    }
  })));
};

DefaultCaption.propTypes = defaultCaptionPropTypes;
Slider.propTypes = propTypes$3;
Slider.defaultProps = defaultProps$1;

var css_248z$I = ".StatusBar-module_bar__G5pov {\n  position: relative;\n  height: 4px;\n  width: 100%;\n  margin-bottom: -5px;\n  background: #302e35;\n  overflow: hidden;\n  opacity: 0;\n}\n\n.StatusBar-module_thinking__jdOoH {\n  opacity: 1;\n  transition: opacity 0.5s ease-out;\n}\n.StatusBar-module_thinking__jdOoH:before, .StatusBar-module_thinking__jdOoH:after {\n  content: close-quote;\n  position: absolute;\n  width: 75%;\n  height: 100%;\n  left: -75%;\n  background: linear-gradient(to right, transparent, #fc5aa6);\n}\n.StatusBar-module_thinking__jdOoH:before {\n  -webkit-animation: StatusBar-module_think__kcbSj 1.5s linear infinite;\n          animation: StatusBar-module_think__kcbSj 1.5s linear infinite;\n}\n.StatusBar-module_thinking__jdOoH:after {\n  -webkit-animation: StatusBar-module_think__kcbSj 1.5s 0.75s linear infinite;\n          animation: StatusBar-module_think__kcbSj 1.5s 0.75s linear infinite;\n}\n\n@-webkit-keyframes StatusBar-module_think__kcbSj {\n  0% {\n    left: -75%;\n  }\n  100% {\n    left: calc(100% + 75%);\n  }\n}\n\n@keyframes StatusBar-module_think__kcbSj {\n  0% {\n    left: -75%;\n  }\n  100% {\n    left: calc(100% + 75%);\n  }\n}";
var styles$H = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","bar":"StatusBar-module_bar__G5pov","thinking":"StatusBar-module_thinking__jdOoH","think":"StatusBar-module_think__kcbSj","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$I);

const _excluded$8 = ["thinking", "className"];
var _jsxFileName$T = "/home/circleci/app/libs/listings-bot/src/components/StatusBar/StatusBar.jsx";

const StatusBar = _ref => {
  let {
    thinking,
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$8);

  return /*#__PURE__*/React__default.createElement("div", _extends$1({
    className: classnames(styles$H.bar, thinking && styles$H.thinking, className)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$T,
      lineNumber: 8,
      columnNumber: 3
    }
  }));
};

StatusBar.propTypes = {
  thinking: PropTypes.bool,
  className: PropTypes.string
};

var css_248z$H = ".Tabs-module_tabs__cqEwW {\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  list-style: none;\n  margin: 0;\n  padding: 0 1em 0 1em;\n  flex-wrap: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.Tabs-module_tabs__cqEwW > li:not(:first-of-type) {\n  padding-left: 0.375em;\n}";
var styles$G = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","tabs":"Tabs-module_tabs__cqEwW","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$H);

var _jsxFileName$S = "/home/circleci/app/libs/listings-bot/src/components/Tabs/Tabs.jsx";

const Tabs = ({
  activeTab,
  children,
  onClick,
  className
}) => {
  const handleOnClick = e => {
    e.preventDefault();
    onClick(e);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("ul", {
    className: classnames(styles$G.tabs, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$S,
      lineNumber: 16,
      columnNumber: 7
    }
  }, children.map(child => {
    if (child.type.displayName !== 'Tab') {
      throw new Error('Tab must be used within Tabs');
    }

    const enhancedTab = /*#__PURE__*/React__default.cloneElement(child, {
      key: child.props.label,
      activeTab,
      children,
      onClick: handleOnClick
    });
    return enhancedTab;
  })), /*#__PURE__*/React__default.createElement("div", {
    __self: window,
    __source: {
      fileName: _jsxFileName$S,
      lineNumber: 31,
      columnNumber: 7
    }
  }, children.map(child => {
    if (child.props.label !== activeTab) return undefined;
    return child.props.children;
  })));
};

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

var css_248z$G = "button.Tab-module_tabBtn__zwT09 {\n  font-size: 0.875em;\n  line-height: 16px;\n  background: transparent;\n  border: none;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0.75em 0.375em;\n  border: solid #302e35;\n  border-width: 2px 0;\n}\nbutton.Tab-module_tabBtn__zwT09.Tab-module_activeTabBtn__orqQn {\n  border-bottom-color: #f3eff1;\n  color: #f3eff1;\n}\nbutton.Tab-module_tabBtn__zwT09:hover:not(.Tab-module_activeTabBtn__orqQn) {\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 0 15px 7.5px #302e35 inset;\n  color: #dfdbdd;\n}";
var styles$F = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","tabBtn":"Tab-module_tabBtn__zwT09","activeTabBtn":"Tab-module_activeTabBtn__orqQn","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$G);

var _jsxFileName$R = "/home/circleci/app/libs/listings-bot/src/components/Tabs/Tab.jsx";

const Tab = ({
  label,
  onClick,
  activeTab
}) => {
  const isActiveTab = activeTab === label;
  return /*#__PURE__*/React__default.createElement("li", {
    key: label,
    className: styles$F.tabItem,
    __self: window,
    __source: {
      fileName: _jsxFileName$R,
      lineNumber: 15,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    className: classnames(styles$F.tabBtn, isActiveTab && styles$F.activeTabBtn),
    element: "button",
    weight: "semibold",
    color: isActiveTab ? 'white' : 'gray',
    onClick: onClick,
    name: label,
    value: label,
    __self: window,
    __source: {
      fileName: _jsxFileName$R,
      lineNumber: 16,
      columnNumber: 7
    }
  }, label));
};

Tab.displayName = 'Tab';
Tab.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  activeTab: PropTypes.string
};

var css_248z$F = ".TargetOverlay-module_root__6tAW0 {\n  position: fixed;\n  z-index: 100001;\n}";
var styles$E = {"root":"TargetOverlay-module_root__6tAW0"};
styleInject(css_248z$F);

var _jsxFileName$Q = "/home/circleci/app/libs/listings-bot/src/components/TargetOverlay/TargetOverlay.jsx";

const TargetOverlay = ({
  targetQuery,
  element: Element = 'div',
  className,
  children
}) => {
  var _targetPos$top, _targetPos$left, _targetPos$width;

  const [targetPos, setParentPos] = useState(null);
  const setPosition = useCallback(() => {
    const target = window.document.querySelector(targetQuery);
    const pos = target ? target.getBoundingClientRect() : null;
    setParentPos(pos);
  }, [targetQuery]);
  useEffect(() => {
    setPosition();
    window.addEventListener('resize', setPosition);
    return () => {
      window.removeEventListener('resize', setPosition);
      setPosition();
    };
  }, [setPosition]);
  useEffect(() => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(setPosition);
    });
    const body = document.querySelector('body');
    const config = {
      childList: true,
      subtree: true
    };
    observer.observe(body, config);
    return () => {
      observer.disconnect();
    };
  }, [setPosition]);
  return /*#__PURE__*/React__default.createElement(Element, {
    className: classnames(styles$E.root, className),
    style: {
      top: (_targetPos$top = targetPos == null ? void 0 : targetPos.top) != null ? _targetPos$top : 0,
      left: (_targetPos$left = targetPos == null ? void 0 : targetPos.left) != null ? _targetPos$left : 0,
      width: (_targetPos$width = targetPos == null ? void 0 : targetPos.width) != null ? _targetPos$width : 0,
      height: 0 // TODO: We only want to draw height OR width, otherwise overlays Target, only width for now...

    },
    __self: window,
    __source: {
      fileName: _jsxFileName$Q,
      lineNumber: 51,
      columnNumber: 5
    }
  }, children);
};

TargetOverlay.propTypes = {
  targetQuery: PropTypes.string,
  element: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  children: PropTypes.any
};

var css_248z$E = "@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap\");\n\n.Text-module_text__1v7Ur {\n  font-family: \"Open Sans\", sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n.Text-module_ellipsis__tUPj- {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.Text-module_size-xxs__jvv-A {\n  font-size: 0.75em;\n}\n.Text-module_size-xs__ooHuN {\n  font-size: 0.8125em;\n}\n.Text-module_size-s__uBNbW {\n  font-size: 0.875em;\n}\n.Text-module_size-m__geVd9 {\n  font-size: 1em;\n}\n.Text-module_size-l__RH-3o {\n  font-size: 1.125em;\n}\n.Text-module_size-xl__n6UKa {\n  font-size: 1.5em;\n}\n.Text-module_size-xxl__gBhym {\n  font-size: 2.25em;\n}\n.Text-module_size-xxxl__WigNB {\n  font-size: 3em;\n}\n\n.Text-module_weight-light__vJ-qd {\n  font-weight: 300;\n}\n.Text-module_weight-light__vJ-qd.Text-module_size-xxs__jvv-A {\n  font-weight: 400;\n}\n.Text-module_weight-light__vJ-qd.Text-module_size-xs__ooHuN {\n  font-weight: 400;\n}\n.Text-module_weight-light__vJ-qd.Text-module_size-s__uBNbW {\n  font-weight: 400;\n}\n.Text-module_weight-regular__JKjPT {\n  font-weight: 400;\n}\n.Text-module_weight-semibold__SwBti {\n  font-weight: 600;\n}\n.Text-module_weight-bold__bYK67 {\n  font-weight: 700;\n}\n\n.Text-module_color-green__3l97M {\n  color: #3ce967;\n}\n.Text-module_color-orange__NItqT {\n  color: #ff9545;\n}\n.Text-module_color-red__rjTZt {\n  color: #ff4545;\n}\n.Text-module_color-blue__dIdwA {\n  color: #06a3f7;\n}\n.Text-module_color-pink__n9EIr {\n  color: #fc5aa6;\n}\n.Text-module_color-heather__OVIJS {\n  color: #9d97ab;\n}\n.Text-module_color-white__6NUf2 {\n  color: #f3eff1;\n}\n.Text-module_color-inherit__Etp1P {\n  color: inherit;\n}\n.Text-module_color-gray__kTkxk {\n  color: #bbb2b7;\n}\n.Text-module_color-eggShell__KZXwR {\n  color: #d5d0d6;\n}\n.Text-module_color-twilight__7iXtY {\n  color: #cac7c9;\n}\n\n.Text-module_align-left__rmDLR {\n  text-align: left;\n}\n.Text-module_align-right__RdhD6 {\n  text-align: right;\n}\n.Text-module_align-center__I9xTb {\n  text-align: center;\n}\n\n.Text-module_paragraph__b-jHR {\n  margin-bottom: 0.75em;\n}\n\n.Text-module_nowrap__iyvd6 {\n  white-space: nowrap;\n}\n\n.Text-module_transform-capitalize__ThASX {\n  text-transform: capitalize;\n}\n.Text-module_transform-lowercase__3uDwi {\n  text-transform: lowercase;\n}\n.Text-module_transform-uppercase__tNUtc {\n  text-transform: uppercase;\n}\n\n.Text-module_upperspaced__EmHG2 {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.Text-module_letter-spacing-normal__7-k7W {\n  letter-spacing: normal;\n}\n.Text-module_letter-spacing-large__O3FdD {\n  letter-spacing: 1px;\n}";
var styles$D = {"color-green":"Text-module_color-green__3l97M","color-dark-green":"#41664c","color-orange":"Text-module_color-orange__NItqT","color-pink":"Text-module_color-pink__n9EIr","color-red":"Text-module_color-red__rjTZt","color-dark-red":"#5c2d2f","color-gray":"Text-module_color-gray__kTkxk","text":"Text-module_text__1v7Ur","ellipsis":"Text-module_ellipsis__tUPj-","size-xxs":"Text-module_size-xxs__jvv-A","size-xs":"Text-module_size-xs__ooHuN","size-s":"Text-module_size-s__uBNbW","size-m":"Text-module_size-m__geVd9","size-l":"Text-module_size-l__RH-3o","size-xl":"Text-module_size-xl__n6UKa","size-xxl":"Text-module_size-xxl__gBhym","size-xxxl":"Text-module_size-xxxl__WigNB","weight-light":"Text-module_weight-light__vJ-qd","weight-regular":"Text-module_weight-regular__JKjPT","weight-semibold":"Text-module_weight-semibold__SwBti","weight-bold":"Text-module_weight-bold__bYK67","color-blue":"Text-module_color-blue__dIdwA","color-heather":"Text-module_color-heather__OVIJS","color-white":"Text-module_color-white__6NUf2","color-inherit":"Text-module_color-inherit__Etp1P","color-eggShell":"Text-module_color-eggShell__KZXwR","color-twilight":"Text-module_color-twilight__7iXtY","align-left":"Text-module_align-left__rmDLR","align-right":"Text-module_align-right__RdhD6","align-center":"Text-module_align-center__I9xTb","paragraph":"Text-module_paragraph__b-jHR","nowrap":"Text-module_nowrap__iyvd6","transform-capitalize":"Text-module_transform-capitalize__ThASX","transform-lowercase":"Text-module_transform-lowercase__3uDwi","transform-uppercase":"Text-module_transform-uppercase__tNUtc","upperspaced":"Text-module_upperspaced__EmHG2","letter-spacing-normal":"Text-module_letter-spacing-normal__7-k7W","letter-spacing-large":"Text-module_letter-spacing-large__O3FdD","color___green":"Text-module_color-green__3l97M","color___dark___green":"#41664c","color___orange":"Text-module_color-orange__NItqT","color___pink":"Text-module_color-pink__n9EIr","color___red":"Text-module_color-red__rjTZt","color___dark___red":"#5c2d2f","color___gray":"Text-module_color-gray__kTkxk","size___xxs":"Text-module_size-xxs__jvv-A","size___xs":"Text-module_size-xs__ooHuN","size___s":"Text-module_size-s__uBNbW","size___m":"Text-module_size-m__geVd9","size___l":"Text-module_size-l__RH-3o","size___xl":"Text-module_size-xl__n6UKa","size___xxl":"Text-module_size-xxl__gBhym","size___xxxl":"Text-module_size-xxxl__WigNB","weight___light":"Text-module_weight-light__vJ-qd","weight___regular":"Text-module_weight-regular__JKjPT","weight___semibold":"Text-module_weight-semibold__SwBti","weight___bold":"Text-module_weight-bold__bYK67","color___blue":"Text-module_color-blue__dIdwA","color___heather":"Text-module_color-heather__OVIJS","color___white":"Text-module_color-white__6NUf2","color___inherit":"Text-module_color-inherit__Etp1P","color___eggShell":"Text-module_color-eggShell__KZXwR","color___twilight":"Text-module_color-twilight__7iXtY","align___left":"Text-module_align-left__rmDLR","align___right":"Text-module_align-right__RdhD6","align___center":"Text-module_align-center__I9xTb","transform___capitalize":"Text-module_transform-capitalize__ThASX","transform___lowercase":"Text-module_transform-lowercase__3uDwi","transform___uppercase":"Text-module_transform-uppercase__tNUtc","letter___spacing___normal":"Text-module_letter-spacing-normal__7-k7W","letter___spacing___large":"Text-module_letter-spacing-large__O3FdD"};
styleInject(css_248z$E);

const _excluded$7 = ["align", "className", "color", "element", "ellipsis", "paragraph", "size", "nowrap", "transform", "weight", "upperspaced", "letterSpacing"];
var _jsxFileName$P = "/home/circleci/app/libs/listings-bot/src/components/Text/Text.jsx";
const defaultProps = {
  element: 'p',
  ellipsis: false,
  paragraph: false,
  size: 'm',
  weight: 'regular',
  upperspaced: false,
  color: 'gray',
  letterSpacing: 'normal'
};
const TEXT_ALIGNMENTS = ['left', 'right', 'center'];
const TEXT_SIZES = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
const TEXT_WEIGHTS = ['light', 'regular', 'semibold', 'bold'];
const TEXT_COLORS = ['green', 'orange', 'red', 'blue', 'pink', 'heather', 'white', 'inherit', 'gray', 'eggShell', 'twilight'];
const TEXT_TRANSFORMS = ['capitalize', 'lowercase', 'uppercase'];
const TEXT_LETTER_SPACING = ['normal', 'large'];
const propTypes$2 = {
  // add text-alignment
  align: PropTypes.oneOf(TEXT_ALIGNMENTS),
  // render something other than a 'p' tag, such as an h1
  element: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  // truncate single-line overflowing text with ellipsis
  ellipsis: PropTypes.bool,
  // modify the font size
  size: PropTypes.oneOf(TEXT_SIZES),
  // modify the font weight
  weight: PropTypes.oneOf(TEXT_WEIGHTS),
  // modify the color
  color: PropTypes.oneOf(TEXT_COLORS),
  nowrap: PropTypes.bool,
  transform: PropTypes.oneOf(TEXT_TRANSFORMS),
  paragraph: PropTypes.bool,
  upperspaced: PropTypes.bool,
  className: PropTypes.string,
  letterSpacing: PropTypes.oneOf(TEXT_LETTER_SPACING)
};

const Text = _ref => {
  let {
    align,
    className,
    color,
    element: Element,
    ellipsis,
    paragraph,
    size,
    nowrap,
    transform,
    weight,
    upperspaced,
    letterSpacing
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$7);

  const textClassName = classnames(className, styles$D.text, ellipsis && styles$D.ellipsis, styles$D[`size-${size}`], styles$D[`weight-${weight}`], styles$D[`color-${color}`], styles$D[`align-${align}`], styles$D[`transform-${transform}`], styles$D[`letter-spacing-${letterSpacing}`], nowrap && styles$D.nowrap, paragraph && styles$D.paragraph, upperspaced && styles$D.upperspaced);
  return /*#__PURE__*/React__default.createElement(Element, _extends$1({
    className: textClassName
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$P,
      lineNumber: 104,
      columnNumber: 10
    }
  }));
};

Text.defaultProps = defaultProps;
Text.propTypes = propTypes$2;
Text.Colors = TEXT_COLORS;
Text.Alignments = TEXT_ALIGNMENTS;
Text.Sizes = TEXT_SIZES;
Text.Weights = TEXT_WEIGHTS;
Text.Transforms = TEXT_TRANSFORMS;
Text.LetterSpacing = TEXT_LETTER_SPACING;

var css_248z$D = ".EvaluationTile-module_evalWrapper__EtiZN {\n  width: 100%;\n  padding: 1em;\n}\n\n.EvaluationTile-module_evalRow__Skvi- {\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin: 0.375em;\n  margin-left: 0.75em;\n}\n\n.EvaluationTile-module_evalCol__hmJLq {\n  display: flex;\n  flex-direction: column;\n  margin-left: 0.75em;\n  text-transform: capitalize;\n}\n\n.EvaluationTile-module_evalBotHead__QIyxJ {\n  height: 50px;\n  width: 50px;\n}";
var styles$C = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","evalWrapper":"EvaluationTile-module_evalWrapper__EtiZN","evalRow":"EvaluationTile-module_evalRow__Skvi-","evalCol":"EvaluationTile-module_evalCol__hmJLq","evalBotHead":"EvaluationTile-module_evalBotHead__QIyxJ","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$D);

var _jsxFileName$O = "/home/circleci/app/libs/listings-bot/src/components/Evaluation/EvaluationTile.jsx";

const EvaluationTile$1 = ({
  text,
  color,
  thinking,
  subText
}) => {
  const enhancedColor = thinking ? 'white' : color || 'pink';
  const botHeadColor = thinking ? 'pink' : color;
  const robotSpeak = useMemo(() => {
    if (thinking) {
      const words = ['beep', 'boop', 'blop', 'bzzz'];
      const first = capitalizeFirstLetter(words[getRandomInt(4)]);
      const second = words[getRandomInt(4)];
      const third = words[getRandomInt(4)];
      return `${first} ${second} ${third}...`;
    }
  }, [thinking]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$C.evalRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 29,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$C.evalBotHead,
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 30,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ListingStatusHead, {
    color: botHeadColor,
    spin: thinking,
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 31,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$C.evalCol,
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: enhancedColor,
    size: "xl",
    weight: "bold",
    letterSpacing: "large",
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 34,
      columnNumber: 9
    }
  }, thinking ? robotSpeak : text), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$O,
      lineNumber: 42,
      columnNumber: 9
    }
  }, thinking ? 'Crunching your numbers' : subText)));
};

EvaluationTile$1.propTypes = {
  color: PropTypes.oneOf(['green', 'orange', 'red']),
  subText: PropTypes.string,
  text: PropTypes.string,
  thinking: PropTypes.bool
};

var _jsxFileName$N = "/home/circleci/app/libs/listings-bot/src/components/Evaluation/EvaluationList.jsx";

const EvaluationList$1 = ({
  subText,
  className
}) => {
  return /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    size: "xxs",
    weight: "semibold",
    className: classnames(className),
    __self: window,
    __source: {
      fileName: _jsxFileName$N,
      lineNumber: 10,
      columnNumber: 5
    }
  }, subText);
};

EvaluationList$1.propTypes = {
  subText: PropTypes.string,
  className: PropTypes.string
};

const useAccessQuery = () => {
  const authSettings = useAuthSettings();
  const isChromeExtension = useIsExtension();
  return useQuery('access', () => getAccess(authSettings), Object.assign({}, getQueryDefaults(), {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: Boolean(authSettings) && isChromeExtension
  }));
};

const UNAUTHORIZED = 401;
const FORBIDDEN = 403;

const useAccess = () => {
  const queryAttributes = useAccessQuery();
  return Object.assign({}, queryAttributes, {
    isUnauthorized: checkIfUnauthorized(queryAttributes.error),
    isForbidden: checkIfForbidden(queryAttributes.error)
  });
};

const checkIfUnauthorized = err => {
  if (err == null) return false;
  return err.response.status === UNAUTHORIZED;
};

const checkIfForbidden = err => {
  if (err == null) return false;
  return err.response.status === FORBIDDEN;
};

// Hooks
const useLoading = () => {
  const access = useAccess();
  const buyerSettings = useBuyerSettingsWithDefaults();
  const listingEvaluation = useListingDisplay();
  const isGlobalUpdating = (listingEvaluation == null ? void 0 : listingEvaluation.isFetching) || (buyerSettings == null ? void 0 : buyerSettings.isFetching);
  const settledRequest = (listingEvaluation == null ? void 0 : listingEvaluation.isFetched) && !isGlobalUpdating;
  return {
    isGlobalUpdating,
    settledRequest,
    isGlobalLoading: (listingEvaluation == null ? void 0 : listingEvaluation.isLoading) || !(buyerSettings != null && buyerSettings.isFetched) || (access == null ? void 0 : access.isFetching)
  };
};

var _jsxFileName$M = "/home/circleci/app/libs/listings-bot/src/components/Evaluation/EvaluationContainer.jsx";

const withContainer = WrappedComponent => props => {
  const {
    budgetDiff,
    color,
    savingsValue,
    text: statusText,
    totalBuyCost
  } = useListingDisplay();
  const {
    settledRequest
  } = useLoading();
  const isOwner = useIsOwner();
  const text = useMemo(() => `${statusText} buy`, [statusText]);
  const overUnderBudget = useMemo(() => budgetDiff >= 0 ? OVER_BUDGET : UNDER_BUDGET, [budgetDiff]);
  const gainOrLoss = useMemo(() => {
    if (isOwner) {
      return totalBuyCost < 0 ? POSSIBLE_GAIN : POSSIBLE_LOSS;
    } else {
      return savingsValue > 0 ? POSSIBLY_SAVE : POSSIBLY_LOSE;
    }
  }, [savingsValue, totalBuyCost, isOwner]);
  const subText = `${overUnderBudget}  •  ${gainOrLoss}`;
  return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends$1({}, props, {
    text: text,
    subText: subText,
    color: color,
    thinking: !settledRequest,
    __self: window,
    __source: {
      fileName: _jsxFileName$M,
      lineNumber: 49,
      columnNumber: 5
    }
  }));
};

const EvaluationTile = withContainer(EvaluationTile$1);
const EvaluationList = withContainer(EvaluationList$1);

var img = "data:image/svg+xml,%3csvg width='36' height='48' viewBox='0 0 36 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.12493 47.9077H11.7864H24.5149H29.1398C30.6669 47.9077 31.908 46.6691 31.908 45.1425V40.4531H33.5311C34.3561 40.4531 35.0241 39.7858 35.0241 38.9641V32.9426C35.0241 32.1197 34.3561 31.4536 33.5311 31.4536H31.908V26.2969C31.908 24.9723 30.9731 24.9938 29.7264 25.0224C29.5373 25.0267 29.3411 25.0312 29.1398 25.0312H18.9008H17.3311H7.12371C6.92204 25.0312 6.72537 25.0267 6.53591 25.0223C5.2908 24.9935 4.35679 24.9718 4.35679 26.2969V31.4536H2.71173C1.88798 31.4536 1.22119 32.1209 1.22119 32.9426V38.9641C1.22119 39.7858 1.88919 40.4531 2.71173 40.4531H4.35801V45.1425C4.35801 46.6691 5.59667 47.9077 7.12493 47.9077ZM11.252 36.4628C8.89757 36.4628 6.98968 34.5569 6.98968 32.2061C6.98968 29.8542 8.89757 27.9483 11.252 27.9483C13.6064 27.9483 15.5143 29.8542 15.5143 32.2061C15.5143 34.5569 13.6064 36.4628 11.252 36.4628ZM25.0751 36.4628C22.7219 36.4628 20.814 34.5569 20.814 32.2061C20.814 29.8542 22.7231 27.9483 25.0751 27.9483C27.4308 27.9483 29.3374 29.8542 29.3374 32.2061C29.3374 34.5569 27.4308 36.4628 25.0751 36.4628ZM7.85381 41.9733C7.85381 41.0559 8.6055 40.285 9.53434 40.285H26.7106C27.6371 40.285 28.3912 41.0415 28.3912 41.9733V42.2279C28.3912 43.1454 27.6395 43.9163 26.7106 43.9163H9.53434C8.60789 43.9163 7.85381 43.1598 7.85381 42.2279V41.9733Z' fill='%23BBB2B7'/%3e%3cpath d='M17.9991 0.999979C16.7215 0.999979 15.6858 2.03568 15.6858 3.31327V8.88103C15.6858 9.37267 15.2873 9.77122 14.7956 9.77122C14.304 9.77122 13.9054 9.37267 13.9054 8.88103V4.83563C13.9054 3.01625 11.9423 1.87358 10.3603 2.77214C8.05025 4.08421 6.10924 5.99366 4.76878 8.28737C3.42864 10.5805 2.72237 13.1888 2.72237 15.8448V18.1175H2.03039H2.0086C1.03735 18.1175 0.25 18.9049 0.25 19.8761C0.25 20.9061 0.802399 21.8569 1.69713 22.367L3.4439 23.3629C4.39876 23.9072 5.47895 24.1935 6.5781 24.1935H29.7186H29.782C30.6452 24.1935 31.4934 23.9687 32.2432 23.5412L34.2626 22.39C35.1822 21.8657 35.75 20.8884 35.75 19.8297C35.75 18.8841 34.9834 18.1175 34.0378 18.1175H33.2776V15.8453C33.2776 13.189 32.571 10.5805 31.2303 8.28737C29.8891 5.99334 27.9462 4.08015 25.6379 2.76351C24.0576 1.86206 22.0928 3.00328 22.0928 4.82265V8.88103C22.0928 9.37267 21.6943 9.77122 21.2026 9.77122C20.711 9.77122 20.3124 9.37267 20.3124 8.88103V3.31327C20.3124 2.03568 19.2767 0.999979 17.9991 0.999979ZM7.61497 19.792C7.61497 19.3063 8.00865 18.9127 8.49427 18.9127H27.5057C27.9914 18.9127 28.385 19.3063 28.385 19.792C28.385 20.2776 27.9914 20.6713 27.5057 20.6713H8.49427C8.00865 20.6713 7.61497 20.2776 7.61497 19.792Z' fill='%23FF9545'/%3e%3c/svg%3e";

var css_248z$C = ".UnderConstruction-module_root__j9keA {\n  line-height: 1.5;\n  background-color: #3a383f;\n  font-size: 1em;\n  margin: 4.5em 2.25em;\n  padding: 1.5em 0.75em 0.75em 0.75em;\n}\n\n.UnderConstruction-module_heading__oX-Ko {\n  padding: 0.25em 0;\n}\n\n.UnderConstruction-module_emailLink__CyQCx {\n  color: #06a3f7;\n  text-decoration: none;\n}\n.UnderConstruction-module_emailLink__CyQCx:hover {\n  color: #0696e3;\n}";
var styles$B = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"UnderConstruction-module_root__j9keA","heading":"UnderConstruction-module_heading__oX-Ko","emailLink":"UnderConstruction-module_emailLink__CyQCx","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$C);

var _jsxFileName$L = "/home/circleci/app/libs/listings-bot/src/components/UnderConstruction/UnderConstruction.jsx";
const propTypes$1 = {
  className: PropTypes.string
};

const UnderConstruction = ({
  className
}) => {
  const email = 'support@homebot.ai';
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$B.root, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$L,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img,
    alt: "under construction",
    __self: window,
    __source: {
      fileName: _jsxFileName$L,
      lineNumber: 23,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    weight: "semibold",
    size: "xl",
    color: "gray",
    className: styles$B.heading,
    __self: window,
    __source: {
      fileName: _jsxFileName$L,
      lineNumber: 24,
      columnNumber: 7
    }
  }, "This section is still in the works"), /*#__PURE__*/React__default.createElement(Text, {
    size: "l",
    color: "heather",
    __self: window,
    __source: {
      fileName: _jsxFileName$L,
      lineNumber: 27,
      columnNumber: 7
    }
  }, "If you are running into an issue reach out to", /*#__PURE__*/React__default.createElement(Text, {
    element: "a",
    href: `mailto:${email}`,
    className: styles$B.emailLink,
    __self: window,
    __source: {
      fileName: _jsxFileName$L,
      lineNumber: 29,
      columnNumber: 9
    }
  }, ` ${email}`)));
};

UnderConstruction.propTypes = propTypes$1;

var css_248z$B = ".UnderConstructionModal-module_root__CAIke {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background: rgba(48, 46, 53, 0.9);\n}\n\n.UnderConstructionModal-module_wrapper__VFfx8 {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n}\n\n.UnderConstructionModal-module_content__1U5wx {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  background: #3a383f;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.195511);\n  border-radius: 3px;\n  margin: 0 1.5em;\n  position: absolute;\n  top: 150px;\n}\n\n.UnderConstructionModal-module_closeRow__2r6V- {\n  position: relative;\n  width: 100%;\n}\n\n.UnderConstructionModal-module_closeButton__vObtS {\n  position: absolute;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  top: 0.75em;\n  right: 0.75em;\n}\n\n.UnderConstructionModal-module_imageRow__JXl-- {\n  text-align: center;\n  margin-top: 0.75em;\n}\n\n.UnderConstructionModal-module_contentContainer__5tCvB {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75em;\n}\n\n.UnderConstructionModal-module_textAndButtonWrapper__Mn-Rq {\n  padding: 0.75em;\n}\n\n.UnderConstructionModal-module_textRow__aUoQw {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.UnderConstructionModal-module_text__sKFNo {\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 1.5em;\n  line-height: 1.5;\n  color: #f3eff1;\n  padding: 0.25em 0;\n}\n\n.UnderConstructionModal-module_subTextRow__sKIFu {\n  text-align: center;\n  padding: 2px 5px 20px 5px;\n}\n\n.UnderConstructionModal-module_subText__jcv5U {\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 1em;\n  line-height: 1.5;\n  color: #bbb2b7;\n}\n\n.UnderConstructionModal-module_buttonRow__cDuLU {\n  text-align: center;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.UnderConstructionModal-module_button__6Shhe {\n  border-radius: 2px;\n  opacity: 0.9;\n}";
var styles$A = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"UnderConstructionModal-module_root__CAIke","wrapper":"UnderConstructionModal-module_wrapper__VFfx8","content":"UnderConstructionModal-module_content__1U5wx","closeRow":"UnderConstructionModal-module_closeRow__2r6V-","closeButton":"UnderConstructionModal-module_closeButton__vObtS","imageRow":"UnderConstructionModal-module_imageRow__JXl--","contentContainer":"UnderConstructionModal-module_contentContainer__5tCvB","textAndButtonWrapper":"UnderConstructionModal-module_textAndButtonWrapper__Mn-Rq","textRow":"UnderConstructionModal-module_textRow__aUoQw","text":"UnderConstructionModal-module_text__sKFNo","subTextRow":"UnderConstructionModal-module_subTextRow__sKIFu","subText":"UnderConstructionModal-module_subText__jcv5U","buttonRow":"UnderConstructionModal-module_buttonRow__cDuLU","button":"UnderConstructionModal-module_button__6Shhe","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$B);

var _jsxFileName$K = "/home/circleci/app/libs/listings-bot/src/components/UnderConstructionModal/UnderConstructionModal.jsx";

const UnderConstructionModal = ({
  className,
  handleModalToggle,
  underConstructionActive
}) => {
  return /*#__PURE__*/React__default.createElement(If, {
    condition: underConstructionActive,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$A.root, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.wrapper,
    onClick: handleModalToggle,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 21,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.content,
    style: {
      top: '120px'
    },
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 22,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.closeRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 23,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    className: styles$A.closeButton,
    onClick: handleModalToggle,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 24,
      columnNumber: 15
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.contentContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 29,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.imageRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 30,
      columnNumber: 15
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img,
    alt: "under construction",
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 31,
      columnNumber: 17
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.textAndButtonWrapper,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 33,
      columnNumber: 15
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.textRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 34,
      columnNumber: 17
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    className: styles$A.text,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 35,
      columnNumber: 19
    }
  }, "This feature is still in the works")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.subTextRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 39,
      columnNumber: 17
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    className: styles$A.subText,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 40,
      columnNumber: 19
    }
  }, "We hope to add this capability sooner rather than later.")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$A.buttonRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 44,
      columnNumber: 17
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: styles$A.button,
    onClick: handleModalToggle,
    fullWidth: true,
    regular: true,
    children: 'Close',
    __self: window,
    __source: {
      fileName: _jsxFileName$K,
      lineNumber: 45,
      columnNumber: 19
    }
  }))))))));
};

UnderConstructionModal.propTypes = {
  className: PropTypes.string,
  underConstructionActive: PropTypes.bool,
  handleModalToggle: PropTypes.func.isRequired
};

var css_248z$A = ".Fade-module_fadeOut__UXZUY {\n  -webkit-animation: Fade-module_fadeOut__UXZUY 1s linear 1;\n          animation: Fade-module_fadeOut__UXZUY 1s linear 1;\n}\n@-webkit-keyframes Fade-module_fadeOut__UXZUY {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes Fade-module_fadeOut__UXZUY {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}";
var styles$z = {"fadeOut":"Fade-module_fadeOut__UXZUY"};
styleInject(css_248z$A);

var _jsxFileName$J = "/home/circleci/app/libs/listings-bot/src/components/Fade/Fade.jsx";

const Fade = ({
  show,
  className,
  children
}) => {
  const [shouldRender, setRender] = useState(show);
  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  const fadeClass = classnames(className, {
    [styles$z.fadeOut]: !show
  });
  return shouldRender && /*#__PURE__*/React__default.createElement("div", {
    className: fadeClass,
    onAnimationEnd: onAnimationEnd,
    __self: window,
    __source: {
      fileName: _jsxFileName$J,
      lineNumber: 23,
      columnNumber: 7
    }
  }, children);
};

Fade.propTypes = {
  show: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.any
};

var css_248z$z = ".Popup-module_popupContainer__BrWgY {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.Popup-module_popupContainer__BrWgY hr {\n  color: #9d97ab;\n  border-top: none;\n  border-bottom: 0.025px solid #48464e;\n  margin: 0px -1.5em 0.75em -1.5em;\n}\n\n.Popup-module_close__afztm {\n  cursor: pointer;\n  float: right;\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  border: none;\n  background-color: inherit;\n}\n\n.Popup-module_overlay__KcI1j {\n  background-color: #3a383f;\n  border-radius: 3px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.195511);\n  margin: auto;\n  padding: 1.5em;\n  position: relative;\n  text-align: center;\n  width: 85%;\n  box-sizing: border-box;\n}\n\n.Popup-module_overlayExtension__65YE8 {\n  margin: 140px auto;\n}";
var styles$y = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","popupContainer":"Popup-module_popupContainer__BrWgY","close":"Popup-module_close__afztm","overlay":"Popup-module_overlay__KcI1j","overlayExtension":"Popup-module_overlayExtension__65YE8","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$z);

var _jsxFileName$I = "/home/circleci/app/libs/listings-bot/src/components/Popup/Popup.jsx";

const Popup = ({
  onClose,
  children
}) => {
  const isChromeExtension = useIsExtension();
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.popupContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    className: styles$y.close,
    onClick: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 18,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$y.overlay, {
      [styles$y.overlayExtension]: isChromeExtension
    }),
    __self: window,
    __source: {
      fileName: _jsxFileName$I,
      lineNumber: 19,
      columnNumber: 7
    }
  }, children));
};

Popup.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node])
};

const useDelay = (delay = 250) => {
  const [isPastDelay, setIsPastDelay] = useState(false);
  useEffect(() => {
    const id = window.setTimeout(() => {
      setIsPastDelay(true);
    }, delay);
    return () => {
      window.clearTimeout(id);
    };
  }, [delay]);
  return isPastDelay;
};

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;

var bind$1 = functionBind;

var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = functionBind;
var hasOwn$1 = src;
var $concat$1 = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$1(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$1(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$1 = {exports: {}};

(function (module) {

var bind = functionBind;
var GetIntrinsic = getIntrinsic;

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
}(callBind$1));

var GetIntrinsic$1 = getIntrinsic;

var callBind = callBind$1.exports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var util_inspect = require$$0.inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = util_inspect.custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$3(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$3(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$3(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$3(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$3(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$2(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$2(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$2(target) && !isArray$2(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$2(target) && isArray$2(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$2 = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

var getSideChannel = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$1 = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$1(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$1 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$1.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        obj = utils$1.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$1.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$1(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$1(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$1(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$1;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$1.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$1.filter;
    if (typeof opts.filter === 'function' || isArray$1(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$1.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$1.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$1.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$1.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$1.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$1.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$1.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$1.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$1(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils = utils$2;

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

var stringify = stringify_1;
var parse = parse$1;
var formats = formats$3;

var lib = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

const useToggleGuestSignup = () => {
  const {
    customerProfileId,
    customerPublicKey
  } = useContext(AppContext);
  const {
    showIframe,
    setShowIframe,
    setIframeSrc
  } = useContext(RouterContext);
  const [redirectParams, setRedirectParams] = useState({});
  const generateRedirectUrl = useCallback(() => {
    if (redirectParams.redirectUrl) {
      return redirectParams.redirectUrl;
    }

    const redirectUrlSearchParams = new URLSearchParams(window.location.search);
    Object.keys(redirectParams).forEach(k => {
      if (redirectParams[k] == null) return;
      redirectUrlSearchParams.set(k, redirectParams[k]);
    });
    const url = encodeURIComponent(window.location.origin + window.location.pathname + `?${redirectUrlSearchParams.toString()}`);
    return url;
  }, [redirectParams.expandModal, redirectParams.focusTab, redirectParams.focusTarget, redirectParams.redirectUrl]);
  useLayoutEffect(() => {
    const params = {
      customerPublicKey,
      customerProfileId,
      redirectUrl: generateRedirectUrl()
    };
    let src = `${clientFrontendUri}/sign-up`;
    src += lib.stringify(params, {
      addQueryPrefix: true
    });
    setIframeSrc(src);
  }, [customerProfileId, customerPublicKey, setIframeSrc, generateRedirectUrl]);
  const toggle = useCallback((props = {}) => {
    const {
      expandModal,
      focusTab,
      focusTarget,
      redirectUrl
    } = props;
    setRedirectParams({
      expandModal,
      focusTab,
      focusTarget,
      redirectUrl
    });
    setShowIframe(!showIframe);
  }, [setShowIframe, showIframe]);
  return toggle;
};

const PATH_HELPERS = {
  homebotForChromeSync: {
    buildPath: () => {
      return `${clientFrontendUri}/homebot-for-chrome`;
    }
  }
};

var css_248z$y = ".Unauthorized-module_svg__HM3vY {\n  margin-bottom: 0.75em;\n}\n.Unauthorized-module_svg__HM3vY svg {\n  width: 36px;\n  height: 36px;\n}\n\n.Unauthorized-module_btn__YEw7H {\n  margin-top: 1.5em;\n}";
var styles$x = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","svg":"Unauthorized-module_svg__HM3vY","btn":"Unauthorized-module_btn__YEw7H","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$y);

var _jsxFileName$H = "/home/circleci/app/libs/listings-bot/src/components/Popup/Popups/Errors/Unauthorized/Unauthorized.jsx";

const Unauthorized = ({
  onClose
}) => {
  const toggleSignup = useToggleGuestSignup();
  return /*#__PURE__*/React__default.createElement(Popup, {
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 23,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$x.svg,
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 24,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(BotHead, {
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 25,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "bold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 27,
      columnNumber: 7
    }
  }, "Do you have an account?"), /*#__PURE__*/React__default.createElement(Text, {
    color: "gray",
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 30,
      columnNumber: 7
    }
  }, "To continue, sign in with the email address you receive Homebot emails from."), /*#__PURE__*/React__default.createElement(Button, {
    onClick: () => toggleSignup({
      redirectUrl: PATH_HELPERS.homebotForChromeSync.buildPath()
    }),
    className: styles$x.btn,
    fullWidth: true,
    secondary: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$H,
      lineNumber: 34,
      columnNumber: 7
    }
  }, "Sign In"));
};

Unauthorized.propTypes = {
  onClose: PropTypes.func.isRequired
};

var css_248z$x = ".Forbidden-module_container__rN0no {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  line-height: 1.5;\n}\n\n.Forbidden-module_avatar__mFJ2e {\n  margin-bottom: 0.75em;\n  width: 50px;\n  height: 50px;\n  border: 2px solid #f3eff1;\n}\n\n.Forbidden-module_lock__aSEU9 {\n  height: 20px;\n  width: 20px;\n  position: absolute;\n  top: 36px;\n  left: 53%;\n}";
var styles$w = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","container":"Forbidden-module_container__rN0no","avatar":"Forbidden-module_avatar__mFJ2e","lock":"Forbidden-module_lock__aSEU9","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$x);

var _jsxFileName$G = "/home/circleci/app/libs/listings-bot/src/components/Popup/Popups/Errors/Forbidden/Forbidden.jsx";

const Forbidden = ({
  onClose
}) => {
  const {
    customerPhotoUri,
    customerFullName
  } = useBranding();
  return /*#__PURE__*/React__default.createElement(Popup, {
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$w.container,
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 21,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$w.avatar,
    src: customerPhotoUri,
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 22,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Lock, {
    className: styles$w.lock,
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "bold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 24,
      columnNumber: 9
    }
  }, "This isn\u2019t available to you yet"), /*#__PURE__*/React__default.createElement(Text, {
    color: "gray",
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$G,
      lineNumber: 28,
      columnNumber: 11
    }
  }, customerFullName, ' '), "would need to upgrade their account to unlock this area for you.")));
};

Forbidden.propTypes = {
  onClose: PropTypes.func.isRequired
};

var css_248z$w = ".Standard-module_triangle__mK15V {\n  height: 35px;\n  width: 35px;\n  margin-bottom: 0.75em;\n}\n\n.Standard-module_retryButton__UG9C6 {\n  margin-top: 0.75em;\n  margin-bottom: 0.75em;\n}\n\n.Standard-module_reachOut__L6m1n {\n  line-height: 1;\n  margin-top: 1.5em;\n}\n\n.Standard-module_link__GwcGK {\n  color: #06a3f7;\n}";
var styles$v = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","triangle":"Standard-module_triangle__mK15V","retryButton":"Standard-module_retryButton__UG9C6","reachOut":"Standard-module_reachOut__L6m1n","link":"Standard-module_link__GwcGK","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$w);

var _jsxFileName$F = "/home/circleci/app/libs/listings-bot/src/components/Popup/Popups/Errors/Standard/Standard.jsx";

const Standard = ({
  onClose
}) => {
  const [loading, setLoading] = useState(false);
  const {
    refetch: refetchAllQueries
  } = useListingDisplay();

  const handleRetryClick = () => {
    setLoading(true);
    refetchAllQueries();
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  return /*#__PURE__*/React__default.createElement(Popup, {
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 27,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(ExclamationTriangle, {
    className: styles$v.triangle,
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 28,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "bold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 29,
      columnNumber: 7
    }
  }, "Something went wrong"), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 32,
      columnNumber: 7
    }
  }, "Let's see if we can try again"), /*#__PURE__*/React__default.createElement(Button, {
    regular: true,
    wide: true,
    className: styles$v.retryButton,
    loading: loading,
    onClick: handleRetryClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 33,
      columnNumber: 7
    }
  }, "Retry"), /*#__PURE__*/React__default.createElement("hr", {
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 42,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    className: styles$v.reachOut,
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 43,
      columnNumber: 7
    }
  }, "If the problem continues,"), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 46,
      columnNumber: 7
    }
  }, "reach out to", /*#__PURE__*/React__default.createElement("a", {
    href: 'mailto:support@homebot.ai',
    className: styles$v.link,
    __self: window,
    __source: {
      fileName: _jsxFileName$F,
      lineNumber: 48,
      columnNumber: 9
    }
  }, ' ', "support@homebot.ai")));
};

Standard.propTypes = {
  onClose: PropTypes.func.isRequired
};

var css_248z$v = ".NoHomeDetailsError-module_homeDetailsErrorContainer__nSZjh {\n  text-align: left;\n}\n\n.NoHomeDetailsError-module_subheader__EYXgi {\n  margin: 0.375em 0 1.5em 0;\n}\n\n.NoHomeDetailsError-module_listingPrice__rIsP9 {\n  line-height: 1;\n}\n\n.NoHomeDetailsError-module_listingPrice__rIsP9 > input[type=text] {\n  font-size: 14px;\n  padding: 0.375em 1.5em 0.375em 0.75em;\n}\n\n.NoHomeDetailsError-module_streetAddress__oOUGR {\n  font-size: 1em;\n  line-height: 1.5;\n}\n\n.NoHomeDetailsError-module_errorText__nL3Jm {\n  margin-top: 0.75em;\n}";
var styles$u = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","homeDetailsErrorContainer":"NoHomeDetailsError-module_homeDetailsErrorContainer__nSZjh","subheader":"NoHomeDetailsError-module_subheader__EYXgi","listingPrice":"NoHomeDetailsError-module_listingPrice__rIsP9","streetAddress":"NoHomeDetailsError-module_streetAddress__oOUGR","errorText":"NoHomeDetailsError-module_errorText__nL3Jm","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$v);

var _jsxFileName$E = "/home/circleci/app/libs/listings-bot/src/components/Popup/Popups/Errors/NoHomeDetailsError/NoHomeDetailsError.jsx";

const StreetAddressInput = props => /*#__PURE__*/React__default.createElement(TextArea, _extends$1({}, props, {
  __self: window,
  __source: {
    fileName: _jsxFileName$E,
    lineNumber: 24,
    columnNumber: 39
  }
}));

const NoHomeDetailsError = ({
  onClose
}) => {
  const {
    address,
    listingPrice,
    resetAndFetchManualAddress
  } = useContext(ZillowContext);
  const [values, setValues] = useState({
    listingPrice: listingPrice || '',
    streetAddress: address || ''
  });
  const [submitDisabled, setSubmitDisabled] = useState(false);
  useEffect(() => {
    if (values.listingPrice === '' || values.streetAddress === '') {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
  }, [values]);
  const {
    refetch: validateAddress,
    isError,
    isLoading,
    isSuccess
  } = useValidateListingEvaluationQuery(values.streetAddress, values.listingPrice);
  useEffect(() => {
    if (!isSuccess) return;
    resetAndFetchManualAddress(values.streetAddress, parseInt(values.listingPrice));
  }, [isSuccess, resetAndFetchManualAddress, values.streetAddress, values.listingPrice]);

  const handleChange = event => {
    const {
      target: {
        name,
        value
      }
    } = event;
    const newValues = Object.assign({}, values, {
      [name]: value
    });
    setValues(newValues);
  };

  const handleSubmit = e => {
    e.preventDefault();
    validateAddress();
  };

  const addressPlaceholder = 'Ex: 1248 Commonwealth Ave Mayfield Heights, OH 43202';
  return /*#__PURE__*/React__default.createElement(Popup, {
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 89,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$u.homeDetailsErrorContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 90,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "bold",
    size: "l",
    align: "left",
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 91,
      columnNumber: 9
    }
  }, "Sorry to ask, but we couldn't find a few home details"), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    align: "left",
    className: styles$u.subheader,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 94,
      columnNumber: 9
    }
  }, "This calibrates our market analysis and your personal buy grade."), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 97,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(FormField, {
    value: values.listingPrice,
    name: "listingPrice",
    input: CurrencyInput,
    placeholder: "$",
    label: "Listing price",
    onChange: handleChange,
    allowNegative: false,
    className: styles$u.listingPrice,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 98,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(FormField, {
    value: values.streetAddress,
    name: "streetAddress",
    input: StreetAddressInput,
    placeholder: addressPlaceholder,
    label: "Street address",
    onChange: handleChange,
    className: styles$u.streetAddress,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 108,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    secondary: true,
    fullWidth: true,
    loading: isLoading,
    disabled: submitDisabled,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 117,
      columnNumber: 11
    }
  }, "Submit details")), /*#__PURE__*/React__default.createElement(If, {
    condition: isError,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 127,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "red",
    className: styles$u.errorText,
    __self: window,
    __source: {
      fileName: _jsxFileName$E,
      lineNumber: 128,
      columnNumber: 11
    }
  }, "There was an issue processing this address. Please try again!"))));
};

NoHomeDetailsError.propTypes = {
  onClose: PropTypes.func.isRequired
};

const useErrorPopup = () => {
  const {
    isUnauthorized,
    isForbidden,
    isError: anyAccessError
  } = useAccess();
  const {
    isZillowDomError,
    isError: anyListingError
  } = useListingError();
  const {
    userManuallyEntered
  } = useContext(ZillowContext);

  if (!anyAccessError && !anyListingError) {
    return hidePopup();
  } else if (isUnauthorized) {
    return displayPopup(Unauthorized);
  } else if (isForbidden) {
    return displayPopup(Forbidden);
  } else if (isZillowDomError && !userManuallyEntered) {
    return displayPopup(NoHomeDetailsError);
  } else {
    return displayPopup(Standard);
  }
};

const displayPopup = popup => ({
  showPopup: true,
  popup
});

const hidePopup = () => ({
  showPopup: false,
  popup: null
});

var css_248z$u = ".CatchAllError-module_root__Pf-ET {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n.CatchAllError-module_root__Pf-ET hr {\n  color: #9d97ab;\n  border-top: none;\n  border-bottom: 0.025px solid #48464e;\n  border-right: #48464e;\n  border-left: #48464e;\n  margin: 0px -1.5em 0.75em -1.5em;\n}\n\n.CatchAllError-module_close__pIGJY {\n  cursor: pointer;\n  float: right;\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  border: none;\n  background-color: inherit;\n}\n\n.CatchAllError-module_CatchAllError__Yto0x {\n  background-color: #3a383f;\n  border-radius: 3px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.195511);\n  min-height: 255px;\n  margin: 140px auto;\n  padding: 1.5em;\n  position: relative;\n  text-align: center;\n  width: 85%;\n  box-sizing: border-box;\n}\n\n.CatchAllError-module_triangle__2oveS {\n  height: 35px;\n  width: 35px;\n  margin-bottom: 0.75em;\n}\n\n.CatchAllError-module_retryButton__BIJF4 {\n  margin-top: 0.75em;\n  margin-bottom: 0.75em;\n}\n\n.CatchAllError-module_reachOut__9I5xr {\n  line-height: 1;\n  margin-top: 1.5em;\n}\n\n.CatchAllError-module_link__LUk8L {\n  color: #06a3f7;\n}\n\n.CatchAllError-module_errorMessage__ErJHk {\n  background-color: #2a2832;\n  margin-bottom: 1.5em;\n  padding: 0.75em;\n  overflow: scroll;\n  height: 100px;\n}\n\n.CatchAllError-module_errorText__j-U5R {\n  font-family: \"Operator Mono\", \"Fira Code\", \"SF Mono\", SFMono-Regular, ui-monospace, Menlo, SF Mono, Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", Monaco, \"Courier New\", Courier, monospace;\n}";
var styles$t = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"CatchAllError-module_root__Pf-ET","close":"CatchAllError-module_close__pIGJY","CatchAllError":"CatchAllError-module_CatchAllError__Yto0x","triangle":"CatchAllError-module_triangle__2oveS","retryButton":"CatchAllError-module_retryButton__BIJF4","reachOut":"CatchAllError-module_reachOut__9I5xr","link":"CatchAllError-module_link__LUk8L","errorMessage":"CatchAllError-module_errorMessage__ErJHk","errorText":"CatchAllError-module_errorText__j-U5R","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$u);

var _jsxFileName$D = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/CatchAllError/CatchAllError.jsx";

const CatchAllError = ({
  onClose,
  error
}) => {
  const [loading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const handleRetryClick = () => {
    setLoading(true);
    window.location.reload();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleShowErrorMessage = () => {
    setShowErrorMessage(!showErrorMessage);
  };

  const renderStackTrace = e => {
    const error = new Error(e);
    return error.stack;
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.root,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    className: styles$t.close,
    onClick: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 35,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.CatchAllError,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ExclamationTriangle, {
    className: styles$t.triangle,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 37,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "bold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 38,
      columnNumber: 9
    }
  }, "Something unexpected happened"), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 41,
      columnNumber: 9
    }
  }, "Because you encountered something we hadn't considered, we hope reloading will fix it"), /*#__PURE__*/React__default.createElement(Button, {
    regular: true,
    wide: true,
    className: styles$t.retryButton,
    loading: loading,
    onClick: handleRetryClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 45,
      columnNumber: 9
    }
  }, "Reload Page"), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    onClick: handleShowErrorMessage,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 54,
      columnNumber: 9
    }
  }, showErrorMessage && 'Hide Error Details', !showErrorMessage && 'Show Error Details'), /*#__PURE__*/React__default.createElement(If, {
    condition: showErrorMessage,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 58,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.errorMessage,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 59,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    align: "left",
    color: "white",
    size: "xs",
    className: styles$t.errorText,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 60,
      columnNumber: 13
    }
  }, renderStackTrace(error)))), /*#__PURE__*/React__default.createElement("hr", {
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 70,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    className: styles$t.reachOut,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 71,
      columnNumber: 9
    }
  }, "If the problem continues,"), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 74,
      columnNumber: 9
    }
  }, "reach out to", /*#__PURE__*/React__default.createElement("a", {
    href: 'mailto:support@homebot.ai',
    className: styles$t.link,
    __self: window,
    __source: {
      fileName: _jsxFileName$D,
      lineNumber: 76,
      columnNumber: 11
    }
  }, ' ', "support@homebot.ai"))));
};

CatchAllError.propTypes = {
  onClose: PropTypes.func.isRequired,
  error: PropTypes.string
};
CatchAllError.defaultProps = {
  error: null
};

var css_248z$t = ".Header-module_header__0zSHo {\n  position: relative;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n}\n.Header-module_header__0zSHo.Header-module_header-green__WqqTp {\n  background: #313c39;\n}\n.Header-module_header__0zSHo.Header-module_header-orange__ZMRSk {\n  background: #403636;\n}\n.Header-module_header__0zSHo.Header-module_header-red__lhPV3 {\n  background: #402f36;\n}\n\n.Header-module_topRow__5LBwc {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 0.5em;\n}\n\n.Header-module_topRowText__oHmFa {\n  font-family: Open Sans;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 1.125em;\n  line-height: 16px;\n  margin-left: 5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.Header-module_tabRow__XjxNt {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  position: relative;\n}\n\n.Header-module_tabDividerBottom__DXJx1 {\n  width: 100%;\n  height: 2px;\n  opacity: 0.1;\n  background-color: #f3eff1;\n  margin-top: -2px;\n}\n\n.Header-module_evalRow__hccXP {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 8px;\n  padding: 0.75em;\n  transition: 0.1s ease-in-out background-color;\n  width: 100%;\n}\n.Header-module_evalRow__hccXP.Header-module_eval-green__ODm6N {\n  background-color: #313c39;\n}\n.Header-module_evalRow__hccXP.Header-module_eval-orange__ZgeAw {\n  background-color: #403636;\n}\n.Header-module_evalRow__hccXP.Header-module_eval-red__eNbba {\n  background-color: #402f36;\n}\n\n.Header-module_evalBotHead__2m3ky {\n  height: 50px;\n  width: 50px;\n}\n.Header-module_evalBotHead__2m3ky.Header-module_botHead-green__5uqlc > svg {\n  box-shadow: 0 0 10px #3ce967;\n}\n.Header-module_evalBotHead__2m3ky.Header-module_botHead-orange__lv8pM > svg {\n  box-shadow: 0 0 10px #ff9545;\n}\n.Header-module_evalBotHead__2m3ky.Header-module_botHead-red__KeeBx > svg {\n  box-shadow: 0 0 10px #ff4545;\n}\n\n.Header-module_evalText__PZSO- {\n  margin-left: 0.25em;\n}\n\n.Header-module_close__xWOmt {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  border: none;\n  background-color: transparent;\n}\n\n.Header-module_statusBar__aq2Nq {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 1px;\n}";
var styles$s = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","header":"Header-module_header__0zSHo","header-green":"Header-module_header-green__WqqTp","header-orange":"Header-module_header-orange__ZMRSk","header-red":"Header-module_header-red__lhPV3","topRow":"Header-module_topRow__5LBwc","topRowText":"Header-module_topRowText__oHmFa","tabRow":"Header-module_tabRow__XjxNt","tabDividerBottom":"Header-module_tabDividerBottom__DXJx1","evalRow":"Header-module_evalRow__hccXP","eval-green":"Header-module_eval-green__ODm6N","eval-orange":"Header-module_eval-orange__ZgeAw","eval-red":"Header-module_eval-red__eNbba","evalBotHead":"Header-module_evalBotHead__2m3ky","botHead-green":"Header-module_botHead-green__5uqlc","botHead-orange":"Header-module_botHead-orange__lv8pM","botHead-red":"Header-module_botHead-red__KeeBx","evalText":"Header-module_evalText__PZSO-","close":"Header-module_close__xWOmt","statusBar":"Header-module_statusBar__aq2Nq","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7","header___green":"Header-module_header-green__WqqTp","header___orange":"Header-module_header-orange__ZMRSk","header___red":"Header-module_header-red__lhPV3","eval___green":"Header-module_eval-green__ODm6N","eval___orange":"Header-module_eval-orange__ZgeAw","eval___red":"Header-module_eval-red__eNbba","botHead___green":"Header-module_botHead-green__5uqlc","botHead___orange":"Header-module_botHead-orange__lv8pM","botHead___red":"Header-module_botHead-red__KeeBx"};
styleInject(css_248z$t);

var _jsxFileName$C = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/Header/Header.jsx";

const Header = ({
  activeTab,
  onTabClick,
  onClose
}) => {
  const {
    settledRequest
  } = useLoading();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$s.header),
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 27,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.topRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 28,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(EvaluationTile, {
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(CloseButton, {
    className: styles$s.close,
    onClick: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 30,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.tabRow,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 32,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.tabDividerTop,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 33,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Tabs, {
    activeTab: activeTab,
    onClick: onTabClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 34,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Tab, {
    label: TABS.OVERVIEW,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 35,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Tab, {
    label: TABS.TEAM,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 36,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Tab, {
    label: TABS.SETTINGS,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 37,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(StatusBar, {
    thinking: !settledRequest,
    className: styles$s.statusBar,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 39,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.tabDividerBottom,
    __self: window,
    __source: {
      fileName: _jsxFileName$C,
      lineNumber: 40,
      columnNumber: 9
    }
  })));
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired
};

const curry = f => a => (...args) => f(a, ...args);

const sendMessageGroup = async (authSettings, metadata, questionsArray) => {
  const postBody = {
    message_group: {
      messages: questionsArray.map(message => snakeCaseKeys(message)),
      metadata
    }
  };
  const client = await buildMikasaClient(authSettings);
  const endpoint = 'chromebot/message_groups';
  const response = client.post(endpoint, postBody);
  return response;
};

const useCreateMetaData = () => {
  var _useFullListingData;

  const {
    address,
    listingPrice
  } = (_useFullListingData = useFullListingData()) != null ? _useFullListingData : {};
  const url = useZillowListingUrl();
  const isExtension = useIsExtension();
  const source = isExtension ? EXTENSION_CLIENT_EVENT_SOURCE : EMBED_CLIENT_EVENT_SOURCE;
  const {
    marketTempSliderPrice,
    appreciationSliderPercent,
    includeRental
  } = useContext(AppContext);
  const metadata = {
    raw_address: address,
    listing_price: listingPrice,
    estimated_growth_rate: appreciationSliderPercent,
    proposed_offer: marketTempSliderPrice || listingPrice,
    considering_short_term_rental: includeRental,
    listing_url: url,
    source: source
  };
  return metadata;
};

const useMessageGroupRequestAsync = () => {
  const metadata = useCreateMetaData();
  const authSettings = useAuthSettings();
  const messageFunc = curry(curry(sendMessageGroup)(authSettings))(metadata);
  return useAsync(messageFunc, {
    minimumDuration: true
  });
};
const usePrequalRequestAsync = () => {
  const metadata = useCreateMetaData();
  const authSettings = useAuthSettings();
  const questionsArray = [{
    topic: 'a Listing they viewed',
    topicKey: PREQUAL_TOPIC_KEY,
    message: 'Can I get pre-qualified for this home?'
  }];
  const messageFuncWithAuth = curry(sendMessageGroup)(authSettings);
  const messageFuncWithAuthAndMetadata = curry(messageFuncWithAuth)(metadata);
  const messageFuncWithQuestions = curry(messageFuncWithAuthAndMetadata)(questionsArray);
  return useAsync(messageFuncWithQuestions, {
    minimumDuration: true
  });
};

var css_248z$s = ".LenderStats-module_highlights__vLbQA {\n  display: flex;\n  justify-content: space-between;\n}\n\n.LenderStats-module_stats__hDouD {\n  color: rgba(213, 208, 214, 0.7);\n}\n\n.LenderStats-module_center__bSTzl {\n  text-align: center;\n}";
var styles$r = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","highlights":"LenderStats-module_highlights__vLbQA","stats":"LenderStats-module_stats__hDouD","center":"LenderStats-module_center__bSTzl","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$s);

var _jsxFileName$B = "/home/circleci/app/libs/listings-bot/src/components/LenderStats/LenderStats.jsx";

const LenderStats = ({
  center
}) => {
  var _useFullListingData;

  const {
    address
  } = (_useFullListingData = useFullListingData()) != null ? _useFullListingData : {};
  const zip = getListingZipcode(address);
  const {
    loClientsHelped,
    loYearsInIndustry
  } = useBranding();
  const statsPresent = loClientsHelped || loYearsInIndustry;
  if (!statsPresent) return null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$r.highlights,
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 28,
      columnNumber: 5
    }
  }, loClientsHelped && /*#__PURE__*/React__default.createElement("div", {
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "xl",
    color: "eggShell",
    className: classnames(center && styles$r.center),
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 31,
      columnNumber: 11
    }
  }, loClientsHelped), /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    className: styles$r.stats,
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 38,
      columnNumber: 11
    }
  }, `clients helped in ${zip}`)), loYearsInIndustry && /*#__PURE__*/React__default.createElement("div", {
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 45,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "xl",
    color: "eggShell",
    className: classnames(center && styles$r.center),
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 46,
      columnNumber: 11
    }
  }, loYearsInIndustry), /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    className: styles$r.stats,
    __self: window,
    __source: {
      fileName: _jsxFileName$B,
      lineNumber: 53,
      columnNumber: 11
    }
  }, loYearsInIndustry === 1 ? 'year' : 'years', " in the industry")));
};

LenderStats.propTypes = {
  center: PropTypes.bool
};

var css_248z$r = ".CospoPrequalPrompt-module_wrapper__BeQXW {\n  position: absolute;\n  bottom: 0;\n}\n\n.CospoPrequalPrompt-module_root__Mv5-7 {\n  background-color: #302e35;\n  width: 100%;\n  box-shadow: 0px -8px 9px 0px rgba(0, 0, 0, 0.25);\n}\n\n.CospoPrequalPrompt-module_contents__-Ztyt {\n  padding: 1.5em;\n}\n\n.CospoPrequalPrompt-module_close__7A0-Z {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.CospoPrequalPrompt-module_avatarWrap__CCQka {\n  display: flex;\n  justify-content: center;\n  margin-top: 0.75em;\n  margin-bottom: 0.75em;\n}\n.CospoPrequalPrompt-module_avatarWrap__CCQka :not(:first-child) {\n  margin-left: -0.75em;\n}\n\n.CospoPrequalPrompt-module_avatar__KHnyA {\n  width: 50px;\n  height: 50px;\n  border: solid #f3eff1 1px;\n  margin: 0.75em 0px;\n}\n\n.CospoPrequalPrompt-module_subheader__DOG-- {\n  margin-bottom: 1.5em;\n}\n\n.CospoPrequalPrompt-module_statement__deQkF {\n  margin-top: 0.75em;\n  margin-bottom: 1.5em;\n}\n\n.CospoPrequalPrompt-module_getIntroButton__-kbsG {\n  margin-top: 2.25em;\n  margin-bottom: 0.75em;\n}\n\n.CospoPrequalPrompt-module_closeButton__uUzAt {\n  margin-top: 2.25em;\n}\n\n.CospoPrequalPrompt-module_lookOut__wMuJW {\n  margin-bottom: 1.5em;\n  padding-left: 42px;\n  padding-right: 42px;\n}\n\n.CospoPrequalPrompt-module_retry__DwBrx {\n  padding: 0;\n  margin-bottom: 1.5em;\n}";
var styles$q = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","wrapper":"CospoPrequalPrompt-module_wrapper__BeQXW","root":"CospoPrequalPrompt-module_root__Mv5-7","contents":"CospoPrequalPrompt-module_contents__-Ztyt","close":"CospoPrequalPrompt-module_close__7A0-Z","avatarWrap":"CospoPrequalPrompt-module_avatarWrap__CCQka","avatar":"CospoPrequalPrompt-module_avatar__KHnyA","subheader":"CospoPrequalPrompt-module_subheader__DOG--","statement":"CospoPrequalPrompt-module_statement__deQkF","getIntroButton":"CospoPrequalPrompt-module_getIntroButton__-kbsG","closeButton":"CospoPrequalPrompt-module_closeButton__uUzAt","lookOut":"CospoPrequalPrompt-module_lookOut__wMuJW","retry":"CospoPrequalPrompt-module_retry__DwBrx","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$r);

var _jsxFileName$A = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/CospoPrequalPrompt/CospoPrequalPrompt.jsx";

const CospoPrequalPrompt = ({
  onClose
}) => {
  const {
    customerPhotoUri,
    customerFirstName,
    customerLastName,
    customerStatement,
    sponsorFirstName,
    sponsorLastName,
    sponsorPhotoUri
  } = useBranding();
  const {
    execute: sendPrequalRequest,
    isLoading,
    isSuccess: showSuccessInfo,
    promptRetry
  } = usePrequalRequestAsync();
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.wrapper,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 34,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.root,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 35,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.contents,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 36,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(CloseButton, {
    className: styles$q.close,
    onClick: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 37,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(Unless, {
    condition: showSuccessInfo,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 38,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.avatarWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 39,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$q.avatar,
    src: customerPhotoUri,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 40,
      columnNumber: 15
    }
  }), /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$q.avatar,
    src: sponsorPhotoUri,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 41,
      columnNumber: 15
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    color: "white",
    size: "xl",
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 43,
      columnNumber: 13
    }
  }, "Speed Up Pre-Qualification"), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    className: styles$q.subheader,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 46,
      columnNumber: 13
    }
  }, `${sponsorFirstName} trusts the expert advice of lender ${customerFirstName} ${customerLastName}`), customerStatement && /*#__PURE__*/React__default.createElement("div", {
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 50,
      columnNumber: 15
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    color: "heather",
    size: "s",
    transform: "uppercase",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 51,
      columnNumber: 17
    }
  }, `About ${customerFirstName} ${customerLastName}`), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    className: styles$q.statement,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 58,
      columnNumber: 17
    }
  }, `"${customerStatement}"`)), /*#__PURE__*/React__default.createElement(LenderStats, {
    center: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 64,
      columnNumber: 13
    }
  }), /*#__PURE__*/React__default.createElement(Unless, {
    condition: promptRetry,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 65,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fullWidth: true,
    loading: isLoading,
    className: styles$q.getIntroButton,
    onClick: sendPrequalRequest,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 66,
      columnNumber: 15
    }
  }, "Get Intro"), /*#__PURE__*/React__default.createElement(Button, {
    regular: true,
    fullWidth: true,
    className: styles$q.button,
    onClick: () => onClose(),
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 75,
      columnNumber: 15
    }
  }, "Maybe Later")), /*#__PURE__*/React__default.createElement(If, {
    condition: promptRetry,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 84,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 85,
      columnNumber: 15
    }
  }, "Something went wrong."), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    loading: isLoading,
    className: styles$q.retry,
    onClick: sendPrequalRequest,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 88,
      columnNumber: 15
    }
  }, "Retry getting an intro?"))), /*#__PURE__*/React__default.createElement(If, {
    condition: showSuccessInfo,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 98,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.avatarWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 99,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$q.avatar,
    src: sponsorPhotoUri,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 100,
      columnNumber: 15
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    color: "white",
    size: "xl",
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 102,
      columnNumber: 13
    }
  }, "Talk to You Soon"), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    className: styles$q.lookOut,
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 105,
      columnNumber: 13
    }
  }, `Keep a look out for a phone call or email from ${sponsorFirstName} ${sponsorLastName} in the next few days.`), /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fullWidth: true,
    className: styles$q.closeButton,
    onClick: () => onClose(),
    __self: window,
    __source: {
      fileName: _jsxFileName$A,
      lineNumber: 108,
      columnNumber: 13
    }
  }, "Sounds Good")))));
};

CospoPrequalPrompt.propTypes = {
  onClose: PropTypes.func
};

//constants
const FooterQuestions = [{
  topic: `a Listing they viewed`,
  topicKey: AFFORD_TOPIC_KEY,
  message: 'Can I afford this home?'
}, {
  topic: `a Listing they viewed`,
  topicKey: INVESTMENT_TOPIC_KEY,
  message: 'Is this home a good investment?'
}, {
  topic: `a Listing they viewed`,
  topicKey: PREQUAL_TOPIC_KEY,
  message: 'Can I get pre-qualified for this home?'
}];

var css_248z$q = ".Footer-module_footer__-Jpoz {\n  bottom: 0;\n  z-index: 1;\n  background: #28262e;\n  box-shadow: 0px -8px 9px rgba(0, 0, 0, 0.25);\n}";
var styles$p = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","footer":"Footer-module_footer__-Jpoz","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$q);

var _jsxFileName$z = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/Footer/Footer.jsx";

const Footer = ({
  className
}) => {
  const {
    clientType
  } = useBuyerSettings();
  const toggleSignup = useToggleGuestSignup(); ////Drawer////

  const [drawerText, setDrawerText] = useState('');
  const [drawerSubText, setDrawerSubText] = useState('');
  const [drawerExpanded, setDrawerExpanded] = useState(false); ////MultiSelect////

  const [customQuestionMessage, setCustomQuestionMessage] = useState('');
  const [selectedQuestions, setSelectedQuestions] = useState([]); ////PrequalPrompt////

  const [shouldPromptPrequal, setShouldPromptPrequal] = useState(false);
  const [prequalSelected, setPrequalSelected] = useState(false);
  const [showPrequal, setShowPrequal] = useState(false);
  const {
    customerFirstName,
    customerPhotoUri,
    isLoading,
    isSponsorPresent
  } = useBranding();
  const {
    execute,
    reset,
    executeStatus: dmStatus,
    isLoading: dmLoading,
    isErrored: dmErrored,
    isSuccess: dmSuccess
  } = useMessageGroupRequestAsync();
  const messageSuccessText = 'Message Sent!';
  const messageSuccessSubText = `${customerFirstName} will be in touch soon`;
  const initializedText = 'Have any questions?';
  const initializedSubText = `${customerFirstName}'s here to help`;
  const handleSuccessText = useCallback(() => {
    setDrawerText(messageSuccessText);
    setDrawerSubText(messageSuccessSubText);
  }, [messageSuccessText, messageSuccessSubText]);
  const handleInitializedText = useCallback(() => {
    setDrawerText(initializedText);
    setDrawerSubText(initializedSubText);
  }, [initializedText, initializedSubText]);

  const handleCustomQuestion = e => {
    const value = e.target.value;
    setCustomQuestionMessage(value);
  };

  const handleToggleDrawer = useCallback(() => {
    if (drawerExpanded) {
      setSelectedQuestions([]);
      setCustomQuestionMessage('');
    }

    if (clientType === GUEST_CLIENT_TYPE) {
      toggleSignup({
        expandModal: 1
      });
    } else {
      setDrawerExpanded(!drawerExpanded);
    }
  }, [drawerExpanded, clientType, toggleSignup]);
  const updateSelectedQuestions = useCallback(questions => {
    setSelectedQuestions(questions);
  }, []);
  const executeResetTimeout = useCallback(() => {
    let timer = setTimeout(() => {
      handleInitializedText();
      reset();
    }, 4000);
    return () => {
      clearTimeout(timer);
    };
  }, [handleInitializedText, reset]);
  const handleCospoPrequalPromptClose = useCallback(() => {
    setPrequalSelected(false);
    setShowPrequal(false);
    executeResetTimeout();
  }, [executeResetTimeout]);
  const onSubmit = useCallback(() => {
    if (customQuestionMessage) {
      selectedQuestions.push({
        topic: 'a Listing they viewed',
        topicKey: CUSTOM_QUESTION_TOPIC_KEY,
        message: customQuestionMessage
      });
    }

    let questionsToSubmit = [...selectedQuestions];

    if (prequalSelected && isSponsorPresent) {
      questionsToSubmit = selectedQuestions.filter(question => question.topicKey !== PREQUAL_TOPIC_KEY);

      if (questionsToSubmit.length > 0) {
        // if there are more questions, wait for first request to fire
        setShouldPromptPrequal(true);
      } else {
        // else the regular request will not fire, so go ahead and prompt
        setShowPrequal(true);
        handleToggleDrawer();
      }
    }

    if (questionsToSubmit.length > 0) {
      execute(questionsToSubmit);
    }

    setCustomQuestionMessage('');
    setSelectedQuestions([]);
  }, [customQuestionMessage, execute, handleToggleDrawer, isSponsorPresent, prequalSelected, selectedQuestions]);
  const previousStatus = usePrevious(dmStatus);
  useEffect(() => {
    if (previousStatus !== dmStatus) {
      if (dmSuccess) {
        handleToggleDrawer();
        handleSuccessText();

        if (shouldPromptPrequal) {
          setShowPrequal(true);
        } else {
          executeResetTimeout();
        }
      }
    }
  }, [prequalSelected, dmStatus, dmErrored, dmSuccess, setDrawerExpanded, handleSuccessText, handleToggleDrawer, isSponsorPresent, previousStatus, executeResetTimeout, shouldPromptPrequal]);
  useEffect(() => {
    handleInitializedText();
  }, [handleInitializedText]);
  const numberOfMessages = customQuestionMessage ? selectedQuestions.length + 1 : selectedQuestions.length;
  const buttonLabel = numberOfMessages > 1 ? `Send ${numberOfMessages} Questions` : `Send Question`;
  const multiSelectDisabled = !selectedQuestions.length && !customQuestionMessage;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$p.footer, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 202,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Unless, {
    condition: isLoading,
    __self: window,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 203,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Drawer, {
    onClick: handleToggleDrawer,
    imageSrc: customerPhotoUri,
    text: drawerText,
    subtext: drawerSubText,
    status: dmStatus,
    expanded: drawerExpanded,
    disabled: dmSuccess,
    children: /*#__PURE__*/React__default.createElement(MultiSelect, {
      onCustomQuestionChange: handleCustomQuestion,
      updateSelectedQuestions: updateSelectedQuestions,
      setPrequalSelected: setPrequalSelected,
      onSubmit: onSubmit,
      customQuestionMessage: customQuestionMessage,
      multiSelectDisabled: multiSelectDisabled,
      buttonLabel: buttonLabel,
      questions: FooterQuestions,
      loadingSpin: dmLoading,
      error: dmErrored,
      __self: window,
      __source: {
        fileName: _jsxFileName$z,
        lineNumber: 213,
        columnNumber: 15
      }
    }),
    __self: window,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 204,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(If, {
    condition: showPrequal,
    __self: window,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 228,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(CospoPrequalPrompt, {
    onClose: handleCospoPrequalPromptClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$z,
      lineNumber: 229,
      columnNumber: 11
    }
  }))));
};

Footer.propTypes = {
  className: PropTypes.string
};

var css_248z$p = ".RenterForm-module_renterForm__dwceV {\n  color: #bbb2b7;\n}\n\n.RenterForm-module_formFields__hkyOi {\n  margin-bottom: 2.25em;\n}\n\n.RenterForm-module_yearsInHome__4QuxP,\n.RenterForm-module_rentableNights__1rUeb {\n  max-width: 6em;\n}\n\ninput[type=number]::-webkit-inner-spin-button {\n  display: none;\n}";
var styles$o = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","renterForm":"RenterForm-module_renterForm__dwceV","formFields":"RenterForm-module_formFields__hkyOi","yearsInHome":"RenterForm-module_yearsInHome__4QuxP","rentableNights":"RenterForm-module_rentableNights__1rUeb","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$p);

const _excluded$6 = ["onSubmit", "isSubmitting", "values", "focusedField", "placeholders", "errors"];
var _jsxFileName$y = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsForm/RenterForm/RenterForm.jsx";

const DownPaymentHint$1 = () => {
  const {
    listingPrice
  } = useListingDisplay();
  const downPayment = listingPrice * BUYER_DOWN_PAYMENT_PERCENT_OF_LISTING_PRICE;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "First-time buyers usually put down", ' ', /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "heather",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 38,
      columnNumber: 7
    }
  }, BUYER_DOWN_PAYMENT, "%"), ", or", ' ', /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "heather",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 42,
      columnNumber: 7
    }
  }, formatToCurrency(downPayment)));
};

const RenterForm = _ref => {
  let {
    onSubmit,
    isSubmitting,
    values,
    focusedField,
    placeholders,
    errors
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$6);

  const {
    listingPrice
  } = useListingDisplay();
  return /*#__PURE__*/React__default.createElement("form", {
    className: styles$o.renterForm,
    onSubmit: onSubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 61,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$o.formFields,
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 62,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.CURRENT_MONTHLY_COST],
    placeholder: placeholders && placeholders[INPUT_NAMES.CURRENT_MONTHLY_COST],
    name: INPUT_NAMES.CURRENT_MONTHLY_COST,
    label: "Current monthly costs",
    hint: "Think rent payment, renter\u2019s insurance, etc.",
    input: PerMonthInput,
    error: errors && errors[INPUT_NAMES.CURRENT_MONTHLY_COST],
    autoFocus: focusedField === INPUT_NAMES.CURRENT_MONTHLY_COST
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 63,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.MAX_BUDGET],
    placeholder: placeholders && placeholders[INPUT_NAMES.MAX_BUDGET],
    name: INPUT_NAMES.MAX_BUDGET,
    label: "Max monthly budget",
    hint: "This should be ~25% of your monthly income",
    input: PerMonthInput,
    error: errors && errors[INPUT_NAMES.MAX_BUDGET],
    autoFocus: focusedField === INPUT_NAMES.MAX_BUDGET
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 76,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    total: listingPrice,
    amount: values && parseFloat(values[INPUT_NAMES.DOWN_PAYMENT]),
    placeholder: placeholders && placeholders[INPUT_NAMES.DOWN_PAYMENT],
    name: INPUT_NAMES.DOWN_PAYMENT,
    label: "Down payment",
    hint: /*#__PURE__*/React__default.createElement(DownPaymentHint$1, {
      __self: window,
      __source: {
        fileName: _jsxFileName$y,
        lineNumber: 93,
        columnNumber: 17
      }
    }),
    input: AmountPercentInput,
    error: errors && errors[INPUT_NAMES.DOWN_PAYMENT],
    autoFocus: focusedField === INPUT_NAMES.DOWN_PAYMENT
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 87,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.YEARS_IN_HOME],
    placeholder: placeholders && placeholders[INPUT_NAMES.YEARS_IN_HOME],
    name: INPUT_NAMES.YEARS_IN_HOME,
    label: "Years in home",
    className: styles$o.yearsInHome,
    hint: "On average, 7 years is the general guidance",
    input: YearsInput,
    error: errors && errors[INPUT_NAMES.YEARS_IN_HOME],
    autoFocus: focusedField === INPUT_NAMES.YEARS_IN_HOME
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 99,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.RENTABLE_NIGHTS],
    placeholder: placeholders && placeholders[INPUT_NAMES.RENTABLE_NIGHTS],
    name: INPUT_NAMES.RENTABLE_NIGHTS,
    label: "Rentable Nights",
    className: styles$o.rentableNights,
    hint: "How many nights a month would you consider renting on Airbnb?",
    input: NightsInput,
    error: errors && errors[INPUT_NAMES.RENTABLE_NIGHTS],
    autoFocus: focusedField === INPUT_NAMES.RENTABLE_NIGHTS
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 111,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    primary: true,
    fullWidth: true,
    loading: isSubmitting,
    __self: window,
    __source: {
      fileName: _jsxFileName$y,
      lineNumber: 127,
      columnNumber: 7
    }
  }, "Update"));
};

RenterForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  focusedField: PropTypes.string,
  values: PropTypes.shape({
    maxBudget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    downPayment: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    yearsInHome: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currentMonthlyCost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rentableNights: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  placeholders: PropTypes.shape({
    currentMonthlyCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxBudget: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    downPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    yearsInHome: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rentableNights: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  errors: PropTypes.shape({
    maxBudget: PropTypes.string,
    downPayment: PropTypes.string,
    yearsInHome: PropTypes.string,
    currentMonthlyCost: PropTypes.string,
    rentableNights: PropTypes.string
  })
};

var _jsxFileName$x = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsForm/HomeownerForm/DownPaymentHint.jsx";

const DownPaymentHint = () => {
  const {
    currentAddress,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment
  } = useListingDisplay();

  if (usingDefaultDownPayment) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 25,
      columnNumber: 7
    }
  }, "If you sold "), /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "pink",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 26,
      columnNumber: 7
    }
  }, currentAddress || 'your current home'), /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 29,
      columnNumber: 7
    }
  }, " today, you could pocket around "), /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "green",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 30,
      columnNumber: 7
    }
  }, formatAbbrCurrency(estimatedDownPaymentFromEquity)), /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$x,
      lineNumber: 33,
      columnNumber: 7
    }
  }, " after selling fees."));
};

var css_248z$o = ".DownPaymentSubtext-module_downPaymentSubtext__wLbfT {\n  margin-top: 0.5em;\n}\n\n.DownPaymentSubtext-module_updateToPmiPercentButton__kxaiU {\n  display: inline;\n  padding: 0;\n}";
var styles$n = {"downPaymentSubtext":"DownPaymentSubtext-module_downPaymentSubtext__wLbfT","updateToPmiPercentButton":"DownPaymentSubtext-module_updateToPmiPercentButton__kxaiU"};
styleInject(css_248z$o);

var _jsxFileName$w = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsForm/HomeownerForm/DownPaymentSubtext.jsx";

const DownPaymentSubtext = () => /*#__PURE__*/React__default.createElement("div", {
  className: styles$n.downPaymentSubtext,
  __self: window,
  __source: {
    fileName: _jsxFileName$w,
    lineNumber: 10,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement(Text, {
  element: "span",
  __self: window,
  __source: {
    fileName: _jsxFileName$w,
    lineNumber: 11,
    columnNumber: 5
  }
}, "Down payments under ", PMI_DROPPED_PERCENT, "% often require PMI, increasing monthly costs."));

var css_248z$n = ".HomeownerForm-module_homeownerForm__D2Al7 {\n  color: #f3eff1;\n  margin-bottom: 1em;\n}\n\n.HomeownerForm-module_header__SLoFK {\n  position: fixed;\n  top: 0;\n  display: flex;\n  align-items: center;\n  width: calc(100% - (2 * 1em));\n  background-color: #302e35;\n  height: 88px;\n  z-index: 1;\n}\n\n.HomeownerForm-module_headerText__3rbDT {\n  font-size: 1.5em;\n  flex-grow: 1;\n}\n\n.HomeownerForm-module_formBody__KK-HX {\n  padding-top: calc(88px - 1em);\n}\n\n.HomeownerForm-module_section__Z0vm5 {\n  margin-bottom: 1.5rem;\n}\n.HomeownerForm-module_section__Z0vm5:last-of-type {\n  margin-bottom: 0;\n}\n\n.HomeownerForm-module_sectionHeader__6CkeU {\n  margin-bottom: 1rem;\n}\n\n.HomeownerForm-module_sectionBody__AWCUO {\n  border: 2px solid #3b393e;\n  border-radius: 8px;\n  padding: 1em;\n}\n\n.HomeownerForm-module_yearsInHome__HfNQc,\n.HomeownerForm-module_rentableNights__-7qPx {\n  max-width: 6em;\n}";
var styles$m = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","homeownerForm":"HomeownerForm-module_homeownerForm__D2Al7","header":"HomeownerForm-module_header__SLoFK","headerText":"HomeownerForm-module_headerText__3rbDT","formBody":"HomeownerForm-module_formBody__KK-HX","section":"HomeownerForm-module_section__Z0vm5","sectionHeader":"HomeownerForm-module_sectionHeader__6CkeU","sectionBody":"HomeownerForm-module_sectionBody__AWCUO","yearsInHome":"HomeownerForm-module_yearsInHome__HfNQc","rentableNights":"HomeownerForm-module_rentableNights__-7qPx","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$n);

const _excluded$5 = ["onSubmit", "onChange", "isSubmitting", "values", "errors", "placeholders", "focusedField"];
var _jsxFileName$v = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsForm/HomeownerForm/HomeownerForm.jsx";

const HomeownerForm = _ref => {
  let {
    onSubmit,
    onChange,
    isSubmitting,
    values,
    errors,
    placeholders,
    focusedField
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$5);

  const {
    listingPrice,
    currentAddress
  } = useListingDisplay();
  const showDownPaymentSubtext = values && values[INPUT_NAMES.DOWN_PAYMENT] < listingPrice * PMI_DROPPED_PERCENT_AS_DECIMAL;
  return /*#__PURE__*/React__default.createElement("form", {
    className: styles$m.homeownerForm,
    onSubmit: onSubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 43,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.header,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    weight: "light",
    color: "white",
    className: styles$m.headerText,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 45,
      columnNumber: 9
    }
  }, "Your Profile"), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    type: "submit",
    loading: isSubmitting,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 48,
      columnNumber: 9
    }
  }, "Update")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.formBody,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 53,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("section", {
    className: styles$m.section,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 54,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.sectionHeader,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 55,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    className: styles$m.sectionHeader,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 56,
      columnNumber: 13
    }
  }, "For this home")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.sectionBody,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 60,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.MAX_BUDGET],
    placeholder: placeholders && placeholders[INPUT_NAMES.MAX_BUDGET],
    name: INPUT_NAMES.MAX_BUDGET,
    label: "Max monthly budget",
    hint: "What's the most you can spend on home costs?",
    input: PerMonthInput,
    error: errors && errors[INPUT_NAMES.MAX_BUDGET],
    autoFocus: focusedField === INPUT_NAMES.MAX_BUDGET,
    onChange: onChange
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 61,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    total: listingPrice,
    amount: values && parseFloat(values[INPUT_NAMES.DOWN_PAYMENT]),
    placeholder: placeholders && placeholders[INPUT_NAMES.DOWN_PAYMENT],
    name: INPUT_NAMES.DOWN_PAYMENT,
    label: "Down payment",
    hint: /*#__PURE__*/React__default.createElement(DownPaymentHint, {
      __self: window,
      __source: {
        fileName: _jsxFileName$v,
        lineNumber: 82,
        columnNumber: 21
      }
    }),
    input: AmountPercentInput,
    subtext: showDownPaymentSubtext && /*#__PURE__*/React__default.createElement(DownPaymentSubtext, {
      __self: window,
      __source: {
        fileName: _jsxFileName$v,
        lineNumber: 84,
        columnNumber: 50
      }
    }),
    error: errors && errors[INPUT_NAMES.DOWN_PAYMENT],
    onChange: onChange,
    autoFocus: focusedField === INPUT_NAMES.DOWN_PAYMENT
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 74,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    className: styles$m.yearsInHome,
    value: values && values[INPUT_NAMES.YEARS_IN_HOME],
    placeholder: placeholders && placeholders[INPUT_NAMES.YEARS_IN_HOME],
    name: INPUT_NAMES.YEARS_IN_HOME,
    label: "Years in home",
    hint: "How long will you stay there?",
    input: YearsInput,
    error: errors && errors[INPUT_NAMES.YEARS_IN_HOME],
    onChange: onChange,
    autoFocus: focusedField === INPUT_NAMES.YEARS_IN_HOME
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 91,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    className: styles$m.rentableNights,
    value: values && values[INPUT_NAMES.RENTABLE_NIGHTS],
    placeholder: placeholders && placeholders[INPUT_NAMES.RENTABLE_NIGHTS],
    name: INPUT_NAMES.RENTABLE_NIGHTS,
    label: "Rentable nights",
    hint: "How many nights a month would you consider renting on Airbnb?",
    input: NightsInput,
    error: errors && errors[INPUT_NAMES.RENTABLE_NIGHTS],
    onChange: onChange,
    autoFocus: focusedField === INPUT_NAMES.RENTABLE_NIGHTS
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 107,
      columnNumber: 13
    }
  })))), /*#__PURE__*/React__default.createElement("section", {
    className: styles$m.section,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 125,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.sectionHeader,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 126,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 127,
      columnNumber: 13
    }
  }, "For", ' '), /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "pink",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 130,
      columnNumber: 13
    }
  }, currentAddress || 'Your current address')), /*#__PURE__*/React__default.createElement("div", {
    className: styles$m.sectionBody,
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 134,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(FormField, _extends$1({
    value: values && values[INPUT_NAMES.CURRENT_MONTHLY_COST],
    placeholder: placeholders && placeholders[INPUT_NAMES.CURRENT_MONTHLY_COST],
    name: INPUT_NAMES.CURRENT_MONTHLY_COST,
    label: "Monthly costs",
    hint: "What are your current monthly home costs?",
    input: PerMonthInput,
    error: errors && errors[INPUT_NAMES.CURRENT_MONTHLY_COST],
    onChange: onChange,
    autoFocus: focusedField === INPUT_NAMES.CURRENT_MONTHLY_COST
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$v,
      lineNumber: 135,
      columnNumber: 13
    }
  }))))));
};

HomeownerForm.propTypes = {
  isSubmitting: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  focusedField: PropTypes.string,
  values: PropTypes.shape({
    maxBudget: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    downPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    yearsInHome: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currentMonthlyCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rentableNights: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  errors: PropTypes.shape({
    maxBudget: PropTypes.string,
    downPayment: PropTypes.string,
    yearsInHome: PropTypes.string,
    currentMonthlyCost: PropTypes.string,
    rentableNights: PropTypes.string
  }),
  placeholders: PropTypes.shape({
    maxBudget: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    downPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    yearsInHome: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currentMonthlyCost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rentableNights: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

// Constants

const mustBeInRange = (min, max) => `Must be ${min}-${max}`;

const mustBeGreaterThan = bound => `Must be greater than ${bound}`;

const validator = values => {
  const errors = {};
  const {
    currentMonthlyCost,
    maxBudget,
    downPayment,
    yearsInHome,
    rentableNights
  } = values;

  if (currentMonthlyCost && currentMonthlyCost <= 0) {
    errors[INPUT_NAMES.CURRENT_MONTHLY_COST] = mustBeGreaterThan(0);
  }

  if (maxBudget && maxBudget <= 0) {
    errors[INPUT_NAMES.MAX_BUDGET] = mustBeGreaterThan(0);
  }

  if (downPayment && downPayment <= 0) {
    errors[INPUT_NAMES.DOWN_PAYMENT] = mustBeGreaterThan(0);
  }

  if (yearsInHome && (yearsInHome < MIN_YEARS_IN_HOME || yearsInHome > MAX_YEARS_IN_HOME)) {
    errors[INPUT_NAMES.YEARS_IN_HOME] = mustBeInRange(MIN_YEARS_IN_HOME, MAX_YEARS_IN_HOME);
  }

  if (rentableNights && (rentableNights < MIN_RENTABLE_NIGHTS || rentableNights > MAX_RENTABLE_NIGHTS)) {
    errors[INPUT_NAMES.RENTABLE_NIGHTS] = mustBeInRange(MIN_RENTABLE_NIGHTS, MAX_RENTABLE_NIGHTS);
  }

  return errors;
};

const _excluded$4 = ["afterSubmit"];
var _jsxFileName$u = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsForm/SettingsForm.jsx";

const SettingsForm = _ref => {
  let {
    afterSubmit
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$4);

  const {
    focusedSettingsField
  } = useContext(AppContext);
  const {
    affordability,
    downPayment
  } = useBuyerSettings();

  const calculateAffordabilityPlaceholder = val => {
    const budget = val ? BUDGET_PRICE_POINT_RATIO * val : DEFAULT_MAX_BUDGET;
    return formatToCurrency(budget);
  };

  const calculateDownPaymentPlaceholder = val => {
    const budget = val ? val : DEFAULT_DOWN_PAYMENT;
    return formatToCurrency(budget);
  };

  const [values, setValues] = useState({
    [INPUT_NAMES.CURRENT_MONTHLY_COST]: '',
    [INPUT_NAMES.MAX_BUDGET]: '',
    [INPUT_NAMES.DOWN_PAYMENT]: '',
    [INPUT_NAMES.YEARS_IN_HOME]: '',
    [INPUT_NAMES.RENTABLE_NIGHTS]: ''
  });
  const [dirty, setDirty] = useState({
    [INPUT_NAMES.CURRENT_MONTHLY_COST]: false,
    [INPUT_NAMES.MAX_BUDGET]: false,
    [INPUT_NAMES.DOWN_PAYMENT]: false,
    [INPUT_NAMES.YEARS_IN_HOME]: false,
    [INPUT_NAMES.RENTABLE_NIGHTS]: false
  });
  const placeholders = {
    [INPUT_NAMES.CURRENT_MONTHLY_COST]: formatToCurrency(DEFAULT_CURRENT_MONTHLY_COST),
    [INPUT_NAMES.MAX_BUDGET]: calculateAffordabilityPlaceholder(affordability),
    [INPUT_NAMES.DOWN_PAYMENT]: calculateDownPaymentPlaceholder(downPayment),
    [INPUT_NAMES.YEARS_IN_HOME]: DEFAULT_YEARS_IN_HOME,
    [INPUT_NAMES.RENTABLE_NIGHTS]: DEFAULT_RENTABLE_NIGHTS
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const buyerSettings = useBuyerSettings();
  const [errors, setErrors] = useState({});
  const toggleSignup = useToggleGuestSignup();
  const mutation = useBuyerSettingsMutation();

  const handleAuthedUserSubmit = e => {
    e.preventDefault();
    const errors = validator(values);

    if (!isEmpty$1(errors)) {
      setErrors(errors);
    } else {
      setIsSubmitting(true);
      const payload = snakeCaseKeys(values);
      mutation.mutate(payload, {
        onSuccess: () => {
          const prequalFieldChanged = dirty[INPUT_NAMES.MAX_BUDGET] || dirty[INPUT_NAMES.DOWN_PAYMENT];
          setDirty({});
          afterSubmit(prequalFieldChanged);
        },
        onSettled: () => {
          setIsSubmitting(false);
        }
      });
    }
  };

  const handleChange = e => {
    const {
      target: {
        name,
        value
      }
    } = e;
    const newValues = Object.assign({}, values, {
      [name]: value
    });
    const updatedDirtyFields = Object.assign({}, dirty, {
      [name]: parseInt(value) !== buyerSettings[name]
    });
    setValues(newValues);
    setDirty(updatedDirtyFields);
  };

  const handleGuestFocus = e => {
    const {
      target: {
        name
      }
    } = e;
    toggleSignup({
      expandModal: 1,
      focusTab: TABS.SETTINGS,
      focusTarget: name
    });
    e.preventDefault();
    e.target.blur();
  };

  const handleGuestSubmit = () => {
    toggleSignup({
      expandModal: 1,
      focusTab: TABS.SETTINGS
    });
  };

  useEffect(() => {
    if (!mutation.isLoading) {
      var _buyerSettings$curren, _buyerSettings$maxBud, _buyerSettings$downPa, _buyerSettings$yearsI, _buyerSettings$rentab;

      setValues({
        [INPUT_NAMES.CURRENT_MONTHLY_COST]: (_buyerSettings$curren = buyerSettings.currentMonthlyCost) != null ? _buyerSettings$curren : '',
        [INPUT_NAMES.MAX_BUDGET]: (_buyerSettings$maxBud = buyerSettings.maxBudget) != null ? _buyerSettings$maxBud : '',
        [INPUT_NAMES.DOWN_PAYMENT]: (_buyerSettings$downPa = buyerSettings.downPayment) != null ? _buyerSettings$downPa : '',
        [INPUT_NAMES.YEARS_IN_HOME]: (_buyerSettings$yearsI = buyerSettings.yearsInHome) != null ? _buyerSettings$yearsI : '',
        [INPUT_NAMES.RENTABLE_NIGHTS]: (_buyerSettings$rentab = buyerSettings.rentableNights) != null ? _buyerSettings$rentab : ''
      });
    }
  }, [buyerSettings.currentMonthlyCost, buyerSettings.clientType, buyerSettings.maxBudget, buyerSettings.downPayment, buyerSettings.yearsInHome, buyerSettings.rentableNights, mutation.isLoading]);
  const guestUserProps = Object.assign({}, restProps, {
    onSubmit: handleGuestSubmit,
    onChange: handleChange,
    onFocus: handleGuestFocus,
    values,
    placeholders,
    errors
  });
  const authedUserProps = Object.assign({}, restProps, {
    onSubmit: handleAuthedUserSubmit,
    onChange: handleChange,
    isSubmitting,
    values,
    placeholders,
    errors,
    focusedField: focusedSettingsField
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(If.Guest, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 193,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(RenterForm, _extends$1({}, guestUserProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 194,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React__default.createElement(If.Rent, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 196,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(RenterForm, _extends$1({}, authedUserProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 197,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React__default.createElement(If.Own, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 199,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(HomeownerForm, _extends$1({}, authedUserProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$u,
      lineNumber: 200,
      columnNumber: 9
    }
  }))));
};

SettingsForm.propTypes = {
  afterSubmit: PropTypes.func
};

var css_248z$m = ".PrequalPrompt-module_wrapper__I0Mb5 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.PrequalPrompt-module_curtain__NLOHZ {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(35, 35, 35, 0.85);\n  z-index: 2;\n}\n\n.PrequalPrompt-module_content__zMK-7 {\n  margin-top: -65px;\n  width: 80%;\n  height: auto;\n  padding: 0.75em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 3px;\n  background-color: #3a383f;\n  box-shadow: 0 0px 10px rgba(0, 0, 0, 0.25);\n  z-index: 2;\n}\n.PrequalPrompt-module_content__zMK-7 > p {\n  text-align: center;\n  margin: 0.375em;\n}\n.PrequalPrompt-module_content__zMK-7 button {\n  margin: 0.375em auto;\n}\n.PrequalPrompt-module_content__zMK-7 button:first-of-type {\n  margin-top: 1.5em;\n}\n\n.PrequalPrompt-module_avatarWrap__w-1kR {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n}\n.PrequalPrompt-module_avatarWrap__w-1kR :not(:first-child) {\n  margin-left: -0.75em;\n}\n\n.PrequalPrompt-module_avatar__3gWVG {\n  width: 50px;\n  height: 50px;\n  border: solid gray 1px;\n  margin: 0.75em 0px;\n}\n.PrequalPrompt-module_avatar__3gWVG.PrequalPrompt-module_errored__YJXC3 {\n  padding: 0;\n  border: none;\n  transform: rotate(30deg);\n}\n.PrequalPrompt-module_avatar__3gWVG.PrequalPrompt-module_errored__YJXC3 svg {\n  width: 50px !important;\n  height: 50px !important;\n}";
var styles$l = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","wrapper":"PrequalPrompt-module_wrapper__I0Mb5","curtain":"PrequalPrompt-module_curtain__NLOHZ","content":"PrequalPrompt-module_content__zMK-7","avatarWrap":"PrequalPrompt-module_avatarWrap__w-1kR","avatar":"PrequalPrompt-module_avatar__3gWVG","errored":"PrequalPrompt-module_errored__YJXC3","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$m);

const _excluded$3 = ["onClose", "className"];
var _jsxFileName$t = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/PrequalPrompt/PrequalPrompt.jsx";

const PrequalPrompt = _ref => {
  let {
    onClose,
    className
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$3);

  const {
    customerFirstName,
    sponsorFirstName,
    sponsorFullName,
    customerPhotoUri,
    sponsorPhotoUri,
    customerPhone,
    sponsorPhone,
    customerEmail,
    sponsorEmail,
    customerType
  } = useBranding();
  const {
    execute: sendPrequalRequest,
    isLoading,
    isSuccess,
    promptRetry
  } = usePrequalRequestAsync();
  const lenderPhoto = customerType === 'RealEstateAgent' ? sponsorPhotoUri : customerPhotoUri;
  const contactFirstName = sponsorFirstName || customerFirstName;
  const contactEmail = sponsorEmail || customerEmail;
  const contactPhone = sponsorPhone || customerPhone;
  const requestComplete = isSuccess || promptRetry;
  const needsLenderPhoto = customerType === 'RealEstateAgent' && lenderPhoto;
  const mainTextProps = {
    size: 'l',
    color: 'white'
  };
  const subTextProps = {
    size: 's',
    color: 'gray'
  };

  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return /*#__PURE__*/React__default.createElement("div", _extends$1({
    className: classnames(styles$l.wrapper, className)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 53,
      columnNumber: 5
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.curtain,
    onClick: handleOnClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 54,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.content,
    onClick: e => e.stopPropagation(),
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 55,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.avatarWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Unless, {
    condition: promptRetry,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 57,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: customerType === 'LoanOfficer' || !requestComplete,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 58,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$l.avatar,
    src: customerPhotoUri,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 59,
      columnNumber: 15
    }
  })), /*#__PURE__*/React__default.createElement(If, {
    condition: needsLenderPhoto,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 61,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$l.avatar,
    src: lenderPhoto,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 62,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React__default.createElement(If, {
    condition: promptRetry,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 65,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(CircleIcon, {
    className: classnames(styles$l.avatar, styles$l.errored),
    icon: "homebot",
    backgroundColor: "none",
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 66,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React__default.createElement(Unless, {
    condition: requestComplete,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 73,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, _extends$1({}, mainTextProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 75,
      columnNumber: 13
    }
  }), "Verify your price point"), /*#__PURE__*/React__default.createElement(If, {
    condition: sponsorFullName,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 76,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Text, _extends$1({}, subTextProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 77,
      columnNumber: 15
    }
  }), customerFirstName, " trusts lender ", sponsorFullName, " to help answer your questions.")), /*#__PURE__*/React__default.createElement(Text, _extends$1({}, subTextProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 82,
      columnNumber: 13
    }
  }), "Chat with ", contactFirstName, " about your goals, how to be competitive in the market, and getting a prequalification."), /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fullWidth: true,
    loading: isLoading,
    onClick: sendPrequalRequest,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 86,
      columnNumber: 13
    }
  }, "Verify with ", contactFirstName), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    fullWidth: true,
    onClick: handleOnClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 94,
      columnNumber: 13
    }
  }, "Maybe later"))), /*#__PURE__*/React__default.createElement(If, {
    condition: requestComplete,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 99,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, _extends$1({}, mainTextProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 101,
      columnNumber: 13
    }
  }), isSuccess && `${contactFirstName} has been notified and will reach out soon!`, promptRetry && `Something went wrong!`), /*#__PURE__*/React__default.createElement(Text, _extends$1({}, subTextProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 106,
      columnNumber: 13
    }
  }), promptRetry && 'Please retry again in a few minutes.', promptRetry && /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 108,
      columnNumber: 31
    }
  }), "Can\u2019t wait?", /*#__PURE__*/React__default.createElement(Text, {
    element: "a",
    color: "blue",
    href: `mailto:${contactEmail}`,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 110,
      columnNumber: 15
    }
  }, ` Email ${contactFirstName} `), "or call at", /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 114,
      columnNumber: 15
    }
  }), formatToPhone(contactPhone)), /*#__PURE__*/React__default.createElement(If, {
    condition: isSuccess,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 117,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fullWidth: true,
    onClick: handleOnClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 118,
      columnNumber: 15
    }
  }, "Sounds good")), /*#__PURE__*/React__default.createElement(If, {
    condition: promptRetry,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 122,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fullWidth: true,
    loading: isLoading,
    onClick: sendPrequalRequest,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 123,
      columnNumber: 15
    }
  }, "Retry"), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    fullWidth: true,
    onClick: handleOnClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$t,
      lineNumber: 131,
      columnNumber: 15
    }
  }, "Maybe later"))))));
};

PrequalPrompt.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func
};

var css_248z$l = ".SettingsPanel-module_container__ETxxZ {\n  padding: 1em;\n}\n\n.SettingsPanel-module_prequalPrompt__vU-ha {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}";
var styles$k = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","container":"SettingsPanel-module_container__ETxxZ","prequalPrompt":"SettingsPanel-module_prequalPrompt__vU-ha","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$l);

var _jsxFileName$s = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SettingsPanel/SettingsPanel.jsx";

const SettingsPanel = () => {
  const {
    execute: updateCanRequestPrequal,
    value: canRequestPrequal
  } = useShouldRequestPrequal();
  const [showPrequalPrompt, setShowPrequalPrompt] = useState(false);
  const {
    setActiveTab
  } = useContext(AppContext);

  const hidePrequal = () => {
    setShowPrequalPrompt(false);
    setActiveTab(TABS.OVERVIEW);
  };

  const showPrequal = () => {
    setShowPrequalPrompt(true);
    updateCanRequestPrequal();
  };

  const afterSubmit = prequalChanged => {
    if (canRequestPrequal && prequalChanged) {
      showPrequal();
    } else {
      setActiveTab(TABS.OVERVIEW);
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$k.container,
    __self: window,
    __source: {
      fileName: _jsxFileName$s,
      lineNumber: 47,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(SettingsForm, {
    afterSubmit: afterSubmit,
    __self: window,
    __source: {
      fileName: _jsxFileName$s,
      lineNumber: 48,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(If, {
    condition: showPrequalPrompt,
    __self: window,
    __source: {
      fileName: _jsxFileName$s,
      lineNumber: 50,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(PrequalPrompt, {
    className: styles$k.prequalPrompt,
    onClose: hidePrequal,
    __self: window,
    __source: {
      fileName: _jsxFileName$s,
      lineNumber: 51,
      columnNumber: 9
    }
  })));
};

SettingsPanel.propTypes = {};

var css_248z$k = ".ProfileCard-module_panel__nBCkG {\n  margin-bottom: 1.5em;\n  padding: 0.75em 1.2em;\n}\n\n.ProfileCard-module_divider__PTFvf {\n  position: relative;\n}\n\n.ProfileCard-module_type__MsH1N {\n  color: rgba(202, 199, 201, 0.6);\n}\n\n.ProfileCard-module_priority__ZrMvb {\n  color: rgba(213, 208, 214, 0.6);\n}\n\n.ProfileCard-module_stats__78axC {\n  color: rgba(213, 208, 214, 0.7);\n}\n\n.ProfileCard-module_avatar__CY6IH {\n  border: 1px solid white;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  top: 0px;\n  right: 0px;\n}\n\n.ProfileCard-module_note__kA754 {\n  color: rgba(157, 151, 171, 0.7);\n  margin-top: 1.5em;\n  margin-bottom: 0.375em;\n}\n\n.ProfileCard-module_highlightHeader__ACPaN,\n.ProfileCard-module_contact__m2oBV {\n  color: rgba(157, 151, 171, 0.7);\n  margin-top: 1.5em;\n  margin-bottom: 0.375em;\n}\n\n.ProfileCard-module_email__MZsv6 {\n  display: block;\n  text-decoration: none;\n}\n.ProfileCard-module_email__MZsv6:hover {\n  color: #4fbffb;\n}\n\n.ProfileCard-module_phone__q2St2 {\n  text-decoration: none;\n}\n.ProfileCard-module_phone__q2St2:hover {\n  color: #4fbffb;\n}";
var styles$j = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","panel":"ProfileCard-module_panel__nBCkG","divider":"ProfileCard-module_divider__PTFvf","type":"ProfileCard-module_type__MsH1N","priority":"ProfileCard-module_priority__ZrMvb","stats":"ProfileCard-module_stats__78axC","avatar":"ProfileCard-module_avatar__CY6IH","note":"ProfileCard-module_note__kA754","highlightHeader":"ProfileCard-module_highlightHeader__ACPaN","contact":"ProfileCard-module_contact__m2oBV","email":"ProfileCard-module_email__MZsv6","phone":"ProfileCard-module_phone__q2St2","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$k);

var _jsxFileName$r = "/home/circleci/app/libs/listings-bot/src/components/ProfileCard/ProfileCard.jsx";

const ProfileCard = ({
  profile,
  isSponsorPresent,
  sponsorForFirstName,
  branding
}) => {
  if (!profile) {
    return null;
  }

  const {
    type,
    firstName,
    lastName,
    brandingStatement,
    corporateProfileName,
    corporateProfilePhone,
    nmls,
    phone,
    email,
    photo
  } = profile;
  const {
    loClientsHelped,
    loYearsInIndustry
  } = branding;
  const statsPresent = loClientsHelped || loYearsInIndustry;
  const phoneNumber = phone || corporateProfilePhone;
  return /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$j.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 43,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(PanelDivider, {
    header: true,
    className: styles$j.divider,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    size: "s",
    color: "twilight",
    weight: "bold",
    letterSpacing: "large",
    className: styles$j.type,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 45,
      columnNumber: 9
    }
  }, type === REA ? 'Real estate pro' : 'Lending pro'), /*#__PURE__*/React__default.createElement(Text, {
    size: "xl",
    color: "eggShell",
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 55,
      columnNumber: 9
    }
  }, `${firstName} ${lastName}`), /*#__PURE__*/React__default.createElement(If, {
    condition: isSponsorPresent,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 58,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    className: styles$j.priority,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 59,
      columnNumber: 11
    }
  }, sponsorForFirstName ? `Trusted by ${sponsorForFirstName}` : 'Your main contact')), /*#__PURE__*/React__default.createElement(Avatar, {
    className: styles$j.avatar,
    src: photo,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 65,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(If, {
    condition: type === LO,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 67,
      columnNumber: 7
    }
  }, brandingStatement && /*#__PURE__*/React__default.createElement(Text, {
    className: styles$j.note,
    transform: "uppercase",
    letterSpacing: "large",
    size: "s",
    color: "heather",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 69,
      columnNumber: 11
    }
  }, `A note from ${firstName}`), brandingStatement && /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 80,
      columnNumber: 31
    }
  }, `"${brandingStatement}"`)), /*#__PURE__*/React__default.createElement(If, {
    condition: type === LO,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 82,
      columnNumber: 7
    }
  }, statsPresent && /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    letterSpacing: "large",
    size: "s",
    color: "heather",
    weight: "bold",
    className: styles$j.highlightHeader,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 84,
      columnNumber: 11
    }
  }, "Highlights"), /*#__PURE__*/React__default.createElement(LenderStats, {
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 95,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    letterSpacing: "large",
    size: "s",
    color: "heather",
    weight: "bold",
    className: styles$j.contact,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 97,
      columnNumber: 7
    }
  }, "Contact info"), corporateProfileName && /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 107,
      columnNumber: 32
    }
  }, corporateProfileName), nmls && /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 108,
      columnNumber: 16
    }
  }, "NMLS #", nmls), email && /*#__PURE__*/React__default.createElement(Text, {
    element: "a",
    color: "blue",
    size: "m",
    className: styles$j.email,
    href: `mailto:${email}`,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 110,
      columnNumber: 9
    }
  }, email), phoneNumber && /*#__PURE__*/React__default.createElement(Text, {
    element: "a",
    size: "m",
    className: styles$j.phone,
    href: `tel:${phoneNumber}`,
    __self: window,
    __source: {
      fileName: _jsxFileName$r,
      lineNumber: 121,
      columnNumber: 9
    }
  }, formatToPhone(phoneNumber)));
};

ProfileCard.propTypes = {
  profile: PropTypes.object,
  isSponsorPresent: PropTypes.bool.isRequired,
  sponsorForFirstName: PropTypes.string,
  branding: PropTypes.shape({
    loClientsHelped: PropTypes.number,
    loYearsInIndustry: PropTypes.number
  })
};

var css_248z$j = ".YourTeam-module_yourTeam__KKagb {\n  padding: 1em;\n}";
var styles$i = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","yourTeam":"YourTeam-module_yourTeam__KKagb","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$j);

var _jsxFileName$q = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/YourTeam/YourTeam.jsx";

const YourTeam = () => {
  const {
    // cp
    customerType,
    customerFirstName,
    customerLastName,
    customerStatement,
    customerNMLS,
    customerPhone,
    customerEmail,
    customerPhotoUri,
    customerCorporateName,
    customerCorporatePhone,
    // sponsor
    isSponsorPresent,
    sponsorType,
    sponsorFirstName,
    sponsorLastName,
    sponsorStatement,
    sponsorNMLS,
    sponsorPhone,
    sponsorEmail,
    sponsorPhotoUri,
    sponsorCorporateName,
    sponsorCorporatePhone,
    //branding
    loClientsHelped,
    loYearsInIndustry
  } = useBranding();
  const customerProfile = {
    type: customerType,
    firstName: customerFirstName,
    lastName: customerLastName,
    brandingStatement: customerStatement,
    nmls: customerNMLS,
    phone: customerPhone,
    email: customerEmail,
    photo: customerPhotoUri,
    corporateProfileName: customerCorporateName,
    corporateProfilePhone: customerCorporatePhone
  };
  const sponsorProfile = {
    type: sponsorType,
    firstName: sponsorFirstName,
    lastName: sponsorLastName,
    brandingStatement: sponsorStatement,
    nmls: sponsorNMLS,
    phone: sponsorPhone,
    email: sponsorEmail,
    photo: sponsorPhotoUri,
    corporateProfileName: sponsorCorporateName,
    corporateProfilePhone: sponsorCorporatePhone
  };
  const branding = {
    loClientsHelped,
    loYearsInIndustry
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$i.yourTeam,
    __self: window,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 74,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(ProfileCard, {
    profile: customerProfile,
    isSponsorPresent: isSponsorPresent,
    branding: branding,
    __self: window,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 75,
      columnNumber: 7
    }
  }), isSponsorPresent && /*#__PURE__*/React__default.createElement(ProfileCard, {
    profile: sponsorProfile,
    isSponsorPresent: isSponsorPresent,
    sponsorForFirstName: customerFirstName,
    branding: branding,
    __self: window,
    __source: {
      fileName: _jsxFileName$q,
      lineNumber: 81,
      columnNumber: 9
    }
  }));
};

const buildSliderValues = ({
  price,
  min,
  max,
  botHeadValue
}) => {
  return [min, price, botHeadValue, max].sort((a, b) => a - b);
};
const hijackSliderValues = ({
  markerValues,
  // slider markers, min, max - anywhere a marker may be
  allSpecialValues,
  // all marker values plus min and max
  interval,
  // increments
  sliderValue,
  // current slider value
  roundValue: _roundValue = false
}) => {
  const satisfiesCondition = markerValues.map(value => sliderValue + interval > value && sliderValue <= value || sliderValue - interval < value && sliderValue >= value);

  if (satisfiesCondition.includes(true)) {
    let selectedArrayValue = sliderValue;
    let diff = null;
    allSpecialValues.forEach(value => {
      const currentDiff = Math.abs(value - sliderValue);

      if (!diff || currentDiff < diff) {
        diff = currentDiff;
        selectedArrayValue = value;
      }
    });
    return selectedArrayValue;
  } else {
    if (_roundValue) {
      return Math.round(sliderValue / interval) * interval;
    }

    return sliderValue;
  }
};

var css_248z$i = ".base-module_panel__Pa0Px {\n  margin-bottom: 1.5em;\n  padding: 0.75em 1.2em;\n}\n\n.base-module_label__bpyj4 {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  flex: 1;\n  text-align: left;\n  margin-bottom: 0.75em;\n}\n\n.base-module_icon__gf0EG {\n  margin-right: 0.75em;\n  margin-top: 0.2em;\n}\n\n.base-module_heading__hAefl {\n  align-self: center;\n}\n\n.base-module_center__Tz2jZ {\n  margin-top: 0.3em;\n}\n\n.base-module_amount__J0cci {\n  margin-bottom: 0.375em;\n}\n\n.base-module_slider__Mmxex {\n  margin-bottom: 2.25em;\n}\n\n.base-module_hbHead__Mzr-7 {\n  height: 20px;\n  width: 20px;\n}";
var baseStyles = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","panel":"base-module_panel__Pa0Px","label":"base-module_label__bpyj4","icon":"base-module_icon__gf0EG","heading":"base-module_heading__hAefl","center":"base-module_center__Tz2jZ","amount":"base-module_amount__J0cci","slider":"base-module_slider__Mmxex","hbHead":"base-module_hbHead__Mzr-7","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$i);

var _jsxFileName$p = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/IndicatorContainer/Indicators/Appreciation/Appreciation.jsx";

const Appreciation = () => {
  const indicator = useAppreciationIndicator();
  const logGA = useLogGAEvent(LISTING_EVAL_SLIDER_MOVED, {
    debounceInterval: 5000
  });
  const {
    theme,
    color,
    appreciationPercent,
    yearsOfData
  } = indicator || {};

  const projectedAppreciation = () => {
    if (appreciationPercent === null || appreciationPercent < 5) return FALLBACK_APPRECIATION_PERCENT;
    if (appreciationPercent >= 10) return FAST_APPRECIATION_PERCENT;
    if (appreciationPercent >= 5) return STEADY_APPRECIATION_PERCENT;
  };

  const projectedAppreciationValue = projectedAppreciation();
  const {
    appreciationSliderPercent,
    setAppreciationSliderPercent
  } = useContext(AppContext);
  const [sliderValue, setSliderValue] = useState(appreciationSliderPercent || projectedAppreciationValue);

  if (!indicator) {
    return null;
  }

  const headers = {
    [GREEN]: {
      heading: appreciationPercent >= 10 ? 'FAST GROWTH MARKET' : 'STEADY GROWTH MARKET',
      icon: appreciationPercent >= 10 ? 'rabbit' : 'dog'
    },
    [ORANGE]: {
      heading: 'SLOW GROWTH MARKET',
      icon: 'turtle'
    }
  };
  const title = headers[color].heading;
  const icon = headers[color].icon;

  const BotHead = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: baseStyles.hbHead,
      __self: window,
      __source: {
        fileName: _jsxFileName$p,
        lineNumber: 90,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement(HomebotIcon, {
      __self: window,
      __source: {
        fileName: _jsxFileName$p,
        lineNumber: 91,
        columnNumber: 9
      }
    }));
  };

  const markers = [{
    value: projectedAppreciationValue,
    direction: 'down',
    content: /*#__PURE__*/React__default.createElement(BotHead, {
      __self: window,
      __source: {
        fileName: _jsxFileName$p,
        lineNumber: 100,
        columnNumber: 16
      }
    })
  }];
  const step = 0.25;
  const min = -10;
  const max = 20;
  const sliderValues = buildSliderValues({
    min,
    max,
    botHeadValue: projectedAppreciationValue
  });

  const onSliderChange = e => {
    const num = e.target.value;
    const requestValue = hijackSliderValues({
      markerValues: [projectedAppreciationValue],
      allSpecialValues: sliderValues,
      interval: step,
      sliderValue: num
    });
    setSliderValue(requestValue);
    setAppreciationSliderPercent(requestValue);
    logGA({
      slider_name: 'Custom Appreciation Percent',
      slider_value: sliderValue
    });
  };

  return /*#__PURE__*/React__default.createElement(Panel, {
    className: baseStyles.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 134,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: baseStyles.label,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 135,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(CircleIcon, {
    className: baseStyles.icon,
    backgroundColor: theme,
    icon: icon,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 136,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    letterSpacing: "large",
    size: "s",
    color: color,
    weight: "bold",
    className: classnames(baseStyles.heading, baseStyles.center),
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 141,
      columnNumber: 9
    }
  }, title)), /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 151,
      columnNumber: 7
    }
  }, "How quickly would you bet this home will grow in value?"), /*#__PURE__*/React__default.createElement(Text, {
    size: "xxxl",
    color: "eggShell",
    weight: "light",
    className: baseStyles.amount,
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 154,
      columnNumber: 7
    }
  }, roundWithPrecision(sliderValue, 2), '% '), /*#__PURE__*/React__default.createElement(Text, {
    size: "l",
    color: "eggShell",
    weight: "light",
    element: "span",
    className: baseStyles.amount,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 164,
      columnNumber: 7
    }
  }, "per year"), /*#__PURE__*/React__default.createElement(Slider, {
    name: 'appreciationSlider',
    min: min,
    max: max,
    step: step,
    minPhrase: 'slow',
    maxPhrase: 'fast',
    value: sliderValue,
    onChange: onSliderChange,
    markers: markers,
    className: baseStyles.slider,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 173,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(PanelDivider, {
    footer: true,
    icon: LightBulb,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 185,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 186,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 187,
      columnNumber: 11
    }
  }, projectedAppreciationValue, "%"), ' ', /*#__PURE__*/React__default.createElement(If, {
    condition: yearsOfData === null || yearsOfData === 0,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 190,
      columnNumber: 11
    }
  }, "is our conservative assumption based on the home\u2019s projected growth."), /*#__PURE__*/React__default.createElement(If, {
    condition: yearsOfData !== null & yearsOfData !== 0,
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 193,
      columnNumber: 11
    }
  }, "is our conservative projection based on the past ", yearsOfData, " year average of", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$p,
      lineNumber: 196,
      columnNumber: 13
    }
  }, ' ', roundWithPrecision(appreciationPercent, 2), '% growth.')))));
};

var _jsxFileName$o = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/IndicatorContainer/Indicators/MarketTemp/MarketTemp.jsx";

const MarketTemp = () => {
  const {
    marketTempSliderPrice,
    setMarketTempSliderPrice
  } = useContext(AppContext);
  const indicator = useMarketTempIndicator();
  const listing = useFullListingData();
  const logGA = useLogGAEvent(LISTING_EVAL_SLIDER_MOVED, {
    debounceInterval: 5000
  });
  const {
    listingPrice
  } = listing;
  const [sliderValue, setSliderValue] = useState(marketTempSliderPrice || listingPrice);

  if (!indicator) {
    return null;
  }

  const {
    color: status,
    theme,
    marketTemp
  } = indicator;

  const botHeadValue = () => {
    const roundTo = listingPrice + listingPrice * 0.05 >= 1000000 ? -4 : -3;
    if (marketTemp >= 60) return roundWithPrecision(listingPrice + listingPrice * 0.05, roundTo);
    if (marketTemp >= 40) return roundWithPrecision(listingPrice, roundTo);
    if (marketTemp < 40) return roundWithPrecision(listingPrice - listingPrice * 0.05, roundTo);
  };

  const roundedBotheadValue = Math.round(botHeadValue());
  const copy = {
    [GREEN]: {
      title: marketTemp >= 40 ? 'BALANCED MARKET' : 'COOL MARKET',
      sub: marketTemp >= 40 ? 'Houses are selling for near list price.' : 'You could come in under the list price.',
      icon: marketTemp >= 40 ? 'check' : 'snowflakeCool',
      color: GREEN
    },
    [ORANGE]: {
      title: 'IN DEMAND MARKET',
      sub: 'There’s likely to be multiple offers.',
      icon: 'chart',
      color: ORANGE
    }
  };

  const FooterText = () => {
    if (marketTemp >= 60) {
      return /*#__PURE__*/React__default.createElement(Text, {
        size: "s",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 87,
          columnNumber: 9
        }
      }, "Since competition is high & homes tend to sell over listing price, we think you might need to offer", ' ', /*#__PURE__*/React__default.createElement(Text, {
        element: "span",
        color: "white",
        weight: "semibold",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 90,
          columnNumber: 11
        }
      }, "~", formatAbbrCurrency(listingPrice + listingPrice * 0.05)));
    } else if (marketTemp >= 40) {
      return /*#__PURE__*/React__default.createElement(Text, {
        size: "s",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 97,
          columnNumber: 9
        }
      }, "Since competition is balanced & homes are selling near listing price, we think you could offer", ' ', /*#__PURE__*/React__default.createElement(Text, {
        element: "span",
        color: "white",
        weight: "semibold",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 100,
          columnNumber: 11
        }
      }, "~", formatAbbrCurrency(listingPrice)));
    } else {
      return /*#__PURE__*/React__default.createElement(Text, {
        size: "s",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 107,
          columnNumber: 9
        }
      }, "Since competition is low & homes are selling under listing price, we think you could offer", ' ', /*#__PURE__*/React__default.createElement(Text, {
        element: "span",
        color: "white",
        weight: "semibold",
        __self: window,
        __source: {
          fileName: _jsxFileName$o,
          lineNumber: 110,
          columnNumber: 11
        }
      }, "~", formatAbbrCurrency(listingPrice - listingPrice * 0.05)));
    }
  };

  const {
    title,
    sub,
    icon,
    color
  } = copy[status];

  const BotHead = () => {
    return /*#__PURE__*/React__default.createElement("div", {
      className: baseStyles.hbHead,
      __self: window,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 122,
        columnNumber: 7
      }
    }, /*#__PURE__*/React__default.createElement(HomebotIcon, {
      __self: window,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 123,
        columnNumber: 9
      }
    }));
  };

  const PriceText = () => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
      size: "s",
      weight: "bold",
      __self: window,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 131,
        columnNumber: 9
      }
    }, formatToCurrency(Math.abs(listingPrice)), " price"));
  };

  const markers = [{
    value: roundedBotheadValue,
    direction: 'down',
    content: /*#__PURE__*/React__default.createElement(BotHead, {
      __self: window,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 142,
        columnNumber: 16
      }
    })
  }, {
    value: listingPrice,
    direction: 'up',
    content: /*#__PURE__*/React__default.createElement(PriceText, {
      __self: window,
      __source: {
        fileName: _jsxFileName$o,
        lineNumber: 147,
        columnNumber: 16
      }
    })
  }];
  const step = 1;
  const interval = listingPrice >= 1000000 ? 10000 : 5000;
  const min = Math.floor((listingPrice - listingPrice * 0.3) / interval) * interval;
  const max = Math.ceil((listingPrice + listingPrice * 0.3) / interval) * interval;
  const sliderValues = buildSliderValues({
    price: listingPrice,
    min,
    max,
    botHeadValue: roundedBotheadValue
  });

  const onSliderChange = e => {
    const num = parseInt(e.target.valueAsNumber);
    const requestValue = hijackSliderValues({
      markerValues: [listingPrice, roundedBotheadValue],
      allSpecialValues: sliderValues,
      interval,
      sliderValue: num,
      roundValue: true
    });
    setSliderValue(requestValue);
    setMarketTempSliderPrice(requestValue);
    logGA({
      slider_name: 'Custom Listing Price',
      slider_value: sliderValue
    });
  };

  return /*#__PURE__*/React__default.createElement(Panel, {
    className: baseStyles.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 187,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: baseStyles.label,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 188,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(CircleIcon, {
    className: baseStyles.icon,
    backgroundColor: theme,
    icon: icon,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 189,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    letterSpacing: "large",
    color: color,
    weight: "bold",
    className: classnames(baseStyles.heading, baseStyles.center),
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 194,
      columnNumber: 9
    }
  }, title)), /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 204,
      columnNumber: 7
    }
  }, sub), /*#__PURE__*/React__default.createElement(Text, {
    size: "m",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 207,
      columnNumber: 7
    }
  }, "What would you offer?"), /*#__PURE__*/React__default.createElement(Text, {
    size: "xxxl",
    color: "eggShell",
    weight: "light",
    className: baseStyles.amount,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 210,
      columnNumber: 7
    }
  }, formatToCurrency(Math.abs(sliderValue))), /*#__PURE__*/React__default.createElement(Slider, {
    name: 'marketTempSlider',
    min: min,
    max: max,
    step: step,
    minPhrase: formatAbbrCurrency(Math.abs(min)).toString(),
    maxPhrase: formatAbbrCurrency(Math.abs(max)).toString(),
    value: sliderValue,
    onChange: onSliderChange,
    markers: markers,
    className: baseStyles.slider,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 218,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(PanelDivider, {
    footer: true,
    icon: LightBulb,
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 230,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(FooterText, {
    __self: window,
    __source: {
      fileName: _jsxFileName$o,
      lineNumber: 231,
      columnNumber: 9
    }
  })));
};

var css_248z$h = ".RentalPotential-module_header__ursi- {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.RentalPotential-module_headerText__pNg-G {\n  margin-top: 0.3em;\n}\n\n.RentalPotential-module_body__DCeFj {\n  margin-top: 0.75em;\n}\n\n.RentalPotential-module_results__DMpEz {\n  display: flex;\n  align-items: center;\n}\n\n.RentalPotential-module_equal__ptUMt {\n  margin-right: 0.375em;\n  margin-top: 0.25em;\n}\n\n.RentalPotential-module_perMonth__BhgPv {\n  margin-left: 0.375em;\n  font-size: 1rem;\n  color: rgba(213, 208, 214, 0.7);\n}\n\n.RentalPotential-module_footer__NBxFq {\n  display: flex;\n  flex-direction: row;\n  margin-top: 0.75em;\n  align-items: center;\n}\n.RentalPotential-module_footer__NBxFq > p {\n  padding: 0.25em 0;\n  margin-right: 0.5em;\n}";
var styles$h = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","header":"RentalPotential-module_header__ursi-","headerText":"RentalPotential-module_headerText__pNg-G","body":"RentalPotential-module_body__DCeFj","results":"RentalPotential-module_results__DMpEz","equal":"RentalPotential-module_equal__ptUMt","perMonth":"RentalPotential-module_perMonth__BhgPv","footer":"RentalPotential-module_footer__NBxFq","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$h);

var _jsxFileName$n = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/IndicatorContainer/Indicators/RentalPotential/RentalPotential.jsx";

const RentalPotential = () => {
  const {
    avgNightlyRental
  } = useFullListingData();
  const {
    rentableNights
  } = useBuyerSettingsWithDefaults();
  const {
    includeRental,
    setIncludeRental,
    setFocusFieldAndNavigateToSettings
  } = useContext(AppContext);

  if (!avgNightlyRental) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Panel, {
    className: classnames(baseStyles.panel, styles$h.panel),
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 49,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$h.header,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 50,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(CircleIcon, {
    className: baseStyles.icon,
    backgroundColor: "success",
    icon: "greenMoneyBag",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 51,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$h.headerText,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    letterSpacing: "large",
    size: "s",
    color: "green",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 57,
      columnNumber: 11
    }
  }, "Airbnb Income"))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$h.body,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 69,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 70,
      columnNumber: 9
    }
  }, "Based on similar rentals nearby, you may be able to rent this home for", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "green",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 72,
      columnNumber: 11
    }
  }, ' ', formatToCurrency(avgNightlyRental), "/night", ' '), "for", /*#__PURE__*/React__default.createElement(Button, {
    editable: true,
    className: baseButtonStyles.border,
    iconEnd: Pencil,
    onClick: () => setFocusFieldAndNavigateToSettings(INPUT_NAMES.RENTABLE_NIGHTS),
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 77,
      columnNumber: 11
    }
  }, rentableNights, " ", rentableNights === 1 ? 'night' : 'nights', "/mo"))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$h.results,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 90,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    className: styles$h.equal,
    element: "div",
    weight: "bold",
    color: "heather",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 91,
      columnNumber: 9
    }
  }, "="), /*#__PURE__*/React__default.createElement(Text, {
    className: styles$h.income,
    element: "div",
    size: "xxxl",
    color: "eggShell",
    weight: "light",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 100,
      columnNumber: 9
    }
  }, formatToCurrency(rentableNights * avgNightlyRental), /*#__PURE__*/React__default.createElement(Text, {
    className: styles$h.perMonth,
    element: "span",
    weight: "bold",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 108,
      columnNumber: 11
    }
  }, ' ', "/ mo"))), /*#__PURE__*/React__default.createElement(PanelDivider, {
    footer: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 114,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$h.footer,
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 115,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 116,
      columnNumber: 11
    }
  }, "See how this can offset monthly expenses"), /*#__PURE__*/React__default.createElement(Checkbox, {
    toggle: true,
    checked: includeRental,
    onChange: e => setIncludeRental(e.target.checked),
    __self: window,
    __source: {
      fileName: _jsxFileName$n,
      lineNumber: 117,
      columnNumber: 11
    }
  }))));
};

var _jsxFileName$m = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/IndicatorContainer/IndicatorContainer.jsx";

const IndicatorContainer = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MarketTemp, {
    __self: window,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 9,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Appreciation, {
    __self: window,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 10,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(RentalPotential, {
    __self: window,
    __source: {
      fileName: _jsxFileName$m,
      lineNumber: 11,
      columnNumber: 7
    }
  }));
};

const PANEL_IDS = {
  MONTHLY_COST: 'monthlyCost',
  DISCLAIMER: 'disclaimer',
  BREAKEVEN_CHART: 'breakevenChart'
};

var css_248z$g = ".base-module_tile__X2ujf {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.base-module_tileBody__s1eMa {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}";
var styles$g = {"tile":"base-module_tile__X2ujf","tileBody":"base-module_tileBody__s1eMa"};
styleInject(css_248z$g);

var _jsxFileName$l = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/Tiles/SavingsTile/HomeownerSavingsTile/HomeownerSavingsTile.jsx";

const SubTitle$2 = ({
  yearsInHome
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
  size: "s",
  __self: window,
  __source: {
    fileName: _jsxFileName$l,
    lineNumber: 23,
    columnNumber: 5
  }
}, "if you stayed in this home for", ' ', /*#__PURE__*/React__default.createElement(Text, {
  element: "span",
  weight: "semibold",
  __self: window,
  __source: {
    fileName: _jsxFileName$l,
    lineNumber: 25,
    columnNumber: 7
  }
}, yearsInHome, " ", yearsInHome === 1 ? 'year' : 'years')));

const HomeownerSavingsTile = ({
  className,
  value,
  yearsInHome
}) => {
  const {
    handleAddOverlay
  } = useContext(OverlayContext);
  const tileHeading = value < 0 ? POSSIBLE_GAIN : POSSIBLE_LOSS;
  const tileValue = -value || 0;
  const SubTitleComponent = useCallback(() => /*#__PURE__*/React__default.createElement(SubTitle$2, {
    yearsInHome: yearsInHome,
    __self: window,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 38,
      columnNumber: 11
    }
  }), [yearsInHome]);
  return /*#__PURE__*/React__default.createElement(ClickableTile, {
    className: classnames(styles$g.tile, className),
    heading: tileHeading,
    value: tileValue,
    prefix: " ",
    formatter: formatAbbrCurrency,
    subTitleComponent: SubTitleComponent,
    onClick: () => handleAddOverlay(PANEL_IDS.BREAKEVEN_CHART),
    __self: window,
    __source: {
      fileName: _jsxFileName$l,
      lineNumber: 43,
      columnNumber: 5
    }
  });
};

SubTitle$2.propTypes = {
  yearsInHome: PropTypes.number
};
HomeownerSavingsTile.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  yearsInHome: PropTypes.number
};

var _jsxFileName$k = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/Tiles/SavingsTile/RenterSavingsTile/RenterSavingsTile.jsx";

const SubTitle$1 = ({
  yearsInHome
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
  size: "s",
  __self: window,
  __source: {
    fileName: _jsxFileName$k,
    lineNumber: 23,
    columnNumber: 5
  }
}, "over", ' ', /*#__PURE__*/React__default.createElement(Text, {
  element: "span",
  weight: "semibold",
  __self: window,
  __source: {
    fileName: _jsxFileName$k,
    lineNumber: 25,
    columnNumber: 7
  }
}, yearsInHome, " ", yearsInHome === 1 ? 'year' : 'years')), /*#__PURE__*/React__default.createElement(Text, {
  size: "s",
  __self: window,
  __source: {
    fileName: _jsxFileName$k,
    lineNumber: 29,
    columnNumber: 5
  }
}, "versus renting"));

const RenterSavingsTile = ({
  className,
  value,
  yearsInHome
}) => {
  const {
    handleAddOverlay
  } = useContext(OverlayContext);
  const tileHeading = value > 0 ? POSSIBLY_SAVE : POSSIBLY_LOSE;
  const tileValue = value || 0;
  const SubTitleComponent = useCallback(() => /*#__PURE__*/React__default.createElement(SubTitle$1, {
    yearsInHome: yearsInHome,
    __self: window,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 39,
      columnNumber: 11
    }
  }), [yearsInHome]);
  return /*#__PURE__*/React__default.createElement(ClickableTile, {
    className: classnames(styles$g.tile, className),
    heading: tileHeading,
    value: tileValue,
    prefix: " ",
    formatter: formatAbbrCurrency,
    subTitleComponent: SubTitleComponent,
    onClick: () => handleAddOverlay(PANEL_IDS.BREAKEVEN_CHART),
    __self: window,
    __source: {
      fileName: _jsxFileName$k,
      lineNumber: 44,
      columnNumber: 5
    }
  });
};

SubTitle$1.propTypes = {
  yearsInHome: PropTypes.number
};
RenterSavingsTile.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number,
  yearsInHome: PropTypes.number
};

var _jsxFileName$j = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/Tiles/SavingsTile/SavingsTile.jsx";

const SavingsTile = props => {
  const {
    yearsInHome,
    savingsValue,
    totalBuyCost
  } = useListingDisplay();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Unless.Own, {
    __self: window,
    __source: {
      fileName: _jsxFileName$j,
      lineNumber: 17,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(RenterSavingsTile, _extends$1({
    value: savingsValue,
    yearsInHome: yearsInHome
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$j,
      lineNumber: 18,
      columnNumber: 9
    }
  }))), /*#__PURE__*/React__default.createElement(If.Own, {
    __self: window,
    __source: {
      fileName: _jsxFileName$j,
      lineNumber: 24,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(HomeownerSavingsTile, _extends$1({
    value: totalBuyCost,
    yearsInHome: yearsInHome
  }, props, {
    __self: window,
    __source: {
      fileName: _jsxFileName$j,
      lineNumber: 25,
      columnNumber: 9
    }
  }))));
};

SavingsTile.propTypes = {
  className: PropTypes.string
};

var _jsxFileName$i = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/Tiles/MonthlyCostTile/MonthlyCostTile.jsx";

const SubTitle = ({
  budgetDiff
}) => {
  const text = budgetDiff >= 0 ? 'over' : 'under';
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 24,
      columnNumber: 7
    }
  }, "which is", ' ', /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 26,
      columnNumber: 9
    }
  }, formatToCurrency(Math.abs(Math.round(budgetDiff))))), /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 30,
      columnNumber: 7
    }
  }, text, " your budget"));
};

const MonthlyCostTile = ({
  className,
  budgetDiff,
  monthlyCost
}) => {
  const {
    handleAddOverlay
  } = useContext(OverlayContext);
  const color = budgetDiff >= 0 ? 'red' : 'green';
  const subTitleComponent = useCallback(() => /*#__PURE__*/React__default.createElement(SubTitle, {
    budgetDiff: budgetDiff,
    __self: window,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 40,
      columnNumber: 11
    }
  }), [budgetDiff]);
  return /*#__PURE__*/React__default.createElement(ClickableTile, {
    className: classnames(styles$g.tile, className),
    heading: "you might pay",
    controlledColor: color,
    value: monthlyCost ? monthlyCost : 0,
    suffix: monthlyCost ? '/mo' : '',
    formatter: formatToCurrency,
    subTitleComponent: subTitleComponent,
    onClick: () => handleAddOverlay(PANEL_IDS.MONTHLY_COST),
    __self: window,
    __source: {
      fileName: _jsxFileName$i,
      lineNumber: 45,
      columnNumber: 5
    }
  });
};

SubTitle.propTypes = {
  budgetDiff: PropTypes.number
};
MonthlyCostTile.propTypes = {
  className: PropTypes.string,
  budgetDiff: PropTypes.number,
  monthlyCost: PropTypes.number
};

var css_248z$f = ".ToDo-module_root__4zDiU {\n  background-color: #3a383f;\n  display: flex;\n  flex-direction: row;\n  transition: 0.1s ease-in-out background-color;\n}\n\n.ToDo-module_body__H1ZMm {\n  padding: 1em;\n  flex: 1;\n  border-right: 1px solid rgb(83, 82, 86);\n}\n.ToDo-module_body__H1ZMm p {\n  margin: 0;\n}\n\n.ToDo-module_edit__Vn-yX {\n  height: unset;\n  margin: unset;\n  padding: 1.5em;\n  border-radius: 0 12px 12px 0;\n  background-color: #3a383f;\n  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;\n}\n.ToDo-module_edit__Vn-yX:hover {\n  background-color: rgba(6, 163, 247, 0.1);\n  color: #06a3f7;\n}\n.ToDo-module_edit__Vn-yX:focus {\n  box-shadow: inset 0 0 0 2px rgba(65, 185, 250, 0.5);\n}\n.ToDo-module_edit__Vn-yX:active {\n  background-color: #41b9fa;\n  color: #f3eff1;\n}";
var styles$f = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","root":"ToDo-module_root__4zDiU","body":"ToDo-module_body__H1ZMm","edit":"ToDo-module_edit__Vn-yX","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$f);

var _jsxFileName$h = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/ToDo/ToDo.jsx";

const ToDo = () => {
  const {
    activeTab,
    setActiveTab
  } = useContext(AppContext);
  return /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$f.root,
    __self: window,
    __source: {
      fileName: _jsxFileName$h,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$f.body,
    __self: window,
    __source: {
      fileName: _jsxFileName$h,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    size: "s",
    letterSpacing: "large",
    color: "white",
    weight: "semibold",
    transform: "uppercase",
    __self: window,
    __source: {
      fileName: _jsxFileName$h,
      lineNumber: 20,
      columnNumber: 9
    }
  }, "to do: edit your profile"), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$h,
      lineNumber: 29,
      columnNumber: 9
    }
  }, "Improve your report by changing our starter values")), /*#__PURE__*/React__default.createElement(Button, {
    className: styles$f.edit,
    onClick: e => setActiveTab(TABS.SETTINGS),
    regular: true,
    tabIndex: "0",
    __self: window,
    __source: {
      fileName: _jsxFileName$h,
      lineNumber: 31,
      columnNumber: 7
    }
  }, "Edit"));
};

var css_248z$e = ".OverviewPanel-module_container__P5di9 {\n  padding: 0;\n  padding-left: 1em;\n  margin-top: 1.5em;\n}\n\n.OverviewPanel-module_header__95Y8T {\n  margin-bottom: 1.5em;\n}\n\n.OverviewPanel-module_tileContainer__cL3FZ {\n  display: flex;\n  margin-bottom: 0.75em;\n}\n.OverviewPanel-module_tileContainer__cL3FZ div:first-child {\n  margin-right: 4px;\n}\n.OverviewPanel-module_tileContainer__cL3FZ div:last-child {\n  margin-left: 4px;\n}\n\n.OverviewPanel-module_link__4DPOU {\n  margin-left: 0.375em;\n}\n\n.OverviewPanel-module_feedback__UzOtA {\n  padding-bottom: 1.5em;\n}";
var styles$e = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","container":"OverviewPanel-module_container__P5di9","header":"OverviewPanel-module_header__95Y8T","tileContainer":"OverviewPanel-module_tileContainer__cL3FZ","link":"OverviewPanel-module_link__4DPOU","feedback":"OverviewPanel-module_feedback__UzOtA","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$e);

var _jsxFileName$g = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverviewPanel/OverviewPanel.jsx";

const OverviewPanel = () => {
  const {
    handleAddOverlay
  } = useContext(OverlayContext);
  const {
    monthlyCost
  } = useListingDisplay();
  const {
    maxBudget
  } = useBuyerSettingsWithDefaults();
  const {
    data
  } = useChromeBotUpdatedProfileSettingsClientEvents();
  const {
    clientType
  } = useBuyerSettings();
  const notGuest = clientType !== GUEST_CLIENT_TYPE;
  const budgetDiff = monthlyCost - maxBudget;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.container,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.header,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 39,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.tileContainer,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 40,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(MonthlyCostTile, {
    budgetDiff: budgetDiff,
    monthlyCost: monthlyCost,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 41,
      columnNumber: 11
    }
  }), /*#__PURE__*/React__default.createElement(SavingsTile, {
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 42,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(Fade, {
    show: isEmpty(data),
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(ToDo, {
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 45,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React__default.createElement(IndicatorContainer, {
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 48,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(DisclaimerButton, {
    onClick: () => handleAddOverlay(PANEL_IDS.DISCLAIMER),
    className: styles$e.link,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 49,
      columnNumber: 7
    }
  }, "View Disclaimers"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.feedback,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 55,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: notGuest,
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Feedback, {
    __self: window,
    __source: {
      fileName: _jsxFileName$g,
      lineNumber: 57,
      columnNumber: 11
    }
  }))));
};

var _jsxFileName$f = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/TabContent/TabContent.jsx";

const TabContent = () => {
  const {
    activeTab
  } = useContext(AppContext);

  switch (activeTab) {
    case TABS.OVERVIEW:
      return /*#__PURE__*/React__default.createElement(OverviewPanel, {
        __self: window,
        __source: {
          fileName: _jsxFileName$f,
          lineNumber: 18,
          columnNumber: 14
        }
      });

    case TABS.TEAM:
      return /*#__PURE__*/React__default.createElement(YourTeam, {
        __self: window,
        __source: {
          fileName: _jsxFileName$f,
          lineNumber: 20,
          columnNumber: 14
        }
      });

    case TABS.SETTINGS:
      return /*#__PURE__*/React__default.createElement(SettingsPanel, {
        __self: window,
        __source: {
          fileName: _jsxFileName$f,
          lineNumber: 22,
          columnNumber: 14
        }
      });

    default:
      return null;
  }
};

var css_248z$d = ".DisclaimerPanel-module_bottomText__6WNlr {\n  padding-bottom: 2.25em;\n}";
var styles$d = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","bottomText":"DisclaimerPanel-module_bottomText__6WNlr","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$d);

var _jsxFileName$e = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/DisclaimerPanel/DisclaimerPanel.jsx";
const DisclaimerPanel = ({
  handleBack
}) => {
  return /*#__PURE__*/React__default.createElement(OverlayPanel, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 12,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(OverlayPanelHeader, {
    onBack: handleBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 13,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "semibold",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 14,
      columnNumber: 9
    }
  }, "Disclaimers")), /*#__PURE__*/React__default.createElement(Text, {
    element: "div",
    size: "s",
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 18,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 19,
      columnNumber: 9
    }
  }, "APR is based on a reasonably current index and margin from the Freddie Mac PMMS. This message is for information purposes only and is not an advertisement to extend customer credit as defined by Section 12 CFR 1026.2 Regulation Z. Program rates, terms, and conditions are subject to change at any time. All examples of potential mortgage products above are estimates for illustration purposes only. All programs and mortgage products are subject to borrower income, credit, and property approval. Not all borrowers will qualify. This is not an offer for extension of credit or a commitment to lend. Home valuations are estimates purchased from a third-party data provider. Actual appraised value at the time of a transaction may vary."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 32,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 33,
      columnNumber: 9
    }
  }, "Fees and charges may apply and may vary by product and State. Loans may be secured by a lien against your property. Application may be required and subject to underwriting approval for any loan products. Not all loan applicants will be approved. Interest rates are based on national averages and are estimates for informational purposes only; they are not quoted rates (and any rates quoted by a professional are subject to change due to market conditions). If you apply for a loan and do not lock in a rate when you apply, your rate at closing may differ from the rate in effect when you applied. Important information relating specifically to any actual loan will be contained in the loan documents, which alone will establish your rights and obligations under the loan plan. Call for details. Terms, conditions and restrictions apply. The calculation on what you have paid toward principal and interest are estimated based on the available data (in some cases, entirely on public record data) and may not account for principal reductions, early or late payment penalties or other fees. To obtain exact and available options for your personal circumstances, please contact your lender."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 53,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 54,
      columnNumber: 9
    }
  }, "If you apply and are approved for an actual loan, we may transfer any applicable escrow account balance from your current loan to your new loan. If your current escrow account is insufficient due to changes in taxes or insurance, we may require additional money when you close on your new loan. By consolidating or refinancing your existing debts, you may increase the time needed to repay the debt and/or the finance charges and the total loan amount."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 63,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 64,
      columnNumber: 9
    }
  }, "With respect to any estimated home value data shown, Homebot purchases these data from a third-party provider and they are estimates based on an \"automated valuation model\" (a.k.a. an AVM, which is a computer algorithm) that analyzes recent property sales in the same area to estimate the value of a given property. The valuations are estimated based on available data and do not constitute an appraisal of the subject property and should not be relied upon in lieu of underwriting or an appraisal. In some instances where an AVM is unavailable (esp. \"new builds\") or when other data are available that conflict with the AVM value, Homebot may choose to display the \"appraised value,\" if provided by your loan officer, or \"sold price,\" if available from your loan officer and/or public record in lieu of an AVM. For approval of any actual loan products, a full appraisal will be required with your loan application to determine the actual value of your property, which may differ from the AVM estimate. The estimated cash-out available is calculated by subtracting your current loan balance from the AVM estimate of your property value and assumes closing costs are paid in cash. Any additional liens on your property would likely impact the amount of cash available."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 85,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 86,
      columnNumber: 9
    }
  }, "Homebot provides the content in this webpage strictly for educational and informational purposes only. It is not intended to imply that a loan will be originated or approved by HUD, FHA, VA or any government-sponsored enterprise."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 92,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 93,
      columnNumber: 9
    }
  }, "California Privacy Rights (a.k.a. \"CCPA\") are honored nationally. If you are a California resident, you have the right to request information from us regarding the manner in which we share certain categories of Personal Information with third parties for their direct marketing purposes, in addition to the rights set forth above. Under California law, you have the right to send us a request at the designated address listed below to receive the following information: 1) the categories of information we disclosed to third parties for their direct marketing purposes during the preceding calendar year; 2) the names and addresses of the third parties that received the information; and 3) if the nature of the third party\u2019s business cannot be determined from their name, examples of the products or services marketed. This information may be provided in a standardized format that is not specific to you. The designated email address for these requests is: customersuccess@homebot.ai. Note, even if you do not live in California, we will honor the same requests from you regardless of the State in which you live. Also, please note that we have not yet developed a response to browser \u201CDo Not Track\u201D signals, and do not change any of our data collection practices when we receive such signals. We will continue to evaluate potential responses to \u201CDo Not Track\u201D signals in light of industry developments or legal changes."), /*#__PURE__*/React__default.createElement("br", {
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 116,
      columnNumber: 9
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    className: styles$d.bottomText,
    __self: window,
    __source: {
      fileName: _jsxFileName$e,
      lineNumber: 117,
      columnNumber: 9
    }
  }, "You may be receiving Homebot from finance and/or real estate industry professionals, such as a loan officer or real estate agent. In some cases, you may be receiving Homebot from a real estate agent who is also providing you contact information for a loan officer (in a manner that is compliant with the CFPB and RESPA rules and regulations) in order to help provide answers related to financing. While it\u2019s important to note that Homebot\u2019s mission is to help you, the consumer, make the best and most informed choices when it comes to making smart home finance decisions, it is equally important to know you have choices and neither party is recommending or endorsing the other. You should choose the lender and/or real estate agent who best meets your needs.")));
};
DisclaimerPanel.propTypes = {
  handleBack: PropTypes.func
};

var css_248z$c = ".MonthlyCostPanel-module_overlayPanel__YpgwJ {\n  margin-bottom: 2.25em;\n}\n\n.MonthlyCostPanel-module_headerPanel__1qwKL {\n  padding: 0.75em;\n}\n\n.MonthlyCostPanel-module_chartPanel__W4VuM {\n  margin-top: 0.75em;\n  padding: 0.75em 0.75em 0.375em 0.75em;\n}\n.MonthlyCostPanel-module_chartPanel__W4VuM .MonthlyCostPanel-module_panelDivider__BfIHM > hr {\n  margin-left: -0.75em;\n  margin-right: -0.75em;\n}\n\n.MonthlyCostPanel-module_editButton__sgPnv {\n  margin-top: 0.375em;\n  margin-bottom: 0.75em;\n}\n\n.MonthlyCostPanel-module_headerGroup__RTN8W {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.MonthlyCostPanel-module_headerGroup__RTN8W > button {\n  margin: 0;\n}";
var styles$c = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","overlayPanel":"MonthlyCostPanel-module_overlayPanel__YpgwJ","headerPanel":"MonthlyCostPanel-module_headerPanel__1qwKL","chartPanel":"MonthlyCostPanel-module_chartPanel__W4VuM","panelDivider":"MonthlyCostPanel-module_panelDivider__BfIHM","editButton":"MonthlyCostPanel-module_editButton__sgPnv","headerGroup":"MonthlyCostPanel-module_headerGroup__RTN8W","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$c);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Group(_ref) {
  var _ref$top = _ref.top,
      top = _ref$top === void 0 ? 0 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? 0 : _ref$left,
      transform = _ref.transform,
      className = _ref.className,
      children = _ref.children,
      innerRef = _ref.innerRef,
      restProps = _objectWithoutPropertiesLoose(_ref, ["top", "left", "transform", "className", "children", "innerRef"]);

  return /*#__PURE__*/React__default.createElement("g", _extends({
    ref: innerRef,
    className: classnames('visx-group', className),
    transform: transform || "translate(" + left + ", " + top + ")"
  }, restProps), children);
}
Group.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  transform: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  innerRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
};

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => ascending(f(d), x);
}

function number$1(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$1).center;
var bisect = bisectRight;

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function define$1(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend$1(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color$1() {}

var darker$1 = 0.7;
var brighter$1 = 1 / darker$1;

var reI$1 = "\\s*([+-]?\\d+)\\s*",
    reN$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP$1 = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex$1 = /^#([0-9a-f]{3,8})$/,
    reRgbInteger$1 = new RegExp("^rgb\\(" + [reI$1, reI$1, reI$1] + "\\)$"),
    reRgbPercent$1 = new RegExp("^rgb\\(" + [reP$1, reP$1, reP$1] + "\\)$"),
    reRgbaInteger$1 = new RegExp("^rgba\\(" + [reI$1, reI$1, reI$1, reN$1] + "\\)$"),
    reRgbaPercent$1 = new RegExp("^rgba\\(" + [reP$1, reP$1, reP$1, reN$1] + "\\)$"),
    reHslPercent$1 = new RegExp("^hsl\\(" + [reN$1, reP$1, reP$1] + "\\)$"),
    reHslaPercent$1 = new RegExp("^hsla\\(" + [reN$1, reP$1, reP$1, reN$1] + "\\)$");

var named$1 = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define$1(Color$1, color$1, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex$1, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex$1,
  formatHsl: color_formatHsl$1,
  formatRgb: color_formatRgb$1,
  toString: color_formatRgb$1
});

function color_formatHex$1() {
  return this.rgb().formatHex();
}

function color_formatHsl$1() {
  return hslConvert$1(this).formatHsl();
}

function color_formatRgb$1() {
  return this.rgb().formatRgb();
}

function color$1(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex$1.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn$1(m) // #ff0000
      : l === 3 ? new Rgb$1((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba$1(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba$1((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger$1.exec(format)) ? new Rgb$1(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent$1.exec(format)) ? new Rgb$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger$1.exec(format)) ? rgba$1(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent$1.exec(format)) ? rgba$1(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent$1.exec(format)) ? hsla$1(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named$1.hasOwnProperty(format) ? rgbn$1(named$1[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb$1(NaN, NaN, NaN, 0)
      : null;
}

function rgbn$1(n) {
  return new Rgb$1(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba$1(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb$1(r, g, b, a);
}

function rgbConvert$1(o) {
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Rgb$1;
  o = o.rgb();
  return new Rgb$1(o.r, o.g, o.b, o.opacity);
}

function rgb$2(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert$1(r) : new Rgb$1(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb$1(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define$1(Rgb$1, rgb$2, extend$1(Color$1, {
  brighter: function(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Rgb$1(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex$1, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex$1,
  formatRgb: rgb_formatRgb$1,
  toString: rgb_formatRgb$1
}));

function rgb_formatHex$1() {
  return "#" + hex$1(this.r) + hex$1(this.g) + hex$1(this.b);
}

function rgb_formatRgb$1() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex$1(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla$1(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl$1(h, s, l, a);
}

function hslConvert$1(o) {
  if (o instanceof Hsl$1) return new Hsl$1(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color$1)) o = color$1(o);
  if (!o) return new Hsl$1;
  if (o instanceof Hsl$1) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl$1(h, s, l, o.opacity);
}

function hsl$2(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert$1(h) : new Hsl$1(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl$1(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define$1(Hsl$1, hsl$2, extend$1(Color$1, {
  brighter: function(k) {
    k = k == null ? brighter$1 : Math.pow(brighter$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker$1 : Math.pow(darker$1, k);
    return new Hsl$1(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb$1(
      hsl2rgb$1(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb$1(h, m1, m2),
      hsl2rgb$1(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb$1(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant$1 = x => () => x;

function linear$2(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential$1(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma$1(y) {
  return (y = +y) === 1 ? nogamma$1 : function(a, b) {
    return b - a ? exponential$1(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma$1(a, b) {
  var d = b - a;
  return d ? linear$2(a, d) : constant$1(isNaN(a) ? b : a);
}

var rgb$1 = (function rgbGamma(y) {
  var color = gamma$1(y);

  function rgb(start, end) {
    var r = color((start = rgb$2(start)).r, (end = rgb$2(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma$1(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$1(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color$1(b)) ? (b = c, rgb$1) : string)
      : b instanceof color$1 ? rgb$1
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound$1(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function constants(x) {
  return function() {
    return x;
  };
}

function number(x) {
  return +x;
}

var unit = [0, 1];

function identity$1(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$1,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$1) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound$1, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$1, rescale()) : clamp !== identity$1;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity$1, identity$1);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;

defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear$1() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear$1());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

var t0$1 = new Date,
    t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

var utcSecond = second;

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

var timeMinute = minute;

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

var timeHour = hour;

var day = newInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

var timeDay = day;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
weekday(1);
weekday(2);
weekday(3);
weekday(4);
weekday(5);
weekday(6);

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var timeMonth = month;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var timeYear = year;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinute$1 = utcMinute;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

var utcHour$1 = utcHour;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDay$1 = utcDay;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
utcWeekday(1);
utcWeekday(2);
utcWeekday(3);
utcWeekday(4);
utcWeekday(5);
utcWeekday(6);

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonth$1 = utcMonth;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYear$1 = utcYear;

function applyDomain(scale, config) {
  if (config.domain) {
    if ('nice' in scale || 'quantiles' in scale) {
      // continuous input scales
      scale.domain(config.domain);
    } else if ('padding' in scale) {
      // point and band scales
      scale.domain(config.domain);
    } else {
      // ordinal and threshold scale
      scale.domain(config.domain);
    }
  }
}

function applyRange(scale, config) {
  if (config.range) {
    if ('padding' in scale) {
      // point and band scales
      scale.range(config.range);
    } else {
      // the rest
      scale.range(config.range);
    }
  }
}

function applyAlign(scale, config) {
  if ('align' in scale && 'align' in config && typeof config.align !== 'undefined') {
    scale.align(config.align);
  }
}

function applyBase(scale, config) {
  if ('base' in scale && 'base' in config && typeof config.base !== 'undefined') {
    scale.base(config.base);
  }
}

function applyClamp(scale, config) {
  if ('clamp' in scale && 'clamp' in config && typeof config.clamp !== 'undefined') {
    scale.clamp(config.clamp);
  }
}

function applyConstant(scale, config) {
  if ('constant' in scale && 'constant' in config && typeof config.constant !== 'undefined') {
    scale.constant(config.constant);
  }
}

function applyExponent(scale, config) {
  if ('exponent' in scale && 'exponent' in config && typeof config.exponent !== 'undefined') {
    scale.exponent(config.exponent);
  }
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl$1(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl$1, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab$1(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab$1, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new Rgb(
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl$1(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * deg2rad;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

define(Hcl, hcl$1, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));

var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix$1(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix$1, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function constant(x) {
  return function() {
    return x;
  };
}

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
}

var interpolateRgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb$1(start, end) {
    var r = color((start = rgb(start)).r, (end = rgb(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$1.gamma = rgbGamma;

  return rgb$1;
})(1);

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function hsl(hue) {
  return function(start, end) {
    var h = hue((start = hsl$1(start)).h, (end = hsl$1(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var interpolateHsl = hsl(hue);
var hslLong = hsl(nogamma);

function lab(start, end) {
  var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl(hue) {
  return function(start, end) {
    var h = hue((start = hcl$1(start)).h, (end = hcl$1(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var interpolateHcl = hcl(hue);
var hclLong = hcl(nogamma);

function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = cubehelix$1(start)).h, (end = cubehelix$1(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

var interpolateCubehelix = cubehelix(hue);
var cubehelixLong = cubehelix(nogamma);

var interpolatorMap = {
  lab: lab,
  hcl: interpolateHcl,
  'hcl-long': hclLong,
  hsl: interpolateHsl,
  'hsl-long': hslLong,
  cubehelix: interpolateCubehelix,
  'cubehelix-long': cubehelixLong,
  rgb: interpolateRgb
};
function createColorInterpolator(interpolate) {
  switch (interpolate) {
    case 'lab':
    case 'hcl':
    case 'hcl-long':
    case 'hsl':
    case 'hsl-long':
    case 'cubehelix':
    case 'cubehelix-long':
    case 'rgb':
      return interpolatorMap[interpolate];
  }

  var type = interpolate.type,
      gamma = interpolate.gamma;
  var interpolator = interpolatorMap[type];
  return typeof gamma === 'undefined' ? interpolator : interpolator.gamma(gamma);
}

function applyInterpolate(scale, config) {
  if ('interpolate' in config && 'interpolate' in scale && typeof config.interpolate !== 'undefined') {
    var interpolator = createColorInterpolator(config.interpolate);
    scale.interpolate(interpolator);
  }
}

var TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var TEST_FORMAT = '%Y-%m-%d %H:%M';
/**
 * Check if the scale is UTC or Time scale
 * When local time is equal to UTC, always return true
 * @param scale time or utc scale
 */

function isUtcScale(scale) {
  // The only difference between time and utc scale is
  // whether the tick format function is utcFormat or timeFormat
  var output = scale.tickFormat(1, TEST_FORMAT)(TEST_TIME);
  return output === '2020-02-02 03:04';
}

var localTimeIntervals = {
  day: timeDay,
  hour: timeHour,
  minute: timeMinute,
  month: timeMonth,
  second: utcSecond,
  week: sunday,
  year: timeYear
};
var utcIntervals = {
  day: utcDay$1,
  hour: utcHour$1,
  minute: utcMinute$1,
  month: utcMonth$1,
  second: utcSecond,
  week: utcSunday,
  year: utcYear$1
};
function applyNice(scale, config) {
  if ('nice' in config && typeof config.nice !== 'undefined' && 'nice' in scale) {
    var nice = config.nice;

    if (typeof nice === 'boolean') {
      if (nice) {
        scale.nice();
      }
    } else if (typeof nice === 'number') {
      scale.nice(nice);
    } else {
      var timeScale = scale;
      var isUtc = isUtcScale(timeScale);

      if (typeof nice === 'string') {
        timeScale.nice(isUtc ? utcIntervals[nice] : localTimeIntervals[nice]);
      } else {
        var interval = nice.interval,
            step = nice.step;
        var parsedInterval = (isUtc ? utcIntervals[interval] : localTimeIntervals[interval]).every(step);

        if (parsedInterval != null) {
          timeScale.nice(parsedInterval);
        }
      }
    }
  }
}

function applyPadding(scale, config) {
  if ('padding' in scale && 'padding' in config && typeof config.padding !== 'undefined') {
    scale.padding(config.padding);
  }

  if ('paddingInner' in scale && 'paddingInner' in config && typeof config.paddingInner !== 'undefined') {
    scale.paddingInner(config.paddingInner);
  }

  if ('paddingOuter' in scale && 'paddingOuter' in config && typeof config.paddingOuter !== 'undefined') {
    scale.paddingOuter(config.paddingOuter);
  }
}

function applyReverse(scale, config) {
  if (config.reverse) {
    var reversedRange = scale.range().slice().reverse();

    if ('padding' in scale) {
      // point and band scales
      scale.range(reversedRange);
    } else {
      // the rest
      scale.range(reversedRange);
    }
  }
}

function applyRound(scale, config) {
  if ('round' in config && typeof config.round !== 'undefined') {
    if (config.round && 'interpolate' in config && typeof config.interpolate !== 'undefined') {
      console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
    } else if ('round' in scale) {
      // for point and band scales
      scale.round(config.round);
    } else if ('interpolate' in scale && config.round) {
      // for continuous output scales
      // setting config.round = true
      // is actually setting interpolator to interpolateRound
      // as these scales do not have scale.round() function
      scale.interpolate(interpolateRound);
    }
  }
}

function applyUnknown(scale, config) {
  if ('unknown' in scale && 'unknown' in config && typeof config.unknown !== 'undefined') {
    scale.unknown(config.unknown);
  }
}

function applyZero(scale, config) {
  if ('zero' in config && config.zero === true) {
    var domain = scale.domain();
    var a = domain[0],
        b = domain[1];
    var isDescending = b < a;

    var _ref = isDescending ? [b, a] : [a, b],
        min = _ref[0],
        max = _ref[1];

    var domainWithZero = [Math.min(0, min), Math.max(0, max)];
    scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
  }
}

/**
 * List of all operators, in order of execution
 */

var ALL_OPERATORS = [// domain => nice => zero
'domain', 'nice', 'zero', // interpolate before round
'interpolate', 'round', // set range then reverse
'range', 'reverse', // Order does not matter for these operators
'align', 'base', 'clamp', 'constant', 'exponent', 'padding', 'unknown'];
// Use Record to enforce that all keys in OperatorType must exist.
var operators = {
  domain: applyDomain,
  nice: applyNice,
  zero: applyZero,
  interpolate: applyInterpolate,
  round: applyRound,
  align: applyAlign,
  base: applyBase,
  clamp: applyClamp,
  constant: applyConstant,
  exponent: applyExponent,
  padding: applyPadding,
  range: applyRange,
  reverse: applyReverse,
  unknown: applyUnknown
};
function scaleOperator() {
  for (var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++) {
    ops[_key] = arguments[_key];
  }

  var selection = new Set(ops);
  var selectedOps = ALL_OPERATORS.filter(function (o) {
    return selection.has(o);
  });
  return function applyOperators(scale, config) {
    if (typeof config !== 'undefined') {
      selectedOps.forEach(function (op) {
        operators[op](scale, config);
      });
    }

    return scale;
  };
}

var updateBandScale = scaleOperator('domain', 'range', 'reverse', 'align', 'padding', 'round');
function createBandScale(config) {
  return updateBandScale(band(), config);
}

var updateLinearScale = scaleOperator('domain', 'range', 'reverse', 'clamp', 'interpolate', 'nice', 'round', 'zero');
function createLinearScale(config) {
  return updateLinearScale(linear$1(), config);
}

var css_248z$b = ".Charts-module_slideBar__eZm-U {\n  cursor: pointer;\n}\n\n.Charts-module_ttPortal__r81nV {\n  color: #bbb2b7 !important;\n  background: #29282e !important;\n  padding: 5px 2px;\n  width: 70px;\n  font-size: 13px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 999999;\n}\n.Charts-module_ttPortal__r81nV:before {\n  content: \"\";\n  height: 0;\n  position: absolute;\n  width: 0;\n  transform: translateX(-50%);\n  border-top: 10px solid #29282e;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-left: 10px solid transparent;\n  top: 100%;\n  left: 50%;\n}";
var styles$b = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","slideBar":"Charts-module_slideBar__eZm-U","ttPortal":"Charts-module_ttPortal__r81nV","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$b);

const _excluded$2 = ["datum", "getColor", "xScale", "yScale"];
var _jsxFileName$d = "/home/circleci/app/libs/listings-bot/src/components/Charts/BreakEvenBarChart.jsx";

const verticalMargin = 20;

const BreakEvenBarChart = ({
  width,
  height,
  data,
  outsideScopeIndex,
  // ie. years in home highlighting
  breakEvenIndex,
  // ie. vertical dashed gray line
  withEllipsis,
  compact
}) => {
  const xMax = width;
  const yMax = height - verticalMargin; // scales, memoize for performance

  const xScale = useMemo(() => createBandScale({
    range: [0, xMax],
    round: true,
    domain: data.map(d => d.x),
    padding: 0.4
  }), [xMax, data]);
  const yScale = useMemo(() => createLinearScale({
    range: [yMax, 0],
    round: true,
    domain: [Math.min(...data.map(d => d.y)), Math.max(...data.map(d => d.y))]
  }), [yMax, data]); // tooltip methods via hook and mouseOver event to wire in

  const {
    tooltipData,
    tooltipLeft,
    tooltipTop,
    tooltipOpen,
    showTooltip,
    hideTooltip
  } = useTooltip();
  const {
    containerRef,
    TooltipInPortal
  } = useTooltipInPortal({
    detectBounds: true,
    scroll: true
  });

  const handleMouseOver = (event, datum) => {
    const coords = localPoint(event.target.ownerSVGElement, event);
    const left = xScale(datum.x) - xScale.bandwidth() / 1.5 - 35;
    showTooltip({
      tooltipLeft: Math.min(xMax - 63, Math.max(-26, left)),
      tooltipTop: coords.y - 65,
      tooltipData: datum
    });
  }; // utility


  const getColor = ({
    x,
    y
  }) => {
    if (x > outsideScopeIndex) {
      return y >= 0 ? styles$b['color-dark-green'] : styles$b['color-dark-red'];
    } else {
      return y >= 0 ? styles$b['color-green'] : styles$b['color-red'];
    }
  };

  if (!data || !data.length || !height || !width || width < 10) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  } // calcs for breakeven


  let breakEvenFrom, breakEvenTo;

  if (breakEvenIndex > 0 && breakEvenIndex < data.length) {
    const breakX = xScale(data[breakEvenIndex].x) - 3;
    breakEvenFrom = new Point({
      x: breakX,
      y: -5
    });
    breakEvenTo = new Point({
      x: breakX,
      y: yMax + 5
    });
  } // calcs for ellipsis


  const ellipsisData = data[data.length - 1];
  const ellipsisX = xScale(ellipsisData.x) + xScale.bandwidth() + 4;
  const ellipsisY = ellipsisData.y > 0 ? yScale(0) - 1 : yScale(yMax) - yScale(0) + 1;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("svg", {
    width: width,
    height: height,
    ref: containerRef,
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 106,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Group, {
    top: verticalMargin / 2,
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 107,
      columnNumber: 9
    }
  }, data.map((d, i) => /*#__PURE__*/React__default.createElement(SlideBar, {
    className: styles$b.slideBar,
    key: `bar-${i}`,
    datum: d,
    xScale: xScale,
    yScale: yScale,
    getColor: getColor,
    onMouseOver: e => {
      !compact && handleMouseOver(e, d);
    },
    onMouseOut: hideTooltip,
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 109,
      columnNumber: 13
    }
  })), breakEvenFrom && !compact && /*#__PURE__*/React__default.createElement(Line, {
    key: "break-even-line",
    from: breakEvenFrom,
    to: breakEvenTo,
    stroke: styles$b['color-gray'],
    strokeDasharray: "5 4",
    strokeWidth: "2",
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 123,
      columnNumber: 13
    }
  }), withEllipsis && !compact && /*#__PURE__*/React__default.createElement(Ellipsis, {
    xStart: ellipsisX,
    yStart: ellipsisY,
    fill: getColor(ellipsisData),
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 133,
      columnNumber: 13
    }
  }))), tooltipOpen && /*#__PURE__*/React__default.createElement(TooltipInPortal, {
    key: Math.random(),
    top: tooltipTop,
    left: tooltipLeft,
    className: styles$b.ttPortal,
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 142,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 148,
      columnNumber: 11
    }
  }, `Year ${tooltipData.x}`), /*#__PURE__*/React__default.createElement("span", {
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 149,
      columnNumber: 11
    }
  }, tooltipData.y >= 100000 ? formatAbbrCurrency(tooltipData.y) : formatToCurrency(tooltipData.y))));
}; // Three dots on the right of the chart


const Ellipsis = ({
  xStart,
  yStart,
  fill
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("circle", {
  key: "ellipsis-point-1",
  cx: xStart,
  cy: yStart,
  r: 1,
  fill: fill,
  __self: window,
  __source: {
    fileName: _jsxFileName$d,
    lineNumber: 163,
    columnNumber: 5
  }
}), /*#__PURE__*/React__default.createElement("circle", {
  key: "ellipsis-point-2",
  cx: xStart + 4,
  cy: yStart,
  r: 1,
  fill: fill,
  __self: window,
  __source: {
    fileName: _jsxFileName$d,
    lineNumber: 164,
    columnNumber: 5
  }
}), /*#__PURE__*/React__default.createElement("circle", {
  key: "ellipsis-point-3",
  cx: xStart + 8,
  cy: yStart,
  r: 1,
  fill: fill,
  __self: window,
  __source: {
    fileName: _jsxFileName$d,
    lineNumber: 171,
    columnNumber: 5
  }
})); // Uses react-countup to interploate change in svg position/size


const SlideBar = _ref => {
  let {
    datum,
    getColor,
    xScale,
    yScale
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$2);

  const {
    countUp,
    start: startCount,
    update: updateCount
  } = useCountUp({
    start: 0,
    end: datum.y,
    duration: 0.1,
    useEasing: false
  });
  useEffect(() => {
    updateCount(datum.y);
  }, [datum.y]); // eslint-disable-line

  useEffect(() => {
    startCount();
  }, []); // eslint-disable-line
  // the actual important mathy bits for chart svg bars

  const barWidth = xScale.bandwidth();
  const barHeight = Math.max(1, yScale(0) - yScale(Math.abs(countUp)));
  const barX = xScale(datum.x);
  const barY = countUp > 0 ? yScale(0) - barHeight : yScale(0);
  const fill = getColor(Object.assign({}, datum, {
    y: countUp
  }));
  return /*#__PURE__*/React__default.createElement(Bar, _extends$1({
    x: barX,
    y: barY,
    width: barWidth,
    height: barHeight,
    fill: fill
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$d,
      lineNumber: 210,
      columnNumber: 5
    }
  }));
};

BreakEvenBarChart.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  })).isRequired,
  outsideScopeIndex: PropTypes.number,
  breakEvenIndex: PropTypes.number,
  withEllipsis: PropTypes.bool,
  compact: PropTypes.bool
};
Ellipsis.propTypes = {
  xStart: PropTypes.number.isRequired,
  yStart: PropTypes.number.isRequired,
  fill: PropTypes.string
};
SlideBar.propTypes = {
  datum: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  getColor: PropTypes.func,
  xScale: PropTypes.any,
  yScale: PropTypes.any
};

var css_248z$a = ".Chart-module_chart__gSr9- {\n  width: 100%;\n  border-radius: 12px;\n}";
var styles$a = {"chart":"Chart-module_chart__gSr9-"};
styleInject(css_248z$a);

var _jsxFileName$c = "/home/circleci/app/libs/listings-bot/src/components/Charts/HorizontalStackedBarChart/Chart.jsx";

const calcTotalWidth = filteredDataset => filteredDataset.reduce((acc, currentDatapoint) => acc + currentDatapoint.value, 0);

const dataWithDisplayParams = (dataset, gap) => {
  const filteredDataset = dataset.filter(datapoint => !!datapoint.value);
  const halfGap = gap / 2;
  const widthTotal = calcTotalWidth(filteredDataset);
  let position = 0;
  let barWidth = 0;
  const bars = filteredDataset.map((datapoint, index) => {
    // Since the first and last bars only have a gap on one side of them, subtract
    // half of the gap size from their length. For all other bars, subtract the entire
    // gap size since there will be a gap on both sides and position them a full gap
    // size away from the previous bar
    const percentOfTotal = datapoint.value * 100 / widthTotal;

    if (index === 0) {
      position = 0;
      barWidth = percentOfTotal - halfGap;
    } else if (index === filteredDataset.length - 1) {
      position = position + barWidth + gap;
      barWidth = percentOfTotal - halfGap;
    } else {
      position = position + barWidth + gap;
      barWidth = percentOfTotal - gap;
    }

    return Object.assign({
      position,
      barWidth,
      label: `${datapoint.title} ${percentOfTotal.toFixed(2)}%`
    }, datapoint);
  });
  return bars;
};

const Chart = ({
  data,
  gapPercent,
  className
}) => {
  const bars = dataWithDisplayParams(data, gapPercent);
  return /*#__PURE__*/React__default.createElement("svg", {
    height: "12",
    width: "292",
    viewBox: "0 0 292 12",
    className: classnames(styles$a.chart, className),
    __self: window,
    __source: {
      fileName: _jsxFileName$c,
      lineNumber: 54,
      columnNumber: 5
    }
  }, bars.map((bar, index) => /*#__PURE__*/React__default.createElement("rect", {
    key: index,
    width: `${bar.barWidth}%`,
    height: "100%",
    style: {
      fill: bar.color
    },
    x: `${bar.position}%`,
    "aria-label": bar.label,
    __self: window,
    __source: {
      fileName: _jsxFileName$c,
      lineNumber: 61,
      columnNumber: 9
    }
  })));
};

Chart.propTypes = {
  className: PropTypes.string,
  gapPercent: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    color: PropTypes.string,
    title: PropTypes.string
  }))
};
Chart.defaultProps = {
  className: '',
  gapPercent: 1,
  data: []
};

var css_248z$9 = ".Legend-module_legend__zOXQR {\n  display: flex;\n  flex-direction: column;\n  color: #f3eff1;\n}\n.Legend-module_legend__zOXQR ul {\n  padding: 0;\n}\n\n.Legend-module_row__Oi0hG {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  margin-bottom: 0.75em;\n}\n\n.Legend-module_bullet__WxqK8 {\n  grid-column-start: 1;\n  margin-right: 0.5em;\n  width: 0.75em;\n  height: 0.75em;\n  border-radius: 50%;\n}\n\n.Legend-module_emptyBullet__yk8WX {\n  border: 1px solid #f3eff1;\n}\n\n.Legend-module_title__onJNf {\n  grid-column-start: 2;\n  font-weight: 700;\n  margin: 0;\n}\n\n.Legend-module_subtitle__G0jv2 {\n  grid-column-start: 2;\n  grid-row-start: 2;\n  color: #bbb2b7;\n  margin: 0;\n  font-size: 0.875em;\n}\n\n.Legend-module_formattedValue__WMTc2 {\n  grid-column-start: 3;\n  margin: 0;\n}";
var styles$9 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","legend":"Legend-module_legend__zOXQR","row":"Legend-module_row__Oi0hG","bullet":"Legend-module_bullet__WxqK8","emptyBullet":"Legend-module_emptyBullet__yk8WX","title":"Legend-module_title__onJNf","subtitle":"Legend-module_subtitle__G0jv2","formattedValue":"Legend-module_formattedValue__WMTc2","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$9);

var _jsxFileName$b = "/home/circleci/app/libs/listings-bot/src/components/Charts/HorizontalStackedBarChart/Legend.jsx";

const Legend = ({
  data
}) => /*#__PURE__*/React__default.createElement("div", {
  className: styles$9.legend,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 7,
    columnNumber: 3
  }
}, /*#__PURE__*/React__default.createElement("ul", {
  className: styles$9.legendList,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 8,
    columnNumber: 5
  }
}, data.map((datapoint, index) => /*#__PURE__*/React__default.createElement("li", {
  className: styles$9.row,
  key: index,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 10,
    columnNumber: 9
  }
}, /*#__PURE__*/React__default.createElement("span", {
  className: classnames(styles$9.bullet, !datapoint.value && styles$9.emptyBullet),
  style: {
    backgroundColor: datapoint.color
  },
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 11,
    columnNumber: 11
  }
}), /*#__PURE__*/React__default.createElement("p", {
  className: styles$9.title,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 18,
    columnNumber: 11
  }
}, datapoint.title), /*#__PURE__*/React__default.createElement("p", {
  className: styles$9.subtitle,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 19,
    columnNumber: 11
  }
}, datapoint.subtitle), /*#__PURE__*/React__default.createElement("p", {
  className: styles$9.formattedValue,
  __self: window,
  __source: {
    fileName: _jsxFileName$b,
    lineNumber: 20,
    columnNumber: 11
  }
}, datapoint.formattedValue || datapoint.value || '?')))));

Legend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    formattedValue: PropTypes.string,
    value: PropTypes.number,
    color: PropTypes.string
  }))
};

var css_248z$8 = "";
var styles$8 = {"color1":"#41B9FA","color2":"#005ECC","color3":"#7600D3","color4":"#BE41D2","color5":"#FC5AEC","color6":"#FD5AA7","colorNoData":"#28292c"};
styleInject(css_248z$8);

const _excluded$1 = ["data"],
      _excluded2 = ["data"];
var _jsxFileName$a = "/home/circleci/app/libs/listings-bot/src/components/Charts/HorizontalStackedBarChart/index.js";
const propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    formattedValue: PropTypes.string,
    value: PropTypes.number
  }))
};
const noDataColor = styles$8.colorNoData;
const colors = [styles$8.color1, styles$8.color2, styles$8.color3, styles$8.color4, styles$8.color5, styles$8.color6];

const dataWithColorInfo = data => {
  if (!data) return [];
  return data.map((datapoint, index) => {
    const color = datapoint.value ? colors[index % colors.length] : noDataColor;
    return Object.assign({
      color
    }, datapoint);
  });
};

const ChartWithColorData = _ref => {
  let {
    data
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

  return /*#__PURE__*/React__default.createElement(Chart, _extends$1({
    data: dataWithColorInfo(data)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 41,
      columnNumber: 3
    }
  }));
};

const LegendWithColorData = _ref2 => {
  let {
    data
  } = _ref2,
      restProps = _objectWithoutPropertiesLoose$1(_ref2, _excluded2);

  return /*#__PURE__*/React__default.createElement(Legend, _extends$1({
    data: dataWithColorInfo(data)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$a,
      lineNumber: 45,
      columnNumber: 3
    }
  }));
};

ChartWithColorData.propTypes = Object.assign({}, propTypes, {
  gapPercent: PropTypes.number
});
LegendWithColorData.propTypes = propTypes;
const HorizontalStackedBarChart = {};
HorizontalStackedBarChart.Chart = ChartWithColorData;
HorizontalStackedBarChart.Legend = LegendWithColorData;

var _jsxFileName$9 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/MonthlyCostPanel/MonthlyCostPanel.jsx";

const MonthlyCostPanel = ({
  handleBack
}) => {
  const {
    listingPrice,
    monthlyCost,
    monthlyCostBreakdown = {},
    mostRecentInterestRate
  } = useListingDisplay();
  const {
    loanPayment
  } = monthlyCostBreakdown;
  const {
    downPayment
  } = useBuyerSettings();
  const {
    maxBudget
  } = useBuyerSettingsWithDefaults();
  const {
    setFocusFieldAndNavigateToSettings
  } = useContext(AppContext);
  const budgetDiff = monthlyCost - maxBudget;
  const budgetDirection = budgetDiff > 0 ? 'Over' : 'Under';
  const budgetColor = budgetDirection === 'Over' ? 'red' : 'green';
  const formattedBudgetDiff = formatToCurrency(Math.abs(budgetDiff));
  const [underConstructionActive, setUnderConstructionActive] = useState(false);
  const logGA = useLogGAEvent(EDIT_ESTIMATED_COSTS_TEASER_CLICK);
  const toggleUnderConstructionActive = useCallback(_ => {
    if (!underConstructionActive) {
      logGA();
    }

    setUnderConstructionActive(!underConstructionActive);
  }, [underConstructionActive, logGA]);

  const DownPaymentSubtitle = () => {
    const handleNavigation = () => {
      handleBack();
      setFocusFieldAndNavigateToSettings(INPUT_NAMES.DOWN_PAYMENT);
    }; // TODO: can delete default downpayment here after 1836 goes in, moving this logic to the BE


    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NavigationButton, {
      onClick: handleNavigation,
      __self: window,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 83,
        columnNumber: 9
      }
    }, downPayment ? formatToCurrency(downPayment) : formatToCurrency(DEFAULT_DOWN_PAYMENT), ' ', "down"), /*#__PURE__*/React__default.createElement(Text, {
      element: "span",
      __self: window,
      __source: {
        fileName: _jsxFileName$9,
        lineNumber: 89,
        columnNumber: 9
      }
    }, ' ', "over 30 years at ", formatToPercent(mostRecentInterestRate, 2)));
  };

  const noDataSubtitle = "Couldn't be determined";
  const loanDataSubtitle = useCallback(() => {
    if (loanPayment === 0 && downPayment >= listingPrice) {
      return 'Home purchased in cash';
    } else if (loanPayment !== 0) {
      return /*#__PURE__*/React__default.createElement(DownPaymentSubtitle, {
        __self: window,
        __source: {
          fileName: _jsxFileName$9,
          lineNumber: 103,
          columnNumber: 14
        }
      });
    } else {
      return noDataSubtitle;
    }
  }, [downPayment, listingPrice, loanPayment]);
  const chartData = useMemo(() => {
    const {
      loanPayment,
      hoaFees,
      propertyTaxes,
      mortgageInsurance,
      maintenance,
      homeInsurance
    } = monthlyCostBreakdown;
    const formattedLoan = formatToCurrency(loanPayment);
    const formattedHoa = formatToCurrency(hoaFees);
    const formattedPropTax = formatToCurrency(propertyTaxes);
    const formattedPmi = formatToCurrency(mortgageInsurance);
    const formattedMaintenance = formatToCurrency(maintenance);
    const formattedHomeInsurance = formatToCurrency(homeInsurance);
    const loanData = {
      title: 'Principal & interest',
      subtitle: loanDataSubtitle(),
      value: loanPayment,
      formattedValue: formattedLoan
    };
    const hoaData = {
      title: 'HOA',
      subtitle: hoaFees ? 'Based on historical figures' : noDataSubtitle,
      value: hoaFees,
      formattedValue: formattedHoa
    };
    const propTaxData = {
      title: 'Property taxes',
      subtitle: propertyTaxes ? 'Based on historical figures' : noDataSubtitle,
      value: propertyTaxes,
      formattedValue: formattedPropTax
    };
    const pmiSubtitle = mortgageInsurance === undefined ? noDataSubtitle : mortgageInsurance === 0 ? 'Not applicable' : 'Based on your estimated PMI';
    const mortgageInsuranceData = {
      title: 'Mortgage insurance',
      subtitle: pmiSubtitle,
      value: mortgageInsurance,
      formattedValue: formattedPmi
    };
    const maintenanceData = {
      title: 'Budget for maintenance',
      subtitle: maintenance ? "Save 1% of home's value / year" : noDataSubtitle,
      value: maintenance,
      formattedValue: formattedMaintenance
    };
    const homeInsuranceData = {
      title: 'Home insurance',
      subtitle: homeInsurance ? 'Based on national averages' : noDataSubtitle,
      value: homeInsurance,
      formattedValue: formattedHomeInsurance
    }; // Sorts high to low with undefined at the bottom

    const sortedByValues = [loanData, hoaData, propTaxData, maintenanceData, mortgageInsuranceData, homeInsuranceData].sort((a, b) => a !== undefined && a.value < b.value ? 1 : -1);
    return sortedByValues;
  }, [monthlyCostBreakdown, loanDataSubtitle]);

  const handleEditYourBudgetClick = () => {
    handleBack();
    setFocusFieldAndNavigateToSettings(INPUT_NAMES.MAX_BUDGET);
  };

  return /*#__PURE__*/React__default.createElement(OverlayPanel, {
    className: styles$c.overlayPanel,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 186,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(OverlayPanelHeader, {
    onBack: handleBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 187,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    weight: "semibold",
    color: "white",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 188,
      columnNumber: 9
    }
  }, "Monthly Costs")), /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$c.headerPanel,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 192,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    weight: "light",
    align: "center",
    size: "xxl",
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 193,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(ColoredCountUp, {
    weight: "light",
    value: Math.abs(monthlyCost),
    controlledColor: budgetColor,
    formatter: formatToCurrency,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 194,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 201,
      columnNumber: 9
    }
  }, `${budgetDirection} budget of ${formatToCurrency(Math.abs(maxBudget))} by `, /*#__PURE__*/React__default.createElement(Text, {
    color: "inherit",
    element: "span",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 205,
      columnNumber: 11
    }
  }, formattedBudgetDiff))), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    iconEnd: BudgetRightArrow,
    onClick: handleEditYourBudgetClick,
    className: styles$c.editButton,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 210,
      columnNumber: 7
    }
  }, "Edit your budget"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$c.headerGroup,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 218,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    upperspaced: true,
    weight: "semibold",
    letterSpacing: "large",
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 219,
      columnNumber: 9
    }
  }, "Est. Cost Breakdown"), /*#__PURE__*/React__default.createElement(Button, {
    minimal: true,
    onClick: toggleUnderConstructionActive,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 222,
      columnNumber: 9
    }
  }, "Edit")), /*#__PURE__*/React__default.createElement(If, {
    condition: chartData,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 226,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$c.chartPanel,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 227,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(PanelDivider, {
    header: true,
    className: styles$c.panelDivider,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 228,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(HorizontalStackedBarChart.Chart, {
    data: chartData,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 229,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(HorizontalStackedBarChart.Legend, {
    data: chartData,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 232,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React__default.createElement(UnderConstructionModal, {
    underConstructionActive: underConstructionActive,
    handleModalToggle: toggleUnderConstructionActive,
    __self: window,
    __source: {
      fileName: _jsxFileName$9,
      lineNumber: 236,
      columnNumber: 7
    }
  }));
};

MonthlyCostPanel.propTypes = {
  handleBack: PropTypes.func
};

var css_248z$7 = ".SavingsGraph-module_defaultChart__RBH7S {\n  position: relative;\n  width: calc(100% + 16px);\n  height: 80px;\n  padding-bottom: 30px;\n  margin: 0 -8px;\n}\n\n.SavingsGraph-module_breakEvenLabel__N--Sw {\n  position: absolute;\n  bottom: -15px;\n  left: 0;\n  white-space: nowrap;\n}";
var styles$7 = {"defaultChart":"SavingsGraph-module_defaultChart__RBH7S","breakEvenLabel":"SavingsGraph-module_breakEvenLabel__N--Sw"};
styleInject(css_248z$7);

const _excluded = ["className", "compact"];
var _jsxFileName$8 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/SavingsGraph/SavingsGraph.jsx";

const SavingsGraph = _ref => {
  let {
    className,
    compact
  } = _ref,
      restProps = _objectWithoutPropertiesLoose$1(_ref, _excluded);

  const {
    savingsValues,
    breakEvenYears,
    yearsInHome
  } = useListingDisplay();
  const wrapperRef = useRef(null);
  const labelRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    height: 0,
    width: 0
  });
  const [labelStyle, setLabelStyle] = useState({
    opacity: '0'
  });
  useEffect(() => {
    const wrapper = wrapperRef == null ? void 0 : wrapperRef.current;

    if (wrapper && wrapper.offsetHeight && !dimensions.width) {
      const rect = wrapper.getBoundingClientRect();

      if (rect.height && rect.width) {
        setDimensions({
          width: rect.width,
          height: rect.height
        });
      }
    }
  });
  useEffect(() => {
    const wrapper = wrapperRef == null ? void 0 : wrapperRef.current;
    const label = labelRef == null ? void 0 : labelRef.current;

    if (wrapper && label) {
      const wrapperRect = wrapper.getBoundingClientRect();
      const labelRect = label.getBoundingClientRect();
      const maxLeft = wrapperRect.width - labelRect.width;
      setLabelStyle({
        opacity: '1',
        left: `${Math.min(breakEvenYears, 20) / 20 * maxLeft + 4}px`
      });
    }
  }, [breakEvenYears]);

  if (!savingsValues || !savingsValues.length) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  const data = savingsValues.map((v, i) => ({
    x: i + 1,
    y: v
  })).slice(0, 20);
  const negativeYears = breakEvenYears - 1;
  return /*#__PURE__*/React__default.createElement("div", _extends$1({
    ref: wrapperRef,
    className: classnames(className, styles$7.defaultChart)
  }, restProps, {
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 52,
      columnNumber: 5
    }
  }), /*#__PURE__*/React__default.createElement(BreakEvenBarChart, _extends$1({}, dimensions, {
    data: data,
    compact: compact,
    withEllipsis: true,
    outsideScopeIndex: yearsInHome,
    breakEvenIndex: Math.max(0, breakEvenYears - 1),
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 57,
      columnNumber: 7
    }
  })), !compact && /*#__PURE__*/React__default.createElement("div", {
    ref: labelRef,
    className: styles$7.breakEvenLabel,
    style: labelStyle,
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 66,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: negativeYears >= 0,
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 71,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    weight: "bold",
    color: "heather",
    size: "s",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 72,
      columnNumber: 13
    }
  }, `${negativeYears} year${negativeYears !== 1 ? 's ' : ' '}`), /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    size: "s",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 75,
      columnNumber: 13
    }
  }, "to break even", /*#__PURE__*/React__default.createElement("sup", {
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 77,
      columnNumber: 15
    }
  }, /*#__PURE__*/React__default.createElement("i", {
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 78,
      columnNumber: 17
    }
  }, "*")))), /*#__PURE__*/React__default.createElement(Unless, {
    condition: negativeYears >= 0,
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 82,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "heather",
    size: "s",
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 83,
      columnNumber: 13
    }
  }, "no break even", /*#__PURE__*/React__default.createElement("sup", {
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 85,
      columnNumber: 15
    }
  }, /*#__PURE__*/React__default.createElement("i", {
    __self: window,
    __source: {
      fileName: _jsxFileName$8,
      lineNumber: 86,
      columnNumber: 17
    }
  }, "*"))))));
};

SavingsGraph.propTypes = {
  compact: PropTypes.bool,
  className: PropTypes.string
};

var css_248z$6 = ".ComparedToRenting-module_panel__iW5QX {\n  padding: 0.75em;\n  margin-bottom: 1.5em;\n}\n\n.ComparedToRenting-module_chart__UtcYk {\n  padding-bottom: 1.5em;\n}\n\n.ComparedToRenting-module_margin__x48oe {\n  margin-bottom: 1.5em;\n}\n\n.ComparedToRenting-module_noWrap__zf6PA {\n  white-space: nowrap;\n}\n\n.ComparedToRenting-module_bottomText__Pz3w4 {\n  padding-bottom: 2.25em;\n}";
var styles$6 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","panel":"ComparedToRenting-module_panel__iW5QX","chart":"ComparedToRenting-module_chart__UtcYk","margin":"ComparedToRenting-module_margin__x48oe","noWrap":"ComparedToRenting-module_noWrap__zf6PA","bottomText":"ComparedToRenting-module_bottomText__Pz3w4","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$6);

var _jsxFileName$7 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/ComparedToRenting/ComparedToRenting.jsx";

const ComparedToRenting = ({
  handleBack
}) => {
  const {
    savingsValue,
    breakEvenYears,
    yearsInHome,
    totalBuyCost,
    totalCurrentCost
  } = useListingDisplay();
  const savingsCopy = savingsValue > 0 ? 'Saved' : 'Cost';
  return /*#__PURE__*/React__default.createElement(OverlayPanel, {
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 37,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(OverlayPanelHeader, {
    onBack: handleBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    weight: "semibold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 39,
      columnNumber: 9
    }
  }, "Compared to Renting")), /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$6.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 43,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    size: "xxl",
    align: "center",
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(ColoredCountUp, {
    weight: "light",
    value: savingsValue,
    formatter: formatAbbrCurrency,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 45,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    align: "center",
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 51,
      columnNumber: 9
    }
  }, `${savingsCopy} compared to renting`)), /*#__PURE__*/React__default.createElement(Panel, {
    className: classnames(styles$6.panel, styles$6.chart),
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 53,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(SavingsGraph, {
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 54,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    transform: "uppercase",
    letterSpacing: "large",
    weight: "semibold",
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 56,
      columnNumber: 7
    }
  }, "Summary"), /*#__PURE__*/React__default.createElement("hr", {
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 59,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    className: styles$6.margin,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 60,
      columnNumber: 7
    }
  }, "Compared to renting", `, buying this house could ${savingsValue >= 0 ? 'save' : 'cost'} you about`, /*#__PURE__*/React__default.createElement(ColoredCountUp, {
    value: savingsValue,
    prefix: " ",
    suffix: " ",
    formatter: formatAbbrCurrency,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 65,
      columnNumber: 9
    }
  }), "if you stayed for", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    color: "white",
    className: styles$6.noWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 72,
      columnNumber: 9
    }
  }, ` ${yearsInHome} years`)), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    className: styles$6.margin,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: breakEvenYears,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 81,
      columnNumber: 9
    }
  }, "If you stay less than", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    color: "white",
    className: styles$6.noWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 83,
      columnNumber: 11
    }
  }, ` ${breakEvenYears} year${breakEvenYears !== 1 ? 's' : ''}`), ", it could be better to rent"), /*#__PURE__*/React__default.createElement(Unless, {
    condition: breakEvenYears,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 91,
      columnNumber: 9
    }
  }, "It is likely better to stay where you are")), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    className: styles$6.bottomText,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 96,
      columnNumber: 7
    }
  }, "So your total cost of owning this home for", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    color: "white",
    className: styles$6.noWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 98,
      columnNumber: 9
    }
  }, ` ${yearsInHome} years`), ` would be about`, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    color: "white",
    className: styles$6.noWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 105,
      columnNumber: 9
    }
  }, ` ${formatAbbrCurrency(Math.abs(totalBuyCost))}`), ", while renting a similar place would be about", /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    weight: "bold",
    color: "white",
    className: styles$6.noWrap,
    __self: window,
    __source: {
      fileName: _jsxFileName$7,
      lineNumber: 114,
      columnNumber: 9
    }
  }, ` ${formatAbbrCurrency(Math.abs(totalCurrentCost))}`)));
};

ComparedToRenting.propTypes = {
  handleBack: PropTypes.func
};

var css_248z$5 = ".ComparedToStaying-module_panel__Kiazl {\n  padding: 0.75em;\n  margin-bottom: 1.5em;\n}\n\n.ComparedToStaying-module_pill__gh7ss {\n  max-width: 145px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.ComparedToStaying-module_subnav__nG950 {\n  display: flex;\n  justify-content: center;\n  padding: 0 0.75em 1.5em 0.75em;\n}\n\n.ComparedToStaying-module_active__yBBMB {\n  background-color: #4c4851;\n}";
var styles$5 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","panel":"ComparedToStaying-module_panel__Kiazl","pill":"ComparedToStaying-module_pill__gh7ss","subnav":"ComparedToStaying-module_subnav__nG950","active":"ComparedToStaying-module_active__yBBMB","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$5);

var _jsxFileName$6 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/ComparedToStaying/ComparedToStaying.jsx";

const formattedCostOrSavings = cost => {
  // Negative cost == positive savings
  return {
    color: cost < 0 ? 'green' : 'red',
    symbol: cost < 0 ? '+' : '-',
    copy: cost < 0 ? 'gain' : 'lose'
  };
};

const ComparedToStaying = ({
  handleBack
}) => {
  const {
    yearsInHome,
    totalBuyCost,
    totalCurrentCost
  } = useListingDisplay();
  const {
    currentAddress: currentHomeAddress
  } = useBuyerSettings();
  const [activeSubNav, setActiveSubNav] = useState('thisHome');
  const formattedBuyCost = formattedCostOrSavings(totalBuyCost);
  const formattedCurrentCost = formattedCostOrSavings(totalCurrentCost);
  return /*#__PURE__*/React__default.createElement(OverlayPanel, {
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 45,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(OverlayPanelHeader, {
    onBack: handleBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 46,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: "span",
    color: "white",
    weight: "semibold",
    size: "l",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 47,
      columnNumber: 9
    }
  }, "Financial Forecast")), /*#__PURE__*/React__default.createElement("div", {
    className: styles$5.subnav,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 52,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Pill, {
    onClick: () => setActiveSubNav('thisHome'),
    className: classnames(styles$5.pill, activeSubNav === 'thisHome' && styles$5.active),
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 53,
      columnNumber: 9
    }
  }, "This home"), /*#__PURE__*/React__default.createElement(Pill, {
    onClick: () => setActiveSubNav('currentHome'),
    className: classnames(styles$5.pill, activeSubNav === 'currentHome' && styles$5.active),
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 62,
      columnNumber: 9
    }
  }, currentHomeAddress)), /*#__PURE__*/React__default.createElement(If, {
    condition: activeSubNav === 'thisHome',
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 73,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$5.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 74,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    size: "m",
    upperspaced: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 75,
      columnNumber: 11
    }
  }, `You might ${formattedBuyCost.copy} around`), /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    size: "xxl",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 78,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: formattedBuyCost.color,
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 79,
      columnNumber: 13
    }
  }, formattedBuyCost.symbol), /*#__PURE__*/React__default.createElement(ColoredCountUp, {
    weight: "light",
    value: totalBuyCost * -1,
    formatter: formatAbbrCurrency,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 82,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 88,
      columnNumber: 11
    }
  }, "if you sold", ' ', /*#__PURE__*/React__default.createElement(Text, {
    weight: "bold",
    element: "span",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 90,
      columnNumber: 13
    }
  }, currentHomeAddress), ' ', "today, then bought this home and sold it after", ' ', /*#__PURE__*/React__default.createElement(Text, {
    weight: "bold",
    element: "span",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 94,
      columnNumber: 13
    }
  }, ` ${yearsInHome} years`)))), /*#__PURE__*/React__default.createElement(If, {
    condition: activeSubNav === 'currentHome',
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 101,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Panel, {
    className: styles$5.panel,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 102,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    size: "m",
    upperspaced: true,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 103,
      columnNumber: 11
    }
  }, `You might ${formattedCurrentCost.copy} around`), /*#__PURE__*/React__default.createElement(Text, {
    color: "eggShell",
    size: "xxl",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 106,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: formattedCurrentCost.color,
    element: "span",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 107,
      columnNumber: 13
    }
  }, formattedCurrentCost.symbol), /*#__PURE__*/React__default.createElement(ColoredCountUp, {
    weight: "light",
    value: totalCurrentCost * -1,
    formatter: formatAbbrCurrency,
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 110,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(Text, {
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 116,
      columnNumber: 11
    }
  }, "if you stayed and sold", ' ', /*#__PURE__*/React__default.createElement(Text, {
    weight: "bold",
    element: "span",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 118,
      columnNumber: 13
    }
  }, currentHomeAddress), ' ', "after", ' ', /*#__PURE__*/React__default.createElement(Text, {
    weight: "bold",
    element: "span",
    color: "white",
    __self: window,
    __source: {
      fileName: _jsxFileName$6,
      lineNumber: 122,
      columnNumber: 13
    }
  }, ` ${yearsInHome} ${yearsInHome === 1 ? 'year' : 'years'}`)))));
};

ComparedToStaying.propTypes = {
  handleBack: PropTypes.func
};

var _jsxFileName$5 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/OverlayPanels/OverlayPanels.jsx";

const OverlayPanels = () => {
  const {
    activeOverlayId,
    handleOverlayBack
  } = useContext(OverlayContext);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Show, {
    condition: activeOverlayId === PANEL_IDS.DISCLAIMER,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 21,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(DisclaimerPanel, {
    handleBack: handleOverlayBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 22,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Show, {
    condition: activeOverlayId === PANEL_IDS.MONTHLY_COST,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 24,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(MonthlyCostPanel, {
    handleBack: handleOverlayBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 25,
      columnNumber: 9
    }
  })), /*#__PURE__*/React__default.createElement(Show, {
    condition: activeOverlayId === PANEL_IDS.BREAKEVEN_CHART,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(If.Own, {
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 28,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(ComparedToStaying, {
    handleBack: handleOverlayBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 29,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(If.Rent, {
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 31,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(ComparedToRenting, {
    handleBack: handleOverlayBack,
    __self: window,
    __source: {
      fileName: _jsxFileName$5,
      lineNumber: 32,
      columnNumber: 11
    }
  }))));
};

var css_248z$4 = ".Body-module_analyzeModalBody__-y0Ea {\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 539px;\n  width: 100%;\n  font-size: 1em;\n  flex: 1;\n  transform: translateY(0);\n}\n\n/* total width */\n.Body-module_analyzeModalBody__-y0Ea::-webkit-scrollbar {\n  background-color: #302e35;\n}\n\n/* background of the scrollbar except button or resizer */\n.Body-module_analyzeModalBody__-y0Ea::-webkit-scrollbar-track {\n  background-color: #302e35;\n}\n\n/* scrollbar itself */\n.Body-module_analyzeModalBody__-y0Ea::-webkit-scrollbar-thumb {\n  background-color: #6e6d6d;\n  border-radius: 16px;\n  border: 4px solid #302e35;\n}\n\n/* set button(top and bottom of the scrollbar) */\n.Body-module_analyzeModalBody__-y0Ea::-webkit-scrollbar-button {\n  display: none;\n}";
var styles$4 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","analyzeModalBody":"Body-module_analyzeModalBody__-y0Ea","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$4);

var _jsxFileName$4 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/Body/Body.jsx";

const Body = () => {
  const {
    activeTab
  } = useContext(AppContext);
  const {
    activeOverlayId
  } = useContext(OverlayContext);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.analyzeModalBody,
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(ScrollableContent, {
    scrollTopDeps: [activeOverlayId, activeTab],
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(Show, {
    condition: !activeOverlayId,
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 20,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(TabContent, {
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 21,
      columnNumber: 11
    }
  })), /*#__PURE__*/React__default.createElement(Show, {
    condition: activeOverlayId,
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 23,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(OverlayPanels, {
    __self: window,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 24,
      columnNumber: 11
    }
  }))));
};

var css_248z$3 = ".AnalyzeModal-module_overlay__rkrNL {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.25);\n  margin-top: -100vh;\n  margin-left: -100vw;\n  height: 300vh;\n  width: 300vw;\n}\n\n.AnalyzeModal-module_analyzeModalRoot__BQZR1 {\n  font-family: \"Open Sans\", sans-serif;\n  color: #bbb2b7;\n  position: absolute;\n  width: 340px;\n  background-color: #302e35;\n  border-radius: 2px;\n  font-size: 1em;\n  line-height: 1.5;\n  margin-top: -26px;\n  margin-left: -254px;\n  min-height: 300px;\n  height: auto;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: content-box;\n}\n.AnalyzeModal-module_analyzeModalRoot__BQZR1 > * {\n  box-sizing: border-box !important;\n}\n\n.AnalyzeModal-module_analyzeModalRootFullHeight__UqlbT {\n  height: 100vh;\n  max-height: 100%;\n  margin-top: 0px;\n}\n\n.AnalyzeModal-module_textColor-green__S9N8N {\n  color: #3ce967;\n}\n.AnalyzeModal-module_textColor-orange__jXR6V {\n  color: #ff9545;\n}\n.AnalyzeModal-module_textColor-red__WiWvi {\n  color: #ff4545;\n}\n\n.AnalyzeModal-module_monthlyCost__4iqjQ {\n  margin-bottom: 1.5em;\n}\n\n.AnalyzeModal-module_analyzeButton__EOy2p {\n  margin-bottom: 1.5em;\n  padding-bottom: 17px;\n}\n.AnalyzeModal-module_analyzeButton__EOy2p svg {\n  width: 22px;\n  margin-right: 5px;\n  position: relative;\n  top: 3px;\n  fill: #06a3f7;\n}\n.AnalyzeModal-module_analyzeButton__EOy2p:hover svg {\n  fill: #f3eff1 !important;\n}\n\n.AnalyzeModal-module_footer__kvX-j > img {\n  max-width: 100%;\n  display: inline-block;\n}\n\nhr {\n  border-top: none;\n  border-bottom: 0.025px solid #48464e;\n  margin: 0.75em -25px 0.75em -25px;\n}\n\n.AnalyzeModal-module_centerLoading__UwaAJ {\n  display: inline-block;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  top: 50%;\n}\n\n.AnalyzeModal-module_overflowHidden__8L0ad {\n  min-height: 300px;\n  height: auto;\n  max-height: 90vh;\n  overflow: hidden;\n}\n\n.AnalyzeModal-module_iframeWrap__pUt-K {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background: #302e35;\n  z-index: 1;\n}\n\n.AnalyzeModal-module_iframe__VemMm {\n  height: 100%;\n  width: 340px;\n  overflow: hidden;\n}";
var styles$3 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","overlay":"AnalyzeModal-module_overlay__rkrNL","analyzeModalRoot":"AnalyzeModal-module_analyzeModalRoot__BQZR1","analyzeModalRootFullHeight":"AnalyzeModal-module_analyzeModalRootFullHeight__UqlbT","textColor-green":"AnalyzeModal-module_textColor-green__S9N8N","textColor-orange":"AnalyzeModal-module_textColor-orange__jXR6V","textColor-red":"AnalyzeModal-module_textColor-red__WiWvi","monthlyCost":"AnalyzeModal-module_monthlyCost__4iqjQ","analyzeButton":"AnalyzeModal-module_analyzeButton__EOy2p","footer":"AnalyzeModal-module_footer__kvX-j","centerLoading":"AnalyzeModal-module_centerLoading__UwaAJ","overflowHidden":"AnalyzeModal-module_overflowHidden__8L0ad","iframeWrap":"AnalyzeModal-module_iframeWrap__pUt-K","iframe":"AnalyzeModal-module_iframe__VemMm","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7","textColor___green":"AnalyzeModal-module_textColor-green__S9N8N","textColor___orange":"AnalyzeModal-module_textColor-orange__jXR6V","textColor___red":"AnalyzeModal-module_textColor-red__WiWvi"};
styleInject(css_248z$3);

var _jsxFileName$3 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/AnalyzeModal/AnalyzeModal.jsx";

const AnalyzeModal = ({
  onClose,
  withOverlay: _withOverlay = false
}) => {
  const {
    activeTab,
    setActiveTab
  } = useContext(AppContext);
  const {
    showPopup,
    popup: Popup
  } = useErrorPopup();
  const {
    showIframe,
    setShowIframe,
    iframeReady,
    setIframeReady,
    iframeSrc
  } = useContext(RouterContext);
  const {
    setOverlayIdHistory
  } = useContext(OverlayContext);
  const {
    isGlobalLoading
  } = useLoading();
  const isPastLoadingDelayOffset = useDelay(175);
  const handleTabClick = useCallback(activeTabValue => {
    setOverlayIdHistory([]);
    setActiveTab(activeTabValue);
  }, [setActiveTab, setOverlayIdHistory]);
  const handleIframeLoad = useCallback(() => {
    setIframeReady(true);
  }, [setIframeReady]);
  useEffect(() => {
    const listenForMessageEvents = event => {
      if (event.data.actionType === 'close') {
        setShowIframe(false);
      }

      if (event.data.actionType === 'openExternalLink') {
        window.open(event.data.link, '_blank');
      }

      if (event.data.actionType === 'sendEmailRequest') {
        window.open(`mailto:${event.data.link}`, '_self');
      }
    };

    window.addEventListener('message', listenForMessageEvents);
    return () => window.removeEventListener('message', listenForMessageEvents);
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: classnames({
      [styles$3.overlay]: _withOverlay
    }),
    onClick: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 76,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classnames(styles$3.analyzeModalRoot, {
      [styles$3.analyzeModalRootFullHeight]: !_withOverlay
    }),
    onClick: e => e.stopPropagation(),
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 80,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    fallbackComponent: CatchAllError,
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 86,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(If, {
    condition: isGlobalLoading && isPastLoadingDelayOffset,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 87,
      columnNumber: 11
    }
  }, /*#__PURE__*/React__default.createElement(LineLoader, {
    className: styles$3.centerLoading,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 88,
      columnNumber: 13
    }
  })), /*#__PURE__*/React__default.createElement(If, {
    condition: !isGlobalLoading && isPastLoadingDelayOffset,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 91,
      columnNumber: 11
    }
  }, showPopup && /*#__PURE__*/React__default.createElement(Popup, {
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 92,
      columnNumber: 27
    }
  }), /*#__PURE__*/React__default.createElement(Unless, {
    condition: showPopup,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 94,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Header, {
    activeTab: activeTab,
    onTabClick: e => handleTabClick(e.target.value),
    onClose: onClose,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 95,
      columnNumber: 15
    }
  }), /*#__PURE__*/React__default.createElement(Body, {
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 100,
      columnNumber: 15
    }
  }), /*#__PURE__*/React__default.createElement(Footer, {
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 101,
      columnNumber: 15
    }
  }))), /*#__PURE__*/React__default.createElement(Show, {
    className: styles$3.iframeWrap,
    condition: showIframe,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 105,
      columnNumber: 11
    }
  }, !iframeReady && /*#__PURE__*/React__default.createElement(LineLoader, {
    className: styles$3.centerLoading,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 106,
      columnNumber: 30
    }
  }), /*#__PURE__*/React__default.createElement(Show, {
    className: styles$3.iframeWrap,
    condition: iframeReady,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 107,
      columnNumber: 13
    }
  }, /*#__PURE__*/React__default.createElement(Iframe, {
    className: styles$3.iframe,
    title: 'iframe',
    src: iframeSrc,
    onLoad: handleIframeLoad,
    __self: window,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 108,
      columnNumber: 15
    }
  }))))));
};

AnalyzeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  withOverlay: PropTypes.bool,
  modalStyles: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  })
};

var css_248z$2 = ".LaunchPadBotHead-module_button__Ggiuv {\n  position: absolute;\n  right: -25px;\n  top: 80px;\n  padding: 0;\n  width: 50px;\n  height: 50px;\n  border: none;\n  outline: none;\n  border-radius: 100%;\n}\n.LaunchPadBotHead-module_button__Ggiuv:active {\n  transform: scale(0.9);\n}";
var styles$2 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","button":"LaunchPadBotHead-module_button__Ggiuv","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z$2);

var _jsxFileName$2 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/LaunchTargets/LaunchPadBotHead/LaunchPadBotHead.jsx";

const LaunchPadBotHead = ({
  id,
  handleClick
}) => {
  const {
    color,
    isFetched,
    isErrored
  } = useListingDisplay();
  return /*#__PURE__*/React__default.createElement("button", {
    id: id,
    className: styles$2.button,
    onClick: handleClick,
    __self: window,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 14,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(ListingStatusHead, {
    color: color || 'pink',
    spin: !isFetched,
    fail: isErrored,
    __self: window,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 15,
      columnNumber: 7
    }
  }));
};

LaunchPadBotHead.propTypes = {
  id: PropTypes.string,
  handleClick: PropTypes.func
};

var css_248z$1 = ".LaunchPadRibbon-module_wrapper__Hx7C8 {\n  background-color: hsl(240deg, 4%, 17%);\n  box-shadow: 0px 10px 12px hsla(240deg, 20%, 2%, 0.07), 0px 4px 8px hsla(240deg, 20%, 2%, 0.07);\n  margin: -17px;\n  padding: 16px;\n  border: 1px solid hsla(320deg, 27%, 98%, 0.1);\n}\n@media screen and (max-width: 480px) {\n  .LaunchPadRibbon-module_wrapper__Hx7C8 {\n    border-radius: 8px;\n    margin: 0;\n  }\n}\n\n.LaunchPadRibbon-module_center__PDNb- {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.LaunchPadRibbon-module_center__PDNb- .LaunchPadRibbon-module_bothead__hdNOv {\n  width: 30px;\n  height: 30px;\n  margin-bottom: 0.375em;\n}\n@media screen and (max-width: 480px) {\n  .LaunchPadRibbon-module_center__PDNb- .LaunchPadRibbon-module_bothead__hdNOv {\n    margin-top: 0.75em;\n  }\n}\n\n.LaunchPadRibbon-module_text__mEMOF {\n  text-align: center;\n  margin: 0 1.5em;\n}\n.LaunchPadRibbon-module_text__mEMOF .LaunchPadRibbon-module_heading__1codF {\n  font-size: 18px;\n}\n\n.LaunchPadRibbon-module_subText__mbBSY {\n  color: #E4EDF7;\n}\n\n.LaunchPadRibbon-module_inspectButton__1UcL9 {\n  margin: 0.75em 0.75em 0 0.75em;\n  height: 40px;\n  border-radius: 4px;\n  background-color: #121314;\n  color: #89CAF0;\n}\n.LaunchPadRibbon-module_inspectButton__1UcL9.LaunchPadRibbon-module_errored__-OiWh {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.LaunchPadRibbon-module_inspectButton__1UcL9:hover {\n  background-color: hsl(209deg, 78.1%, 57.1%);\n  color: #fff;\n}\n.LaunchPadRibbon-module_inspectButton__1UcL9:active {\n  -webkit-animation: LaunchPadRibbon-module_button-pop__xoJkn 0.1s;\n          animation: LaunchPadRibbon-module_button-pop__xoJkn 0.1s;\n  transition: 0.1s;\n}\n.LaunchPadRibbon-module_inspectButton__1UcL9 path {\n  stroke-width: 6px;\n  transform: rotate(-90deg);\n  transform-origin: center;\n}\n@media screen and (max-width: 480px) {\n  .LaunchPadRibbon-module_inspectButton__1UcL9 {\n    margin-bottom: 0.75em;\n  }\n}\n\n@-webkit-keyframes LaunchPadRibbon-module_button-pop__xoJkn {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes LaunchPadRibbon-module_button-pop__xoJkn {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}";
var styles$1 = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","wrapper":"LaunchPadRibbon-module_wrapper__Hx7C8","center":"LaunchPadRibbon-module_center__PDNb-","bothead":"LaunchPadRibbon-module_bothead__hdNOv","text":"LaunchPadRibbon-module_text__mEMOF","heading":"LaunchPadRibbon-module_heading__1codF","subText":"LaunchPadRibbon-module_subText__mbBSY","inspectButton":"LaunchPadRibbon-module_inspectButton__1UcL9","errored":"LaunchPadRibbon-module_errored__-OiWh","button-pop":"LaunchPadRibbon-module_button-pop__xoJkn","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7","button___pop":"LaunchPadRibbon-module_button-pop__xoJkn"};
styleInject(css_248z$1);

const LaunchPadRibbon = ({
  id,
  handleClick: expandWidget
}) => {
  const {
    text,
    color,
    isError,
    isFetched
  } = useListingDisplay();
  const {
    setActiveTab,
    setFocusedSettingsField
  } = useContext(AppContext);
  const colorWithFallBack = color || 'pink';
  const settledRequest = isFetched;
  const [failure, setFailure] = useState(false);
  const {
    expandModal,
    focusTab,
    focusTarget
  } = lib.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  useEffect(() => {
    if (isError) {
      setFailure(true);
    } else if (settledRequest) {
      setFailure(false);
    }
  }, [isError, settledRequest]);
  useEffect(() => {
    if (focusTab && VALID_TAB_VALUES.includes(focusTab)) {
      setActiveTab(focusTab);
    }

    if (focusTarget && focusTab === TABS.SETTINGS) {
      setFocusedSettingsField(focusTarget);
    } // only care about presence of param, not value


    if (expandModal) {
      expandWidget();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const itemProps = {
    color: 'white',
    size: 'xxs',
    weight: 'semibold'
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.wrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.center
  }, /*#__PURE__*/React__default.createElement(ListingStatusHead, {
    className: styles$1.bothead,
    color: colorWithFallBack,
    spin: !settledRequest && !failure,
    fail: failure
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.text
  }, /*#__PURE__*/React__default.createElement(Text, {
    color: colorWithFallBack,
    weight: 'bold',
    className: styles$1.heading
  }, !settledRequest && 'Analyzing...', settledRequest && failure && 'Failed to load', settledRequest && !failure && `${text} Buy`), /*#__PURE__*/React__default.createElement(Unless, {
    condition: settledRequest && !failure
  }, /*#__PURE__*/React__default.createElement(Text, Object.assign({
    className: styles$1.subText
  }, itemProps), !failure && "We're crunching numbers", failure && 'Could not communicate with server')), /*#__PURE__*/React__default.createElement(If, {
    condition: settledRequest && !failure
  }, /*#__PURE__*/React__default.createElement(InlineBulletedList, null, /*#__PURE__*/React__default.createElement(EvaluationList, {
    className: styles$1.subText
  })))), /*#__PURE__*/React__default.createElement(Button, {
    id: id,
    className: classnames(styles$1.inspectButton, failure && styles$1.errored),
    fullWidth: true,
    disabled: !settledRequest || failure,
    onClick: expandWidget
  }, /*#__PURE__*/React__default.createElement(Text, {
    element: 'span',
    color: 'inherit',
    size: 's',
    weight: 'bold'
  }, "See why"))));
};

var css_248z = ".ListingLaunchPad-module_launchPad__8YQiK {\n  position: fixed;\n  top: 0;\n  z-index: 100001;\n}\n\n.ListingLaunchPad-module_launchPadRight__cfFpi {\n  left: calc(100% - (340px / 4));\n  min-height: 100%;\n}";
var styles = {"color-green":"#3ce967","color-dark-green":"#41664c","color-orange":"#ff9545","color-pink":"#fc5aa6","color-red":"#ff4545","color-dark-red":"#5c2d2f","color-gray":"#bbb2b7","launchPad":"ListingLaunchPad-module_launchPad__8YQiK","launchPadRight":"ListingLaunchPad-module_launchPadRight__cfFpi","color___green":"#3ce967","color___dark___green":"#41664c","color___orange":"#ff9545","color___pink":"#fc5aa6","color___red":"#ff4545","color___dark___red":"#5c2d2f","color___gray":"#bbb2b7"};
styleInject(css_248z);

var _jsxFileName$1 = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/ListingLaunchPad.jsx";

const RenderTarget = ({
  positioning,
  id,
  children,
  setModalOpen
}) => {
  const {
    Portal
  } = usePortal({
    containerId: `launch-pad-${positioning}`,
    onShow: _e => {
      setModalOpen(true);
    },
    onHide: _e => {
      setModalOpen(false);
    }
  });

  switch (positioning) {
    case positioningTypes.RELATIVE:
      return /*#__PURE__*/React__default.createElement(TargetOverlay, {
        targetQuery: `#${id}`,
        __self: window,
        __source: {
          fileName: _jsxFileName$1,
          lineNumber: 45,
          columnNumber: 14
        }
      }, children);

    default:
      return /*#__PURE__*/React__default.createElement(Portal, {
        __self: window,
        __source: {
          fileName: _jsxFileName$1,
          lineNumber: 48,
          columnNumber: 9
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        tabIndex: -1,
        className: classnames(styles.launchPad, {
          [styles.launchPadRight]: positioning === positioningTypes.FIXED_RIGHT
        }),
        __self: window,
        __source: {
          fileName: _jsxFileName$1,
          lineNumber: 49,
          columnNumber: 11
        }
      }, children));
  }
};

RenderTarget.propTypes = {
  positioning: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  setModalOpen: PropTypes.func.isRequired
};

const ListingLaunchPad = ({
  launcher: Launcher = LaunchPadBotHead,
  positioning: _positioning = positioningTypes.FIXED_RIGHT
}) => {
  const id = 'HB_Listing_BotHead';
  const [modalOpen, setModalOpen] = useState(false);
  const {
    setOverlayIdHistory
  } = useContext(OverlayContext);
  const {
    setIframeSrc
  } = useContext(RouterContext);
  const {
    setMarketTempSliderPrice,
    setAppreciationSliderPercent,
    setActiveTab
  } = useContext(AppContext);
  const {
    setUserManuallyEntered
  } = useContext(ZillowContext);
  const {
    execute: trackEvent
  } = useTrackBotheadClickAsync();
  const {
    address,
    listingPrice
  } = useListingDisplay();
  const logGA = useLogGAEvent(BOTHEAD_MOUNT_ON_LISTING);
  const handleCloseAndCleanup = useCallback(() => {
    setModalOpen(false);
    setOverlayIdHistory([]);
    setIframeSrc('');
    setActiveTab(TABS.OVERVIEW);
    setUserManuallyEntered && setUserManuallyEntered(false);
  }, [setOverlayIdHistory, setIframeSrc, setActiveTab, setUserManuallyEntered]);
  const handleOpen = useCallback(() => {
    setModalOpen(true);
    trackEvent();
  }, [trackEvent]);
  useEffect(() => {
    logGA(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setMarketTempSliderPrice(null);
    setAppreciationSliderPercent(null);
  }, [address, listingPrice, setMarketTempSliderPrice, setAppreciationSliderPercent]);
  useQueryPrefetches();
  const withOverlay = _positioning === positioningTypes.RELATIVE;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Launcher, {
    id: id,
    handleClick: handleOpen,
    __self: window,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 128,
      columnNumber: 7
    }
  }), /*#__PURE__*/React__default.createElement(If, {
    condition: modalOpen,
    __self: window,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 129,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(RenderTarget, {
    positioning: _positioning,
    id: id,
    setModalOpen: setModalOpen,
    __self: window,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 130,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(AnalyzeModal, {
    withOverlay: withOverlay,
    onClose: handleCloseAndCleanup,
    __self: window,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 135,
      columnNumber: 11
    }
  }))));
};

ListingLaunchPad.propTypes = {
  launcher: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func]),
  positioning: PropTypes.string
};

var _jsxFileName = "/home/circleci/app/libs/listings-bot/src/Widgets/ListingLaunchPad/ListingLaunchPad.interface.jsx";

const ListingLaunchPadInterface = ({
  // drives behavior - must be set by props or internally
  address,
  listingPrice,
  // required for EMBEDDED
  customerProfileId,
  clientAuthToken,
  customerPublicKey,
  // defaulted
  queryClient: _queryClient = new QueryClient(),
  widgetMode: _widgetMode = EMBEDDED,
  devMode: _devMode = false,
  children
}) => {
  const hasCustomer = Boolean(customerProfileId);
  const hasAuth = Boolean(clientAuthToken || customerPublicKey);
  const hasEmbedProps = hasCustomer && hasAuth;

  if (_widgetMode === EMBEDDED && !hasEmbedProps) {
    console.warn('ListingLaunchPad export missing required props. Nothing rendered.');
    return;
  }

  return /*#__PURE__*/React__default.createElement(AppContextProvider, {
    address: address,
    listingPrice: listingPrice,
    customerProfileId: customerProfileId,
    clientAuthToken: clientAuthToken,
    customerPublicKey: customerPublicKey,
    widgetMode: _widgetMode,
    devMode: _devMode,
    __self: window,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, /*#__PURE__*/React__default.createElement(QueryClientProvider, {
    client: _queryClient,
    __self: window,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React__default.createElement(RouterContextProvider, {
    __self: window,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(OverlayContextProvider, {
    __self: window,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }, children))));
};

ListingLaunchPadInterface.propTypes = {
  address: PropTypes.string,
  listingPrice: PropTypes.number,
  widgetMode: PropTypes.string,
  devMode: PropTypes.bool,
  queryClient: PropTypes.object,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string,
  customerProfileId: PropTypes.string,
  children: PropTypes.any
};

const ListingLaunchPadExtended = ListingLaunchPad;
ListingLaunchPadExtended.Interface = ListingLaunchPadInterface;

const Chromebot = props => {
  const {
    clientAuthToken,
    customerPublicKey,
    customerProfileId,
    address,
    listingPrice,
    positioning
  } = props;
  const launcher = useCallback(({
    className,
    id,
    handleClick
  }) => /*#__PURE__*/React__default.createElement(LaunchPadRibbon, {
    className: className,
    id: id,
    handleClick: handleClick
  }), []);
  return /*#__PURE__*/React__default.createElement(ListingLaunchPadExtended.Interface // Implementation Type
  , {
    // Implementation Type
    widgetMode: EMBEDDED,
    // Auth Props
    customerProfileId: customerProfileId,
    clientAuthToken: clientAuthToken,
    customerPublicKey: customerPublicKey,
    // Behavior Props
    address: address,
    listingPrice: listingPrice
  }, /*#__PURE__*/React__default.createElement(ListingLaunchPadExtended, {
    launcher: launcher,
    positioning: positioning
  }));
};

Chromebot.propTypes = {
  listingPrice: PropTypes.number,
  address: PropTypes.string,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string.isRequired,
  customerProfileId: PropTypes.string.isRequired,
  positioning: PropTypes.oneOf([positioningTypes.FIXED_RIGHT, positioningTypes.RELATIVE]),
  className: PropTypes.string
};

export { AmountPercentInput, AppContext, AppContextProvider, Avatar, BotHead, Button, Checkbox, Chromebot, CircleIcon, ClickableTile, CloseButton, ColoredCountUp, CurrencyInput, DisclaimerButton, Drawer, ErrorBoundary, ErrorMessage, EvaluationList, EvaluationTile, ExpandablePillTextField, Fade, Feedback, FormField, If, Iframe, InlineBulletedList, Input, LineLoader, ListingLaunchPadExtended as ListingLaunchPad, ListingStatusHead, MultiSelect, NavigationButton, NightsInput, OverlayContext, OverlayContextProvider, OverlayPanel, OverlayPanelHeader, Panel, PanelDivider, PerMonthInput, Pill, Popup, QuestionCheckboxes, RouterContext, RouterContextProvider, ScrollContext, ScrollableContent, Show, Slider, StatusBar, index as Svg, Tab, Tabs, TargetOverlay, Text, TextArea, UnderConstruction, UnderConstructionModal, Unless, YearsInput, ZillowContext, ZillowContextProvider };
